/* eslint-disable */
import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Represents a decimal number with 2 decimal places (e.g. 19.99). */
  BigDecimal: any;
  /** Represents an ISO-4217 currency codes (e.g. GBP). */
  Currency: any;
  /** Represents an internet domain (e.g. global.com) based on RFC 2181. */
  DomainName: any;
  /** Represents generic json body */
  JSON: any;
  /** Represents the date in ISO format (e.g. 2011-12-03). */
  LocalDate: any;
  /** Represents the date and time in ISO format (e.g. 2011-12-03T10:15:30 or 2011-12-03T10:15:30Z). */
  LocalDateTime: any;
  /** Represents a combined ISO-639 language code and ISO-3166 country code (e.g. en-GB). */
  Locale: any;
  /** Represents a numerical long. */
  Long: any;
  /** Represents a signed (negative) integer (< 0). */
  NegativeInt: any;
  /** Represents an unsigned (positive) float/double (>= 0). */
  NonNegativeFloat: any;
  /** Represents an unsigned (positive) integer (>= 0). */
  NonNegativeInt: any;
  /** Represents a signed (negative) integer (<= 0). */
  NonPositiveInt: any;
  /** Represents an unsigned (positive) float/double (> 0). */
  PositiveFloat: any;
  /** Represents an unsigned (positive) integer (> 0). */
  PositiveInt: any;
  /** Represents a TimeZone string in IANA Time Zone Database (TZDB) format */
  TimeZone: any;
  /** Represents a URL with protocol, domain, and optionally a path, hash or query string. */
  Url: any;
  /** Represents a IANA formatted zone identifier (e.g. Europe/London). */
  ZoneId: any;
};

export type Activity = {
  __typename?: 'Activity';
  changes?: Maybe<Array<ActivityChange>>;
  dateTime: Scalars['LocalDateTime'];
  entityName: Scalars['String'];
  entityTypeId: EntityTypeId;
  id: Scalars['ID'];
  user?: Maybe<User>;
};

export type ActivityChange = {
  __typename?: 'ActivityChange';
  field: ActivityChangeField;
  newValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  oldValue?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ActivityChangeField = {
  __typename?: 'ActivityChangeField';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ActivityFilter = {
  dateRange?: InputMaybe<DateRange>;
  entityIds?: InputMaybe<Array<Scalars['String']>>;
  entityTypes?: InputMaybe<Array<EntityType>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ActivityHistoryFilterCategory = {
  __typename?: 'ActivityHistoryFilterCategory';
  displayName: Scalars['String'];
  filterDisplayType: ActivityHistoryFilterDisplayType;
  filterType: ActivityHistoryFilterType;
};

export enum ActivityHistoryFilterDisplayType {
  FreeText = 'FREE_TEXT',
  TimeRange = 'TIME_RANGE',
  Values = 'VALUES'
}

export enum ActivityHistoryFilterType {
  EntityIds = 'ENTITY_IDS',
  EntityType = 'ENTITY_TYPE',
  TimeRange = 'TIME_RANGE'
}

export type ActivityHistoryFilterValue = {
  __typename?: 'ActivityHistoryFilterValue';
  displayName: Scalars['String'];
  filterType: ActivityHistoryFilterType;
  id: Scalars['String'];
};

export type ActivityOffsetPaginationResponse = {
  __typename?: 'ActivityOffsetPaginationResponse';
  activities?: Maybe<Array<Activity>>;
  pageMetaData: PageMetaData;
};

export enum ActivityOrderableField {
  Date = 'DATE'
}

export type Ad = {
  __typename?: 'Ad';
  /** Optional as we can have ads in 1.0 without creatives */
  adExclusive: Scalars['Boolean'];
  businessId?: Maybe<Scalars['ID']>;
  creative?: Maybe<Creative>;
  creativeOverride?: Maybe<CreativeOverride>;
  duration: Scalars['NonNegativeFloat'];
  endDate: InheritableLocalDateTime;
  id: Scalars['ID'];
  impressions?: Maybe<Scalars['NonNegativeInt']>;
  ltr?: Maybe<Scalars['NonNegativeFloat']>;
  mediaSpend?: Maybe<Scalars['BigDecimal']>;
  name: Scalars['String'];
  startDate: InheritableLocalDateTime;
  status: AdStatus;
  territory: Territory;
  timeZone: Scalars['ZoneId'];
  weight?: Maybe<Scalars['NonNegativeInt']>;
};

export type AdAttributesLegacy = {
  /** Flag that marks this ad as exclusive. */
  adExclusive?: InputMaybe<Scalars['Boolean']>;
  /** The audio creative ID that is attached to this ad. */
  creativeAudioId?: InputMaybe<Scalars['ID']>;
  /** The list of image creative IDs that are attached to this ad. */
  creativeImageIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The redirect creative ID that is attached to this ad. */
  creativeRedirectId?: InputMaybe<Scalars['ID']>;
  /** The daily cap of impressions that the ad wants to deliver. */
  dailyCap?: InputMaybe<Scalars['NonNegativeInt']>;
  /** The duration of this ad in seconds. */
  duration?: InputMaybe<Scalars['NonNegativeFloat']>;
  /** The end date and time of the ad in ISO format. */
  endDate?: InputMaybe<InheritableLocalDateTimeAttributes>;
  /** Determines the maximum number of impressions per listener. */
  frequencyCapCount?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Determines the time unit which the frequency cap value represents a multiple of. */
  frequencyCapTimeUnit?: InputMaybe<FrequencyCapTimeUnit>;
  /** Determines the time period value over which to deliver the number of ad impressions. */
  frequencyCapValue?: InputMaybe<Scalars['NonNegativeInt']>;
  /** The name of the ad. */
  name?: InputMaybe<Scalars['String']>;
  /** The list of possible ads IDs to be next in sequence; typically a singleton list containing 1 ad ID. */
  sequence?: InputMaybe<Array<Scalars['ID']>>;
  /** Flag stating whether this ad is the start of a sequence within its campaign. */
  sequenceStart?: InputMaybe<Scalars['Boolean']>;
  /** The start date and time of the ad in ISO format. */
  startDate?: InputMaybe<InheritableLocalDateTimeAttributes>;
  /** The status of the given ad. */
  status?: InputMaybe<AdStatusLegacy>;
  /**
   * The list of tag ids that are attached to this ad. If tagsAreInherited=false tagIds must also be present in the
   * campaign. If tagsAreInherited=true, the tagIds must not also exist in the campaign.
   */
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Flag to determine whether tags are inherited from parent campaign. When toggling from true to false, also
   * clear tagIds.
   */
  tagsAreInherited?: InputMaybe<Scalars['Boolean']>;
  /** The targeting definition that is attached to this ad. */
  targetingDefinition?: InputMaybe<TargetingDefinitionAttributes>;
  /** The targeting definition V2 that is attached to this ad. */
  targetingDefinitionV2?: InputMaybe<TargetingDefinitionV2Attributes>;
  /** The territory of the given ad. */
  territory?: InputMaybe<Territory>;
  /** The weighting this ad holds as part of the campaign it belongs to. */
  weighting?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type AdEdge = {
  __typename?: 'AdEdge';
  cursor: Scalars['String'];
  node: AdLegacy;
};

export type AdFilterLegacy = {
  status_in?: InputMaybe<Array<AdStatusLegacy>>;
};

export type AdFormatAttributes = {
  mediaType: MediaType;
  price: Scalars['PositiveFloat'];
  type: AdFormatType;
  unit: AdFormatPriceUnit;
};

export type AdFormatDetail = {
  __typename?: 'AdFormatDetail';
  mediaType: MediaType;
  price: Scalars['BigDecimal'];
  type: AdFormatType;
  unit: AdFormatPriceUnit;
};

export type AdFormatInfo = {
  __typename?: 'AdFormatInfo';
  displayName: Scalars['String'];
  type: AdFormatType;
  unit: AdFormatPriceUnit;
};

export enum AdFormatPriceUnit {
  Cpm = 'CPM',
  FlatFee = 'FLAT_FEE'
}

export enum AdFormatType {
  BrandedEpisode = 'BRANDED_EPISODE',
  BrandedSegment = 'BRANDED_SEGMENT',
  BrandedSeries = 'BRANDED_SERIES',
  EnhancedHostRead = 'ENHANCED_HOST_READ',
  FeedDrop = 'FEED_DROP',
  HostRead = 'HOST_READ',
  PostGuaranteed = 'POST_GUARANTEED',
  PostOrganic = 'POST_ORGANIC',
  PremiumBrandedSegment = 'PREMIUM_BRANDED_SEGMENT',
  Production = 'PRODUCTION',
  ProductPlacement = 'PRODUCT_PLACEMENT',
  PromoPlus = 'PROMO_PLUS',
  SocialBoostCosts = 'SOCIAL_BOOST_COSTS',
  SocialExtension = 'SOCIAL_EXTENSION',
  Sponsorship = 'SPONSORSHIP',
  SponsorCredit = 'SPONSOR_CREDIT',
  ThirdPartyDeliverableNonSpot = 'THIRD_PARTY_DELIVERABLE_NON_SPOT',
  ThirdPartyDeliverableSpot = 'THIRD_PARTY_DELIVERABLE_SPOT',
  Usage = 'USAGE',
  Vlog = 'VLOG'
}

export type AdLegacy = Node & TargetingTemplateLink & {
  __typename?: 'AdLegacy';
  /** Flag that marks this ad as exclusive. */
  adExclusive?: Maybe<Scalars['Boolean']>;
  /** The type of the ad. */
  adType: AdType;
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** The parent campaign that created this ad. */
  campaign?: Maybe<Campaign>;
  /** The audio creative used in this ad.  */
  creativeAudio?: Maybe<CreativeAudioLegacy>;
  /** The image creatives used in this ad. */
  creativeImages: Array<CreativeImageLegacy>;
  /** The redirect creative used in this ad. */
  creativeRedirect?: Maybe<CreativeRedirectLegacy>;
  /** The daily cap of impressions that the ad wants to deliver. */
  dailyCap?: Maybe<Scalars['NonNegativeInt']>;
  /** The duration of this ad in seconds. */
  duration?: Maybe<Scalars['NonNegativeFloat']>;
  /** The end date and time of the ad in ISO format and whether it is inherited from its campaign */
  endDate: InheritableLocalDateTime;
  /** Determines the maximum number of impressions per listener. */
  frequencyCapCount?: Maybe<Scalars['NonNegativeInt']>;
  /** Determines the time unit which the frequency cap value represents a multiple of. */
  frequencyCapTimeUnit?: Maybe<FrequencyCapTimeUnit>;
  /** Determines the time period value for which to deliver the number of ad impressions. */
  frequencyCapValue?: Maybe<Scalars['NonNegativeInt']>;
  /** The historical audio creatives no longer used in this ad.  */
  historicalAudioCreatives?: Maybe<Array<CreativeAudioLegacy>>;
  /** The historical image creatives no longer used in this ad. */
  historicalImageCreatives?: Maybe<Array<CreativeImageLegacy>>;
  /** The historical redirect creative no longer used in this ad. */
  historicalRedirectCreatives?: Maybe<Array<CreativeRedirectLegacy>>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The number of total impresssions served so far. */
  impressions?: Maybe<Scalars['NonNegativeInt']>;
  /** The list of inherited tags for this ad. */
  inheritedTags: Array<Tag>;
  /** The global listen-through-rate for the ad. */
  ltr?: Maybe<Scalars['NonNegativeFloat']>;
  /** The total media spend of the ad. */
  mediaSpend?: Maybe<Scalars['BigDecimal']>;
  /** The targeting definition of this ad, with all it's targeting templates and general targeting group merged in. */
  mergedTargetingDefinition?: Maybe<TargetingDefinition>;
  /** The name of the ad. */
  name?: Maybe<Scalars['String']>;
  /** The list of possible ads to be next in sequence; typically a singleton list containing 1 ad. */
  sequence: Array<AdLegacy>;
  /** Flag stating whether this ad is the start of a sequence within its campaign. */
  sequenceStart?: Maybe<Scalars['Boolean']>;
  /** The start date and time of the ad in ISO format and whether it is inherited from its campaign */
  startDate: InheritableLocalDateTime;
  /** The status of the given ad. */
  status?: Maybe<AdStatusLegacy>;
  /** The list of tags for this ad. This does not include any tags inherited when tagsAreInherited=true. */
  tags: Array<Tag>;
  /** Flag to determine whether tags are inherited from parent campaign. */
  tagsAreInherited: Scalars['Boolean'];
  /** The targeting definition of this ad. */
  targetingDefinition?: Maybe<TargetingDefinition>;
  /** The targeting definition V2 of this campaign. */
  targetingDefinitionV2?: Maybe<TargetingDefinitionV2>;
  /** The targeting restrictions for this ad. */
  targetingRestrictions: Array<TargetingRestriction>;
  /** The targeting version used for this ad based on the parent campaign. */
  targetingVersion: TargetingVersion;
  /** The territory of the given ad. */
  territory: Territory;
  /** The weighting this ad holds as part of the campaign it belongs to. */
  weighting?: Maybe<Scalars['NonNegativeInt']>;
};


export type AdLegacyCreativeImagesArgs = {
  filter?: InputMaybe<CreativeFilterLegacy>;
};

export type AdLegacyConnection = {
  __typename?: 'AdLegacyConnection';
  edges: Array<Maybe<AdEdge>>;
  pageInfo: PageInfo;
};

export enum AdPosition {
  /** During inventory playing. */
  MidRoll = 'MID_ROLL',
  /** After inventory has finished playing. */
  PostRoll = 'POST_ROLL',
  /** Before inventory has started started. */
  PreRoll = 'PRE_ROLL'
}

export type AdPositionParam = AudienceParam & {
  __typename?: 'AdPositionParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** List of ad position units to target. */
  positions: Array<AdPositionUnit>;
};

export type AdPositionParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** List of ad position units to target. */
  positions: Array<AdPositionUnitAttributes>;
};

export type AdPositionUnit = {
  __typename?: 'AdPositionUnit';
  /** Mid-roll positions in inventory to play the add. */
  midRollPositions: Array<Scalars['NonNegativeInt']>;
  /** The position in inventory to play the add. */
  position: AdPosition;
};

export type AdPositionUnitAttributes = {
  /** Mid-roll positions in inventory to play the add. */
  midRollPositions?: InputMaybe<Array<Scalars['NonNegativeInt']>>;
  /** The position in inventory to play the add. */
  position: AdPosition;
};

export type AdRequestEnrichment = {
  __typename?: 'AdRequestEnrichment';
  customKvps: Array<CustomKvp>;
  parameters: Array<AudienceParameter>;
};

export type AdRequestEnrichmentAttributes = {
  customKvps?: InputMaybe<Array<AdRequestEnrichmentCustomKvpAttribute>>;
  parameters?: InputMaybe<Array<AdRequestEnrichmentAudienceParameterAttribute>>;
};

export type AdRequestEnrichmentAudienceParameterAttribute = {
  type: AudienceParameterType;
  values: Array<Scalars['ID']>;
};

export type AdRequestEnrichmentCustomKvpAttribute = {
  key: Scalars['String'];
  override: Scalars['Boolean'];
  value: Scalars['String'];
};

export type AdRequestKvp = {
  __typename?: 'AdRequestKvp';
  key: Scalars['String'];
  override: Scalars['Boolean'];
  value: Scalars['String'];
};

export enum AdStatus {
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Live = 'LIVE',
  Paused = 'PAUSED',
  Ready = 'READY'
}

export enum AdStatusLegacy {
  /** Ad has finished. */
  Completed = 'COMPLETED',
  /** The status of the ad once deleted. */
  Deleted = 'DELETED',
  /** Ad is disabled. */
  Disabled = 'DISABLED',
  /** The default value when the ad is first created. */
  Draft = 'DRAFT',
  /** Ad is live. */
  Live = 'LIVE',
  /** Ad is paused. */
  Paused = 'PAUSED',
  /** Ad is ready to go live. */
  Ready = 'READY'
}

export enum AdType {
  Placeholder = 'PLACEHOLDER',
  Standard = 'STANDARD'
}

export enum AdUpdateStatus {
  Disabled = 'DISABLED',
  Paused = 'PAUSED',
  Ready = 'READY'
}

export enum AddedValueType {
  Compensation = 'COMPENSATION',
  Incentive = 'INCENTIVE',
  ValuePot = 'VALUE_POT'
}

export type AddedValueTypeInfo = {
  __typename?: 'AddedValueTypeInfo';
  displayName: Scalars['String'];
  type: AddedValueType;
};

export type Advertiser = Node & {
  __typename?: 'Advertiser';
  /** The separation value in seconds for ads within this advertiser. */
  adSeparation?: Maybe<Scalars['NonNegativeFloat']>;
  /** The parent agency to which this advertiser belongs. */
  agency?: Maybe<Agency>;
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** The audio creatives used in this advertiser.  */
  creativeAudios: Array<CreativeAudioLegacy>;
  /** The image creatives used in this advertiser.  */
  creativeImages: Array<CreativeImageLegacy>;
  /** The redirect creatives used in this advertiser.  */
  creativeRedirects: Array<CreativeRedirectLegacy>;
  /** The list of domains that the advertiser owns. */
  domains: Array<Scalars['DomainName']>;
  /** The external identifier of the advertiser. */
  externalId?: Maybe<Scalars['String']>;
  /** The external system identifier of the advertiser. */
  externalSystemId?: Maybe<Scalars['String']>;
  /** The list of IAB categories for this advertiser. */
  iabCategories: Array<IabCategory>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The name of the advertiser. */
  name?: Maybe<Scalars['String']>;
  /** The list of orders created by this advertiser. */
  orders: Array<Order>;
  /** The status of the given advertiser. */
  status?: Maybe<AdvertiserStatus>;
  /** The territory of the given advertiser. */
  territory: Territory;
};


export type AdvertiserCreativeAudiosArgs = {
  filter?: InputMaybe<CreativeFilterLegacy>;
};


export type AdvertiserCreativeImagesArgs = {
  filter?: InputMaybe<CreativeFilterLegacy>;
};


export type AdvertiserOrdersArgs = {
  filter?: InputMaybe<OrderFilter>;
};

export type AdvertiserAttributes = {
  /** The separation value in seconds for ads within this advertiser. */
  adSeparation?: InputMaybe<Scalars['NonNegativeFloat']>;
  /** The list of domains that the advertiser owns. */
  domains?: InputMaybe<Array<Scalars['DomainName']>>;
  /** The external identifier of the advertiser. */
  externalId?: InputMaybe<Scalars['String']>;
  /** The external system identifier of the advertiser. */
  externalSystemId?: InputMaybe<Scalars['String']>;
  /** The list of IAB category codes that are attached to this advertiser. */
  iabCategoryCodes?: InputMaybe<Array<Scalars['ID']>>;
  /** The name of the advertiser. */
  name?: InputMaybe<Scalars['String']>;
  /** The status of the given advertiser. */
  status?: InputMaybe<AdvertiserStatus>;
  /** The territory of the given advertiser. */
  territory?: InputMaybe<Territory>;
};

export type AdvertiserConnection = {
  __typename?: 'AdvertiserConnection';
  edges: Array<Maybe<AdvertiserEdge>>;
  pageInfo: PageInfo;
};

export type AdvertiserEdge = {
  __typename?: 'AdvertiserEdge';
  cursor: Scalars['String'];
  node: Advertiser;
};

export type AdvertiserFilter = {
  status_in?: InputMaybe<Array<AdvertiserStatus>>;
};

export enum AdvertiserStatus {
  /** The status of the advertiser once deleted. */
  Deleted = 'DELETED',
  /** Advertiser is disabled. */
  Disabled = 'DISABLED',
  /** The default value when the advertiser is first created. */
  Draft = 'DRAFT',
  /** Advertiser is enabled. */
  Enabled = 'ENABLED'
}

export type AgeParam = AudienceParam & {
  __typename?: 'AgeParam';
  ageRange: AgeRange;
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
};

export type AgeParamAttributes = {
  /** The age range this audience param targets. */
  ageRange: AgeRangeAttributes;
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
};

export type AgeRange = {
  __typename?: 'AgeRange';
  /** The upper bound age of the targeted audience in the selected range. */
  maxAge: Scalars['NonNegativeInt'];
  /** The lower bound age of the targeted audience in the selected range. */
  minAge: Scalars['NonNegativeInt'];
};

export type AgeRangeAttributes = {
  /** The upper bound age of the targeted audience in the selected range. */
  maxAge: Scalars['NonNegativeInt'];
  /** The lower bound age of the targeted audience in the selected range. */
  minAge: Scalars['NonNegativeInt'];
};

export type Agency = Node & {
  __typename?: 'Agency';
  /** The list of advertisers that are part of this agency. */
  advertisers: Array<Advertiser>;
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** The business ID of the given business. */
  businessId?: Maybe<Scalars['String']>;
  /** The commission of the given agency. */
  commission?: Maybe<Scalars['BigDecimal']>;
  /** The alt ID prefixed with AG-, used for DAX 2.0. */
  entityId: Scalars['ID'];
  /** The external identifier of the agency. */
  externalId?: Maybe<Scalars['String']>;
  /** The external system identifier of the agency. */
  externalSystemId?: Maybe<Scalars['String']>;
  /**
   * The entity identifier as an UUID string.
   * @deprecated Legacy UUID no longer used in DAX 2.0
   */
  id: Scalars['ID'];
  /** The name of the agency. */
  name?: Maybe<Scalars['String']>;
  /** The list of sales channels created by this agency. */
  salesChannels: Array<SalesChannelLegacy>;
  /** The status of the given agency. */
  status: AgencyStatus;
  /** The territory of the given agency. */
  territory: Territory;
};


export type AgencyAdvertisersArgs = {
  filter?: InputMaybe<AdvertiserFilter>;
};


export type AgencySalesChannelsArgs = {
  filter?: InputMaybe<SalesChannelLegacyFilter>;
};

export type AgencyAttributes = {
  commission?: InputMaybe<Scalars['BigDecimal']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSystemId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  status: AgencyStatus;
  territory: Territory;
};

export type AgencyAttributesLegacy = {
  /** The external identifier of the agency. */
  externalId?: InputMaybe<Scalars['String']>;
  /** The external system identifier of the agency. */
  externalSystemId?: InputMaybe<Scalars['String']>;
  /** The name of the agency. */
  name?: InputMaybe<Scalars['String']>;
  /** The status of the given agency. */
  status?: InputMaybe<AgencyStatus>;
  /** The territory of the given agency. */
  territory?: InputMaybe<Territory>;
};

export type AgencyConnection = {
  __typename?: 'AgencyConnection';
  edges: Array<Maybe<AgencyEdge>>;
  pageInfo: PageInfo;
};

export type AgencyEdge = {
  __typename?: 'AgencyEdge';
  cursor: Scalars['String'];
  node: Agency;
};

export type AgencyFilter = {
  status_in?: InputMaybe<Array<AgencyStatus>>;
};

export type AgencyOffsetPaginationResponse = {
  __typename?: 'AgencyOffsetPaginationResponse';
  agencies?: Maybe<Array<Maybe<Agency>>>;
  pageMetaData?: Maybe<PageMetaData>;
};

export enum AgencyStatus {
  /** The status of the agency once deleted. */
  Deleted = 'DELETED',
  /** Agency is disabled. */
  Disabled = 'DISABLED',
  /** The default value when the agency is first created. */
  Draft = 'DRAFT',
  /** Agency is enabled. */
  Enabled = 'ENABLED'
}

export type AmendApprovalRequest = Note & {
  __typename?: 'AmendApprovalRequest';
  author: User;
  createdDate: Scalars['LocalDateTime'];
  id: Scalars['ID'];
  modifiedDate: Scalars['LocalDateTime'];
  noteType: NoteType;
  orderLineId: Scalars['String'];
  text: Scalars['String'];
};

export type AmendApprovalRequestAttributes = {
  text: Scalars['String'];
};

export enum ApprovalStatus {
  /** The status of the programmatic creative once approved. */
  Approved = 'APPROVED',
  /** The creative is blocked and should not be exposed to clients. */
  Blocked = 'BLOCKED',
  /** The programmatic creative is awaiting manual approval. */
  BlockedAwaitingQa = 'BLOCKED_AWAITING_QA',
  /** The created status has come from a trusted source */
  LiveAwaitingQa = 'LIVE_AWAITING_QA'
}

export type AssetUrl = {
  __typename?: 'AssetUrl';
  expirationDate: Scalars['LocalDateTime'];
  preSignedUrl: Scalars['Url'];
  url: Scalars['Url'];
};

export enum AuctionType {
  /** The default value if not specified. */
  AuctionTypeUnspecified = 'AUCTION_TYPE_UNSPECIFIED',
  /** The highest price wins the bid. */
  FirstPrice = 'FIRST_PRICE',
  /** The price is fixed for bid. */
  FixedPrice = 'FIXED_PRICE',
  /** The second highest price wins the bid. */
  SecondPrice = 'SECOND_PRICE'
}

export enum AudienceDataType {
  Behavioural = 'BEHAVIOURAL',
  Contextual = 'CONTEXTUAL',
  Demographics = 'DEMOGRAPHICS'
}

export type AudienceDataTypeInfo = {
  __typename?: 'AudienceDataTypeInfo';
  audienceDataType: AudienceDataType;
  dataSourcesInfo: Array<DataSourceInfo>;
  description: Scalars['String'];
  displayName: Scalars['String'];
};

export type AudienceGroup = TargetingV2ParameterGroup & {
  __typename?: 'AudienceGroup';
  /** Audience parameters are AND concatenated */
  parameters: Array<AudienceParameter>;
};

export type AudienceGroupAttributes = {
  /** Audience parameters are AND concatenated */
  parameters: Array<AudienceParameterAttributes>;
};

/** Generic interface type for querying all targeting audience parameter types. */
export type AudienceParam = {
  clusivity: Clusivity;
};

export type AudienceParamAttributes = {
  /** The ad position params associated with this audience param group. */
  adPositionParams?: InputMaybe<Array<AdPositionParamAttributes>>;
  /** The age range params associated with this audience param group. */
  ageParams?: InputMaybe<Array<AgeParamAttributes>>;
  /**  The audience segments associated with this audience param group. */
  audienceSegmentParams?: InputMaybe<Array<AudienceSegmentParamAttributes>>;
  /** The browser language params associate with this audience param group. */
  browserLanguageParams?: InputMaybe<Array<BrowserLanguageParamAttributes>>;
  /** The complex kvp params associated with this audience param group. */
  complexKvpParams?: InputMaybe<Array<ComplexKvpParamAttributes>>;
  /** The connection types to target on. */
  connectionTypeParams?: InputMaybe<Array<ConnectionTypeParamAttributes>>;
  /** The country params associated with this audience param group. */
  countryParams?: InputMaybe<Array<CountryParamAttributes>>;
  /** The day and time params associated with this audience param group. */
  dayAndTimeParams?: InputMaybe<Array<DayAndTimeParamAttributes>>;
  /** The device maker params associated with this audience param group. */
  deviceMakerParams?: InputMaybe<Array<DeviceMakerParamAttributes>>;
  /** The device operating system params associated with this audience param group. */
  deviceOperatingSystemParams?: InputMaybe<Array<DeviceOperatingSystemParamAttributes>>;
  /** The device type params associated with this audience param group. */
  deviceTypeParams?: InputMaybe<Array<DeviceTypeParamAttributes>>;
  /**  The dmas associated with this audience param group. */
  dmaParams?: InputMaybe<Array<DmaParamAttributes>>;
  /** The DMP segment params associated with this audience param group. */
  dmpSegmentParams?: InputMaybe<Array<DmpSegmentParamAttributes>>;
  /** The gender params associated with this audience param group. */
  genderParams?: InputMaybe<Array<GenderParamAttributes>>;
  /** The genre params associate with this audience param group. */
  genreParams?: InputMaybe<Array<GenreParamAttributes>>;
  /** The isp params associated with this audience param group. */
  ispParams?: InputMaybe<Array<IspsParamAttributes>>;
  /** The itunes category params associate with this audience param group. */
  itunesCategoryParams?: InputMaybe<Array<ItunesCategoryParamAttributes>>;
  /** The key value params associated with this audience param group. */
  keyValueGroupParams?: InputMaybe<Array<KeyValueGroupParamAttributes>>;
  /** The location params associated with this audience param group. */
  locationParams?: InputMaybe<Array<LocationParamAttributes>>;
  /** The podcast params assosciated with this audience param group. */
  podcastParams?: InputMaybe<Array<PodcastParamAttributes>>;
  /** The postal code params associated with this audience param group. */
  postalCodeParams?: InputMaybe<Array<PostalCodeParamAttributes>>;
};

export type AudienceParameter = TargetingV2Parameter & {
  __typename?: 'AudienceParameter';
  clusivity: Clusivity;
  enabledDataSources?: Maybe<Array<Scalars['String']>>;
  enabledGrades?: Maybe<Array<TargetingGrade>>;
  type: AudienceParameterType;
  values: Array<AudienceParameterValue>;
};

export type AudienceParameterAttributes = {
  clusivity: Clusivity;
  enabledDataSources?: InputMaybe<Array<Scalars['String']>>;
  enabledGrades?: InputMaybe<Array<TargetingGrade>>;
  type: AudienceParameterType;
  values: Array<AudienceParameterValueAttribute>;
};

export type AudienceParameterInfo = TargetingV2ParameterInfo & {
  __typename?: 'AudienceParameterInfo';
  audienceDataTypes: Array<AudienceDataTypeInfo>;
  cardinality: Cardinality;
  name: Scalars['String'];
  type: AudienceParameterType;
};

export enum AudienceParameterType {
  Age = 'AGE',
  Gender = 'GENDER',
  Income = 'INCOME',
  Interest = 'INTEREST'
}

export type AudienceParameterValue = TargetingV2ParameterValue & {
  __typename?: 'AudienceParameterValue';
  /** Whether this value is currently available for targeting */
  active: Scalars['Boolean'];
  activeDataSources?: Maybe<Array<Scalars['String']>>;
  activeGrades?: Maybe<Array<TargetingGrade>>;
  children: Array<Maybe<AudienceParameterValue>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parents: Array<Maybe<AudienceParameterValue>>;
};

export type AudienceParameterValueAttribute = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type AudienceSegment = {
  __typename?: 'AudienceSegment';
  /** The optional Cohort segment attached to this audience */
  cohortSegment?: Maybe<CohortSegment>;
  /** The name of this audience */
  displayName: Scalars['String'];
  /** The segment identifier. */
  id: Scalars['Int'];
  /** Mandatory Nielsen segment for this audience */
  nielsenSegment: NielsenSegment;
};

export type AudienceSegmentAttributes = {
  /** The segment id. */
  id: Scalars['ID'];
};

export type AudienceSegmentParam = AudienceParam & {
  __typename?: 'AudienceSegmentParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** List of audience segments to target. */
  segments: Array<AudienceSegment>;
};

export type AudienceSegmentParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of segments of the targeted audience. */
  segments: Array<AudienceSegmentAttributes>;
};

export type AudienceTargeting = {
  __typename?: 'AudienceTargeting';
  /** Audiences are OR concatenated */
  audiences?: Maybe<Array<AudienceGroup>>;
};

export type AudienceTargetingAttributes = {
  /** Audiences are OR concatenated */
  audiences: Array<AudienceGroupAttributes>;
};

/** The type of the change that was audited. */
export enum AuditChangeType {
  /** The entity was automatically transitioned. */
  AutomaticTransition = 'AUTOMATIC_TRANSITION',
  /** The entity was created. */
  Create = 'CREATE',
  /** The entity was deleted. */
  Delete = 'DELETE',
  /** The entity was updated. */
  Update = 'UPDATE'
}

export type AuditTrail = {
  __typename?: 'AuditTrail';
  /** What type of change was audited. */
  changeType?: Maybe<AuditChangeType>;
  /** When did the change occur. */
  changedAt?: Maybe<Scalars['LocalDateTime']>;
  /** Who authored the change. */
  changedBy?: Maybe<User>;
  /** Who was the assumed user during the change. */
  changedByAssumed?: Maybe<User>;
  /** What is the ID of the audited entity (useful when auditing by user). */
  entityId?: Maybe<Scalars['ID']>;
  /** What is the type of the entity (useful when auditing by user). */
  entityType?: Maybe<Scalars['String']>;
};

export type AuditTrailEntityFilter = {
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type AuditTrailFilter = {
  entity?: InputMaybe<AuditTrailEntityFilter>;
  user?: InputMaybe<AuditTrailUserFilter>;
};

export type AuditTrailUserFilter = {
  id: Scalars['ID'];
};

export enum BarterType {
  CashAndTrade = 'CASH_AND_TRADE',
  CashOut = 'CASH_OUT'
}

export type BarterTypeInfo = {
  __typename?: 'BarterTypeInfo';
  barterType: BarterType;
  defaultCashValue: Scalars['Int'];
  defaultTradeValue?: Maybe<Scalars['Int']>;
  displayName: Scalars['String'];
};

export type BillableCpmAttributes = {
  billableCpm: Scalars['BigDecimal'];
  billableCpmChangeReason: BillableCpmChangeReasonType;
};

export type BillableCpmChangeReasonInfo = {
  __typename?: 'BillableCpmChangeReasonInfo';
  displayName: Scalars['String'];
  type: BillableCpmChangeReasonType;
};

export enum BillableCpmChangeReasonType {
  AgencyRate = 'AGENCY_RATE',
  Barter = 'BARTER',
  Compensation = 'COMPENSATION',
  Deferred = 'DEFERRED',
  Filler = 'FILLER',
  Incentive = 'INCENTIVE',
  Mistake = 'MISTAKE',
  Promotion = 'PROMOTION',
  Testing = 'TESTING',
  Unsold = 'UNSOLD',
  ValuePot = 'VALUE_POT',
  VolumeRate = 'VOLUME_RATE'
}

export type BillingLine = {
  __typename?: 'BillingLine';
  addedValueType?: Maybe<AddedValueType>;
  barterType?: Maybe<BarterType>;
  billingLineTypeInfo: BillingLineTypeInfo;
  billingType: BillingLineBillingType;
  cashValue?: Maybe<Scalars['BigDecimal']>;
  costs: Array<BillingLineCost>;
  creativeWriter?: Maybe<Scalars['String']>;
  endDate: Scalars['LocalDateTime'];
  entityType: EntityType;
  feeBreakdown: Array<PriceBreakdown>;
  id: Scalars['ID'];
  mediaType?: Maybe<MediaType>;
  name: Scalars['String'];
  proRata: Scalars['Boolean'];
  proposal: Proposal;
  proposalId: Scalars['ID'];
  startDate: Scalars['LocalDateTime'];
  status: BillingLineStatus;
  supply?: Maybe<InventoryParameterValue>;
  territory: Territory;
  thirdPartyDeliverableSupply?: Maybe<Scalars['String']>;
  timeZone: Scalars['ZoneId'];
  totalFee: Scalars['BigDecimal'];
  tradeValue?: Maybe<Scalars['BigDecimal']>;
};

export type BillingLineAttributes = {
  addedValueType?: InputMaybe<AddedValueType>;
  barter?: InputMaybe<BillingLineBarterAttributes>;
  billingLineType: BillingLineType;
  billingType: BillingLineBillingType;
  businessId?: InputMaybe<Scalars['String']>;
  costs?: InputMaybe<Array<BillingLineCostAttributes>>;
  creativeWriter?: InputMaybe<Scalars['String']>;
  dateRange: DateRangeAttributes;
  fee: BillingLinePriceAttributes;
  mediaType?: InputMaybe<MediaType>;
  name: Scalars['String'];
  supplyNodeId?: InputMaybe<Scalars['ID']>;
  territory: Territory;
  thirdPartyDeliverableSupply?: InputMaybe<Scalars['String']>;
  timeZone: Scalars['ZoneId'];
};

export type BillingLineBarterAttributes = {
  barterType: BarterType;
  cashValue: Scalars['BigDecimal'];
  tradeValue?: InputMaybe<Scalars['BigDecimal']>;
};

export enum BillingLineBillingType {
  AddedValue = 'ADDED_VALUE',
  Barter = 'BARTER',
  Contra = 'CONTRA',
  Deferred = 'DEFERRED',
  PartnerSold = 'PARTNER_SOLD',
  PrePaid = 'PRE_PAID',
  Sold = 'SOLD'
}

export type BillingLineBillingTypeInfo = {
  __typename?: 'BillingLineBillingTypeInfo';
  displayName: Scalars['String'];
  isBillable: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  type: BillingLineBillingType;
};

export type BillingLineCost = {
  __typename?: 'BillingLineCost';
  costBreakdown: Array<PriceBreakdown>;
  item: Scalars['String'];
  proRata: Scalars['Boolean'];
  supplier: Scalars['String'];
  totalCost: Scalars['BigDecimal'];
};

export type BillingLineCostAttributes = {
  costPrice: BillingLinePriceAttributes;
  item: Scalars['String'];
  supplier: Scalars['String'];
};

export enum BillingLineGroupType {
  CreativeFee = 'CREATIVE_FEE',
  Standard = 'STANDARD',
  SupplySelectable = 'SUPPLY_SELECTABLE',
  ThirdPartyDeliverable = 'THIRD_PARTY_DELIVERABLE'
}

export type BillingLinePriceAttributes = {
  breakdowns: Array<PriceBreakdownAttributes>;
  proRata: Scalars['Boolean'];
  total: Scalars['BigDecimal'];
};

export enum BillingLineStatus {
  Amending = 'AMENDING',
  AmendChangesRequired = 'AMEND_CHANGES_REQUIRED',
  AmendPendingApproval = 'AMEND_PENDING_APPROVAL',
  Booked = 'BOOKED',
  BookingApprovalRequired = 'BOOKING_APPROVAL_REQUIRED',
  BookingApproved = 'BOOKING_APPROVED',
  BookingChangesRequired = 'BOOKING_CHANGES_REQUIRED',
  BookingPendingApproval = 'BOOKING_PENDING_APPROVAL',
  Cancelled = 'CANCELLED',
  CreditApprovalRequired = 'CREDIT_APPROVAL_REQUIRED',
  Draft = 'DRAFT',
  InBasket = 'IN_BASKET',
  PendingCancellation = 'PENDING_CANCELLATION'
}

export enum BillingLineType {
  BrandedEpisode = 'BRANDED_EPISODE',
  CancellationCharge = 'CANCELLATION_CHARGE',
  CreativeFee = 'CREATIVE_FEE',
  FeedDrop = 'FEED_DROP',
  ProductPlacement = 'PRODUCT_PLACEMENT',
  ResearchCost = 'RESEARCH_COST',
  SocialBoostCosts = 'SOCIAL_BOOST_COSTS',
  SocialExtension = 'SOCIAL_EXTENSION',
  TalentCost = 'TALENT_COST',
  ThirdPartyDeliverableNonSpot = 'THIRD_PARTY_DELIVERABLE_NON_SPOT',
  ThirdPartyDeliverableSpot = 'THIRD_PARTY_DELIVERABLE_SPOT',
  Usage = 'USAGE',
  Vlog = 'VLOG'
}

export type BillingLineTypeInfo = {
  __typename?: 'BillingLineTypeInfo';
  billingLineType: BillingLineType;
  displayName: Scalars['String'];
  group: BillingLineGroupType;
  supportedMediaTypes?: Maybe<Array<MediaType>>;
};

export enum BillingType {
  /** The default value when the billing type is not set. */
  BillingTypeUnspecified = 'BILLING_TYPE_UNSPECIFIED',
  /** Are available to fill up time. Not billed and delivered only if ad break cannot be filled with sold ads. */
  Filler = 'FILLER',
  /** A normal campaign, which is billed. */
  Sold = 'SOLD',
  /** Audio pre-roll for an announcement. Needs to be delivered, but is not billed. */
  Unsold = 'UNSOLD'
}

export type BillingTypeBasedBookingValidation = BusinessBookingValidation & {
  __typename?: 'BillingTypeBasedBookingValidation';
  billingTypes?: Maybe<Array<FlightBillingType>>;
  enabled: Scalars['Boolean'];
  type: BookingValidationType;
};

export type BillingTypeBasedBookingValidationAttributes = {
  billingTypes?: InputMaybe<Array<FlightBillingType>>;
  enabled: Scalars['Boolean'];
  type: BookingValidationType;
};

export type BlockedKeyValueAttributes = {
  /** The key of the blcoked KVP. */
  key: Scalars['String'];
  /** The value of the param. */
  value: Scalars['String'];
};

export type BlockedKeyValues = {
  __typename?: 'BlockedKeyValues';
  /** The key to block values on. */
  key: Scalars['String'];
  /** The blocked values. */
  values: Array<Scalars['String']>;
};

export type BookingApprovalRequest = Note & {
  __typename?: 'BookingApprovalRequest';
  author: User;
  createdDate: Scalars['LocalDateTime'];
  id: Scalars['ID'];
  modifiedDate: Scalars['LocalDateTime'];
  noteType: NoteType;
  orderLineId: Scalars['String'];
  text: Scalars['String'];
};

export enum BookingValidationType {
  ForecastLikelyToDeliver = 'FORECAST_LIKELY_TO_DELIVER',
  GeoLocationTargetingLimitation = 'GEO_LOCATION_TARGETING_LIMITATION',
  MandatoryDiscountLimit = 'MANDATORY_DISCOUNT_LIMIT',
  MaximumNumberOfFlights = 'MAXIMUM_NUMBER_OF_FLIGHTS',
  MinimumNonSpotFlightValue = 'MINIMUM_NON_SPOT_FLIGHT_VALUE',
  MinimumOrderValue = 'MINIMUM_ORDER_VALUE',
  MinimumSpotFlightValue = 'MINIMUM_SPOT_FLIGHT_VALUE',
  NonSpotFlightsNotAllowedForLocalUsers = 'NON_SPOT_FLIGHTS_NOT_ALLOWED_FOR_LOCAL_USERS',
  OnlySupplyTargetingAllowedForNonSpotFlights = 'ONLY_SUPPLY_TARGETING_ALLOWED_FOR_NON_SPOT_FLIGHTS',
  OrderStartDateMinimumDaysRequired = 'ORDER_START_DATE_MINIMUM_DAYS_REQUIRED',
  SetBillingTypesNotAllowed = 'SET_BILLING_TYPES_NOT_ALLOWED',
  SupplyTargetingMustBeUsedForNonSpotFlights = 'SUPPLY_TARGETING_MUST_BE_USED_FOR_NON_SPOT_FLIGHTS',
  SupplyTargetingNotAllowedForSpotFlights = 'SUPPLY_TARGETING_NOT_ALLOWED_FOR_SPOT_FLIGHTS'
}

export type BookingValidationTypeInfo = {
  __typename?: 'BookingValidationTypeInfo';
  displayName: Scalars['String'];
  type: BookingValidationType;
};

export type Brand = {
  __typename?: 'Brand';
  adSeparation?: Maybe<Scalars['NonNegativeFloat']>;
  agency: Agency;
  businessId?: Maybe<Scalars['String']>;
  domains: Array<Scalars['DomainName']>;
  externalId?: Maybe<Scalars['String']>;
  externalSystemId?: Maybe<Scalars['String']>;
  iabCategories: Array<IabCategory>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  status: BrandStatus;
  team?: Maybe<Team>;
  territory: Territory;
};

export type BrandAttributes = {
  adSeparation?: InputMaybe<Scalars['NonNegativeFloat']>;
  domains: Array<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSystemId?: InputMaybe<Scalars['String']>;
  iabCategoryCodes: Array<Scalars['String']>;
  name: Scalars['String'];
  status: BrandStatus;
  teamId?: InputMaybe<Scalars['String']>;
  territory: Territory;
};

export type BrandFilter = {
  agencyIds?: InputMaybe<Array<Scalars['String']>>;
};

export type BrandOffsetPaginationResponse = {
  __typename?: 'BrandOffsetPaginationResponse';
  brands?: Maybe<Array<Brand>>;
  pageMetaData?: Maybe<PageMetaData>;
};

export enum BrandStatus {
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
  /** @deprecated Will be removed once the old JPA flow is removed */
  Draft = 'DRAFT',
  Enabled = 'ENABLED'
}

export type BreakdownEntry = {
  __typename?: 'BreakdownEntry';
  name: Scalars['String'];
  value: Scalars['Float'];
};

export type BreakdownPoint = {
  __typename?: 'BreakdownPoint';
  displayName: Scalars['String'];
  percentage: Scalars['Float'];
  value?: Maybe<Scalars['Float']>;
};

export type BrowserLanguage = {
  __typename?: 'BrowserLanguage';
  /** The language code. */
  code: Scalars['ID'];
  /** The description of the code. */
  description: Scalars['String'];
};

export type BrowserLanguageAttributes = {
  /** The browser language code */
  code: Scalars['ID'];
  /** The description of the langauge */
  description: Scalars['String'];
};

export type BrowserLanguageParam = AudienceParam & {
  __typename?: 'BrowserLanguageParam';
  /** The list of browser languages. */
  browserLanguages: Array<BrowserLanguage>;
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
};

export type BrowserLanguageParamAttributes = {
  /** The list of browser language codes. */
  browserLanguages: Array<BrowserLanguageAttributes>;
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
};

export type Business = {
  __typename?: 'Business';
  billingLineTypes: Array<BusinessBillingLineType>;
  boltOns: Array<BusinessBoltOn>;
  bookingValidations: Array<BusinessBookingValidation>;
  businessName: Scalars['String'];
  businessRules: Array<BusinessRuleModel>;
  createdDate?: Maybe<Scalars['LocalDateTime']>;
  currency?: Maybe<Scalars['Currency']>;
  defaultGeographicTargeting: DefaultGeographicTargeting;
  flightTypes: Array<BusinessFlightType>;
  hasPricingEngine: Scalars['Boolean'];
  id: Scalars['ID'];
  modifiedDate?: Maybe<Scalars['LocalDateTime']>;
  notifications: Array<BusinessNotification>;
  sharedReportingPartners: Array<BusinessReference>;
  status: BusinessStatus;
  targetingRestrictions: Array<BusinessTargetingRestriction>;
  timeZone?: Maybe<Scalars['ZoneId']>;
  validDomains?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BusinessAttributes = {
  billingLineTypes: Array<BusinessBillingLineTypeAttributes>;
  boltOns?: InputMaybe<Array<BusinessBoltOnAttributes>>;
  bookingValidations: BusinessBookingValidationAttributes;
  businessRules: BusinessRuleAttributes;
  currency?: InputMaybe<Scalars['Currency']>;
  defaultGeographicTargeting: DefaultGeographicTargeting;
  flightTypes: Array<BusinessFlightTypeAttributes>;
  name: Scalars['String'];
  notifications: Array<BusinessNotificationAttributes>;
  sharedReportingPartnerIds: Array<Scalars['ID']>;
  status: BusinessStatus;
  targetingRestrictions: Array<BusinessTargetingRestrictionAttributes>;
  timeZone?: InputMaybe<Scalars['ZoneId']>;
  validDomains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BusinessBillingLineType = {
  __typename?: 'BusinessBillingLineType';
  enabled: Scalars['Boolean'];
  type: BillingLineType;
};

export type BusinessBillingLineTypeAttributes = {
  enabled: Scalars['Boolean'];
  type: BillingLineType;
};

export type BusinessBoltOn = {
  __typename?: 'BusinessBoltOn';
  boltOn: FlightBoltOnType;
  enabled: Scalars['Boolean'];
};

export type BusinessBoltOnAttributes = {
  boltOn: FlightBoltOnType;
  enabled: Scalars['Boolean'];
};

export type BusinessBookingValidation = {
  enabled: Scalars['Boolean'];
  type: BookingValidationType;
};

export type BusinessBookingValidationAttributes = {
  billingTypeBasedValidations?: InputMaybe<Array<BillingTypeBasedBookingValidationAttributes>>;
  countryBasedValidations?: InputMaybe<Array<CountryBasedBookingValidationAttributes>>;
  flagBasedValidations?: InputMaybe<Array<FlagBasedBookingValidationAttributes>>;
  numberBasedValidations?: InputMaybe<Array<NumberBasedBookingValidationAttributes>>;
};

export type BusinessFlightType = {
  __typename?: 'BusinessFlightType';
  enabled: Scalars['Boolean'];
  type: FlightType;
};

export type BusinessFlightTypeAttributes = {
  enabled: Scalars['Boolean'];
  type: FlightType;
};

export type BusinessNotification = {
  __typename?: 'BusinessNotification';
  enabled: Scalars['Boolean'];
  recipientEmailAddress?: Maybe<Scalars['String']>;
  type: NotificationType;
};

export type BusinessNotificationAttributes = {
  enabled: Scalars['Boolean'];
  recipientEmailAddress?: InputMaybe<Scalars['String']>;
  type: NotificationType;
};

export type BusinessOffsetPaginationResponse = {
  __typename?: 'BusinessOffsetPaginationResponse';
  businesses?: Maybe<Array<Business>>;
  pageMetaData?: Maybe<PageMetaData>;
};

export type BusinessReference = {
  __typename?: 'BusinessReference';
  businessName: Scalars['String'];
  id: Scalars['ID'];
  validDomains: Array<Scalars['String']>;
};

export type BusinessRoleConfiguration = {
  __typename?: 'BusinessRoleConfiguration';
  externalUsersPermissions: Array<PermissionV2Info>;
  permissionCategories: Array<PermissionV2Category>;
  standardRoles: Array<Role>;
};

export enum BusinessRule {
  ApprovalRequiredForLateChanges = 'APPROVAL_REQUIRED_FOR_LATE_CHANGES',
  BudgetCannotBeLessThanSpend = 'BUDGET_CANNOT_BE_LESS_THAN_SPEND',
  CancellationRequiresMinimumNotice = 'CANCELLATION_REQUIRES_MINIMUM_NOTICE',
  CannotChangeStartDateIfInPast = 'CANNOT_CHANGE_START_DATE_IF_IN_PAST',
  ChangesToOrdersRequireApproval = 'CHANGES_TO_ORDERS_REQUIRE_APPROVAL',
  DatesCannotBeInThePast = 'DATES_CANNOT_BE_IN_THE_PAST'
}

export type BusinessRuleAttributes = {
  flagBasedRules: Array<FlagBasedBusinessRuleAttributes>;
  numberBasedRules: Array<NumberBasedBusinessRuleAttributes>;
};

export type BusinessRuleModel = {
  enabled: Scalars['Boolean'];
  type: BusinessRule;
};

export enum BusinessRuleType {
  Amend = 'AMEND',
  Cancellation = 'CANCELLATION'
}

export type BusinessRuleTypeInfo = {
  __typename?: 'BusinessRuleTypeInfo';
  displayName: Scalars['String'];
  rule: BusinessRule;
  ruleType: Scalars['String'];
};

export type BusinessSettingsAttributes = {
  billingLineTypes: Array<BusinessBillingLineTypeAttributes>;
  boltOns?: InputMaybe<Array<BusinessBoltOnAttributes>>;
  bookingValidations: BusinessBookingValidationAttributes;
  businessRules: BusinessRuleAttributes;
  flightTypes: Array<BusinessFlightTypeAttributes>;
  notifications: Array<BusinessNotificationAttributes>;
  targetingRestrictions: Array<BusinessTargetingRestrictionAttributes>;
};

export enum BusinessStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type BusinessTargetingGroup = {
  __typename?: 'BusinessTargetingGroup';
  businessId: Scalars['ID'];
  businessTargetingGroupId: Scalars['PositiveInt'];
  networks?: Maybe<Array<NetworkTargeting>>;
};

export type BusinessTargetingRestriction = {
  __typename?: 'BusinessTargetingRestriction';
  enabled: Scalars['Boolean'];
  targetingRestriction: TargetingRestriction;
};

export type BusinessTargetingRestrictionAttributes = {
  enabled: Scalars['Boolean'];
  targetingRestriction: TargetingRestriction;
};

export type BusinessUser = {
  __typename?: 'BusinessUser';
  additionalPermissions: Array<PermissionV2Info>;
  businessId: Scalars['ID'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  roles: Array<Role>;
  supplyLimitSelection?: Maybe<Array<InventoryParameterValue>>;
  teams: Array<Team>;
  type: UserV2Type;
  userId: Scalars['ID'];
};

export type BusinessUserCreateAttributes = {
  additionalPermissions?: InputMaybe<Array<PermissionV2>>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  roleIds: Array<Scalars['ID']>;
  supplyLimitSelection?: InputMaybe<Array<InventoryParameterValueAttribute>>;
  teamIds: Array<Scalars['ID']>;
};

export type BusinessUserPaginatedResponse = {
  __typename?: 'BusinessUserPaginatedResponse';
  businessUsers: Array<BusinessUser>;
  pageMetaData: PageMetaData;
};

export type BusinessUserProfile = {
  __typename?: 'BusinessUserProfile';
  businessId: Scalars['ID'];
  teams: Array<Team>;
};

export type BusinessUserUpdateAttributes = {
  additionalPermissions?: InputMaybe<Array<PermissionV2>>;
  roleIds: Array<Scalars['ID']>;
  supplyLimitSelection?: InputMaybe<Array<InventoryParameterValueAttribute>>;
  teamIds: Array<Scalars['ID']>;
};

export type CalculateCpmAttributes = {
  /** The UserType to calculate for. */
  boltOns?: InputMaybe<Array<FlightBoltOnType>>;
  /** The mandatory length of the creative in seconds. */
  creativeLengthInSeconds: Scalars['NonNegativeFloat'];
  /** The currency of the cpm */
  currency: Scalars['Currency'];
  /** The department ID used to determine department-based pricing. */
  departmentId?: InputMaybe<Scalars['ID']>;
  /** The type of the flight to calculate the CPM for. */
  flightType: FlightType;
  /** The locality of the flight to calculate for. */
  locality: Locality;
  /** The territory to consider for the calculation */
  territory: Territory;
};

export type CalculatePriceBreakdownAttributes = {
  dateRange: DateRangeAttributes;
  isBillable: Scalars['Boolean'];
  lockedBreakdowns?: InputMaybe<Array<PriceBreakdownAttributes>>;
  proRata: Scalars['Boolean'];
  timeZone: Scalars['ZoneId'];
  totalFee: Scalars['BigDecimal'];
};

export type CalculateTargetingNameAttributes = {
  boltOns?: InputMaybe<Array<FlightBoltOnType>>;
  flightType: FlightType;
  restrictions?: InputMaybe<Array<FlightRestrictionType>>;
  targeting: TargetingDefinitionV2Attributes;
};

export type Campaign = Node & {
  __typename?: 'Campaign';
  /** The list of ads belonging to this campaign. */
  ads: Array<AdLegacy>;
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** Whether this campaign is archived or not. */
  archived: Scalars['Boolean'];
  /** The billing type of the campaign. */
  billingType?: Maybe<BillingType>;
  /** The global click-through-rate for the campaign. */
  clickThroughRate?: Maybe<Scalars['NonNegativeFloat']>;
  /** The number of total companion impressions served so far. */
  companionImpressions?: Maybe<Scalars['NonNegativeInt']>;
  /** Campaign's CPM price. */
  cpm?: Maybe<Scalars['BigDecimal']>;
  /** The currency of the campaign (optionally inherited from the order). */
  currency?: Maybe<Scalars['Currency']>;
  /** The daily cap of impressions that the campaign wants to deliver. */
  dailyCap?: Maybe<Scalars['NonNegativeInt']>;
  /** The percentage value showing campaign delivery. */
  deliveryPace?: Maybe<Scalars['NonNegativeFloat']>;
  /** The end date and time of the campaign in ISO format. */
  endDate?: Maybe<Scalars['LocalDateTime']>;
  /** The percentage value showing campaign estimated completion. */
  estimatedCompletion?: Maybe<Scalars['NonNegativeFloat']>;
  /** The external identifier of the campaign. */
  externalId?: Maybe<Scalars['String']>;
  /** The external system of the campaign. */
  externalSystem?: Maybe<CampaignExternalSystem>;
  /** The 2.0 billing type of the campaign. */
  flightBillingType?: Maybe<FlightBillingType>;
  /** The 2.0 flight type for this campaign. */
  flightType?: Maybe<FlightType>;
  /** Determines the maximum number of impressions per listener. */
  frequencyCapCount?: Maybe<Scalars['NonNegativeInt']>;
  /** Determines the time unit which the frequency cap value represents a multiple of. */
  frequencyCapTimeUnit?: Maybe<FrequencyCapTimeUnit>;
  /** Determines the time period value for which to deliver the number of ad impressions. */
  frequencyCapValue?: Maybe<Scalars['NonNegativeInt']>;
  /** The list of IAB categories for this campaign. */
  iabCategories: Array<IabCategory>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The number of total impressions served so far. */
  impressions?: Maybe<Scalars['NonNegativeInt']>;
  /** The global listen-through-rate for the campaign. */
  ltr?: Maybe<Scalars['NonNegativeFloat']>;
  /** The name of the campaign. */
  name?: Maybe<Scalars['String']>;
  /** The total number of impressions that the campaign wants to deliver. */
  objective?: Maybe<Scalars['NonNegativeInt']>;
  /** Campaign's offset CPM (boost) price. */
  offsetCpm?: Maybe<Scalars['BigDecimal']>;
  /** The parent order to which this campaign belongs. */
  order?: Maybe<Order>;
  /** The owner of this campaign. */
  owner?: Maybe<User>;
  /** The owner name of the given campaign. */
  ownerName?: Maybe<Scalars['String']>;
  /** The pacing of the campaign means how quickly the impressions are delivered over the course of the campaign. */
  pacing?: Maybe<Pacing>;
  /** The priority of this campaign. */
  priority?: Maybe<Scalars['NonNegativeInt']>;
  /** The sanities attached to this campaign. */
  sanities: Array<Sanity>;
  /** The sponsorship revenue for the given campaign. */
  sponsorshipRevenue?: Maybe<Scalars['NonNegativeFloat']>;
  /** The start date and time of the campaign in ISO format. */
  startDate?: Maybe<Scalars['LocalDateTime']>;
  /** The status of the given campaign. */
  status?: Maybe<CampaignStatus>;
  /** The list of tags for this campaign. */
  tags: Array<Tag>;
  /** The targeting definition of this campaign. */
  targetingDefinition?: Maybe<TargetingDefinition>;
  /** The targeting definition V2 of this campaign. */
  targetingDefinitionV2?: Maybe<TargetingDefinitionV2>;
  /** The targeting restrictions for this campaign. */
  targetingRestrictions?: Maybe<Array<TargetingRestriction>>;
  /** The targeting version used for this campaign. */
  targetingVersion: TargetingVersion;
  /** The territory of the given campaign. */
  territory: Territory;
  /** All TimeSeries metrics associated with a campaign */
  timeSeries?: Maybe<CampaignTimeSeries>;
  /** The time zone where the campaign starts and ends in IANA format (e.g. Europe/London) */
  timeZone?: Maybe<Scalars['ZoneId']>;
};


export type CampaignAdsArgs = {
  adTypes?: InputMaybe<Array<AdType>>;
  filter?: InputMaybe<AdFilterLegacy>;
  territories: Array<Territory>;
};


export type CampaignTimeSeriesArgs = {
  params?: InputMaybe<TimeSeriesParams>;
};

export type CampaignAttributes = {
  /** Whether this campaign is archived or not. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** The billing type of the campaign. */
  billingType?: InputMaybe<BillingType>;
  /** Campaign's CPM price. */
  cpm?: InputMaybe<Scalars['BigDecimal']>;
  /** The currency of the campaign (optionally inherited from the order). */
  currency?: InputMaybe<Scalars['Currency']>;
  /** The daily cap of impressions that the campaign wants to deliver. */
  dailyCap?: InputMaybe<Scalars['NonNegativeInt']>;
  /** The end date and time of the campaign in ISO format. */
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  /** The external identifier of the campaign. */
  externalId?: InputMaybe<Scalars['String']>;
  /** The external system of the campaign. */
  externalSystem?: InputMaybe<CampaignExternalSystem>;
  /** Determines the maximum number of impressions per listener. */
  frequencyCapCount?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Determines the time unit which the frequency cap value represents a multiple of. */
  frequencyCapTimeUnit?: InputMaybe<FrequencyCapTimeUnit>;
  /** Determines the time period value for which to deliver the number of ad impressions. */
  frequencyCapValue?: InputMaybe<Scalars['NonNegativeInt']>;
  /** The list of IAB category codes that are attached to this campaign. */
  iabCategoryCodes?: InputMaybe<Array<Scalars['ID']>>;
  /** The name of the campaign. */
  name?: InputMaybe<Scalars['String']>;
  /** The total number of impressions that the campaign wants to deliver. */
  objective?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Campaign's offset CPM (boost) price. */
  offsetCpm?: InputMaybe<Scalars['BigDecimal']>;
  /** The ID of the owner of this campaign. */
  ownerId?: InputMaybe<Scalars['ID']>;
  /** The pacing of the campaign means how quickly the impressions are delivered over the course of the campaign. */
  pacing?: InputMaybe<Pacing>;
  /** The priority of this campaign. */
  priority?: InputMaybe<Scalars['NonNegativeInt']>;
  /** The sponsorship revenue for the given campaign. */
  sponsorshipRevenue?: InputMaybe<Scalars['NonNegativeFloat']>;
  /** The start date and time of the campaign in ISO format. */
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  /** The status of the given campaign. */
  status?: InputMaybe<CampaignStatus>;
  /** The list of tag ids that are attached to this campaign. */
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The targeting definition that is attached to this campaign. */
  targetingDefinition?: InputMaybe<TargetingDefinitionAttributes>;
  /** The targeting definition V2 of this campaign. */
  targetingDefinitionV2?: InputMaybe<TargetingDefinitionV2Attributes>;
  /** The targeting restrictions for this campaign. */
  targetingRestrictions?: InputMaybe<Array<TargetingRestriction>>;
  /** The targeting version */
  targetingVersion?: InputMaybe<TargetingVersion>;
  /**  The territory of the given campaign. */
  territory?: InputMaybe<Territory>;
  /** The time zone where the campaign starts and ends in IANA format (e.g. Europe/London) */
  timeZone?: InputMaybe<Scalars['ZoneId']>;
};

export type CampaignConnection = {
  __typename?: 'CampaignConnection';
  edges: Array<Maybe<CampaignEdge>>;
  pageInfo: PageInfo;
};

export type CampaignEdge = {
  __typename?: 'CampaignEdge';
  cursor: Scalars['String'];
  node: Campaign;
};

export enum CampaignExternalSystem {
  /** The default value when the external system is not set. */
  CampaignExternalSystemUnspecified = 'CAMPAIGN_EXTERNAL_SYSTEM_UNSPECIFIED',
  Dax = 'DAX'
}

export type CampaignFilter = {
  archived?: InputMaybe<Scalars['Boolean']>;
  campaignHealth?: InputMaybe<Array<SanityCode>>;
  endDateRange?: InputMaybe<DateRange>;
  /** Filters by match on user id for campaign owner. */
  owner_id?: InputMaybe<Scalars['String']>;
  pacing?: InputMaybe<Array<Pacing>>;
  partialAdvertiserName?: InputMaybe<Scalars['String']>;
  partialAltId?: InputMaybe<Scalars['String']>;
  partialClickThroughRate?: InputMaybe<Scalars['String']>;
  partialCompanionImpressions?: InputMaybe<Scalars['String']>;
  partialDeliveryPace?: InputMaybe<Scalars['String']>;
  partialEstimatedCompletion?: InputMaybe<Scalars['String']>;
  partialExternalId?: InputMaybe<Scalars['String']>;
  partialId?: InputMaybe<Scalars['String']>;
  partialImpressions?: InputMaybe<Scalars['String']>;
  partialListenThroughRate?: InputMaybe<Scalars['String']>;
  partialName?: InputMaybe<Scalars['String']>;
  partialObjective?: InputMaybe<Scalars['String']>;
  partialOwnerName?: InputMaybe<Scalars['String']>;
  startDateRange?: InputMaybe<DateRange>;
  status_in?: InputMaybe<Array<CampaignStatus>>;
};

export type CampaignOffsetPaginationResponse = {
  __typename?: 'CampaignOffsetPaginationResponse';
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  pageMetaData?: Maybe<PageMetaData>;
};

export enum CampaignOrderableField {
  AdvertiserName = 'ADVERTISER_NAME',
  AltId = 'ALT_ID',
  ClickThroughRate = 'CLICK_THROUGH_RATE',
  CompanionImpressions = 'COMPANION_IMPRESSIONS',
  DeliveryPace = 'DELIVERY_PACE',
  EndDate = 'END_DATE',
  EstimatedCompletion = 'ESTIMATED_COMPLETION',
  ExternalId = 'EXTERNAL_ID',
  Id = 'ID',
  Impressions = 'IMPRESSIONS',
  ListenThroughRate = 'LISTEN_THROUGH_RATE',
  Name = 'NAME',
  Objective = 'OBJECTIVE',
  OwnerName = 'OWNER_NAME',
  Pacing = 'PACING',
  StartDate = 'START_DATE',
  Status = 'STATUS'
}

export type CampaignOrdering = {
  direction?: InputMaybe<OrderingDirection>;
  orderableField?: InputMaybe<CampaignOrderableField>;
};

export enum CampaignStatus {
  /** Campaign has finished. */
  Completed = 'COMPLETED',
  /** The status of the campaign once deleted. */
  Deleted = 'DELETED',
  /** Campaign is disabled. */
  Disabled = 'DISABLED',
  /** The default value when the campaign is first created. */
  Draft = 'DRAFT',
  /** Campaign is live. */
  Live = 'LIVE',
  /** Campaign is paused. */
  Paused = 'PAUSED',
  /** Campaign is ready to go live. */
  Ready = 'READY'
}

export type CampaignTimeSeries = {
  __typename?: 'CampaignTimeSeries';
  impressions: TimeSeries;
  ltr: TimeSeries;
};

/** Whether something can occur once or multiple times */
export enum Cardinality {
  Many = 'MANY',
  One = 'ONE',
  OnePerClusivity = 'ONE_PER_CLUSIVITY'
}

export type ChangeRequest = Note & {
  __typename?: 'ChangeRequest';
  author: User;
  createdDate: Scalars['LocalDateTime'];
  id: Scalars['ID'];
  modifiedDate: Scalars['LocalDateTime'];
  noteType: NoteType;
  orderLineId: Scalars['String'];
  text: Scalars['String'];
};

export type ChangeRequestAttributes = {
  text: Scalars['String'];
};

export type Channel = {
  __typename?: 'Channel';
  audioAdsRequested: Scalars['Long'];
  audioImpressions: Scalars['Long'];
  channelType?: Maybe<ChannelType>;
  contentCategories: Array<ChannelContentCategory>;
  enforceTenSecondMultiples: Scalars['Boolean'];
  externalDealId?: Maybe<Scalars['String']>;
  floorCpm?: Maybe<Scalars['BigDecimal']>;
  id: Scalars['ID'];
  inventoryType: InventoryType;
  legacyId: Scalars['ID'];
  maxAdDuration?: Maybe<Scalars['Int']>;
  maxFilterableTrafficPercentage?: Maybe<Scalars['Int']>;
  minAdDuration?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  overrideConsentSignal: Scalars['Boolean'];
  publisher: Publisher;
  status: SupplyStatus;
  supportedAdLanguages: Array<Scalars['String']>;
  trafficAcceptancePercentage?: Maybe<Scalars['Int']>;
  vastVersion?: Maybe<VastVersion>;
};

export enum ChannelContentCategory {
  CreatedForChildren = 'CREATED_FOR_CHILDREN',
  General = 'GENERAL',
  Local = 'LOCAL'
}

export type ChannelContentCategoryInfo = {
  __typename?: 'ChannelContentCategoryInfo';
  displayName: Scalars['String'];
  type: ChannelContentCategory;
};

export type ChannelFilter = {
  publisherId?: InputMaybe<Scalars['ID']>;
};

export type ChannelInventoryTypeInfo = {
  __typename?: 'ChannelInventoryTypeInfo';
  displayName: Scalars['String'];
  type: InventoryType;
};

export type ChannelLegacy = Node & {
  __typename?: 'ChannelLegacy';
  /** The ad request enrichment information */
  adRequestEnrichment?: Maybe<AdRequestEnrichment>;
  /** Generated kvps meant for ad request enrichment */
  adRequestKvps: Array<AdRequestKvp>;
  /** The ad unit groups for this channel. */
  adUnitGroups?: Maybe<Array<Scalars['Int']>>;
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** Associated ads targeting this channel */
  associatedAds: Array<AdLegacy>;
  /** Associated deals targeting this channel */
  associatedDeals: Array<DealLegacy>;
  /** List of domains blacklisted for the channel. */
  blacklistedDomains: Array<Scalars['DomainName']>;
  /** List of IAB categories blacklisted for the channel. */
  blacklistedIabCategories: Array<IabCategory>;
  /** The blocked key values on this channel. */
  blockedKeyValues: Array<BlockedKeyValues>;
  /**
   * The default targeting group for this channel.
   * @deprecated use adRequestEnrichment instead.
   */
  defaultTargetingGroup?: Maybe<DefaultTargetingGroup>;
  /** The default transcode preset assigned to this channel. */
  defaultTranscodePreset?: Maybe<TranscodePreset>;
  /** The external ID of the deal used for supply-supply connections. */
  externalDealId?: Maybe<Scalars['String']>;
  /** The floor CPM for a channel; the minimum CPM required for the channel to be matched with a Deal. */
  floorCpm?: Maybe<Scalars['BigDecimal']>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** Whether this channel is inluded in the default inventory targeting. */
  includedInDefaultInventoryTargeting: Scalars['Boolean'];
  /** The inventory type of this channel */
  inventoryType: InventoryType;
  /**
   * Represents a combined ISO-639 language code and ISO-3166 country code (e.g. en-GB).
   * The language refers to the station language and the country refers to the originating country of content.
   */
  locale?: Maybe<Scalars['Locale']>;
  /** The maximum duration an Ad may have in order to be played on this channel. */
  maxAdDuration?: Maybe<Scalars['NonNegativeFloat']>;
  maxFilterableTraffic?: Maybe<Scalars['NonNegativeFloat']>;
  /** The minimum duration an Ad may have in order to be played on this channel. */
  minAdDuration?: Maybe<Scalars['NonNegativeFloat']>;
  /** The name of the channel. */
  name?: Maybe<Scalars['String']>;
  /** Boolean flag, if true no listener data will be passed in the request. */
  overrideConsentSignal?: Maybe<Scalars['Boolean']>;
  /** The parent publisher to which this channel belongs. */
  publisher?: Maybe<PublisherLegacy>;
  /** The list of shows associated with this channel through contractual data */
  shows: Array<ShowLegacy>;
  /** The status of the given channel. */
  status?: Maybe<ChannelStatus>;
  /** The targeting restrictions for this channel. */
  targetingRestrictions: Array<TargetingRestriction>;
  /** The list of territories assigned to the channel. */
  territories: Array<Territory>;
  /** TimeSeries for the Channel. */
  timeSeries?: Maybe<ChannelTimeSeries>;
  /** The time zone in which the content is hosted by the publisher in IANA format (e.g. Europe/London) */
  timeZone?: Maybe<Scalars['ZoneId']>;
  /** Percentage of traffic that is allowed for the channel. */
  trafficAcceptancePercentage?: Maybe<Scalars['NonNegativeFloat']>;
  /** The list of transcode presets assigned to this channel. */
  transcodePresets: Array<TranscodePreset>;
  /** Type of the channel consumed by the user. */
  type?: Maybe<ChannelType>;
  /** The VAST protocol version the SSP should respond with. */
  vastVersion?: Maybe<VastVersion>;
};


export type ChannelLegacyAssociatedAdsArgs = {
  adTypes?: InputMaybe<Array<AdType>>;
  filter?: InputMaybe<AdFilterLegacy>;
  territories: Array<Territory>;
};


export type ChannelLegacyAssociatedDealsArgs = {
  filter?: InputMaybe<DealLegacyFilter>;
  territories: Array<Territory>;
};


export type ChannelLegacyTimeSeriesArgs = {
  params?: InputMaybe<TimeSeriesParams>;
};

export type ChannelLegacyAttributes = {
  /** Data to enrich ad requests on this channel with. */
  adRequestEnrichment?: InputMaybe<AdRequestEnrichmentAttributes>;
  /** List of domains blacklisted for the channel. */
  blacklistedDomains?: InputMaybe<Array<Scalars['DomainName']>>;
  /** List of IAB categories blacklisted for the channel. */
  blacklistedIabCategoryCodes?: InputMaybe<Array<Scalars['ID']>>;
  /** Blocked key value pairs. */
  blockedKeyValues?: InputMaybe<Array<BlockedKeyValueAttributes>>;
  /**
   * The default targeting group for this channel.
   * @deprecated use adRequestEnrichment instead
   */
  defaultTargetingGroup?: InputMaybe<DefaultTargetingGroupAttributes>;
  /** The default transcode preset ID to be assigned to this channel. */
  defaultTranscodePresetId?: InputMaybe<Scalars['ID']>;
  /** The external ID of the deal used for supply-supply connections. */
  externalDealId?: InputMaybe<Scalars['String']>;
  /** The floor CPM for a channel; the minimum CPM required for the channel to be matched with a Deal. */
  floorCpm?: InputMaybe<Scalars['BigDecimal']>;
  /** Whether this channel is inluded in the default inventory targeting. */
  includedInDefaultInventoryTargeting?: InputMaybe<Scalars['Boolean']>;
  /** The inventory type of this channel */
  inventoryType?: InputMaybe<InventoryType>;
  /**
   * Represents a combined ISO-639 language code and ISO-3166 country code (e.g. en-GB).
   * The language refers to the station language and the country refers to the originating country of content.
   */
  locale?: InputMaybe<Scalars['Locale']>;
  /** The maximum duration in ms an Ad may have in order to be played on this channel. */
  maxAdDuration?: InputMaybe<Scalars['NonNegativeFloat']>;
  /** The minimum duration in ms an Ad may have in order to be played on this channel. */
  minAdDuration?: InputMaybe<Scalars['NonNegativeFloat']>;
  /** The name of the channel. */
  name?: InputMaybe<Scalars['String']>;
  /** Boolean flag, if true no listener data will be passed in the request. */
  overrideConsentSignal?: InputMaybe<Scalars['Boolean']>;
  /** The status of the given channel. */
  status?: InputMaybe<ChannelStatus>;
  /** The targeting restrictions for this channel. */
  targetingRestrictions?: InputMaybe<Array<TargetingRestriction>>;
  /** The list of territories assigned to the channel. */
  territories?: InputMaybe<Array<Territory>>;
  /** The time zone in which the content is hosted by the publisher in IANA format (e.g. Europe/London) */
  timeZone?: InputMaybe<Scalars['ZoneId']>;
  /** Percentage of traffic that is allowed for the channel. */
  trafficAcceptancePercentage?: InputMaybe<Scalars['NonNegativeFloat']>;
  /** The list of transcode preset IDs to be assigned to this channel. */
  transcodePresetIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Type of the channel consumed by the user. */
  type?: InputMaybe<ChannelType>;
  /** The VAST protocol version the SSP should respond with. */
  vastVersion?: InputMaybe<VastVersion>;
};

export type ChannelLegacyFilter = {
  status_in?: InputMaybe<Array<ChannelStatus>>;
};

export type ChannelOffsetPaginationResponse = {
  __typename?: 'ChannelOffsetPaginationResponse';
  channels: Array<Channel>;
  pageMetaData?: Maybe<PageMetaData>;
};

export enum ChannelStatus {
  /** The status of the channel once deleted. */
  Deleted = 'DELETED',
  /** Channel is disabled. */
  Disabled = 'DISABLED',
  /** The default value when the channel is first created. */
  Draft = 'DRAFT',
  /** Channel is enabled. */
  Enabled = 'ENABLED'
}

export type ChannelTargeting = {
  __typename?: 'ChannelTargeting';
  clusivity?: Maybe<Clusivity>;
  id: Scalars['String'];
  shows?: Maybe<Array<ShowTargeting>>;
};

export type ChannelTimeSeries = {
  __typename?: 'ChannelTimeSeries';
  impressions?: Maybe<TimeSeries>;
};

export enum ChannelType {
  /** The default value when the channel type is not set. */
  ChannelTypeUnspecified = 'CHANNEL_TYPE_UNSPECIFIED',
  /** Channel used for radio stations. */
  FmAm = 'FM_AM',
  /** Channel used for music services (e.g. SoundCloud). */
  Music = 'MUSIC',
  /** Channel used for podcasts. */
  Podcast = 'PODCAST'
}

export type ChannelTypeInfo = {
  __typename?: 'ChannelTypeInfo';
  displayName: Scalars['String'];
  type: ChannelType;
};

export type City = {
  __typename?: 'City';
  /** The name of the city. */
  name: Scalars['String'];
  /** The region code of the city. */
  regionCode?: Maybe<Scalars['String']>;
  /** The sub-region code of the city. */
  subRegionCode?: Maybe<Scalars['String']>;
};

export type CityAttributes = {
  /** The city name of the targeted audience. */
  name: Scalars['String'];
  /** The region code of the specified city. */
  regionCode?: InputMaybe<Scalars['String']>;
  /** The sub-region code of the specified city. */
  subRegionCode?: InputMaybe<Scalars['String']>;
};

export type CityParam = Subdivision & {
  __typename?: 'CityParam';
  /** The city name of the targeted audience. */
  name: Scalars['String'];
  /** The region code of the specified city. */
  regionCode?: Maybe<Scalars['String']>;
  /** The sub-region code of the specified city. */
  subRegionCode?: Maybe<Scalars['String']>;
};

export type CityResponse = {
  __typename?: 'CityResponse';
  /** The list of cities for this country. */
  cities: Array<City>;
  /** The ISO 3166-1 country code. */
  countryCode: Scalars['String'];
};

export enum Clusivity {
  /** Declares that the audience parameter type is exclusive of. */
  Exclude = 'EXCLUDE',
  /** Declares that the audience parameter type is inclusive of. */
  Include = 'INCLUDE'
}

export type CohortSegment = {
  __typename?: 'CohortSegment';
  /** The segment identifier. */
  id: Scalars['Int'];
};

export type CohortSegmentAttributes = {
  /** The segment id. */
  id: Scalars['ID'];
};

export type Comment = Note & {
  __typename?: 'Comment';
  author: User;
  createdDate: Scalars['LocalDateTime'];
  id: Scalars['ID'];
  modifiedDate: Scalars['LocalDateTime'];
  noteType: NoteType;
  orderLineId: Scalars['String'];
  text: Scalars['String'];
};

export type CommentAttributes = {
  text: Scalars['String'];
};

export type CompanionBanner = {
  __typename?: 'CompanionBanner';
  assetUrl: AssetUrl;
  fileName: Scalars['String'];
  id: Scalars['ID'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['String'];
  uploadedDate: Scalars['LocalDateTime'];
};

export type CompanionBannerAttributes = {
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['String'];
  url: Scalars['Url'];
};

export type CompanionBannerGroup = {
  __typename?: 'CompanionBannerGroup';
  clickThroughUrl: Scalars['Url'];
  companionBanners: Array<CompanionBanner>;
  trackingUrls: Array<TrackingUrl>;
};

export type CompanionBannerOverride = {
  __typename?: 'CompanionBannerOverride';
  clickThroughUrl: Scalars['Url'];
  trackingUrls: Array<TrackingUrl>;
};

export type CompanionBannerOverrideAttributes = {
  clickThroughUrl: Scalars['Url'];
  trackingUrls: Array<TrackingUrlAttributes>;
};

export type ComplexKvpParam = AudienceParam & {
  __typename?: 'ComplexKvpParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The complex KVP expression. */
  expression: Scalars['String'];
};

export type ComplexKvpParamAttributes = {
  clusivity: Clusivity;
  expression: Scalars['String'];
};

export enum ConnectionType {
  /** Listener is connected via cable or DSL. */
  CableOrDsl = 'CABLE_OR_DSL',
  /** Listener is connected via phone network. */
  Cellular = 'CELLULAR',
  /** Listener is connected via a direct corporate line. */
  Corporate = 'CORPORATE',
  /** Listener is connected via Dial-up connection. */
  Dialup = 'DIALUP'
}

export type ConnectionTypeParam = AudienceParam & {
  __typename?: 'ConnectionTypeParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** Connection Types to target. */
  connectionTypes: Array<ConnectionType>;
};

export type ConnectionTypeParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** Connection Types to target. */
  connectionTypes: Array<ConnectionType>;
};

export type Country = {
  __typename?: 'Country';
  /** The ISO 3166-1 country code. */
  code: Scalars['String'];
  /** The country name. */
  name: Scalars['String'];
};

export type CountryBasedBookingValidation = BusinessBookingValidation & {
  __typename?: 'CountryBasedBookingValidation';
  country?: Maybe<Country>;
  enabled: Scalars['Boolean'];
  type: BookingValidationType;
};

export type CountryBasedBookingValidationAttributes = {
  countryCode?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  type: BookingValidationType;
};

export type CountryGroup = {
  __typename?: 'CountryGroup';
  /** All country targeting included in the country group. */
  countries: Array<CountryGroupElement>;
  /** A description of this country group. */
  description?: Maybe<Scalars['String']>;
  /** The ID of this country group. */
  id: Scalars['ID'];
  /** The name of this country group. */
  name: Scalars['String'];
  /** The territory of this country group. */
  territory: Territory;
};

export type CountryGroupAttributes = {
  /** All country targeting in this group. */
  countries: Array<CountryGroupElementAttributes>;
  /** The description of this country group. */
  description?: InputMaybe<Scalars['String']>;
  /** The name of this country group. */
  name: Scalars['String'];
  /** The territory of this country group. */
  territory?: InputMaybe<Territory>;
};

export type CountryGroupElement = {
  __typename?: 'CountryGroupElement';
  /** The ISO 3166-1 country code of the targeted audience. */
  code: Scalars['String'];
  /** The country name of the targeted audience. */
  name: Scalars['String'];
  /** The list of subdivisions of the targeted audience. */
  subdivisions?: Maybe<Array<Subdivision>>;
};

export type CountryGroupElementAttributes = {
  /** The ISO 3166-1 country code of the targeted audience. */
  code: Scalars['String'];
  /** The country name of the targeted audience. */
  name: Scalars['String'];
  /** The list of regions of the targeted audience. */
  regions?: InputMaybe<Array<RegionAttributes>>;
};

export type CountryParam = AudienceParam & {
  __typename?: 'CountryParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The ISO 3166-1 country code of the targeted audience. */
  code?: Maybe<Scalars['String']>;
  /** The country groups assigned to this country param. */
  countryGroups: Array<CountryGroup>;
  /** The country name of the targeted audience. */
  name?: Maybe<Scalars['String']>;
  /** The list of subdivisions of the targeted audience. */
  subdivisions?: Maybe<Array<Subdivision>>;
};

export type CountryParamAttributes = {
  /** The list of cities of the targeted audience. */
  cities?: InputMaybe<Array<CityAttributes>>;
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The ISO 3166-1 country code of the targeted audience. */
  code?: InputMaybe<Scalars['String']>;
  /** The IDs of any country groups to attach to this param. */
  countryGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The country name of the targeted audience. */
  name?: InputMaybe<Scalars['String']>;
  /** The list of regions of the targeted audience. */
  regions?: InputMaybe<Array<RegionAttributes>>;
};

export type CreateAdAttributes = {
  creativeId: Scalars['ID'];
  dateRange: InheritableDateRangeAttributes;
  flightId: Scalars['ID'];
  targetingDefinitionId: Scalars['ID'];
  territory?: InputMaybe<Territory>;
  weight?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type CreateChannelAttributes = {
  channelType: ChannelType;
  contentCategories?: InputMaybe<Array<ChannelContentCategory>>;
  enforceTenSecondMultiples: Scalars['Boolean'];
  externalDealId?: InputMaybe<Scalars['String']>;
  floorCpm?: InputMaybe<Scalars['BigDecimal']>;
  inventoryType: InventoryType;
  maxAdDuration?: InputMaybe<Scalars['PositiveInt']>;
  maxFilterableTrafficPercentage: Scalars['NonNegativeInt'];
  minAdDuration?: InputMaybe<Scalars['PositiveInt']>;
  name: Scalars['String'];
  overrideConsentSignal: Scalars['Boolean'];
  publisherId: Scalars['ID'];
  supportedAdLanguages: Array<Scalars['String']>;
  trafficAcceptancePercentage: Scalars['NonNegativeInt'];
  vastVersion: VastVersion;
};

export type CreateCompanionBannerGroupAttributes = {
  clickThroughUrl: Scalars['Url'];
  companionBannerAttributes: Array<CompanionBannerAttributes>;
  trackingUrls: Array<TrackingUrlAttributes>;
};

export type CreateCreativeAttributes = {
  approvalStatus: CreativeApprovalStatus;
  companionBannerGroupAttributes?: InputMaybe<CreateCompanionBannerGroupAttributes>;
  creativeAudioAttributes?: InputMaybe<CreativeAudioAttributes>;
  creativeFileAttributes?: InputMaybe<Array<CreativeFileAttributes>>;
  creativeTagAttributes?: InputMaybe<CreativeTagAttributes>;
  name: Scalars['String'];
  territory?: InputMaybe<Territory>;
  timeZone: Scalars['ZoneId'];
};

export type CreateDaxIdTagAttributes = {
  attributes: DaxIdTagAttributes;
  brandId: Scalars['ID'];
  tagType: DaxIdTagType;
};

export type CreateDaxShowContractAttributes = {
  dateRange: DateRangeAttributes;
  notes?: InputMaybe<Scalars['String']>;
  publisherPaymentConfigs?: InputMaybe<Array<PublisherPaymentConfigAttributes>>;
  showId: Scalars['ID'];
};

export type CreateFlightAttributes = {
  flightAttributes: FlightAttributes;
  orderLineId: Scalars['ID'];
  proposedFlightId?: InputMaybe<Scalars['ID']>;
};

export type CreateNetworkAttributes = {
  name: Scalars['String'];
};

export type CreateProposedFlightAttributes = {
  flightType: FlightType;
  proposalId: Scalars['ID'];
  proposedFlightAttributes: ProposedFlightAttributes;
};

export type CreatePublisherAttributes = {
  /** The currency of the publisher. */
  currency?: InputMaybe<Scalars['Currency']>;
  /** The name of the publisher. */
  name?: InputMaybe<Scalars['String']>;
  /** The id of the network. */
  networkId: Scalars['ID'];
};

export type CreatePublisherContractAttributes = {
  dateRange: DateRangeAttributes;
  notes?: InputMaybe<Scalars['String']>;
  paymentConfigs?: InputMaybe<Array<PublisherContractPaymentConfigAttributes>>;
  publisherId: Scalars['ID'];
};

export type CreateShowAttributes = {
  adFormats: Array<AdFormatAttributes>;
  adPositions: Array<ShowAdPositionAttributes>;
  audienceParameters: Array<SupplyAudienceParameterAttributes>;
  blockedDomains: Array<Scalars['DomainName']>;
  blockedIabCategoryCodes: Array<Scalars['ID']>;
  channelId: Scalars['ID'];
  description: Scalars['String'];
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  hostNames: Scalars['String'];
  hostingPlatforms: Array<ShowHostingPlatformAttributes>;
  itunesCategoryIds: Array<Scalars['ID']>;
  name: Scalars['String'];
  startDate: Scalars['LocalDateTime'];
  supportAudio?: InputMaybe<Scalars['Boolean']>;
  supportSocial?: InputMaybe<Scalars['Boolean']>;
  supportVideo?: InputMaybe<Scalars['Boolean']>;
  weeklyReleaseFrequency: Scalars['PositiveInt'];
};

export type CreateSocialProposedFlightAttributes = {
  flightType: FlightType;
  proposalId: Scalars['ID'];
  proposedFlightAttributes: SocialProposedFlightAttributes;
};

export type CreateVideoProposedFlightAttributes = {
  flightType: FlightType;
  proposalId: Scalars['ID'];
  proposedFlightAttributes: VideoProposedFlightAttributes;
};

export type Creative = {
  __typename?: 'Creative';
  approvalStatus: CreativeApprovalStatus;
  brand: Brand;
  businessId?: Maybe<Scalars['ID']>;
  companionBannerGroup?: Maybe<CompanionBannerGroup>;
  createdDate?: Maybe<Scalars['LocalDateTime']>;
  creativeAudio?: Maybe<CreativeAudio>;
  creativeFiles: Array<CreativeFile>;
  creativeTag?: Maybe<CreativeTag>;
  id: Scalars['ID'];
  modifiedDate?: Maybe<Scalars['LocalDateTime']>;
  name: Scalars['String'];
  startDate?: Maybe<Scalars['LocalDateTime']>;
  territory: Territory;
  timeZone: Scalars['ZoneId'];
};

export enum CreativeApprovalStatus {
  Approved = 'APPROVED',
  Blocked = 'BLOCKED',
  BlockedAwaitingQa = 'BLOCKED_AWAITING_QA',
  LiveAwaitingQa = 'LIVE_AWAITING_QA'
}

export type CreativeAudio = {
  __typename?: 'CreativeAudio';
  assetUrl: AssetUrl;
  duration: Scalars['NonNegativeFloat'];
  fileName: Scalars['String'];
  id: Scalars['ID'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
  trackingUrls: Array<TrackingUrl>;
  uploadedDate: Scalars['LocalDateTime'];
};

export type CreativeAudioAttributes = {
  duration: Scalars['NonNegativeFloat'];
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
  trackingUrls: Array<TrackingUrlAttributes>;
  url: Scalars['Url'];
};

export type CreativeAudioCreateAttributesLegacy = {
  /** The duration of this creative in seconds. */
  duration?: InputMaybe<Scalars['NonNegativeFloat']>;
  /** The file name of the audio. */
  fileName?: InputMaybe<Scalars['String']>;
  /** The mime type of the audio. */
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** The status of the audio creative. */
  status?: InputMaybe<CreativeStatusLegacy>;
  /** The territory of the audio creative. */
  territory?: InputMaybe<Territory>;
  /** The list of tracking URLs for this audio creative. */
  trackingUrls?: InputMaybe<Array<TrackingUrlAttributes>>;
  /** The uploaded date of the asset */
  uploadedDate?: InputMaybe<Scalars['LocalDateTime']>;
  /** The location (URL) of the audio. */
  url?: InputMaybe<Scalars['Url']>;
};

export type CreativeAudioLegacy = CreativeLegacy & Node & {
  __typename?: 'CreativeAudioLegacy';
  /** The parent advertiser that created this audio creative. */
  advertiser?: Maybe<Advertiser>;
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** The duration of this creative in seconds. */
  duration?: Maybe<Scalars['NonNegativeFloat']>;
  /** The file name of the audio. */
  fileName?: Maybe<Scalars['String']>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The mime type of the image. */
  mimeType?: Maybe<Scalars['String']>;
  /** The name of the audio. */
  name?: Maybe<Scalars['String']>;
  /** Used to identify the resource (media file) for this creative. */
  resourceAltId: Scalars['Int'];
  /** The status of the audio creative. */
  status?: Maybe<CreativeStatusLegacy>;
  /** The territory of the audio creative. */
  territory: Territory;
  /** The list of tracking URLs for this audio creative. */
  trackingUrls: Array<TrackingUrl>;
  /** The uploaded date of the asset */
  uploadedDate?: Maybe<Scalars['LocalDateTime']>;
  /** The location (URL) of the audio. */
  url?: Maybe<Scalars['Url']>;
};

export type CreativeAudioUpdateAttributesLegacy = {
  /** The status of the image creative. */
  status?: InputMaybe<CreativeStatusLegacy>;
  /** The list of tracking URLs for this audio creative. */
  trackingUrls?: InputMaybe<Array<TrackingUrlAttributes>>;
};

export type CreativeEdge = {
  __typename?: 'CreativeEdge';
  cursor: Scalars['String'];
  node: CreativeLegacy;
};

export type CreativeFile = {
  __typename?: 'CreativeFile';
  assetUrl: AssetUrl;
  fileName: Scalars['String'];
  id: Scalars['ID'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
  uploadedDate: Scalars['LocalDateTime'];
};

export type CreativeFileAttributes = {
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
  url: Scalars['Url'];
};

export type CreativeFilter = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<CreativeApprovalStatus>>;
  types?: InputMaybe<Array<CreativeType>>;
};

export type CreativeFilterLegacy = {
  status_in?: InputMaybe<Array<CreativeStatusLegacy>>;
};

export type CreativeImageCreateAttributesLegacy = {
  /** The file name of the image. */
  fileName?: InputMaybe<Scalars['String']>;
  /** The landing page url of the image. */
  landingPageUrl?: InputMaybe<Scalars['Url']>;
  /** The mime type of the image. */
  mimeType?: InputMaybe<Scalars['String']>;
  /** The name of the image. */
  name?: InputMaybe<Scalars['String']>;
  /** The size of the image in pixels. */
  size?: InputMaybe<Scalars['String']>;
  /** The status of the image creative. */
  status?: InputMaybe<CreativeStatusLegacy>;
  /** The territory of the image creative. */
  territory?: InputMaybe<Territory>;
  /** The list of tracking URLs for this image creative. */
  trackingUrls?: InputMaybe<Array<TrackingUrlAttributes>>;
  /** The uploaded date of the asset */
  uploadedDate?: InputMaybe<Scalars['LocalDateTime']>;
  /** The location (URL) of the image. */
  url?: InputMaybe<Scalars['Url']>;
};

export type CreativeImageLegacy = CreativeLegacy & Node & {
  __typename?: 'CreativeImageLegacy';
  /** The parent advertiser that created this image creative. */
  advertiser?: Maybe<Advertiser>;
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** The file name of the image. */
  fileName?: Maybe<Scalars['String']>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The landing page url of the image. */
  landingPageUrl?: Maybe<Scalars['Url']>;
  /** The mime type of the image. */
  mimeType?: Maybe<Scalars['String']>;
  /** The name of the image. */
  name?: Maybe<Scalars['String']>;
  /** Used to identify the resource (image file) for this creative. */
  resourceAltId: Scalars['Int'];
  /** The size of the image in pixels. */
  size?: Maybe<Scalars['String']>;
  /** The status of the image creative. */
  status?: Maybe<CreativeStatusLegacy>;
  /** The territory of the image creative */
  territory: Territory;
  /** The list of tracking URLs for this image creative. */
  trackingUrls: Array<TrackingUrl>;
  /** The uploaded date of the asset */
  uploadedDate?: Maybe<Scalars['LocalDateTime']>;
  /** The location (URL) of the image. */
  url?: Maybe<Scalars['Url']>;
};

export type CreativeImageUpdateAttributesLegacy = {
  /** The landing page url of the image. */
  landingPageUrl?: InputMaybe<Scalars['Url']>;
  /** The status of the image creative. */
  status?: InputMaybe<CreativeStatusLegacy>;
  /** The list of tracking URLs for this image creative. */
  trackingUrls?: InputMaybe<Array<TrackingUrlAttributes>>;
};

/** Generic interface type for describing the creative. */
export type CreativeLegacy = {
  /** The parent advertiser that created this creative. */
  advertiser?: Maybe<Advertiser>;
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
};

export type CreativeLegacyConnection = {
  __typename?: 'CreativeLegacyConnection';
  edges: Array<Maybe<CreativeEdge>>;
  pageInfo: PageInfo;
};

export type CreativeOffsetPaginationResponse = {
  __typename?: 'CreativeOffsetPaginationResponse';
  creatives?: Maybe<Array<Maybe<Creative>>>;
  pageMetaData?: Maybe<PageMetaData>;
};

export enum CreativeOrderableField {
  ModifiedDate = 'MODIFIED_DATE',
  StartDate = 'START_DATE'
}

export type CreativeOverride = {
  __typename?: 'CreativeOverride';
  companionBannerOverride?: Maybe<CompanionBannerOverride>;
  creativeAudioTrackingUrls: Array<TrackingUrl>;
  creativeTagTrackingUrls: Array<TrackingUrl>;
};

export type CreativeOverrideAttributes = {
  companionBannerOverride?: InputMaybe<CompanionBannerOverrideAttributes>;
  creativeAudioTrackingUrls: Array<TrackingUrlAttributes>;
  creativeTagTrackingUrls: Array<TrackingUrlAttributes>;
};

export type CreativeProgrammaticAttributes = {
  /** The approval status of the programmatic creative. */
  status?: InputMaybe<ApprovalStatus>;
};

export type CreativeRedirectAttributesLegacy = {
  /** Consent vendor ID (for GDPR compliance). */
  consentVendorId?: InputMaybe<Scalars['NonNegativeInt']>;
  /** The territory of the redirect creative. */
  territory?: InputMaybe<Territory>;
  /** The list of tracking URLs for this redirect creative. */
  trackingUrls?: InputMaybe<Array<TrackingUrlAttributes>>;
  /** The VAST redirect URL. */
  url?: InputMaybe<Scalars['Url']>;
};

export type CreativeRedirectLegacy = CreativeLegacy & Node & {
  __typename?: 'CreativeRedirectLegacy';
  /** The parent advertiser that created this redirect creative. */
  advertiser?: Maybe<Advertiser>;
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** Consent vendor ID (for GDPR compliance). */
  consentVendorId?: Maybe<Scalars['NonNegativeInt']>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The status of the redirect creative. */
  status?: Maybe<CreativeStatusLegacy>;
  /** The territory of the redirect creative. */
  territory: Territory;
  /** The list of tracking URLs for this redirect creative. */
  trackingUrls: Array<TrackingUrl>;
  /** The VAST redirect URL. */
  url?: Maybe<Scalars['Url']>;
};

export enum CreativeStatusLegacy {
  /** The status of the creative once deleted. */
  Deleted = 'DELETED',
  /** Creative is disabled. */
  Disabled = 'DISABLED',
  /** The default value when the creative is first created. */
  Ready = 'READY'
}

export type CreativeTag = {
  __typename?: 'CreativeTag';
  consentVendorId?: Maybe<Scalars['NonNegativeInt']>;
  id: Scalars['ID'];
  trackingUrls: Array<TrackingUrl>;
  url: Scalars['Url'];
};

export type CreativeTagAttributes = {
  consentVendorId?: InputMaybe<Scalars['NonNegativeInt']>;
  trackingUrls: Array<TrackingUrlAttributes>;
  url: Scalars['Url'];
};

export enum CreativeType {
  Audio = 'AUDIO',
  Tag = 'TAG'
}

export enum CreativeTypeLegacy {
  /** An audio creative. */
  Audio = 'AUDIO',
  /** An image creative. */
  Image = 'IMAGE',
  /** A redirect creative. */
  Redirect = 'REDIRECT'
}

export type CurrencyRate = {
  __typename?: 'CurrencyRate';
  /** The currency to convert from. */
  from: Scalars['Currency'];
  /** The conversion rate. */
  rate: Scalars['BigDecimal'];
  /** The currency to convert to. */
  to: Scalars['Currency'];
};

export type CustomGroup = {
  __typename?: 'CustomGroup';
  parameters: Array<CustomParameter>;
};

export type CustomGroupAttributes = {
  parameters: Array<CustomParameterAttributes>;
};

export type CustomKvp = {
  __typename?: 'CustomKvp';
  key: Scalars['String'];
  override: Scalars['Boolean'];
  value: Scalars['String'];
};

export type CustomParameter = {
  __typename?: 'CustomParameter';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list custom key value pairs used for targeting. */
  customKvps: Array<KeyValue>;
};

export type CustomParameterAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of custom key value pairs used for targeting. */
  customKvps: Array<KeyValueAttributes>;
};

export type CustomTargeting = {
  __typename?: 'CustomTargeting';
  customGroups?: Maybe<Array<CustomGroup>>;
};

export type CustomTargetingAttributes = {
  customGroups: Array<CustomGroupAttributes>;
};

export type DataCenter = Node & {
  __typename?: 'DataCenter';
  bidUrl: Scalars['String'];
  entityState: EntityState;
  id: Scalars['ID'];
  maxQps?: Maybe<Scalars['NonNegativeInt']>;
  mediaType: MediaType;
  name: Scalars['String'];
  programmaticConnector: ProgrammaticConnector;
  region: Region;
  status: DataCenterStatus;
};

export type DataCenterAttributes = {
  bidUrl: Scalars['Url'];
  maxQps?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  region: Region;
};

export type DataCenterLegacy = Node & {
  __typename?: 'DataCenterLegacy';
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** The DSP end point to which a request is sent. */
  bidUrl?: Maybe<Scalars['Url']>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** Max number of queries per second. */
  maxQps?: Maybe<Scalars['NonNegativeInt']>;
  /** The name of the data center. */
  name?: Maybe<Scalars['String']>;
  /** The region code for the data center. */
  region?: Maybe<Region>;
  /** The status of the given data center. */
  status?: Maybe<DataCenterLegacyStatus>;
  /** The parent technical provider that created this Data Center. */
  technicalProvider?: Maybe<TechnicalProviderLegacy>;
};

export type DataCenterLegacyAttributes = {
  /** The DSP end point to which a request is sent. */
  bidUrl?: InputMaybe<Scalars['Url']>;
  /** Max number of queries per second. */
  maxQps?: InputMaybe<Scalars['NonNegativeInt']>;
  /** The name of the data center. */
  name?: InputMaybe<Scalars['String']>;
  /** The region code for the data center. */
  region?: InputMaybe<Region>;
  /** The status of the given data center. */
  status?: InputMaybe<DataCenterLegacyStatus>;
};

export type DataCenterLegacyFilter = {
  status_in?: InputMaybe<Array<DataCenterLegacyStatus>>;
};

export enum DataCenterLegacyStatus {
  /** Data center is active. */
  Active = 'ACTIVE',
  /** The status of the data center once deleted. */
  Deleted = 'DELETED',
  /** The default value when the data center is first created. */
  Draft = 'DRAFT',
  /** Data center is inactive. */
  Inactive = 'INACTIVE'
}

export type DataCenterMinimal = Node & {
  __typename?: 'DataCenterMinimal';
  id: Scalars['ID'];
  mediaType: MediaType;
  name: Scalars['String'];
  status: DataCenterStatus;
};

export enum DataCenterStatus {
  Disabled = 'DISABLED',
  DisabledInherited = 'DISABLED_INHERITED',
  Enabled = 'ENABLED'
}

export type DataSourceInfo = {
  __typename?: 'DataSourceInfo';
  dataSource: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  isDefault: Scalars['Boolean'];
  price: Scalars['BigDecimal'];
};

export type DateRange = {
  from?: InputMaybe<Scalars['LocalDateTime']>;
  to?: InputMaybe<Scalars['LocalDateTime']>;
};

export type DateRangeAttributes = {
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  startDate: Scalars['LocalDateTime'];
};

export type DaxIdTag = {
  __typename?: 'DaxIdTag';
  allowMultiplePurchases: Scalars['Boolean'];
  conversionCurrency?: Maybe<Scalars['Currency']>;
  conversionEvent?: Maybe<Scalars['String']>;
  conversionValue?: Maybe<Scalars['BigDecimal']>;
  id: Scalars['ID'];
  legacyClient?: Maybe<Scalars['String']>;
  legacyEvent?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: DaxIdTagStatus;
  tagType: DaxIdTagType;
  tagUrl?: Maybe<Scalars['String']>;
};

export type DaxIdTagAttributes = {
  allowMultiplePurchases: Scalars['Boolean'];
  conversionCurrency?: InputMaybe<Scalars['Currency']>;
  conversionEvent?: InputMaybe<Scalars['String']>;
  conversionValue?: InputMaybe<Scalars['BigDecimal']>;
  name: Scalars['String'];
};

export type DaxIdTagFilter = {
  brandId: Scalars['ID'];
};

export type DaxIdTagOffsetPaginationResponse = {
  __typename?: 'DaxIdTagOffsetPaginationResponse';
  daxIdTags?: Maybe<Array<DaxIdTag>>;
  pageMetaData: PageMetaData;
};

export enum DaxIdTagStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Inactive = 'INACTIVE'
}

export enum DaxIdTagType {
  Conversion = 'CONVERSION',
  Legacy = 'LEGACY',
  Site = 'SITE'
}

export type DaxShowContract = {
  __typename?: 'DaxShowContract';
  currency: Scalars['Currency'];
  endDate?: Maybe<Scalars['LocalDateTime']>;
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  publisherPaymentConfigs: Array<PublisherPaymentConfig>;
  show: Show;
  startDate: Scalars['LocalDateTime'];
  status: DaxShowContractStatus;
};

export enum DaxShowContractStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE'
}

export enum Day {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DayAndHourPoint = {
  __typename?: 'DayAndHourPoint';
  day: Day;
  hour: Scalars['Int'];
  value: Scalars['Float'];
};

export type DayAndTimeParam = AudienceParam & {
  __typename?: 'DayAndTimeParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of days of week and hours used for targeting. */
  daysOfWeek: Array<DayOfWeek>;
  /** The time zone that is going to be targed based on the selected date and time. */
  timeZone: TimeZoneTargeting;
};

export type DayAndTimeParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of days of week and hours used for targeting. */
  daysOfWeek: Array<DayOfWeekAttributes>;
  /** The time zone that is going to be targed based on the selected date and time. */
  timeZone: TimeZoneTargeting;
};

export type DayOfWeek = {
  __typename?: 'DayOfWeek';
  /** The day of the week. 'Other' means every other day that was not selected. */
  day: DayTargeting;
  /** The optional hours to be specified. */
  hours: Array<Scalars['NonNegativeInt']>;
};

export type DayOfWeekAttributes = {
  /** The day of the week. 'Other' means every other day that was not selected. */
  day: DayTargeting;
  /** The hours to be specified. */
  hours: Array<Scalars['NonNegativeInt']>;
};

export enum DayTargeting {
  Fri = 'FRI',
  Mon = 'MON',
  Other = 'OTHER',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED'
}

export type DayTimeTargeting = {
  __typename?: 'DayTimeTargeting';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of days of week and hours used for targeting. */
  daysOfWeek: Array<DayOfWeek>;
  /** The time zone that is going to be targed based on the selected date and time. */
  timeZone: TimeZoneTargeting;
};

export type DayTimeTargetingAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of days of week and hours used for targeting. */
  daysOfWeek: Array<DayOfWeekAttributes>;
  /** The time zone that is going to be targed based on the selected date and time. */
  timeZone: TimeZoneTargeting;
};

export type DealLegacy = Node & TargetingTemplateLink & {
  __typename?: 'DealLegacy';
  /** Flag that marks corresponding ads as exclusive. */
  adExclusive?: Maybe<Scalars['Boolean']>;
  /** The separation value in seconds for ads within this deal. */
  adSeparation?: Maybe<Scalars['NonNegativeFloat']>;
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** The type of auction. */
  auctionType?: Maybe<AuctionType>;
  /** The currency of the deal. */
  currency?: Maybe<Scalars['Currency']>;
  /** The dsp associated with the seats on the deal. */
  dsp?: Maybe<DspLegacy>;
  /** It specifies the inclusion of the seats. */
  dspIncludedSeats: DspIncludedSeats;
  /** The end date and time of the deal in ISO format. */
  endDate?: Maybe<Scalars['LocalDateTime']>;
  /** The external ID of the deal. */
  externalId?: Maybe<Scalars['String']>;
  /** Publisher's floor CPM price. */
  floorCpm?: Maybe<Scalars['BigDecimal']>;
  /** The health of this deal. */
  health: Array<HealthMetric>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The targeting definition of this deal, with all it's targeting templates and general targeting group merged in. */
  mergedTargetingDefinition?: Maybe<TargetingDefinition>;
  /** The name of the deal. */
  name?: Maybe<Scalars['String']>;
  /** Publisher's offset CPM (boost) price. */
  offsetCpm?: Maybe<Scalars['BigDecimal']>;
  /** Flag to determine whether we override the publisher floor CPM. */
  overridePublisherFloor?: Maybe<Scalars['Boolean']>;
  /** The owner of this deal. */
  owner?: Maybe<User>;
  /** The priority of this deal. */
  priority?: Maybe<Scalars['NonNegativeInt']>;
  /** Flag identifying a private auction. */
  privateAuction?: Maybe<Scalars['Boolean']>;
  /** Programmatic creatives on this deal. */
  programmaticCreatives: Array<ProgrammaticCreative>;
  /** The parent sales channel that created this deal. */
  salesChannel?: Maybe<SalesChannelLegacy>;
  /**  DEPRECATED use seats property: The associated seat to this deal.  */
  seat?: Maybe<SeatLegacy>;
  /** The seats assigned to the deal. if empty, and a dsp exists, all dsp seats will be used. */
  seats: Array<SeatLegacy>;
  /** The start date and time of the deal in ISO format. */
  startDate?: Maybe<Scalars['LocalDateTime']>;
  /** The status of the given deal. */
  status?: Maybe<DealLegacyStatus>;
  /** The targeting definition of this deal. */
  targetingDefinition?: Maybe<TargetingDefinition>;
  /** The targeting definition V2 of this deal. */
  targetingDefinitionV2?: Maybe<TargetingDefinitionV2>;
  /** The targeting version used for this deal. */
  targetingVersion: TargetingVersion;
  /** The territory assigned to this deal */
  territory: Territory;
  /** Time series for the deal. */
  timeSeries?: Maybe<DealTimeSeries>;
  /** The time zone where the deal starts and ends in IANA format (e.g. Europe/London) */
  timeZone?: Maybe<Scalars['ZoneId']>;
  /** Flag that marks a deal as being trusted. */
  trusted?: Maybe<Scalars['Boolean']>;
};


export type DealLegacyHealthArgs = {
  from?: InputMaybe<Scalars['LocalDate']>;
  until?: InputMaybe<Scalars['LocalDate']>;
};


export type DealLegacyProgrammaticCreativesArgs = {
  filter?: InputMaybe<ProgrammaticCreativeFilter>;
};


export type DealLegacyTimeSeriesArgs = {
  currency: Scalars['Currency'];
  params?: InputMaybe<TimeSeriesParams>;
};

export type DealLegacyAttributes = {
  /** Flag that marks this ad as exclusive. */
  adExclusive?: InputMaybe<Scalars['Boolean']>;
  /** The separation value in seconds for ads within this deal. */
  adSeparation?: InputMaybe<Scalars['NonNegativeFloat']>;
  /** The type of auction. */
  auctionType?: InputMaybe<AuctionType>;
  /** The currency of the deal. */
  currency?: InputMaybe<Scalars['Currency']>;
  /** It specifies the inclusion of the seats. */
  dspIncludedSeats?: InputMaybe<DspIncludedSeats>;
  /** The end date and time of the deal in ISO format. */
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  /** The external ID of the deal. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Publisher's floor CPM price. */
  floorCpm?: InputMaybe<Scalars['BigDecimal']>;
  /** The name of the deal. */
  name?: InputMaybe<Scalars['String']>;
  /** Publisher's offset CPM (boost) price. */
  offsetCpm?: InputMaybe<Scalars['BigDecimal']>;
  /** Flag to determine whether we override the publisher floor CPM. */
  overridePublisherFloor?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the owner of this deal. */
  ownerId?: InputMaybe<Scalars['ID']>;
  /** The priority of this deal. */
  priority?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Flag identifying a private auction. */
  privateAuction?: InputMaybe<Scalars['Boolean']>;
  /** Assign seats to the Deal. */
  seatAllocation?: InputMaybe<MultiSeatAllocation>;
  /** The start date and time of the deal in ISO format. */
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  /** The status of the given deal. */
  status?: InputMaybe<DealLegacyStatus>;
  /** The targeting definition that is attached to this deal. */
  targetingDefinition?: InputMaybe<TargetingDefinitionAttributes>;
  /** The targeting definition V2 that is attached to this deal. */
  targetingDefinitionV2?: InputMaybe<TargetingDefinitionV2Attributes>;
  /** The targeting version */
  targetingVersion?: InputMaybe<TargetingVersion>;
  /** The territory assigned to the owner of this Deal. */
  territory?: InputMaybe<Territory>;
  /** The time zone where the deal starts and ends in IANA format (e.g. Europe/London) */
  timeZone?: InputMaybe<Scalars['ZoneId']>;
  /** Flag that marks a deal as being trusted. */
  trusted?: InputMaybe<Scalars['Boolean']>;
};

export type DealLegacyFilter = {
  status_in?: InputMaybe<Array<DealLegacyStatus>>;
};

export enum DealLegacyStatus {
  /** Deal is active. */
  Active = 'ACTIVE',
  /** The status of the deal once deleted. */
  Deleted = 'DELETED',
  /** The default value when the deal is first created. */
  Draft = 'DRAFT',
  /** Deal is inactive. */
  Inactive = 'INACTIVE',
  /** Deal is ready. */
  Ready = 'READY'
}

export type DealTimeSeries = {
  __typename?: 'DealTimeSeries';
  advPayout?: Maybe<TimeSeries>;
  eCpm?: Maybe<TimeSeries>;
  impressions?: Maybe<TimeSeries>;
  ltr?: Maybe<TimeSeries>;
};

export type DefaultAgeParam = {
  __typename?: 'DefaultAgeParam';
  /** The default age range to assign to add to an ad request if none are present. */
  ageRange: AgeRange;
};

export type DefaultAgeParamAttributes = {
  /** The default age range to assign to add to an ad request if none are present. */
  ageRange: AgeRangeAttributes;
};

/** Generic interface type for querying all default targeting audience parameter types. */
export type DefaultAudienceParam = DefaultAgeParam | DefaultGenderParam | DefaultKeyValueParam;

export type DefaultAudienceParamAttributes = {
  /** The age range params associated with this audience param group. */
  ageParams?: InputMaybe<Array<DefaultAgeParamAttributes>>;
  /** The gender params associated with this audience param group. */
  genderParams?: InputMaybe<Array<DefaultGenderParamAttributes>>;
  /** The key value params associated with this audience param group. */
  keyValueParams?: InputMaybe<Array<DefaultKeyValueParamAttributes>>;
};

export type DefaultGenderParam = {
  __typename?: 'DefaultGenderParam';
  /** The default gender to assign to add to an ad request if none are present. */
  gender: Gender;
};

export type DefaultGenderParamAttributes = {
  /** The default gender to assign to add to an ad request if none are present. */
  gender: Gender;
};

export enum DefaultGeographicTargeting {
  Uk = 'UK',
  Usa = 'USA'
}

export type DefaultKeyValueParam = {
  __typename?: 'DefaultKeyValueParam';
  /** The key value collection of this param. */
  keyValues: Array<Maybe<KeyValue>>;
};

export type DefaultKeyValueParamAttributes = {
  /** The key value of this param. */
  keyValues: Array<KeyValueAttributes>;
};

export type DefaultTargetingGroup = {
  __typename?: 'DefaultTargetingGroup';
  /** The list of default audience params associated with the default targeting group. */
  audienceParams: Array<DefaultAudienceParam>;
};

export type DefaultTargetingGroupAttributes = {
  /** The list of default audience params associated with the targeting group. */
  audienceParams: DefaultAudienceParamAttributes;
};

export enum DeliveryBreakdownField {
  DeviceType = 'DEVICE_TYPE',
  InventoryType = 'INVENTORY_TYPE'
}

export enum DeliveryBreakdownMetric {
  Ctr = 'CTR',
  Impressions = 'IMPRESSIONS',
  Ltr = 'LTR',
  Responses = 'RESPONSES',
  ResponseRate = 'RESPONSE_RATE'
}

export type DeliveryBreakdownMetricInfo = {
  __typename?: 'DeliveryBreakdownMetricInfo';
  displayName: Scalars['String'];
  metric: DeliveryBreakdownMetric;
};

export enum DeliveryDayAndHourMetric {
  Conversions = 'CONVERSIONS',
  ConversionRate = 'CONVERSION_RATE',
  Impressions = 'IMPRESSIONS',
  Reach = 'REACH',
  Responses = 'RESPONSES',
  ResponseRate = 'RESPONSE_RATE'
}

export type DeliveryDayHourMetricInfo = {
  __typename?: 'DeliveryDayHourMetricInfo';
  displayName: Scalars['String'];
  metric: DeliveryDayAndHourMetric;
};

export enum DeliveryGeoMetric {
  Impressions = 'IMPRESSIONS'
}

export type DeliveryGeoMetricInfo = {
  __typename?: 'DeliveryGeoMetricInfo';
  displayName: Scalars['String'];
  metric: DeliveryGeoMetric;
};

export enum DeliveryMetricAggregationType {
  Sum = 'SUM',
  WeightedAverage = 'WEIGHTED_AVERAGE'
}

export enum DeliveryTimeSeriesMetric {
  Conversions = 'CONVERSIONS',
  ConversionRate = 'CONVERSION_RATE',
  Ctr = 'CTR',
  Frequency = 'FREQUENCY',
  Impressions = 'IMPRESSIONS',
  Ltr = 'LTR',
  Reach = 'REACH',
  Responses = 'RESPONSES',
  ResponseRate = 'RESPONSE_RATE'
}

export type DeliveryTimeSeriesMetricInfo = {
  __typename?: 'DeliveryTimeSeriesMetricInfo';
  aggregationType: DeliveryMetricAggregationType;
  displayName: Scalars['String'];
  metric: DeliveryTimeSeriesMetric;
};

export enum DeliveryTotalsMetric {
  Clicks = 'CLICKS',
  CompanionImpressions = 'COMPANION_IMPRESSIONS',
  Ctr = 'CTR',
  EngagementTime = 'ENGAGEMENT_TIME',
  Frequency = 'FREQUENCY',
  Impressions = 'IMPRESSIONS',
  Ltr = 'LTR',
  Reach = 'REACH',
  Responses = 'RESPONSES',
  ResponseRate = 'RESPONSE_RATE'
}

export type DeliveryTotalsPoint = {
  __typename?: 'DeliveryTotalsPoint';
  clickThroughRate?: Maybe<Scalars['BigDecimal']>;
  clicks?: Maybe<Scalars['Long']>;
  companionImpressions?: Maybe<Scalars['Long']>;
  engagementTime?: Maybe<Scalars['Long']>;
  frequency?: Maybe<Scalars['BigDecimal']>;
  impressions?: Maybe<Scalars['Long']>;
  listenThroughRate?: Maybe<Scalars['BigDecimal']>;
  reach?: Maybe<Scalars['Long']>;
  responseRate?: Maybe<Scalars['BigDecimal']>;
  responses?: Maybe<Scalars['Long']>;
};

export type DemandParameterValue = {
  __typename?: 'DemandParameterValue';
  children: Array<DemandParameterValue>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parents: Array<DemandParameterValue>;
};

export type DemandParameterValueAttribute = {
  id: Scalars['ID'];
};

export type Department = {
  __typename?: 'Department';
  id: Scalars['ID'];
  name: Scalars['String'];
  teams: Array<Team>;
};

export type DepartmentAttributes = {
  name: Scalars['String'];
};

export type DeviceMaker = {
  __typename?: 'DeviceMaker';
  /** The device models of this device maker. */
  models: Array<Maybe<Scalars['String']>>;
  /** The name of the device maker. */
  name: Scalars['ID'];
};

export type DeviceMakerAttributes = {
  /** The models of the device maker. */
  models: Array<Scalars['String']>;
  /** The operating system name. */
  name: Scalars['String'];
};

export type DeviceMakerParam = AudienceParam & {
  __typename?: 'DeviceMakerParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of device makers of the targeted audience. */
  deviceMakers: Array<DeviceMaker>;
};

export type DeviceMakerParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of device makers of the targeted audience. */
  deviceMakers: Array<DeviceMakerAttributes>;
};

export type DeviceOperatingSystemParam = AudienceParam & {
  __typename?: 'DeviceOperatingSystemParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of device operating systems of the targeted audience. */
  deviceOperatingSystems: Array<OperatingSystem>;
};

export type DeviceOperatingSystemParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of device operating systems of the targeted audience. */
  deviceOperatingSystems: Array<OperatingSystemAttributes>;
};

export type DeviceTypeParam = AudienceParam & {
  __typename?: 'DeviceTypeParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of device types of the targeted audience. */
  deviceTypes: Array<Scalars['String']>;
};

export type DeviceTypeParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of device types of the targeted audience. */
  deviceTypes: Array<Scalars['String']>;
};

export enum Dimension {
  Channel = 'CHANNEL',
  DeviceType = 'DEVICE_TYPE',
  Show = 'SHOW'
}

export type DirectSearchDateTimeFilterAttributes = {
  endDate: Scalars['LocalDateTime'];
  filterType: DirectSearchFilterType;
  startDate: Scalars['LocalDateTime'];
};

export enum DirectSearchEntityStatus {
  Amending = 'AMENDING',
  AtRisk = 'AT_RISK',
  AwaitingCreative = 'AWAITING_CREATIVE',
  Booked = 'BOOKED',
  BookingApprovalRequired = 'BOOKING_APPROVAL_REQUIRED',
  BookingApproved = 'BOOKING_APPROVED',
  Cancelled = 'CANCELLED',
  ChangesRequired = 'CHANGES_REQUIRED',
  CreditApprovalRequired = 'CREDIT_APPROVAL_REQUIRED',
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  FailedToDeliver = 'FAILED_TO_DELIVER',
  InBasket = 'IN_BASKET',
  NotDelivering = 'NOT_DELIVERING',
  OnTrack = 'ON_TRACK',
  Paused = 'PAUSED',
  PendingApproval = 'PENDING_APPROVAL',
  PendingCancellation = 'PENDING_CANCELLATION',
  Ready = 'READY',
  Stopped = 'STOPPED',
  WillNotDeliver = 'WILL_NOT_DELIVER'
}

export type DirectSearchFilter = {
  __typename?: 'DirectSearchFilter';
  category: DirectSearchFilterCategory;
  values?: Maybe<Array<DirectSearchFilterValue>>;
};

export type DirectSearchFilterAttributes = {
  filterType: DirectSearchFilterType;
  ids: Array<Scalars['String']>;
};

export type DirectSearchFilterCategory = {
  __typename?: 'DirectSearchFilterCategory';
  displayName: Scalars['String'];
  filterDisplayType: SearchFilterDisplayType;
  filterType: DirectSearchFilterType;
};

export type DirectSearchFilterNew = {
  dateTimeFilters: Array<DirectSearchDateTimeFilterAttributes>;
  filters: Array<DirectSearchFilterAttributes>;
};

export enum DirectSearchFilterType {
  Agency = 'AGENCY',
  AssignedTo = 'ASSIGNED_TO',
  BillingType = 'BILLING_TYPE',
  BoltOn = 'BOLT_ON',
  Brand = 'BRAND',
  Collaborator = 'COLLABORATOR',
  EndsWithin = 'ENDS_WITHIN',
  EndDate = 'END_DATE',
  EntityType = 'ENTITY_TYPE',
  FlightType = 'FLIGHT_TYPE',
  LiveDate = 'LIVE_DATE',
  Locality = 'LOCALITY',
  Owner = 'OWNER',
  Restriction = 'RESTRICTION',
  StartsWithin = 'STARTS_WITHIN',
  StartDate = 'START_DATE',
  Status = 'STATUS'
}

export type DirectSearchFilterValue = {
  __typename?: 'DirectSearchFilterValue';
  children?: Maybe<Array<DirectSearchFilterValue>>;
  displayName: Scalars['String'];
  /** @deprecated Field no longer supported */
  filterType: DirectSearchFilterType;
  id: Scalars['ID'];
};

export enum DirectSearchOrderableField {
  Budget = 'BUDGET',
  DeliveryPace = 'DELIVERY_PACE',
  EndDate = 'END_DATE',
  EstimatedCompletion = 'ESTIMATED_COMPLETION',
  ModifiedDate = 'MODIFIED_DATE',
  StartDate = 'START_DATE'
}

export type DirectSearchOrderableInfo = {
  __typename?: 'DirectSearchOrderableInfo';
  displayName: Scalars['String'];
  id: DirectSearchOrderableField;
};

export type DirectSearchResponse = {
  __typename?: 'DirectSearchResponse';
  directSearchResults?: Maybe<Array<DirectSearchResult>>;
  pageMetaData: PageMetaData;
};

export type DirectSearchResult = {
  __typename?: 'DirectSearchResult';
  brand: Brand;
  id: Scalars['ID'];
  modifiedDate: Scalars['LocalDateTime'];
  name: Scalars['String'];
  omOrderId?: Maybe<Scalars['ID']>;
  orderName: Scalars['String'];
  owner: User;
  status: DirectSearchEntityStatus;
  type: EntityType;
};

export type Dma = {
  __typename?: 'Dma';
  /** The dma code. */
  code: Scalars['Int'];
  /** The name of the area associated to the code. */
  name: Scalars['String'];
};

export type DmaAttributes = {
  /** The dma code. */
  code: Scalars['Int'];
  /** The name of the area associated to the code. */
  name: Scalars['String'];
};

export type DmaParam = AudienceParam & {
  __typename?: 'DmaParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of dmas of the targeted audience. */
  dmas: Array<Dma>;
};

export type DmaParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of dmas of the targeted audience. */
  dmas: Array<DmaAttributes>;
};

/** The DMP segment can be of different types. */
export type DmpSegment = NielsenSegment;

export type DmpSegmentParam = AudienceParam & {
  __typename?: 'DmpSegmentParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The type of the segment. */
  segmentType: DmpSegmentType;
  /** The list of segment IDs of the targeted audience. */
  segments: Array<DmpSegment>;
};

export type DmpSegmentParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The type of the segment. */
  segmentType: DmpSegmentType;
  /** The list of segments of the targeted audience. */
  segments: Array<NielsenSegmentAttributes>;
};

export enum DmpSegmentType {
  /** Nielsen DMP segment. */
  Nielsen = 'NIELSEN'
}

export type Dsp = Node & {
  __typename?: 'Dsp';
  dailyCap: Scalars['NonNegativeInt'];
  entityState: EntityState;
  id: Scalars['ID'];
  maxAds: Scalars['NonNegativeInt'];
  mediaType: MediaType;
  name: Scalars['String'];
  programmaticConnector: ProgrammaticConnector;
  sharedWithBusinesses: Array<BusinessReference>;
  status: DspStatus;
};

export type DspAttributes = {
  dailyCap: Scalars['Int'];
  maxAds: Scalars['Int'];
  name: Scalars['String'];
  sharedWithBusinessIds: Array<Scalars['ID']>;
};

/** It describes the inclusion of the seats on a deal. */
export enum DspIncludedSeats {
  /** All known seats which are configured in DAX Audio. */
  AllKnownSeats = 'ALL_KNOWN_SEATS',
  /** Any seats within the DSP. */
  AllSeats = 'ALL_SEATS',
  /** Default sate. Used when DSP is not set on a deal. */
  DspNotSet = 'DSP_NOT_SET',
  /** Seats selected manually by the user. */
  SpecifiedSeats = 'SPECIFIED_SEATS'
}

export type DspLegacy = Node & {
  __typename?: 'DspLegacy';
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** Amount of impressions a DSP can use per day. */
  dailyCap?: Maybe<Scalars['NonNegativeInt']>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The maximum number of adds for this DSP. */
  maxAds: Scalars['NonNegativeInt'];
  /** The name of the DSP. */
  name?: Maybe<Scalars['String']>;
  /** The list of seats created for this DSP. */
  seats: Array<SeatLegacy>;
  /** The status of the given dsp. */
  status?: Maybe<DspLegacyStatus>;
  /** The parent technical provider that created this DSP. */
  technicalProvider?: Maybe<TechnicalProviderLegacy>;
  /** The list of territories for this DSP. */
  territories: Array<Territory>;
};


export type DspLegacySeatsArgs = {
  filter?: InputMaybe<SeatLegacyFilter>;
  territories?: InputMaybe<Array<Territory>>;
};

export type DspLegacyAttributes = {
  /** Amount of impressions a DSP can use per day. */
  dailyCap?: InputMaybe<Scalars['NonNegativeInt']>;
  /** The maximum number of adds for this DSP */
  maxAds?: InputMaybe<Scalars['NonNegativeInt']>;
  /** The name of the DSP. */
  name?: InputMaybe<Scalars['String']>;
  /** The status of the given dsp. */
  status?: InputMaybe<DspLegacyStatus>;
  /** The list of territories assigned to the DSP. */
  territories?: InputMaybe<Array<Territory>>;
};

export type DspLegacyFilter = {
  status_in?: InputMaybe<Array<DspLegacyStatus>>;
};

export enum DspLegacyStatus {
  /** DSP is active. */
  Active = 'ACTIVE',
  /** The status of the DSP once deleted. */
  Deleted = 'DELETED',
  /** The default value when the DSP is first created. */
  Draft = 'DRAFT',
  /** DSP is inactive. */
  Inactive = 'INACTIVE'
}

export type DspMinimal = Node & {
  __typename?: 'DspMinimal';
  id: Scalars['ID'];
  mediaType: MediaType;
  name: Scalars['String'];
  status: DspStatus;
};

export enum DspProvider {
  /** AudioMatic. */
  Audiomatic = 'AUDIOMATIC',
  /** Default option when no dsp provider. */
  DspProviderUnspecified = 'DSP_PROVIDER_UNSPECIFIED'
}

export enum DspStatus {
  Disabled = 'DISABLED',
  DisabledInherited = 'DISABLED_INHERITED',
  Enabled = 'ENABLED'
}

/** Represents the permission access types for a user */
export enum EntityAccess {
  ReadFull = 'READ_FULL',
  ReadNonFinancial = 'READ_NON_FINANCIAL'
}

export type EntityAttributes = {
  /** Entity Type */
  entityType: EntityType;
  /** Entity ID */
  id: Scalars['ID'];
};

export enum EntityFilterDisplayType {
  Hierarchy = 'HIERARCHY',
  Values = 'VALUES'
}

export type EntityIdentity = Node & {
  __typename?: 'EntityIdentity';
  entityType: EntityType;
  id: Scalars['ID'];
};

export type EntityPermission = {
  __typename?: 'EntityPermission';
  entityId: Scalars['String'];
  entityName?: Maybe<Scalars['String']>;
  entityType: EntityType;
};

export type EntityPermissionAttributes = {
  entityId?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<EntityType>;
};

export enum EntityState {
  /** The supply entity is disabled. */
  Disabled = 'DISABLED',
  /** The supply entity is enabled. */
  Enabled = 'ENABLED'
}

export enum EntityStatus {
  /** Statuses used by Programmatic entities. */
  Active = 'ACTIVE',
  Approved = 'APPROVED',
  Blocked = 'BLOCKED',
  BlockedAwaitingQa = 'BLOCKED_AWAITING_QA',
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  /** Statuses used across entities. */
  Draft = 'DRAFT',
  Enabled = 'ENABLED',
  Inactive = 'INACTIVE',
  Live = 'LIVE',
  LiveAwaitingQa = 'LIVE_AWAITING_QA',
  Paused = 'PAUSED',
  /** Statuses used by Direct entities. */
  Ready = 'READY'
}

export enum EntityType {
  Ad = 'AD',
  Advertiser = 'ADVERTISER',
  /** Direct entity types. */
  Agency = 'AGENCY',
  Audio = 'AUDIO',
  BillingLine = 'BILLING_LINE',
  /** Synonym for BRAND */
  Brand = 'BRAND',
  /** Business entity types. */
  Business = 'BUSINESS',
  Campaign = 'CAMPAIGN',
  Channel = 'CHANNEL',
  CompanionBanner = 'COMPANION_BANNER',
  /** Synonym for CREATIVE_TAG */
  Creative = 'CREATIVE',
  CreativeAudio = 'CREATIVE_AUDIO',
  CreativeTag = 'CREATIVE_TAG',
  DataCenter = 'DATA_CENTER',
  Deal = 'DEAL',
  Department = 'DEPARTMENT',
  Dsp = 'DSP',
  FeatureFlag = 'FEATURE_FLAG',
  /** Synonym for FLIGHT */
  Flight = 'FLIGHT',
  /** Synonym for CREATIVE_AUDIO */
  Image = 'IMAGE',
  /** Supply entity types. */
  Network = 'NETWORK',
  Order = 'ORDER',
  OrderLine = 'ORDER_LINE',
  ProgrammaticBillingLine = 'PROGRAMMATIC_BILLING_LINE',
  /** Exchange entity types. */
  ProgrammaticConnector = 'PROGRAMMATIC_CONNECTOR',
  ProgrammaticCreative = 'PROGRAMMATIC_CREATIVE',
  /** Planning entity types. */
  Proposal = 'PROPOSAL',
  ProposedFlight = 'PROPOSED_FLIGHT',
  Publisher = 'PUBLISHER',
  PublisherContract = 'PUBLISHER_CONTRACT',
  /** Synonym for COMPANION_BANNER */
  Redirect = 'REDIRECT',
  Role = 'ROLE',
  /** Programmatic entity types. */
  Saleschannel = 'SALESCHANNEL',
  Seat = 'SEAT',
  Show = 'SHOW',
  ShowContract = 'SHOW_CONTRACT',
  TargetingDefinition = 'TARGETING_DEFINITION',
  TargetingTemplate = 'TARGETING_TEMPLATE',
  Team = 'TEAM',
  Technicalprovider = 'TECHNICALPROVIDER'
}

export type EntityTypeId = {
  __typename?: 'EntityTypeId';
  id: Scalars['ID'];
  type: EntityType;
  typeDisplayName: Scalars['String'];
};

export type EntityTypeIdAttributes = {
  id: Scalars['ID'];
  type: EntityType;
};

export type ExchangeSearchResponse = {
  __typename?: 'ExchangeSearchResponse';
  exchangeSearchResults: Array<ExchangeSearchResult>;
  pageMetaData: PageMetaData;
};

export type ExchangeSearchResult = {
  __typename?: 'ExchangeSearchResult';
  id: Scalars['ID'];
  mediaType: MediaType;
  name: Scalars['String'];
  status: ExchangeSearchStatus;
  type: EntityType;
};

export enum ExchangeSearchStatus {
  Disabled = 'DISABLED',
  DisabledInherited = 'DISABLED_INHERITED',
  Enabled = 'ENABLED'
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  allowedUsers: Array<User>;
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  featureFlagName?: Maybe<FeatureFlagName>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type FeatureFlagAttributes = {
  allowedUserIds: Array<Scalars['ID']>;
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
};

export enum FeatureFlagName {
  BusinessSettings = 'BUSINESS_SETTINGS',
  Daxv = 'DAXV',
  DaxId = 'DAX_ID',
  ExchangeRebuild = 'EXCHANGE_REBUILD',
  GigyaApiAuth = 'GIGYA_API_AUTH',
  ProgrammaticRebuild = 'PROGRAMMATIC_REBUILD',
  Social = 'SOCIAL',
  SupplyAudio = 'SUPPLY_AUDIO',
  SupplyAudioV2 = 'SUPPLY_AUDIO_V2'
}

export type FeatureToggle = Node & {
  __typename?: 'FeatureToggle';
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The name of the feature toggle. */
  name?: Maybe<Scalars['String']>;
  /** Whether the feature is toggled on or off. */
  toggled?: Maybe<Scalars['Boolean']>;
};

export type FlagBasedBookingValidation = BusinessBookingValidation & {
  __typename?: 'FlagBasedBookingValidation';
  enabled: Scalars['Boolean'];
  type: BookingValidationType;
};

export type FlagBasedBookingValidationAttributes = {
  enabled: Scalars['Boolean'];
  type: BookingValidationType;
};

export type FlagBasedBusinessRule = BusinessRuleModel & {
  __typename?: 'FlagBasedBusinessRule';
  enabled: Scalars['Boolean'];
  type: BusinessRule;
};

export type FlagBasedBusinessRuleAttributes = {
  enabled: Scalars['Boolean'];
  type: BusinessRule;
};

export type Flight = {
  __typename?: 'Flight';
  barterType?: Maybe<BarterType>;
  billableCpm?: Maybe<Scalars['BigDecimal']>;
  billableCpmChangeReason?: Maybe<BillableCpmChangeReasonType>;
  billedImpressions?: Maybe<Scalars['Long']>;
  billingTypeInfo: FlightBillingTypeInfo;
  boltOns: Array<FlightBoltOnType>;
  budget: Scalars['BigDecimal'];
  budgetStrategy: FlightBudgetStrategy;
  businessId?: Maybe<Scalars['ID']>;
  cashValue?: Maybe<Scalars['BigDecimal']>;
  clickThroughRate?: Maybe<Scalars['Float']>;
  clicks?: Maybe<Scalars['Int']>;
  companionImpressions?: Maybe<Scalars['NonNegativeInt']>;
  cpm: Scalars['BigDecimal'];
  creativeLength?: Maybe<Scalars['NonNegativeFloat']>;
  dailyCap?: Maybe<Scalars['NonNegativeInt']>;
  dataCost: Scalars['BigDecimal'];
  daxIdTags: Array<DaxIdTag>;
  deliveredPercentage?: Maybe<Scalars['BigDecimal']>;
  deliveryPace?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['LocalDateTime']>;
  engagementTime?: Maybe<Scalars['Long']>;
  estimatedCompletion?: Maybe<Scalars['BigDecimal']>;
  flightType: FlightTypeInfo;
  frequency?: Maybe<Scalars['BigDecimal']>;
  frequencyCapCount?: Maybe<Scalars['NonNegativeInt']>;
  frequencyCapTimeUnit?: Maybe<FrequencyCapTimeUnit>;
  frequencyCapValue?: Maybe<Scalars['NonNegativeInt']>;
  iabCategories: Array<IabCategory>;
  id: Scalars['ID'];
  impressions?: Maybe<Scalars['Long']>;
  legacyId: Scalars['ID'];
  listenThroughRate?: Maybe<Scalars['Float']>;
  mediaSpend?: Maybe<Scalars['BigDecimal']>;
  name: Scalars['String'];
  objectiveImpressions?: Maybe<Scalars['Long']>;
  offsetCpm?: Maybe<Scalars['BigDecimal']>;
  orderLine?: Maybe<OrderLine>;
  pacing: FlightPacing;
  priority?: Maybe<Scalars['NonNegativeInt']>;
  reach?: Maybe<Scalars['Long']>;
  restrictions: Array<FlightRestrictionType>;
  startDate?: Maybe<Scalars['LocalDateTime']>;
  status: FlightStatus;
  targetingDefinitionsWithAds: Array<TargetingDefinitionWithAds>;
  territory: Territory;
  timeZone: Scalars['ZoneId'];
  tradeValue?: Maybe<Scalars['BigDecimal']>;
};

export type FlightAttributes = {
  ads: Array<UpdateAdAttributes>;
  barter?: InputMaybe<FlightBarterAttributes>;
  billingType: FlightBillingType;
  boltOns: Array<FlightBoltOnType>;
  budget: FlightBudgetAttributes;
  creativeLength: Scalars['NonNegativeFloat'];
  dailyCap?: InputMaybe<Scalars['NonNegativeInt']>;
  dateRange: DateRangeAttributes;
  daxIdTagIds?: InputMaybe<Array<Scalars['ID']>>;
  flightType: FlightType;
  frequencyCap?: InputMaybe<FrequencyCapAttributes>;
  iabCategoryCodes: Array<Scalars['String']>;
  name: Scalars['String'];
  offsetCpm?: InputMaybe<Scalars['BigDecimal']>;
  pacing: FlightPacing;
  priority: Scalars['Int'];
  restrictions: Array<FlightRestrictionType>;
  targetingDefinitions: Array<TargetingDefinitionV2Attributes>;
  territory?: InputMaybe<Territory>;
  timeZone: Scalars['ZoneId'];
};

export type FlightBarterAttributes = {
  barterType: BarterType;
  cashValue: Scalars['BigDecimal'];
  tradeValue?: InputMaybe<Scalars['BigDecimal']>;
};

export enum FlightBillingType {
  AddedValue = 'ADDED_VALUE',
  Barter = 'BARTER',
  Contra = 'CONTRA',
  Deferred = 'DEFERRED',
  Filler = 'FILLER',
  PartnerSold = 'PARTNER_SOLD',
  PrePaid = 'PRE_PAID',
  SelfService = 'SELF_SERVICE',
  Sold = 'SOLD',
  Unsold = 'UNSOLD'
}

export type FlightBillingTypeInfo = {
  __typename?: 'FlightBillingTypeInfo';
  billableCpmOverride?: Maybe<Scalars['BigDecimal']>;
  displayName: Scalars['String'];
  isDefault: Scalars['Boolean'];
  type: FlightBillingType;
};

export type FlightBoltOnInfo = {
  __typename?: 'FlightBoltOnInfo';
  mediaTypes: Array<MediaType>;
  name: Scalars['String'];
  type: FlightBoltOnType;
};

export enum FlightBoltOnType {
  ClientData = 'CLIENT_DATA',
  DaxId = 'DAX_ID',
  Dynamic = 'DYNAMIC',
  EnhancedHostRead = 'ENHANCED_HOST_READ',
  Liid = 'LIID',
  PremiumBrandedSegments = 'PREMIUM_BRANDED_SEGMENTS',
  PremiumSpot = 'PREMIUM_SPOT',
  PromoPlus = 'PROMO_PLUS',
  SecondPartyPartnerData = 'SECOND_PARTY_PARTNER_DATA',
  SmartSpeakerSkill = 'SMART_SPEAKER_SKILL',
  ThreeDAudio = 'THREE_D_AUDIO'
}

export type FlightBudgetAttributes = {
  /** Not required for non-spot */
  billableCpmAttributes?: InputMaybe<BillableCpmAttributes>;
  /** Long max */
  billedImpressions?: InputMaybe<Scalars['Long']>;
  budgetStrategy: FlightBudgetStrategy;
  cpm: Scalars['BigDecimal'];
  dataCost?: InputMaybe<Scalars['BigDecimal']>;
  objectiveImpressions?: InputMaybe<Scalars['Long']>;
  spendingBudget: Scalars['BigDecimal'];
};

export enum FlightBudgetStrategy {
  BilledImpressions = 'BILLED_IMPRESSIONS',
  ObjectiveImpressions = 'OBJECTIVE_IMPRESSIONS',
  SpendingBudget = 'SPENDING_BUDGET'
}

export type FlightEntityFilterAttributes = {
  filterType: FlightFilterType;
  ids: Array<Scalars['String']>;
};

export type FlightFilter = {
  associatedUserId?: InputMaybe<Scalars['ID']>;
  creativeIds?: InputMaybe<Array<Scalars['ID']>>;
  entityFilters?: InputMaybe<Array<FlightEntityFilterAttributes>>;
  statuses?: InputMaybe<Array<FlightStatus>>;
};

export type FlightFilterCategory = {
  __typename?: 'FlightFilterCategory';
  displayName: Scalars['String'];
  filterDisplayType: EntityFilterDisplayType;
  filterType: FlightFilterType;
};

export enum FlightFilterType {
  AssignedToTeams = 'ASSIGNED_TO_TEAMS',
  AssignedToUsers = 'ASSIGNED_TO_USERS'
}

export type FlightFilterValue = {
  __typename?: 'FlightFilterValue';
  children?: Maybe<Array<FlightFilterValue>>;
  displayName: Scalars['String'];
  filterType: FlightFilterType;
  id: Scalars['ID'];
};

export type FlightOffsetPaginationResponse = {
  __typename?: 'FlightOffsetPaginationResponse';
  flights?: Maybe<Array<Maybe<Flight>>>;
  pageMetaData?: Maybe<PageMetaData>;
};

export enum FlightOrderableField {
  EndDate = 'END_DATE',
  FlightId = 'FLIGHT_ID',
  ModifiedDate = 'MODIFIED_DATE',
  StartDate = 'START_DATE'
}

export enum FlightPacing {
  /** The impressions delivery should start as soon as possible. */
  Asap = 'ASAP',
  /** The impression delivery will be equally balanced during the whole period that the campaign is live. */
  Evenly = 'EVENLY',
  /** Impressions will be delivered sooner than with even pacing. */
  FrontWeighted = 'FRONT_WEIGHTED'
}

export type FlightRestrictionInfo = {
  __typename?: 'FlightRestrictionInfo';
  name: Scalars['String'];
  type: FlightRestrictionType;
};

export enum FlightRestrictionType {
  CapSensitive = 'CAP_SENSITIVE',
  Hfss = 'HFSS'
}

export enum FlightStatus {
  AtRisk = 'AT_RISK',
  AwaitingCreative = 'AWAITING_CREATIVE',
  Delivered = 'DELIVERED',
  FailedToDeliver = 'FAILED_TO_DELIVER',
  NotDelivering = 'NOT_DELIVERING',
  OnTrack = 'ON_TRACK',
  Paused = 'PAUSED',
  Ready = 'READY',
  Stopped = 'STOPPED',
  WillNotDeliver = 'WILL_NOT_DELIVER'
}

export type FlightTargetingAttributes = {
  /** The bolt ons for this flight. */
  boltOns?: InputMaybe<Array<FlightBoltOnType>>;
  /** Target duration. */
  duration?: InputMaybe<Scalars['NonNegativeFloat']>;
  /** End date for the flight. */
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  /** The id for the flight, if it has one. */
  flightId?: InputMaybe<Scalars['ID']>;
  /** The locality of the flight that is being forecasted. */
  flightLocality?: InputMaybe<Locality>;
  /** The restrictions for this flight. */
  restrictions?: InputMaybe<Array<FlightRestrictionType>>;
  /** Start date for the flight. */
  startDate: Scalars['LocalDateTime'];
  /** The targeting definition that is attached to this flight. */
  targetingDefinition: TargetingDefinitionV2Attributes;
};

export enum FlightType {
  BrandedSegment = 'BRANDED_SEGMENT',
  Filler = 'FILLER',
  HostRead = 'HOST_READ',
  SocialPostGuaranteed = 'SOCIAL_POST_GUARANTEED',
  SocialPostOrganic = 'SOCIAL_POST_ORGANIC',
  Sponsorship = 'SPONSORSHIP',
  SponsorCredit = 'SPONSOR_CREDIT',
  Spot = 'SPOT',
  Unsold = 'UNSOLD'
}

export type FlightTypeInfo = {
  __typename?: 'FlightTypeInfo';
  displayName: Scalars['String'];
  type: FlightType;
};

export enum FlightUpdateStatus {
  Paused = 'PAUSED',
  Ready = 'READY',
  Stopped = 'STOPPED'
}

export type Forecast = {
  __typename?: 'Forecast';
  /** Number of available impressions timeseries. */
  availableImpressions?: Maybe<TimeSeries>;
  /** Number of available impressions total. */
  availableImpressionsTotal: Scalars['Long'];
  /** Number of available request timeseries. */
  availableRequests?: Maybe<TimeSeries>;
  /** Number of available impressions total. */
  availableRequestsTotal: Scalars['Long'];
  /**
   * (deprecated) Number of booked impressions.
   * @deprecated Use bookedImpressionsTotal instead
   */
  booked?: Maybe<ForecastBooked>;
  /** Number of booked impressions timeseries. */
  bookedImpressions?: Maybe<TimeSeries>;
  /** Number of booked impressions timeseries total. */
  bookedImpressionsTotal: Scalars['Long'];
  /** The id for the entity that might be associated with this forecast */
  entityId?: Maybe<Scalars['ID']>;
  /** The total impressions for the forecasted audience */
  impressionsTotal: Scalars['Long'];
  /** Request the payload we send to the forecasting API (for debugging only) */
  jsonPayload?: Maybe<Scalars['JSON']>;
  /** The targeting definition of this forecast, with all it's targeting templates and general targeting group merged in. */
  mergedTargetingDefinition?: Maybe<TargetingDefinition>;
};

export type ForecastAttributes = {
  /** Target duration. */
  duration?: InputMaybe<Scalars['NonNegativeFloat']>;
  /** End date for the forecast. */
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  /** Determines the maximum number of impressions per listener. */
  frequencyCapCount?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Determines the time unit which the frequency cap value represents a multiple of. */
  frequencyCapTimeUnit?: InputMaybe<FrequencyCapTimeUnit>;
  /** Determines the time period value for which to deliver the number of ad impressions. */
  frequencyCapValue?: InputMaybe<Scalars['NonNegativeInt']>;
  /** The list of IAB category codes */
  iabCategoryCodes?: InputMaybe<Array<Scalars['ID']>>;
  /** Includes the Forecast payload in the response */
  includeJsonPayload?: InputMaybe<Scalars['Boolean']>;
  /** Start date for the forecast. */
  startDate: Scalars['LocalDateTime'];
  /** The targeting definition that is attached to this forecast. */
  targetingDefinition?: InputMaybe<TargetingDefinitionAttributes>;
  /** The targeting definition v2 that is attached to this forecast. */
  targetingDefinitionV2?: InputMaybe<TargetingDefinitionV2Attributes>;
  /** The targeting restrictions for this forecast. */
  targetingRestrictions?: InputMaybe<Array<TargetingRestriction>>;
  /** Required if targetingDefinitionV2 is set */
  territory: Territory;
  /** The time zone in IANA format (e.g. Europe/London) */
  timeZone: Scalars['ZoneId'];
};

export type ForecastBooked = {
  __typename?: 'ForecastBooked';
  /** Possible impressions for the new line item that will be booked by current active line items. */
  impressions: Scalars['Long'];
};

export type FrequencyCapAttributes = {
  count: Scalars['NonNegativeInt'];
  timeUnit: FrequencyCapTimeUnit;
  value: Scalars['NonNegativeInt'];
};

export enum FrequencyCapTimeUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  Months = 'MONTHS',
  /** The default value when the time unit is not set. */
  TimeUnitUnspecified = 'TIME_UNIT_UNSPECIFIED',
  Weeks = 'WEEKS'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Unspecified = 'UNSPECIFIED'
}

export type GenderParam = AudienceParam & {
  __typename?: 'GenderParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of genders of the targeted audience. */
  genders: Array<Gender>;
};

export type GenderParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of genders of the targeted audience. */
  genders: Array<Gender>;
};

export type GenreParam = AudienceParam & {
  __typename?: 'GenreParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of genres. */
  genres: Array<Scalars['String']>;
};

export type GenreParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of genres. */
  genres: Array<Scalars['String']>;
};

export type GeoDataPoint = {
  __typename?: 'GeoDataPoint';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  value: Scalars['Float'];
};

export type GeoRegion = {
  __typename?: 'GeoRegion';
  /** The ISO 3166-2 region code. */
  code: Scalars['String'];
  /** The region name. */
  name: Scalars['String'];
};

export type GeoRegionResponse = {
  __typename?: 'GeoRegionResponse';
  /** The ISO 3166-1 country code. */
  countryCode: Scalars['String'];
  /** The list of regions for this country. */
  regions: Array<GeoRegion>;
};

export type HealthMetric = {
  __typename?: 'HealthMetric';
  breakdown?: Maybe<Array<BreakdownEntry>>;
  category?: Maybe<HealthMetricCategory>;
  childrenIds?: Maybe<Array<Scalars['Int']>>;
  id: Scalars['Int'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['Int']>;
  percentOfParent?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};

/** Category for entity health metrics */
export enum HealthMetricCategory {
  Failure = 'FAILURE',
  Success = 'SUCCESS',
  Uncategorized = 'UNCATEGORIZED'
}

/** HTTP method used for generation pre-signed URLs. */
export enum HttpMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Put = 'PUT'
}

export type IabCategory = {
  __typename?: 'IabCategory';
  /** The entity identifier as an IAB code. */
  code: Scalars['ID'];
  /** The name of the IAB category. */
  name?: Maybe<Scalars['String']>;
  parentCategory?: Maybe<IabCategory>;
  /** Any sub categories that this category has. */
  subIabCategories: Array<IabCategory>;
};

export type InheritableDateRangeAttributes = {
  endDate: InheritableLocalDateTimeAttributes;
  startDate: InheritableLocalDateTimeAttributes;
};

export type InheritableLocalDateTime = {
  __typename?: 'InheritableLocalDateTime';
  /** Whether the local date time value is inherited from its parent. */
  isInherited: Scalars['Boolean'];
  /** The local date time value. */
  value?: Maybe<Scalars['LocalDateTime']>;
};

export type InheritableLocalDateTimeAttributes = {
  /** Specify whether a value is inherited from the parent. */
  isInherited: Scalars['Boolean'];
  /** The value to set it to if isInherited is false. */
  value?: InputMaybe<Scalars['LocalDateTime']>;
};

export type Interest = {
  __typename?: 'Interest';
  /** Any child interest that this category has. */
  childInterests: Array<Interest>;
  /** The entity identifier as an IAB code. */
  code: Scalars['ID'];
  /** The name of the Interest. */
  name?: Maybe<Scalars['String']>;
};

export type InventoryGroup = TargetingV2ParameterGroup & {
  __typename?: 'InventoryGroup';
  parameters: Array<InventoryParameter>;
};

export type InventoryGroupAttributes = {
  parameters: Array<InventoryParameterAttributes>;
};

export type InventoryParameter = TargetingV2Parameter & {
  __typename?: 'InventoryParameter';
  clusivity: Clusivity;
  type: InventoryParameterType;
  values: Array<InventoryParameterValue>;
};

export type InventoryParameterAttributes = {
  clusivity: Clusivity;
  type: InventoryParameterType;
  values: Array<InventoryParameterValueAttribute>;
};

export type InventoryParameterInfo = TargetingV2ParameterInfo & {
  __typename?: 'InventoryParameterInfo';
  cardinality: Cardinality;
  name: Scalars['String'];
  type: InventoryParameterType;
};

export enum InventoryParameterType {
  AdPosition = 'AD_POSITION',
  InventoryType = 'INVENTORY_TYPE',
  Supply = 'SUPPLY'
}

export type InventoryParameterValue = TargetingV2ParameterValue & {
  __typename?: 'InventoryParameterValue';
  /** Whether this value is currently available for targeting */
  active: Scalars['Boolean'];
  children: Array<Maybe<InventoryParameterValue>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<InventoryParameterValue>;
  parents: Array<Maybe<InventoryParameterValue>>;
};

export type InventoryParameterValueAttribute = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export enum InventoryParameterValuesLevel {
  Show = 'SHOW'
}

export enum InventoryStatus {
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  Enabled = 'ENABLED'
}

export type InventoryTargeting = {
  __typename?: 'InventoryTargeting';
  inventories?: Maybe<Array<InventoryGroup>>;
};

export type InventoryTargetingAttributes = {
  inventories: Array<InventoryGroupAttributes>;
};

export enum InventoryType {
  AudioArticle = 'AUDIO_ARTICLE',
  Catchup = 'CATCHUP',
  FlashBriefing = 'FLASH_BRIEFING',
  Gaming = 'GAMING',
  Playlist = 'PLAYLIST',
  PodCast = 'POD_CAST',
  Radio = 'RADIO'
}

export type Isp = {
  __typename?: 'Isp';
  /** the internal id of the isp. */
  id: Scalars['NonNegativeInt'];
  /** the name of the ISP. Null if entry with ID not found in records. */
  name?: Maybe<Scalars['String']>;
};

export type IspParam = AudienceParam & {
  __typename?: 'IspParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** List of isps to target. */
  isps: Array<Isp>;
};

export type IspsParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of Isp internal ids. */
  ids?: InputMaybe<Array<Scalars['Int']>>;
};

export type ItunesCategory = {
  __typename?: 'ItunesCategory';
  /** The stable id of the Itunes category. */
  id?: Maybe<Scalars['ID']>;
  /** The name of the Itunes category. */
  name?: Maybe<Scalars['String']>;
  /** Any sub categories that this category has. */
  subItunesCategories: Array<ItunesCategory>;
};

export type ItunesCategoryParam = AudienceParam & {
  __typename?: 'ItunesCategoryParam';
  /** The list of Itunes categories. */
  categories: Array<Scalars['String']>;
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
};

export type ItunesCategoryParamAttributes = {
  /** The list of Itunes categories. */
  categories: Array<Scalars['String']>;
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
};

export type KeyValue = {
  __typename?: 'KeyValue';
  /** The key of the param. */
  key: Scalars['String'];
  /** The value of the param. */
  value: Scalars['String'];
};

export type KeyValueAttributes = {
  /** The key of the param. */
  key: Scalars['String'];
  /** The value of the param. */
  value: Scalars['String'];
};

export enum KeyValueGroupMatchCriteria {
  /** The group is a match if all of the kvps match are matched. */
  AllOf = 'ALL_OF',
  /** The group is a match if any of the kvps match are matched. */
  AnyOf = 'ANY_OF'
}

export type KeyValueGroupParam = AudienceParam & {
  __typename?: 'KeyValueGroupParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The key value pairs in the group. */
  keyValues: Array<KeyValue>;
  /** Definition of what constitutes a match against the group. */
  matchCriteria: KeyValueGroupMatchCriteria;
};

export type KeyValueGroupParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The key value pairs in the group. */
  keyValues: Array<KeyValueAttributes>;
  /** Definition of what constitutes a match against the group. */
  matchCriteria: KeyValueGroupMatchCriteria;
};

export type LocalDateRangeAttributes = {
  endDate: Scalars['LocalDate'];
  startDate: Scalars['LocalDate'];
};

export enum Locality {
  Local = 'LOCAL',
  LocalityUnspecified = 'LOCALITY_UNSPECIFIED',
  National = 'NATIONAL'
}

export type LocationAccuracies = {
  __typename?: 'LocationAccuracies';
  allValues?: Maybe<Array<Scalars['Int']>>;
  defaultValue: Scalars['Int'];
};

export type LocationGroup = TargetingV2ParameterGroup & {
  __typename?: 'LocationGroup';
  /** The accuracy radius of this location in kilometers (km) */
  accuracyRadius?: Maybe<Scalars['Int']>;
  limitLocationParameterValue?: Maybe<LocationParameterValue>;
  parameters: Array<LocationParameter>;
};

export type LocationGroupAttributes = {
  accuracyRadius?: InputMaybe<Scalars['Int']>;
  limitLocationParameterValue?: InputMaybe<LocationParameterValueAttribute>;
  parameters?: InputMaybe<Array<LocationParameterAttributes>>;
};

export type LocationParam = AudienceParam & {
  __typename?: 'LocationParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of geographical positions of the targeted audience. */
  positions: Array<Position>;
};

export type LocationParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of geographical positions of the targeted audience. */
  positions: Array<PositionAttributes>;
};

export type LocationParameter = TargetingV2Parameter & {
  __typename?: 'LocationParameter';
  clusivity: Clusivity;
  type: LocationParameterType;
  values: Array<LocationParameterValue>;
};

export type LocationParameterAttributes = {
  clusivity: Clusivity;
  type: LocationParameterType;
  values: Array<LocationParameterValueAttribute>;
};

export type LocationParameterInfo = TargetingV2ParameterInfo & {
  __typename?: 'LocationParameterInfo';
  cardinality: Cardinality;
  name: Scalars['String'];
  type: LocationParameterType;
};

export enum LocationParameterType {
  DesignatedMarketArea = 'DESIGNATED_MARKET_AREA',
  Geo = 'GEO',
  LatLong = 'LAT_LONG',
  Zipcode = 'ZIPCODE'
}

export type LocationParameterValue = TargetingV2ParameterValue & {
  __typename?: 'LocationParameterValue';
  children: Array<Maybe<LocationParameterValue>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parents: Array<Maybe<LocationParameterValue>>;
};

export type LocationParameterValueAttribute = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type LocationTargeting = {
  __typename?: 'LocationTargeting';
  locations?: Maybe<Array<LocationGroup>>;
};

export type LocationTargetingAttributes = {
  locations: Array<LocationGroupAttributes>;
};

export type MasterControl = {
  __typename?: 'MasterControl';
  /** The state of the master control (e.g. will be true when all campaigns are frozen). */
  disabled: Scalars['Boolean'];
  /** The subject of this master control. */
  subject: MasterControlSubject;
};

/** The action to perform part of a master control operation. */
export enum MasterControlAction {
  Freeze = 'FREEZE',
  Quarantine = 'QUARANTINE',
  RevertQuarantine = 'REVERT_QUARANTINE',
  Unfreeze = 'UNFREEZE'
}

/** The subject to perform the master control operation on. */
export enum MasterControlSubject {
  Campaign = 'CAMPAIGN',
  Deal = 'DEAL',
  SalesChannel = 'SALES_CHANNEL'
}

export enum MediaType {
  Audio = 'AUDIO',
  Social = 'SOCIAL',
  Video = 'VIDEO'
}

export type MinimalAd = {
  __typename?: 'MinimalAd';
  id: Scalars['ID'];
  impressions?: Maybe<Scalars['NonNegativeInt']>;
  ltr?: Maybe<Scalars['NonNegativeFloat']>;
  mediaSpend?: Maybe<Scalars['BigDecimal']>;
  name: Scalars['String'];
  territory: Territory;
};

export type MinimalFlight = {
  __typename?: 'MinimalFlight';
  billedImpressions?: Maybe<Scalars['Long']>;
  budget: Scalars['BigDecimal'];
  businessId?: Maybe<Scalars['String']>;
  clickThroughRate?: Maybe<Scalars['Float']>;
  clicks?: Maybe<Scalars['Int']>;
  companionImpressions?: Maybe<Scalars['NonNegativeInt']>;
  deliveredPercentage?: Maybe<Scalars['BigDecimal']>;
  endDate?: Maybe<Scalars['LocalDateTime']>;
  engagementTime?: Maybe<Scalars['Long']>;
  flightType: FlightTypeInfo;
  frequency?: Maybe<Scalars['BigDecimal']>;
  id: Scalars['ID'];
  impressions?: Maybe<Scalars['Long']>;
  listenThroughRate?: Maybe<Scalars['Float']>;
  mediaSpend?: Maybe<Scalars['BigDecimal']>;
  minimalAds: Array<MinimalAd>;
  minimalOrderLine?: Maybe<MinimalOrderLine>;
  name: Scalars['String'];
  objectiveImpressions?: Maybe<Scalars['Long']>;
  reach?: Maybe<Scalars['Long']>;
  startDate?: Maybe<Scalars['LocalDateTime']>;
  status: FlightStatus;
  territory: Territory;
  timeZone: Scalars['ZoneId'];
};

export type MinimalOrderLine = {
  __typename?: 'MinimalOrderLine';
  businessId?: Maybe<Scalars['String']>;
  clickThroughRate?: Maybe<Scalars['Float']>;
  clicks?: Maybe<Scalars['Long']>;
  companionImpressions?: Maybe<Scalars['NonNegativeInt']>;
  daxOrderId?: Maybe<Scalars['ID']>;
  deliveredPercentage?: Maybe<Scalars['BigDecimal']>;
  endDate?: Maybe<Scalars['LocalDateTime']>;
  engagementTime?: Maybe<Scalars['Long']>;
  frequency?: Maybe<Scalars['BigDecimal']>;
  id: Scalars['ID'];
  impressions?: Maybe<Scalars['Long']>;
  listenThroughRate?: Maybe<Scalars['Float']>;
  minimalFlights: Array<MinimalFlight>;
  name: Scalars['String'];
  omOrderId?: Maybe<Scalars['String']>;
  reach?: Maybe<Scalars['Long']>;
  startDate?: Maybe<Scalars['LocalDateTime']>;
  status: OrderLineStatus;
  territory: Territory;
  timeZone: Scalars['ZoneId'];
  totalBudget?: Maybe<Scalars['BigDecimal']>;
  totalObjectiveImpressions?: Maybe<Scalars['Long']>;
};

export type MinimalOrderLineFilter = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  endDateFilter?: InputMaybe<OrderLineEndDateFilter>;
  owner: OrderLineOwnerFilter;
  startDateFilter?: InputMaybe<OrderLineStartDateFilter>;
  statuses?: InputMaybe<Array<OrderLineStatus>>;
};

export type MinimalOrderLineOffsetPaginationResponse = {
  __typename?: 'MinimalOrderLineOffsetPaginationResponse';
  minimalOrderLines?: Maybe<Array<MinimalOrderLine>>;
  pageMetaData?: Maybe<PageMetaData>;
};

export type MinimalShow = {
  __typename?: 'MinimalShow';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type MultiSeatAllocation = {
  /** The DSP that all seats, whether explicit or not, must belong to. If null, we will unassign the DSP and seatIds are ignored. */
  dspId?: InputMaybe<Scalars['ID']>;
  /** The explicit seats you want to assign to the deal. All seatIds must share the same dspId. If empty, all seats are used on the Deal from the DSP. */
  seatIds: Array<Scalars['ID']>;
};

export type MultipleProposedFlightsForecastAttributes = {
  /** The targeting details of all the flights on this forecast */
  flightTargetingAttributes: Array<FlightTargetingAttributes>;
  /** The list of IAB category codes */
  iabCategoryCodes?: InputMaybe<Array<Scalars['ID']>>;
  /** Includes the Forecast payload in the response */
  includeJsonPayload?: InputMaybe<Scalars['Boolean']>;
  /** Required if targetingDefinition is set */
  territory: Territory;
  /** The time zone in IANA format (e.g. Europe/London) */
  timeZone: Scalars['ZoneId'];
};

export type Mutation = {
  __typename?: 'Mutation';
  amendBookedOrderLine: Scalars['ID'];
  applyAmendment: Array<Scalars['String']>;
  approveAmendment: Array<Scalars['String']>;
  approveBooking: Scalars['String'];
  assignCollaborator: Scalars['Boolean'];
  backloadReportingForAllShowContracts: Scalars['Boolean'];
  backloadReportingForAllShows: Scalars['Boolean'];
  backloadReportingForShow: Scalars['ID'];
  backloadReportingForShowContract: Scalars['ID'];
  backloadReportingForShowContracts: Scalars['ID'];
  bookOrderLine: Scalars['ID'];
  cancelAmendment: Scalars['ID'];
  cancelAmendmentApprovalRequest: Scalars['ID'];
  cancelBookedOrderLine: Scalars['ID'];
  cancelBookingApproval: Scalars['ID'];
  cloneAdLegacy?: Maybe<AdLegacy>;
  cloneCampaign?: Maybe<Campaign>;
  cloneDealLegacy?: Maybe<DealLegacy>;
  cloneOrder?: Maybe<Order>;
  createAd: Scalars['ID'];
  createAdLegacy?: Maybe<AdLegacy>;
  /** @deprecated No longer used in new DAX 2.0 platform */
  createAdvertiserLegacy?: Maybe<Advertiser>;
  createAgency: Scalars['ID'];
  /** @deprecated No longer used in new DAX 2.0 platform */
  createAgencyLegacy?: Maybe<Agency>;
  createAmendApprovalRequest: Scalars['ID'];
  createBillingLine: Scalars['ID'];
  createBrand: Scalars['ID'];
  createBusiness: Scalars['ID'];
  createBusinessUser: Scalars['ID'];
  createCampaign?: Maybe<Campaign>;
  createChangeRequest: Scalars['ID'];
  createChannel: Scalars['ID'];
  /** @deprecated No longer used in new DAX 2.0 platform */
  createChannelLegacy?: Maybe<ChannelLegacy>;
  createComment: Scalars['ID'];
  createCountryGroup?: Maybe<CountryGroup>;
  createCreative: Scalars['ID'];
  /**
   * Based on the type you specify, you need to send the relevant attribute, only one is accepted.
   * @deprecated No longer used in new DAX 2.0 platform
   */
  createCreativeLegacy?: Maybe<CreativeLegacy>;
  createDataCenter: Scalars['ID'];
  createDataCenterLegacy?: Maybe<DataCenterLegacy>;
  createDaxIdTag: Scalars['ID'];
  createDaxShowContract: Scalars['ID'];
  createDealLegacy?: Maybe<DealLegacy>;
  createDepartment: Scalars['String'];
  createDsp: Scalars['ID'];
  createDspLegacy?: Maybe<DspLegacy>;
  createFeatureFlag: Scalars['ID'];
  createFlight: Scalars['ID'];
  createNetwork: Scalars['ID'];
  /** @deprecated No longer used in new DAX 2.0 platform */
  createNetworkLegacy?: Maybe<NetworkLegacy>;
  createOptionsForProposal: Array<Maybe<Scalars['Int']>>;
  createOrder?: Maybe<Order>;
  createOrderLine: Scalars['ID'];
  createOrderLineFromOmOrder: Scalars['ID'];
  createPlatformStatusMessage: Scalars['Boolean'];
  createPlatformUser: Scalars['ID'];
  createPostcodeGroup?: Maybe<PostcodeGroup>;
  createProgrammaticBillingLine: Scalars['ID'];
  createProgrammaticConnector: Scalars['ID'];
  createProposal: Scalars['ID'];
  createProposalAndImportChildren: Scalars['ID'];
  createProposedFlight: Scalars['ID'];
  createProposedFlightWithoutValidations: Scalars['ID'];
  createPublisher: Scalars['ID'];
  createPublisherContract: Scalars['ID'];
  /** @deprecated No longer used in new DAX 2.0 platform */
  createPublisherContractLegacy?: Maybe<PublisherContractLegacy>;
  /** @deprecated No longer used in new DAX 2.0 platform */
  createPublisherLegacy?: Maybe<PublisherLegacy>;
  createSalesChannelLegacy?: Maybe<SalesChannelLegacy>;
  createSeat: Scalars['ID'];
  createSeatLegacy?: Maybe<SeatLegacy>;
  createSharedInventoryGroup: Scalars['String'];
  createSharedReportingGroup: Scalars['String'];
  createShow: Scalars['ID'];
  createShowContract?: Maybe<ShowContract>;
  createSocialProposedFlight: Scalars['ID'];
  createTag?: Maybe<Tag>;
  createTargetingStrategy: Scalars['ID'];
  createTargetingTemplate?: Maybe<TargetingTemplate>;
  createTeam: Scalars['String'];
  createTechnicalProviderLegacy?: Maybe<TechnicalProviderLegacy>;
  createTranscodePreset?: Maybe<TranscodePreset>;
  createUser?: Maybe<User>;
  createVideoProposedFlight: Scalars['ID'];
  deleteAdLegacy?: Maybe<AdLegacy>;
  /** @deprecated No longer used in new DAX 2.0 platform */
  deleteAdvertiserLegacy?: Maybe<Advertiser>;
  deleteAgency: Scalars['ID'];
  /** @deprecated No longer used in new DAX 2.0 platform */
  deleteAgencyLegacy?: Maybe<Agency>;
  deleteBillingLine: Scalars['ID'];
  deleteBrand: Scalars['ID'];
  deleteBusinessUser: Scalars['ID'];
  deleteCampaign?: Maybe<Campaign>;
  /** @deprecated No longer used in new DAX 2.0 platform */
  deleteChannelLegacy?: Maybe<ChannelLegacy>;
  deleteComment: Scalars['ID'];
  deleteCountryGroup?: Maybe<CountryGroup>;
  deleteCreative: Scalars['ID'];
  /** @deprecated No longer used in new DAX 2.0 platform */
  deleteCreativeLegacy?: Maybe<CreativeLegacy>;
  deleteDataCenter: Scalars['ID'];
  deleteDataCenterLegacy?: Maybe<DataCenterLegacy>;
  deleteDealLegacy?: Maybe<DealLegacy>;
  deleteDsp: Scalars['ID'];
  deleteDspLegacy?: Maybe<DspLegacy>;
  deleteFeatureFlag: Scalars['ID'];
  deleteNetwork: Scalars['ID'];
  /** @deprecated No longer used in new DAX 2.0 platform */
  deleteNetworkLegacy?: Maybe<NetworkLegacy>;
  deleteOptionsForProposal: Scalars['ID'];
  deleteOrder?: Maybe<Order>;
  deleteOrderLine: Scalars['ID'];
  deletePlatformStatusMessage: Scalars['Boolean'];
  deletePlatformUser: Scalars['ID'];
  deletePostcodeGroup?: Maybe<PostcodeGroup>;
  deleteProgrammaticBillingLine: Scalars['ID'];
  deleteProgrammaticConnector: Scalars['ID'];
  deleteProposal: Scalars['ID'];
  deleteProposedFlight: Scalars['ID'];
  /** @deprecated No longer used in new DAX 2.0 platform */
  deletePublisherContractLegacy?: Maybe<PublisherContractLegacy>;
  /** @deprecated No longer used in new DAX 2.0 platform */
  deletePublisherLegacy?: Maybe<PublisherLegacy>;
  deleteSalesChannelLegacy?: Maybe<SalesChannelLegacy>;
  deleteSeat: Scalars['ID'];
  deleteSeatLegacy?: Maybe<SeatLegacy>;
  deleteShow: Scalars['ID'];
  deleteShowContract?: Maybe<ShowContract>;
  deleteTag?: Maybe<Tag>;
  deleteTargetingStrategy: Scalars['ID'];
  deleteTargetingTemplate?: Maybe<TargetingTemplate>;
  deleteTechnicalProviderLegacy?: Maybe<TechnicalProviderLegacy>;
  deleteUser?: Maybe<User>;
  duplicateBillingLine: Scalars['ID'];
  duplicateOrderLine: Scalars['ID'];
  duplicateProposal: Scalars['ID'];
  duplicateProposedFlight: Scalars['ID'];
  importProposalChildren: Scalars['ID'];
  indexOrderLine: Scalars['Boolean'];
  inviteUser?: Maybe<User>;
  masterControl?: Maybe<Scalars['Boolean']>;
  populateDirectSearchIndex: Scalars['Boolean'];
  populateExchangeSearchIndex: Scalars['Boolean'];
  populateSupplySearchIndex: Scalars['Boolean'];
  primaryControl: Array<PrimaryControlEntry>;
  putToBasket: Scalars['ID'];
  removeAdCreativeOverride: Scalars['ID'];
  removeCollaborator: Scalars['Boolean'];
  removeDirectEntityFromIndex: Scalars['Boolean'];
  removeSharedInventoryGroup: Scalars['String'];
  removeSharedReportingGroup: Scalars['String'];
  republishNonSpotRevenue: Scalars['ID'];
  requestAmendmentApproval: Scalars['ID'];
  requestAmendmentChange: Scalars['ID'];
  requestBookingApproval: Scalars['ID'];
  requestBookingChange: Scalars['ID'];
  setAdCreativeOverride: Scalars['ID'];
  updateAdCreativeOverride: Scalars['ID'];
  updateAdLegacy?: Maybe<AdLegacy>;
  updateAdStatus: Scalars['ID'];
  /** @deprecated No longer used in new DAX 2.0 platform */
  updateAdvertiserLegacy?: Maybe<Advertiser>;
  updateAgency: Scalars['ID'];
  /** @deprecated No longer used in new DAX 2.0 platform */
  updateAgencyLegacy?: Maybe<Agency>;
  updateBillingLine: Scalars['ID'];
  updateBrand: Scalars['ID'];
  updateBusiness: Scalars['ID'];
  updateBusinessEnabledPermissions: BusinessRoleConfiguration;
  updateBusinessSettings: Scalars['ID'];
  updateBusinessUser: Scalars['ID'];
  updateCampaign?: Maybe<Campaign>;
  updateChannel: Scalars['ID'];
  /** @deprecated No longer used in new DAX 2.0 platform */
  updateChannelLegacy?: Maybe<ChannelLegacy>;
  updateComment: Scalars['ID'];
  updateCountryGroup?: Maybe<CountryGroup>;
  updateCreative: Scalars['ID'];
  /**
   * Based on the type you specify, you need to send the relevant attribute, only one is accepted.
   * @deprecated No longer used in new DAX 2.0 platform
   */
  updateCreativeLegacy?: Maybe<CreativeLegacy>;
  updateDataCenter: Scalars['ID'];
  updateDataCenterLegacy?: Maybe<DataCenterLegacy>;
  updateDataCenterState: Scalars['ID'];
  updateDaxIdTag: Scalars['ID'];
  updateDaxIdTagState: Scalars['ID'];
  updateDaxShowContract: Scalars['ID'];
  updateDealLegacy?: Maybe<DealLegacy>;
  updateDepartment: Scalars['String'];
  updateDsp: Scalars['ID'];
  updateDspLegacy?: Maybe<DspLegacy>;
  updateDspState: Scalars['ID'];
  updateFeatureFlag: Scalars['ID'];
  updateFlight: Scalars['ID'];
  updateFlightStatus: Scalars['ID'];
  updateGlobalBlacklistedDomains: Array<TerritoryToDomains>;
  updateGlobalBlacklistedIabCategories: Array<TerritoryToIabCategories>;
  updateNetwork: Scalars['ID'];
  /** @deprecated No longer used in new DAX 2.0 platform */
  updateNetworkLegacy?: Maybe<NetworkLegacy>;
  updateOrder?: Maybe<Order>;
  updateOrderLine: Scalars['ID'];
  updatePlatformStatusMessage: Scalars['Boolean'];
  updatePlatformUser: Scalars['ID'];
  updatePostcodeGroup?: Maybe<PostcodeGroup>;
  updateProgrammaticBillingLine: Scalars['ID'];
  updateProgrammaticConnector: Scalars['ID'];
  updateProgrammaticConnectorState: Scalars['ID'];
  /** Updating the status of a programmatic creative. */
  updateProgrammaticCreative?: Maybe<ProgrammaticCreative>;
  updateProposal: Scalars['ID'];
  updateProposedFlight: Scalars['ID'];
  updatePublisher: Scalars['ID'];
  updatePublisherContract: Scalars['ID'];
  /** @deprecated No longer used in new DAX 2.0 platform */
  updatePublisherContractLegacy?: Maybe<PublisherContractLegacy>;
  /** @deprecated No longer used in new DAX 2.0 platform */
  updatePublisherLegacy?: Maybe<PublisherLegacy>;
  updatePublisherState: Scalars['ID'];
  updateSalesChannelLegacy?: Maybe<SalesChannelLegacy>;
  updateSeat: Scalars['ID'];
  updateSeatLegacy?: Maybe<SeatLegacy>;
  updateSeatState: Scalars['ID'];
  updateSharedInventoryGroup: Scalars['String'];
  updateSharedReportingGroup: Scalars['String'];
  updateShow: Scalars['ID'];
  updateShowContract?: Maybe<ShowContract>;
  updateTag?: Maybe<Tag>;
  updateTargetingStrategy: Scalars['ID'];
  updateTargetingTemplate?: Maybe<TargetingTemplate>;
  updateTeam: Scalars['String'];
  updateTechnicalProviderLegacy?: Maybe<TechnicalProviderLegacy>;
  updateUser?: Maybe<User>;
  updateVideoProposedFlight: Scalars['ID'];
};


export type MutationAmendBookedOrderLineArgs = {
  id: Scalars['ID'];
};


export type MutationApplyAmendmentArgs = {
  proposalAmendmentId: Scalars['ID'];
};


export type MutationApproveAmendmentArgs = {
  proposalAmendmentId: Scalars['ID'];
};


export type MutationApproveBookingArgs = {
  proposalId: Scalars['ID'];
};


export type MutationAssignCollaboratorArgs = {
  orderLineId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationBackloadReportingForShowArgs = {
  id: Scalars['ID'];
};


export type MutationBackloadReportingForShowContractArgs = {
  id: Scalars['ID'];
};


export type MutationBackloadReportingForShowContractsArgs = {
  daxShowId: Scalars['ID'];
};


export type MutationBookOrderLineArgs = {
  activeProposalId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationCancelAmendmentArgs = {
  proposalAmendmentId: Scalars['ID'];
};


export type MutationCancelAmendmentApprovalRequestArgs = {
  proposalAmendmentId: Scalars['ID'];
};


export type MutationCancelBookedOrderLineArgs = {
  orderLineId: Scalars['ID'];
};


export type MutationCancelBookingApprovalArgs = {
  proposalId: Scalars['ID'];
};


export type MutationCloneAdLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationCloneCampaignArgs = {
  disableCascade?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationCloneDealLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationCloneOrderArgs = {
  disableCascade?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationCreateAdArgs = {
  attributes: CreateAdAttributes;
};


export type MutationCreateAdLegacyArgs = {
  attributes: AdAttributesLegacy;
  campaignId: Scalars['ID'];
};


export type MutationCreateAdvertiserLegacyArgs = {
  agencyId: Scalars['ID'];
  attributes: AdvertiserAttributes;
};


export type MutationCreateAgencyArgs = {
  attributes: AgencyAttributes;
};


export type MutationCreateAgencyLegacyArgs = {
  attributes: AgencyAttributesLegacy;
};


export type MutationCreateAmendApprovalRequestArgs = {
  attributes: AmendApprovalRequestAttributes;
  orderLineId: Scalars['ID'];
};


export type MutationCreateBillingLineArgs = {
  attributes: BillingLineAttributes;
  proposalId: Scalars['ID'];
};


export type MutationCreateBrandArgs = {
  agencyId: Scalars['ID'];
  attributes: BrandAttributes;
};


export type MutationCreateBusinessArgs = {
  businessAttributes: BusinessAttributes;
};


export type MutationCreateBusinessUserArgs = {
  attributes: BusinessUserCreateAttributes;
};


export type MutationCreateCampaignArgs = {
  attributes: CampaignAttributes;
  orderId: Scalars['ID'];
};


export type MutationCreateChangeRequestArgs = {
  attributes: ChangeRequestAttributes;
  orderLineId: Scalars['ID'];
};


export type MutationCreateChannelArgs = {
  attributes: CreateChannelAttributes;
};


export type MutationCreateChannelLegacyArgs = {
  attributes: ChannelLegacyAttributes;
  publisherId: Scalars['ID'];
};


export type MutationCreateCommentArgs = {
  attributes: CommentAttributes;
  orderLineId: Scalars['ID'];
};


export type MutationCreateCountryGroupArgs = {
  attributes: CountryGroupAttributes;
};


export type MutationCreateCreativeArgs = {
  attributes: CreateCreativeAttributes;
  brandId: Scalars['ID'];
};


export type MutationCreateCreativeLegacyArgs = {
  advertiserId: Scalars['ID'];
  audioAttributes?: InputMaybe<CreativeAudioCreateAttributesLegacy>;
  imageAttributes?: InputMaybe<CreativeImageCreateAttributesLegacy>;
  redirectAttributes?: InputMaybe<CreativeRedirectAttributesLegacy>;
  type: CreativeTypeLegacy;
};


export type MutationCreateDataCenterArgs = {
  attributes: DataCenterAttributes;
  programmaticConnectorId: Scalars['ID'];
};


export type MutationCreateDataCenterLegacyArgs = {
  attributes: DataCenterLegacyAttributes;
  technicalProviderId: Scalars['ID'];
};


export type MutationCreateDaxIdTagArgs = {
  attributes?: InputMaybe<CreateDaxIdTagAttributes>;
};


export type MutationCreateDaxShowContractArgs = {
  attributes: CreateDaxShowContractAttributes;
};


export type MutationCreateDealLegacyArgs = {
  attributes: DealLegacyAttributes;
  salesChannelId: Scalars['ID'];
};


export type MutationCreateDepartmentArgs = {
  attributes: DepartmentAttributes;
};


export type MutationCreateDspArgs = {
  attributes: DspAttributes;
  programmaticConnectorId: Scalars['ID'];
};


export type MutationCreateDspLegacyArgs = {
  attributes: DspLegacyAttributes;
  technicalProviderId: Scalars['ID'];
};


export type MutationCreateFeatureFlagArgs = {
  attributes: FeatureFlagAttributes;
  name: Scalars['String'];
};


export type MutationCreateFlightArgs = {
  attributes: CreateFlightAttributes;
};


export type MutationCreateNetworkArgs = {
  attributes: CreateNetworkAttributes;
};


export type MutationCreateNetworkLegacyArgs = {
  attributes: NetworkLegacyAttributes;
};


export type MutationCreateOptionsForProposalArgs = {
  proposalId: Scalars['ID'];
};


export type MutationCreateOrderArgs = {
  advertiserId: Scalars['ID'];
  attributes: OrderAttributes;
};


export type MutationCreateOrderLineArgs = {
  attributes: OrderLineAttributes;
};


export type MutationCreateOrderLineFromOmOrderArgs = {
  id: Scalars['ID'];
};


export type MutationCreatePlatformStatusMessageArgs = {
  attributes: PlatformStatusMessageAttributes;
};


export type MutationCreatePlatformUserArgs = {
  attributes: PlatformUserCreateAttributes;
};


export type MutationCreatePostcodeGroupArgs = {
  attributes: PostCodeGroupAttributes;
};


export type MutationCreateProgrammaticBillingLineArgs = {
  attributes: ProgrammaticBillingLineAttributes;
  proposalId: Scalars['ID'];
};


export type MutationCreateProgrammaticConnectorArgs = {
  attributes: ProgrammaticConnectorAttributes;
};


export type MutationCreateProposalArgs = {
  attributes: ProposalAttributes;
  orderLineId: Scalars['ID'];
};


export type MutationCreateProposalAndImportChildrenArgs = {
  attributes: ProposalAttributes;
  orderLineId: Scalars['ID'];
  sourceProposalId: Scalars['ID'];
};


export type MutationCreateProposedFlightArgs = {
  createAttributes: CreateProposedFlightAttributes;
};


export type MutationCreateProposedFlightWithoutValidationsArgs = {
  createAttributes: CreateProposedFlightAttributes;
};


export type MutationCreatePublisherArgs = {
  attributes: CreatePublisherAttributes;
};


export type MutationCreatePublisherContractArgs = {
  attributes: CreatePublisherContractAttributes;
};


export type MutationCreatePublisherContractLegacyArgs = {
  attributes: PublisherContractLegacyAttributes;
  publisherId: Scalars['ID'];
};


export type MutationCreatePublisherLegacyArgs = {
  attributes: PublisherLegacyAttributes;
  networkId: Scalars['ID'];
};


export type MutationCreateSalesChannelLegacyArgs = {
  agencyId: Scalars['ID'];
  attributes: SalesChannelLegacyAttributes;
};


export type MutationCreateSeatArgs = {
  attributes: SeatAttributes;
  dspId: Scalars['ID'];
};


export type MutationCreateSeatLegacyArgs = {
  attributes: SeatLegacyAttributes;
  dspId: Scalars['ID'];
};


export type MutationCreateSharedInventoryGroupArgs = {
  attributes: SharedInventoryGroupAttributes;
  businessId: Scalars['ID'];
};


export type MutationCreateSharedReportingGroupArgs = {
  attributes: SharedReportingGroupAttributes;
  businessId: Scalars['ID'];
};


export type MutationCreateShowArgs = {
  attributes: CreateShowAttributes;
};


export type MutationCreateShowContractArgs = {
  attributes: ShowContractAttributes;
  channelId: Scalars['ID'];
};


export type MutationCreateSocialProposedFlightArgs = {
  createAttributes: CreateSocialProposedFlightAttributes;
};


export type MutationCreateTagArgs = {
  attributes: TagAttributes;
};


export type MutationCreateTargetingStrategyArgs = {
  attributes: TargetingStrategyAttributes;
  flightId: Scalars['ID'];
};


export type MutationCreateTargetingTemplateArgs = {
  attributes: TargetingTemplateAttributes;
  isMasterTemplate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateTeamArgs = {
  attributes: TeamAttributes;
};


export type MutationCreateTechnicalProviderLegacyArgs = {
  attributes: TechnicalProviderLegacyAttributes;
};


export type MutationCreateTranscodePresetArgs = {
  attributes: TranscodePresetAttributes;
};


export type MutationCreateUserArgs = {
  attributes: UserAttributes;
};


export type MutationCreateVideoProposedFlightArgs = {
  createAttributes: CreateVideoProposedFlightAttributes;
};


export type MutationDeleteAdLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAdvertiserLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAgencyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAgencyLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteBillingLineArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteBrandArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteBusinessUserArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteChannelLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCommentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCountryGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCreativeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCreativeLegacyArgs = {
  id: Scalars['ID'];
  type: CreativeTypeLegacy;
};


export type MutationDeleteDataCenterArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDataCenterLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDealLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDspArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDspLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFeatureFlagArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteNetworkArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteNetworkLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOptionsForProposalArgs = {
  proposalId: Scalars['ID'];
};


export type MutationDeleteOrderArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrderLineArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePlatformUserArgs = {
  userId: Scalars['ID'];
};


export type MutationDeletePostcodeGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProgrammaticBillingLineArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProgrammaticConnectorArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposalArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposedFlightArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePublisherContractLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePublisherLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSalesChannelLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSeatArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSeatLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteShowArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteShowContractArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTargetingStrategyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTargetingTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTechnicalProviderLegacyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
};


export type MutationDuplicateBillingLineArgs = {
  id: Scalars['ID'];
};


export type MutationDuplicateOrderLineArgs = {
  id: Scalars['ID'];
};


export type MutationDuplicateProposalArgs = {
  id: Scalars['ID'];
};


export type MutationDuplicateProposedFlightArgs = {
  id: Scalars['ID'];
};


export type MutationImportProposalChildrenArgs = {
  destinationProposalId: Scalars['ID'];
  sourceProposalId: Scalars['ID'];
};


export type MutationIndexOrderLineArgs = {
  id: Scalars['ID'];
};


export type MutationInviteUserArgs = {
  id: Scalars['ID'];
};


export type MutationMasterControlArgs = {
  action: MasterControlAction;
  subject: MasterControlSubject;
};


export type MutationPopulateDirectSearchIndexArgs = {
  territories: Array<Territory>;
};


export type MutationPrimaryControlArgs = {
  entity: PrimaryControlEntity;
  entries: Array<PrimaryControlEntryInput>;
  state: PrimaryControlState;
};


export type MutationPutToBasketArgs = {
  proposalId: Scalars['ID'];
};


export type MutationRemoveAdCreativeOverrideArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCollaboratorArgs = {
  orderLineId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationRemoveDirectEntityFromIndexArgs = {
  attributes: EntityTypeIdAttributes;
};


export type MutationRemoveSharedInventoryGroupArgs = {
  businessId: Scalars['ID'];
  sharedInventoryGroupId: Scalars['String'];
};


export type MutationRemoveSharedReportingGroupArgs = {
  businessId: Scalars['ID'];
  sharedReportingGroupId: Scalars['String'];
};


export type MutationRepublishNonSpotRevenueArgs = {
  date: Scalars['LocalDate'];
  proposedFlightId: Scalars['ID'];
  revenue?: InputMaybe<Scalars['BigDecimal']>;
};


export type MutationRequestAmendmentApprovalArgs = {
  proposalAmendmentId: Scalars['ID'];
  requestBody: Scalars['String'];
};


export type MutationRequestAmendmentChangeArgs = {
  proposalAmendmentId: Scalars['ID'];
  requestBody: Scalars['String'];
};


export type MutationRequestBookingApprovalArgs = {
  proposalId: Scalars['ID'];
  requestBody: Scalars['String'];
};


export type MutationRequestBookingChangeArgs = {
  proposalId: Scalars['ID'];
  requestBody: Scalars['String'];
};


export type MutationSetAdCreativeOverrideArgs = {
  creativeOverride: CreativeOverrideAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateAdCreativeOverrideArgs = {
  creativeOverride: CreativeOverrideAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateAdLegacyArgs = {
  attributes: AdAttributesLegacy;
  id: Scalars['ID'];
};


export type MutationUpdateAdStatusArgs = {
  id: Scalars['ID'];
  status: AdUpdateStatus;
};


export type MutationUpdateAdvertiserLegacyArgs = {
  attributes: AdvertiserAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateAgencyArgs = {
  attributes: AgencyAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateAgencyLegacyArgs = {
  attributes: AgencyAttributesLegacy;
  id: Scalars['ID'];
};


export type MutationUpdateBillingLineArgs = {
  attributes: BillingLineAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateBrandArgs = {
  attributes: BrandAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateBusinessArgs = {
  businessAttributes: BusinessAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateBusinessEnabledPermissionsArgs = {
  businessId: Scalars['ID'];
  enabledPermissions: Array<PermissionV2>;
};


export type MutationUpdateBusinessSettingsArgs = {
  businessSettingsAttributes: BusinessSettingsAttributes;
};


export type MutationUpdateBusinessUserArgs = {
  attributes: BusinessUserUpdateAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateCampaignArgs = {
  attributes: CampaignAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateChannelArgs = {
  attributes: UpdateChannelAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateChannelLegacyArgs = {
  attributes: ChannelLegacyAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateCommentArgs = {
  attributes: CommentAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateCountryGroupArgs = {
  attributes: CountryGroupAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateCreativeArgs = {
  attributes: UpdateCreativeAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateCreativeLegacyArgs = {
  audioAttributes?: InputMaybe<CreativeAudioUpdateAttributesLegacy>;
  id: Scalars['ID'];
  imageAttributes?: InputMaybe<CreativeImageUpdateAttributesLegacy>;
  redirectAttributes?: InputMaybe<CreativeRedirectAttributesLegacy>;
  type: CreativeTypeLegacy;
};


export type MutationUpdateDataCenterArgs = {
  attributes: DataCenterAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateDataCenterLegacyArgs = {
  attributes: DataCenterLegacyAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateDataCenterStateArgs = {
  id: Scalars['ID'];
  state: EntityState;
};


export type MutationUpdateDaxIdTagArgs = {
  attributes?: InputMaybe<DaxIdTagAttributes>;
  tagId: Scalars['ID'];
};


export type MutationUpdateDaxIdTagStateArgs = {
  id: Scalars['ID'];
  state: EntityState;
};


export type MutationUpdateDaxShowContractArgs = {
  attributes: UpdateDaxShowContractAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateDealLegacyArgs = {
  attributes: DealLegacyAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateDepartmentArgs = {
  attributes: DepartmentAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateDspArgs = {
  attributes: DspAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateDspLegacyArgs = {
  attributes: DspLegacyAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateDspStateArgs = {
  id: Scalars['ID'];
  state: EntityState;
};


export type MutationUpdateFeatureFlagArgs = {
  attributes: FeatureFlagAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateFlightArgs = {
  flightAttributes: FlightAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateFlightStatusArgs = {
  id: Scalars['ID'];
  status: FlightUpdateStatus;
};


export type MutationUpdateGlobalBlacklistedDomainsArgs = {
  blacklistedDomains: Array<Scalars['DomainName']>;
  territory: Territory;
};


export type MutationUpdateGlobalBlacklistedIabCategoriesArgs = {
  blacklistedIabCategoryCodes: Array<Scalars['ID']>;
  territory: Territory;
};


export type MutationUpdateNetworkArgs = {
  attributes: UpdateNetworkAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateNetworkLegacyArgs = {
  attributes: NetworkLegacyAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateOrderArgs = {
  attributes: OrderAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateOrderLineArgs = {
  attributes: OrderLineAttributes;
  id: Scalars['ID'];
};


export type MutationUpdatePlatformStatusMessageArgs = {
  attributes: PlatformStatusMessageAttributes;
};


export type MutationUpdatePlatformUserArgs = {
  attributes: PlatformUserUpdateAttributes;
  userId: Scalars['ID'];
};


export type MutationUpdatePostcodeGroupArgs = {
  attributes: PostCodeGroupAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateProgrammaticBillingLineArgs = {
  attributes: ProgrammaticBillingLineAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateProgrammaticConnectorArgs = {
  attributes: ProgrammaticConnectorAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateProgrammaticConnectorStateArgs = {
  id: Scalars['ID'];
  state: EntityState;
};


export type MutationUpdateProgrammaticCreativeArgs = {
  attributes: CreativeProgrammaticAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateProposalArgs = {
  attributes: ProposalAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateProposedFlightArgs = {
  updateAttributes: UpdateProposedFlightAttributes;
};


export type MutationUpdatePublisherArgs = {
  attributes: UpdatePublisherAttributes;
  id: Scalars['ID'];
};


export type MutationUpdatePublisherContractArgs = {
  attributes: UpdatePublisherContractAttributes;
  id: Scalars['ID'];
};


export type MutationUpdatePublisherContractLegacyArgs = {
  attributes: PublisherContractLegacyAttributes;
  id: Scalars['ID'];
};


export type MutationUpdatePublisherLegacyArgs = {
  attributes: PublisherLegacyAttributes;
  id: Scalars['ID'];
};


export type MutationUpdatePublisherStateArgs = {
  id: Scalars['ID'];
  state: EntityState;
};


export type MutationUpdateSalesChannelLegacyArgs = {
  attributes: SalesChannelLegacyAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateSeatArgs = {
  attributes: SeatAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateSeatLegacyArgs = {
  attributes: SeatLegacyAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateSeatStateArgs = {
  id: Scalars['ID'];
  state: EntityState;
};


export type MutationUpdateSharedInventoryGroupArgs = {
  attributes: SharedInventoryGroupAttributes;
  businessId: Scalars['ID'];
  sharedInventoryGroupId: Scalars['String'];
};


export type MutationUpdateSharedReportingGroupArgs = {
  attributes: SharedReportingGroupAttributes;
  businessId: Scalars['ID'];
  sharedReportingGroupId: Scalars['String'];
};


export type MutationUpdateShowArgs = {
  attributes: UpdateShowAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateShowContractArgs = {
  attributes: ShowContractAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateTagArgs = {
  attributes: TagAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateTargetingStrategyArgs = {
  attributes: TargetingStrategyAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateTargetingTemplateArgs = {
  attributes: TargetingTemplateAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateTeamArgs = {
  attributes: TeamAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateTechnicalProviderLegacyArgs = {
  attributes: TechnicalProviderLegacyAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateUserArgs = {
  attributes: UserAttributes;
  id: Scalars['ID'];
};


export type MutationUpdateVideoProposedFlightArgs = {
  updateAttributes: UpdateVideoProposedFlightAttributes;
};

export type Network = {
  __typename?: 'Network';
  audioAdsRequested: Scalars['Long'];
  audioImpressions: Scalars['Long'];
  id: Scalars['ID'];
  name: Scalars['String'];
  state: EntityState;
  status: SupplyStatus;
};

export type NetworkLegacy = Node & {
  __typename?: 'NetworkLegacy';
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The name of the network. */
  name?: Maybe<Scalars['String']>;
  /** The list of publishers that are part of this network. */
  publishers: Array<PublisherLegacy>;
  /** The status of the given network. */
  status?: Maybe<NetworkStatus>;
  /** The list of territories assigned to the network. */
  territories: Array<Territory>;
};


export type NetworkLegacyPublishersArgs = {
  filter?: InputMaybe<PublisherLegacyFilter>;
  territories: Array<Territory>;
};

export type NetworkLegacyAttributes = {
  /** The name of the network. */
  name?: InputMaybe<Scalars['String']>;
  /** The status of the given network. */
  status?: InputMaybe<NetworkStatus>;
  /** The list of territories assigned to the network. */
  territories?: InputMaybe<Array<Territory>>;
};

export type NetworkLegacyFilter = {
  status_in?: InputMaybe<Array<NetworkStatus>>;
};

export type NetworkOffsetPaginationResponse = {
  __typename?: 'NetworkOffsetPaginationResponse';
  networks: Array<Network>;
  pageMetaData?: Maybe<PageMetaData>;
};

export enum NetworkStatus {
  /** The status of the network once deleted. */
  Deleted = 'DELETED',
  /** Network is disabled. */
  Disabled = 'DISABLED',
  /** The default value when the network is first created. */
  Draft = 'DRAFT',
  /** Network is enabled. */
  Enabled = 'ENABLED'
}

export type NetworkTargeting = {
  __typename?: 'NetworkTargeting';
  clusivity?: Maybe<Clusivity>;
  id: Scalars['String'];
  publishers?: Maybe<Array<PublisherTargeting>>;
};

export type NielsenSegment = {
  __typename?: 'NielsenSegment';
  /** The full name of the segment. */
  fullName: Scalars['String'];
  /** The segment identifier as an UUID string. */
  id: Scalars['Int'];
  /** The short name of the segment. */
  shortName?: Maybe<Scalars['String']>;
};

export type NielsenSegmentAttributes = {
  /** The full/ display name of the segment. */
  fullName?: InputMaybe<Scalars['String']>;
  /** The segment id. */
  id: Scalars['ID'];
};

/** Node interface implemented by all types that must contain ids. */
export type Node = {
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
};

export type NodeHierarchyId = {
  __typename?: 'NodeHierarchyId';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<NodeHierarchyId>;
  type: NodeType;
};

export enum NodeType {
  AdPosition = 'AD_POSITION',
  Agency = 'AGENCY',
  Brand = 'BRAND',
  Channel = 'CHANNEL',
  City = 'CITY',
  Country = 'COUNTRY',
  DaxShow = 'DAX_SHOW',
  DeviceMaker = 'DEVICE_MAKER',
  DeviceModel = 'DEVICE_MODEL',
  DeviceOs = 'DEVICE_OS',
  DeviceVersion = 'DEVICE_VERSION',
  Network = 'NETWORK',
  Publisher = 'PUBLISHER',
  RegionPack = 'REGION_PACK',
  Root = 'ROOT',
  Show = 'SHOW',
  Subdivision1 = 'SUBDIVISION1',
  Subdivision2 = 'SUBDIVISION2'
}

/** Generic interface types for fields common to all note types. */
export type Note = {
  author: User;
  createdDate: Scalars['LocalDateTime'];
  id: Scalars['ID'];
  modifiedDate: Scalars['LocalDateTime'];
  noteType: NoteType;
  orderLineId: Scalars['String'];
};

export enum NoteType {
  AmendApprovalRequest = 'AMEND_APPROVAL_REQUEST',
  BookingApprovalRequest = 'BOOKING_APPROVAL_REQUEST',
  ChangeRequest = 'CHANGE_REQUEST',
  Comment = 'COMMENT'
}

export enum NotificationGroup {
  Amendments = 'AMENDMENTS',
  Booking = 'BOOKING',
  General = 'GENERAL'
}

export enum NotificationType {
  AmendmentsConfirmedAmendment = 'AMENDMENTS_CONFIRMED_AMENDMENT',
  ApprovalNeededAmendment = 'APPROVAL_NEEDED_AMENDMENT',
  ApprovalNeededBooking = 'APPROVAL_NEEDED_BOOKING',
  BookingApproved = 'BOOKING_APPROVED',
  BookingConfirmation = 'BOOKING_CONFIRMATION',
  BrandsMissingDomains = 'BRANDS_MISSING_DOMAINS',
  ChangesRequiredAmendment = 'CHANGES_REQUIRED_AMENDMENT',
  ChangesRequiredBooking = 'CHANGES_REQUIRED_BOOKING',
  CreativeStatusChange = 'CREATIVE_STATUS_CHANGE',
  DailyDigest = 'DAILY_DIGEST',
  OrderCancelled = 'ORDER_CANCELLED'
}

export type NotificationTypeInfo = {
  __typename?: 'NotificationTypeInfo';
  displayGroup: Scalars['String'];
  displayName: Scalars['String'];
  type: NotificationType;
};

export type NumberBasedBookingValidation = BusinessBookingValidation & {
  __typename?: 'NumberBasedBookingValidation';
  enabled: Scalars['Boolean'];
  number?: Maybe<Scalars['PositiveInt']>;
  type: BookingValidationType;
};

export type NumberBasedBookingValidationAttributes = {
  enabled: Scalars['Boolean'];
  number?: InputMaybe<Scalars['PositiveInt']>;
  type: BookingValidationType;
};

export type NumberBasedBusinessRule = BusinessRuleModel & {
  __typename?: 'NumberBasedBusinessRule';
  enabled: Scalars['Boolean'];
  number?: Maybe<Scalars['PositiveInt']>;
  type: BusinessRule;
};

export type NumberBasedBusinessRuleAttributes = {
  enabled: Scalars['Boolean'];
  number?: InputMaybe<Scalars['PositiveInt']>;
  type: BusinessRule;
};

export type OperatingSystem = {
  __typename?: 'OperatingSystem';
  /** The operating system name. */
  name: Scalars['String'];
  /** The versions of the operating system. */
  versions: Array<Scalars['String']>;
};

export type OperatingSystemAttributes = {
  /** The operating system name. */
  name: Scalars['String'];
  /** The versions of the operating system. */
  versions: Array<Scalars['String']>;
};

export type OptionQueue = {
  __typename?: 'OptionQueue';
  adPosition: ShowAdPosition;
  adSlots?: Maybe<Scalars['Int']>;
  options: Array<OptionQueueItem>;
};

export enum OptionQueueBookingStatus {
  Booked = 'BOOKED',
  BookingRequested = 'BOOKING_REQUESTED',
  Optioned = 'OPTIONED'
}

export type OptionQueueFilter = {
  adPosition: ShowAdPosition;
  endDate: Scalars['LocalDate'];
  mediaType: MediaType;
  startDate: Scalars['LocalDate'];
  targetMarkets?: InputMaybe<Array<Scalars['String']>>;
};

export type OptionQueueItem = {
  __typename?: 'OptionQueueItem';
  bookingStatus: OptionQueueBookingStatus;
  brand?: Maybe<Scalars['String']>;
  currency: Scalars['Currency'];
  endDate: Scalars['LocalDate'];
  optionIds: Array<Scalars['Int']>;
  optionedBy?: Maybe<Scalars['String']>;
  optionedDate: Scalars['LocalDateTime'];
  place?: Maybe<Scalars['String']>;
  proposedFlightId: Scalars['ID'];
  revenue?: Maybe<Scalars['BigDecimal']>;
  startDate: Scalars['LocalDate'];
};

export type Order = Node & {
  __typename?: 'Order';
  /** The parent advertiser that created this order. */
  advertiser?: Maybe<Advertiser>;
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** The list of campaigns created for this order. */
  campaigns: Array<Campaign>;
  /** The end date and time of the order in ISO format. */
  endDate?: Maybe<Scalars['LocalDateTime']>;
  /** The external identifier of the order. */
  externalId?: Maybe<Scalars['String']>;
  /** The external system identifier of the order. */
  externalSystemId?: Maybe<Scalars['String']>;
  /** Determines the maximum number of impressions per listener. */
  frequencyCapCount?: Maybe<Scalars['NonNegativeInt']>;
  /** Determines the time unit which the frequency cap value represents a multiple of. */
  frequencyCapTimeUnit?: Maybe<FrequencyCapTimeUnit>;
  /** Determines the time period value for which to deliver the number of ad impressions. */
  frequencyCapValue?: Maybe<Scalars['NonNegativeInt']>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The number of total impresssions served so far. */
  impressions?: Maybe<Scalars['NonNegativeInt']>;
  /** The name of the DAX order. */
  name?: Maybe<Scalars['String']>;
  /** The total number of impressions that the order wants to deliver. */
  objective?: Maybe<Scalars['NonNegativeInt']>;
  /** The owner of this order. */
  owner?: Maybe<User>;
  /** The name of the owner of this order. */
  ownerName?: Maybe<Scalars['String']>;
  /** The start date and time of the order in ISO format. */
  startDate?: Maybe<Scalars['LocalDateTime']>;
  /** The status of the given order. */
  status?: Maybe<OrderStatus>;
  /** The territory of the given order. */
  territory?: Maybe<Territory>;
  /** The time zone where the order starts and ends in IANA format (e.g. Europe/London) */
  timeZone?: Maybe<Scalars['ZoneId']>;
};


export type OrderCampaignsArgs = {
  filter?: InputMaybe<CampaignFilter>;
};

export type OrderAttributes = {
  /** The end date and time of the order in ISO format. */
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  /** The external identifier of the order. */
  externalId?: InputMaybe<Scalars['String']>;
  /** The external system identifier of the order. */
  externalSystemId?: InputMaybe<Scalars['String']>;
  /** Determines the maximum number of impressions per listener. */
  frequencyCapCount?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Determines the time unit which the frequency cap value represents a multiple of. */
  frequencyCapTimeUnit?: InputMaybe<FrequencyCapTimeUnit>;
  /** Determines the time period value for which to deliver the number of ad impressions. */
  frequencyCapValue?: InputMaybe<Scalars['NonNegativeInt']>;
  /** The name of the order. */
  name?: InputMaybe<Scalars['String']>;
  /** The total number of impressions that the order wants to deliver. */
  objective?: InputMaybe<Scalars['NonNegativeInt']>;
  /** The ID of the owner of this order. */
  ownerId?: InputMaybe<Scalars['ID']>;
  /** The start date and time of the order in ISO format. */
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  /** The status of the given order. */
  status?: InputMaybe<OrderStatus>;
  /** The territory of the given order. */
  territory?: InputMaybe<Territory>;
  /** The time zone where the order starts and ends in IANA format (e.g. Europe/London) */
  timeZone?: InputMaybe<Scalars['ZoneId']>;
};

export type OrderConnection = {
  __typename?: 'OrderConnection';
  edges: Array<Maybe<OrderEdge>>;
  pageInfo: PageInfo;
};

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor: Scalars['String'];
  node: Order;
};

export type OrderFilter = {
  /** Filters by end date range on the order. Only supported on cursor pagination. */
  endDateRange?: InputMaybe<DateRange>;
  /** Filters by partial match on alt id. Only supported on offset pagination. */
  partialAltId?: InputMaybe<Scalars['String']>;
  /** Filters by partial match on end date field on the entity. Only supported on offset pagination. */
  partialEndDate?: InputMaybe<Scalars['String']>;
  /** Filters by partial match on external id on the entity. Only supported on offset pagination. */
  partialExternalId?: InputMaybe<Scalars['String']>;
  /** Filters by partial match on name on the entity. Only supported on offset pagination. */
  partialName?: InputMaybe<Scalars['String']>;
  /** Filters by partial match on objective Impressions on the entity. Only supported on offset pagination. */
  partialObjective?: InputMaybe<Scalars['String']>;
  /** Filters by partial match on owner name on the entity. Only supported on offset pagination. */
  partialOwnerName?: InputMaybe<Scalars['String']>;
  /** Filters by partial match on start date field on the entity. Only supported on offset pagination. */
  partialStartDate?: InputMaybe<Scalars['String']>;
  /** Filters by status. Supported on cursor and offset pagination. */
  status_in?: InputMaybe<Array<OrderStatus>>;
};

export type OrderLine = {
  __typename?: 'OrderLine';
  activeProposalId?: Maybe<Scalars['ID']>;
  amendingProposal?: Maybe<Proposal>;
  bookingValidationMessages: Array<Scalars['String']>;
  brand: Brand;
  businessId?: Maybe<Scalars['String']>;
  clickThroughRate?: Maybe<Scalars['Float']>;
  clicks?: Maybe<Scalars['Long']>;
  collaborators?: Maybe<Array<User>>;
  companionImpressions?: Maybe<Scalars['NonNegativeInt']>;
  creditControlMessages: Array<Scalars['String']>;
  daxOrderId?: Maybe<Scalars['ID']>;
  deliveredPercentage?: Maybe<Scalars['BigDecimal']>;
  deliveryType: OrderLineDeliveryType;
  endDate?: Maybe<Scalars['LocalDateTime']>;
  engagementTime?: Maybe<Scalars['Long']>;
  entityType: EntityType;
  flights: Array<Flight>;
  frequency?: Maybe<Scalars['BigDecimal']>;
  iabCategories: Array<IabCategory>;
  id: Scalars['ID'];
  impressions?: Maybe<Scalars['Long']>;
  listenThroughRate?: Maybe<Scalars['Float']>;
  locality: Locality;
  modifiedDate: Scalars['LocalDateTime'];
  name: Scalars['String'];
  notes: Array<Note>;
  omOrderId?: Maybe<Scalars['ID']>;
  owner: User;
  proposals: Array<Proposal>;
  reach?: Maybe<Scalars['Long']>;
  startDate?: Maybe<Scalars['LocalDateTime']>;
  status: OrderLineStatus;
  team?: Maybe<Team>;
  territory: Territory;
  timeZone: Scalars['ZoneId'];
  totalBudget?: Maybe<Scalars['BigDecimal']>;
  totalObjectiveImpressions?: Maybe<Scalars['Long']>;
  type: OrderLineType;
};

export type OrderLineAttributes = {
  brandId: Scalars['ID'];
  iabCategoryCodes: Array<Scalars['ID']>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  teamId?: InputMaybe<Scalars['String']>;
  territory?: InputMaybe<Territory>;
  timeZone: Scalars['ZoneId'];
};

export enum OrderLineDeliveryType {
  Direct = 'DIRECT',
  Programmatic = 'PROGRAMMATIC'
}

export type OrderLineEndDateFilter = {
  endDateAfter?: InputMaybe<Scalars['LocalDateTime']>;
  endDateBefore?: InputMaybe<Scalars['LocalDateTime']>;
};

export type OrderLineEntityFilterAttributes = {
  filterType: OrderLineFilterType;
  ids: Array<Scalars['String']>;
};

export type OrderLineFilter = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  endDateFilter?: InputMaybe<OrderLineEndDateFilter>;
  entityFilters?: InputMaybe<Array<OrderLineEntityFilterAttributes>>;
  owner?: InputMaybe<Scalars['ID']>;
  startDateFilter?: InputMaybe<OrderLineStartDateFilter>;
  statuses?: InputMaybe<Array<OrderLineStatus>>;
};

export type OrderLineFilterCategory = {
  __typename?: 'OrderLineFilterCategory';
  displayName: Scalars['String'];
  filterDisplayType: EntityFilterDisplayType;
  filterType: OrderLineFilterType;
};

export enum OrderLineFilterType {
  AssignedToTeams = 'ASSIGNED_TO_TEAMS',
  AssignedToUsers = 'ASSIGNED_TO_USERS'
}

export type OrderLineFilterValue = {
  __typename?: 'OrderLineFilterValue';
  children?: Maybe<Array<OrderLineFilterValue>>;
  displayName: Scalars['String'];
  filterType: OrderLineFilterType;
  id: Scalars['ID'];
};

export type OrderLineOffsetPaginationResponse = {
  __typename?: 'OrderLineOffsetPaginationResponse';
  orderLines?: Maybe<Array<Maybe<OrderLine>>>;
  pageMetaData?: Maybe<PageMetaData>;
};

export enum OrderLineOrderableField {
  ModifiedDate = 'MODIFIED_DATE',
  OrderLineId = 'ORDER_LINE_ID',
  PlanEndDate = 'PLAN_END_DATE',
  PlanStartDate = 'PLAN_START_DATE'
}

export enum OrderLineOwnerFilter {
  OwnedAndSharedWithLoginUser = 'OWNED_AND_SHARED_WITH_LOGIN_USER',
  OwnedByLoginUser = 'OWNED_BY_LOGIN_USER',
  SharedWithLoginUser = 'SHARED_WITH_LOGIN_USER'
}

export type OrderLineStartDateFilter = {
  startDateAfter?: InputMaybe<Scalars['LocalDateTime']>;
  startDateBefore?: InputMaybe<Scalars['LocalDateTime']>;
};

export enum OrderLineStatus {
  Amending = 'AMENDING',
  AmendChangesRequired = 'AMEND_CHANGES_REQUIRED',
  AmendPendingApproval = 'AMEND_PENDING_APPROVAL',
  AtRisk = 'AT_RISK',
  AwaitingCreative = 'AWAITING_CREATIVE',
  Booked = 'BOOKED',
  BookingApprovalRequired = 'BOOKING_APPROVAL_REQUIRED',
  BookingApproved = 'BOOKING_APPROVED',
  BookingChangesRequired = 'BOOKING_CHANGES_REQUIRED',
  BookingPendingApproval = 'BOOKING_PENDING_APPROVAL',
  Cancelled = 'CANCELLED',
  CreditApprovalRequired = 'CREDIT_APPROVAL_REQUIRED',
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  FailedToDeliver = 'FAILED_TO_DELIVER',
  InBasket = 'IN_BASKET',
  NotDelivering = 'NOT_DELIVERING',
  OnTrack = 'ON_TRACK',
  Paused = 'PAUSED',
  PendingCancellation = 'PENDING_CANCELLATION',
  Ready = 'READY',
  Stopped = 'STOPPED',
  WillNotDeliver = 'WILL_NOT_DELIVER'
}

export enum OrderLineType {
  Filler = 'FILLER',
  SelfService = 'SELF_SERVICE',
  Standard = 'STANDARD'
}

export type OrderOffsetPaginationResponse = {
  __typename?: 'OrderOffsetPaginationResponse';
  orders?: Maybe<Array<Maybe<Order>>>;
  pageMetaData?: Maybe<PageMetaData>;
};

export enum OrderOrderableField {
  AltId = 'ALT_ID',
  EndDate = 'END_DATE',
  ExternalId = 'EXTERNAL_ID',
  Name = 'NAME',
  Objective = 'OBJECTIVE',
  OwnerName = 'OWNER_NAME',
  StartDate = 'START_DATE',
  Status = 'STATUS'
}

export type OrderOrdering = {
  direction?: InputMaybe<OrderingDirection>;
  orderableField?: InputMaybe<OrderOrderableField>;
};

export enum OrderStatus {
  /** Order has finished. */
  Completed = 'COMPLETED',
  /** The status of the order once deleted. */
  Deleted = 'DELETED',
  /** Order is disabled. */
  Disabled = 'DISABLED',
  /** The default value when the order is first created. */
  Draft = 'DRAFT',
  /** Order is live. */
  Live = 'LIVE',
  /** Order is paused. */
  Paused = 'PAUSED',
  /** Order is ready to go live. */
  Ready = 'READY'
}

export enum OrderingDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Pacing {
  /** The impressions delivery should start as soon as possible. */
  Asap = 'ASAP',
  /** The impression delivery will be equally balanced during the whole period that the campaign is live. */
  Evenly = 'EVENLY',
  /** Impressions will be delivered sooner than with even pacing. */
  FrontWeighted = 'FRONT_WEIGHTED',
  /** The default value when the pacing is not set. */
  PacingUnspecified = 'PACING_UNSPECIFIED'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PageMetaData = {
  __typename?: 'PageMetaData';
  pageNumber?: Maybe<Scalars['Int']>;
  totalItems?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type Period = {
  dateRange: LocalDateRangeAttributes;
  episodeCount: Scalars['PositiveInt'];
};

export type Permission = Node & {
  __typename?: 'Permission';
  /** The feature toggles attached to this permission. */
  featureToggles: Array<FeatureToggle>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The name of the permission. */
  name?: Maybe<PermissionName>;
};

export enum PermissionName {
  /** Permission assigned to users that manage the booking side. */
  Booking = 'BOOKING',
  /** Permission assigned to users that want to view the booking side. */
  BookingRead = 'BOOKING_READ',
  /** Permission assigned to users that manage the direct side. */
  Direct = 'DIRECT',
  /** Permission assigned to users that want to view the direct side. */
  DirectRead = 'DIRECT_READ',
  /** Permission assigned to users that want access to beta features. */
  Experimental = 'EXPERIMENTAL',
  /** Permission assigned to users that want to view the forecast side. */
  Forecasting = 'FORECASTING',
  /** Permission assigned to PLATFORM ADMIN users. */
  PlatformAdmin = 'PLATFORM_ADMIN',
  /** Permission assigned to users with admin privileges. */
  Primary = 'PRIMARY',
  /** Permission assigned to users that manage the programmatic side. */
  Programmatic = 'PROGRAMMATIC',
  /** Permission assigned to users that want to view the programmatic side. */
  ProgrammaticRead = 'PROGRAMMATIC_READ',
  /** Permission assigned to users that want to view & edit publisher contracts. */
  PublisherContract = 'PUBLISHER_CONTRACT',
  /** Permission assigned to users that want to view publisher contracts. */
  PublisherContractRead = 'PUBLISHER_CONTRACT_READ',
  /** Permission assigned to tier 1 users that want to view the publisher insights side. */
  PublisherInsightsTier1 = 'PUBLISHER_INSIGHTS_TIER1',
  /** Permission assigned to tier 2 users that want to view the publisher insights side. */
  PublisherInsightsTier2 = 'PUBLISHER_INSIGHTS_TIER2',
  /** Permission assigned to QA users that want to create proposed flights without validations. */
  Qa = 'QA',
  /** Permission assigned to users that manage the supply side. */
  Supply = 'SUPPLY',
  /** Permission assigned to users that want to view the supply side. */
  SupplyRead = 'SUPPLY_READ'
}

export enum PermissionV2 {
  ActivityHistory = 'ACTIVITY_HISTORY',
  Book = 'BOOK',
  BookingApprove = 'BOOKING_APPROVE',
  BusinessesRead = 'BUSINESSES_READ',
  BusinessesWrite = 'BUSINESSES_WRITE',
  BusinessRead = 'BUSINESS_READ',
  BusinessUsersAndTeamsRead = 'BUSINESS_USERS_AND_TEAMS_READ',
  BusinessUsersAndTeamsWrite = 'BUSINESS_USERS_AND_TEAMS_WRITE',
  BusinessWrite = 'BUSINESS_WRITE',
  BuyerRead = 'BUYER_READ',
  BuyerWrite = 'BUYER_WRITE',
  CampaignInsights = 'CAMPAIGN_INSIGHTS',
  DeliveryRead = 'DELIVERY_READ',
  DeliveryWrite = 'DELIVERY_WRITE',
  DirectCreativeApprove = 'DIRECT_CREATIVE_APPROVE',
  DirectCreativeRead = 'DIRECT_CREATIVE_READ',
  DirectCreativeWrite = 'DIRECT_CREATIVE_WRITE',
  ExchangeWrite = 'EXCHANGE_WRITE',
  FeatureFlags = 'FEATURE_FLAGS',
  Filler = 'FILLER',
  Forecasting = 'FORECASTING',
  Monetize = 'MONETIZE',
  OmPlanBookingWrite = 'OM_PLAN_BOOKING_WRITE',
  PlanRead = 'PLAN_READ',
  PlanWrite = 'PLAN_WRITE',
  PlatformUsersRead = 'PLATFORM_USERS_READ',
  PlatformUsersWrite = 'PLATFORM_USERS_WRITE',
  Programmatic = 'PROGRAMMATIC',
  ProgrammaticRead = 'PROGRAMMATIC_READ',
  PublisherContract = 'PUBLISHER_CONTRACT',
  PublisherContractRead = 'PUBLISHER_CONTRACT_READ',
  Supply = 'SUPPLY',
  SupplyRead = 'SUPPLY_READ',
  SupplyReportingLimit = 'SUPPLY_REPORTING_LIMIT'
}

export type PermissionV2Category = {
  __typename?: 'PermissionV2Category';
  category: Scalars['String'];
  permissions: Array<PermissionV2Info>;
};

export type PermissionV2Info = {
  __typename?: 'PermissionV2Info';
  label: Scalars['String'];
  value: PermissionV2;
};

export type PlatformRoleConfiguration = {
  __typename?: 'PlatformRoleConfiguration';
  permissionCategories: Array<PermissionV2Category>;
  standardRoles: Array<Role>;
};

export type PlatformStatusMessage = {
  __typename?: 'PlatformStatusMessage';
  date: Scalars['LocalDateTime'];
  description: Scalars['String'];
  title: Scalars['String'];
  type: PlatformStatusMessageType;
};

export type PlatformStatusMessageAttributes = {
  date: Scalars['LocalDateTime'];
  description: Scalars['String'];
  title: Scalars['String'];
  type: PlatformStatusMessageType;
};

export enum PlatformStatusMessageType {
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type PlatformUser = {
  __typename?: 'PlatformUser';
  additionalPermissions: Array<PermissionV2Info>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  restrictedToBusinesses: Array<BusinessReference>;
  roles: Array<Role>;
  userId: Scalars['ID'];
};

export type PlatformUserCreateAttributes = {
  additionalPermissions: Array<PermissionV2>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  restrictedToBusinessIds: Array<Scalars['ID']>;
  roleIds: Array<Scalars['ID']>;
};

export type PlatformUserUpdateAttributes = {
  additionalPermissions: Array<PermissionV2>;
  restrictedToBusinessIds: Array<Scalars['ID']>;
  roleIds: Array<Scalars['ID']>;
};

export enum PodcastGroupingType {
  /** Podcasts belonging to a general collection. */
  Collection = 'COLLECTION',
  /** A specific episode of a podcast. */
  Episode = 'EPISODE',
  /** Podcasts belonging to a specific show. */
  Show = 'SHOW'
}

export type PodcastParam = AudienceParam & {
  __typename?: 'PodcastParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** Parent collection for a podcast series. */
  podcastTargets: Array<PodcastTarget>;
};

export type PodcastParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** Parent collection for a podcast series. */
  podcastTargets: Array<PodcastTargetAttributes>;
};

export type PodcastTarget = {
  __typename?: 'PodcastTarget';
  /** The external id of the podcast collection. */
  collectionId?: Maybe<Scalars['String']>;
  /** The external id of the podcast show. */
  episodeId?: Maybe<Scalars['String']>;
  /** The name of the podcast param. */
  name?: Maybe<Scalars['String']>;
  /** The external id of the podcast show. */
  showId?: Maybe<Scalars['String']>;
};

export type PodcastTargetAttributes = {
  /** The external id of the podcast collection. */
  collectionId?: InputMaybe<Scalars['String']>;
  /** The external id of the podcast show. */
  episodeId?: InputMaybe<Scalars['String']>;
  /** The name of the podcast group. */
  name?: InputMaybe<Scalars['String']>;
  /** The external id of the podcast show. */
  showId?: InputMaybe<Scalars['String']>;
};

export type Position = {
  __typename?: 'Position';
  /** The latitude geographical coordinate in degrees, number between -90 and 90. */
  latitude: Scalars['Float'];
  /** The longitude geographical coordinate in degrees, number between -180 and 180. */
  longitude: Scalars['Float'];
  /** The radius selected around the latitude/longitude coordinates. */
  radius: Scalars['Float'];
};

export type PositionAttributes = {
  /** The latitude geographical coordinate in degrees, number between -90 and 90. */
  latitude: Scalars['Float'];
  /** The longitude geographical coordinate in degrees, number between -180 and 180. */
  longitude: Scalars['Float'];
  /** The radius (represented in meters) selected around the latitude/longitude coordinates. */
  radius: Scalars['Float'];
};

export type PostCodeGroupAttributes = {
  /** The description of this postcode group. */
  description?: InputMaybe<Scalars['String']>;
  /** The name of this postcode group. */
  name: Scalars['String'];
  /** All postcode codes in this group. */
  postcodes: Array<Scalars['String']>;
  /** The territory of this postcode group. */
  territory?: InputMaybe<Territory>;
};

export type PostalCodeParam = AudienceParam & {
  __typename?: 'PostalCodeParam';
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of postal codes of the targeted audience. */
  postalCodes: Array<Scalars['String']>;
  /** All postcode groups attached to this audience parameter. */
  postcodeGroups: Array<PostcodeGroup>;
};

export type PostalCodeParamAttributes = {
  /** If this audience parameter properties are inclusive or exclusive of. */
  clusivity: Clusivity;
  /** The list of postal codes of the targeted audience. */
  postalCodes?: InputMaybe<Array<Scalars['String']>>;
  /** The list of postal code group ids attached to this parameter. */
  postcodeGroupIds?: InputMaybe<Array<Scalars['String']>>;
};

export type PostcodeGroup = {
  __typename?: 'PostcodeGroup';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  postcodes: Array<Scalars['String']>;
  /** The territory of this postcode group. */
  territory: Territory;
};

export type PreSignedUrl = {
  __typename?: 'PreSignedUrl';
  /** The location of the asset used in the pre-signed URL. */
  assetUrl: Scalars['Url'];
  /** The content type that is allowed to be used */
  contentType?: Maybe<Scalars['String']>;
  /** The uploaded date of the asset */
  uploadedDate: Scalars['LocalDateTime'];
  /** The S3 pre-signed URL for the given parameters. */
  url: Scalars['Url'];
};

/** Attributes for generating a pre-signed URL: https://docs.aws.amazon.com/AmazonS3/latest/dev/ShareObjectPreSignedURL.html */
export type PreSignedUrlAttributes = {
  /** The content type of the file (e.g. audio/wav). */
  contentType?: InputMaybe<Scalars['String']>;
  /** The name of the file. If the file must be placed in a directory, you must prefix the file name (e.g. directory/file.txt). */
  fileName: Scalars['String'];
  /** The size of the file in bytes. */
  fileSize?: InputMaybe<Scalars['Long']>;
  /** The HTTP method you want to use for the operation (e.g. PUT for upload, GET for download). */
  httpMethod: HttpMethod;
};

export type Price = {
  __typename?: 'Price';
  currency: Scalars['Currency'];
  price: Scalars['BigDecimal'];
};

export type PriceBreakdown = {
  __typename?: 'PriceBreakdown';
  endDateExclusive: Scalars['LocalDateTime'];
  isLocked: Scalars['Boolean'];
  price: Scalars['BigDecimal'];
  startDate: Scalars['LocalDateTime'];
};

export type PriceBreakdownAttributes = {
  endDateExclusive: Scalars['LocalDateTime'];
  price: Scalars['BigDecimal'];
  startDate: Scalars['LocalDateTime'];
};

export enum PricingType {
  /** Needs to be represented as a decimal number (e.g. 1.99). */
  Cpm = 'CPM',
  /** The default value when the pricing type is not set. */
  PricingTypeUnspecified = 'PRICING_TYPE_UNSPECIFIED',
  /** Needs to be represented in % (e.g. 50%). */
  RevShare = 'REV_SHARE'
}

export type PrimaryControl = {
  __typename?: 'PrimaryControl';
  /** The entity of this primary control. */
  entity: PrimaryControlEntity;
  /** The entries for the entity  */
  entries: Array<PrimaryControlEntry>;
};

/** The entity to perform the primary control operation on. */
export enum PrimaryControlEntity {
  Campaign = 'CAMPAIGN',
  Deal = 'DEAL',
  SalesChannel = 'SALES_CHANNEL'
}

export type PrimaryControlEntry = {
  __typename?: 'PrimaryControlEntry';
  enabled: Scalars['Boolean'];
  territory: Territory;
};

export type PrimaryControlEntryInput = {
  enabled: Scalars['Boolean'];
  territory: Territory;
};

/** The action to perform part of a primary control operation. */
export enum PrimaryControlState {
  Frozen = 'FROZEN',
  Quarantined = 'QUARANTINED'
}

export type ProgrammaticBillingLine = {
  __typename?: 'ProgrammaticBillingLine';
  billingDate: Scalars['LocalDateTime'];
  dspRevenue: Scalars['BigDecimal'];
  entityType: EntityType;
  id: Scalars['ID'];
  proposal: Proposal;
  proposalId: Scalars['ID'];
  status: ProgrammaticBillingLineStatus;
  territory: Territory;
  timeZone: Scalars['ZoneId'];
};

export type ProgrammaticBillingLineAttributes = {
  billingDate: Scalars['LocalDateTime'];
  dspRevenue: Scalars['BigDecimal'];
  territory: Territory;
};

export enum ProgrammaticBillingLineStatus {
  Booked = 'BOOKED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  InBasket = 'IN_BASKET',
  PendingCancellation = 'PENDING_CANCELLATION'
}

export type ProgrammaticConnector = Node & {
  __typename?: 'ProgrammaticConnector';
  allowOpenSeatDspTargeting: Scalars['Boolean'];
  appBundle?: Maybe<Scalars['String']>;
  appDomain?: Maybe<Scalars['String']>;
  appName?: Maybe<Scalars['String']>;
  consentVendorId?: Maybe<Scalars['NonNegativeInt']>;
  currency: Scalars['Currency'];
  currencyPrecision?: Maybe<Scalars['NonNegativeInt']>;
  dspProvider?: Maybe<DspProvider>;
  entityState: EntityState;
  gzipCompressed: Scalars['Boolean'];
  id: Scalars['ID'];
  kvps1stPartyData?: Maybe<Scalars['String']>;
  mediaType: MediaType;
  name: Scalars['String'];
  passAll1stPartyDataValues: Scalars['Boolean'];
  passAllAppValues: Scalars['Boolean'];
  passAllGeoDataValues: Scalars['Boolean'];
  passAllIpDataValues: Scalars['Boolean'];
  passAllListenerIdValues: Scalars['Boolean'];
  passAllPublisherValues: Scalars['Boolean'];
  passAllSiteValues: Scalars['Boolean'];
  publisherDomain?: Maybe<Scalars['String']>;
  publisherId?: Maybe<Scalars['String']>;
  publisherName?: Maybe<Scalars['String']>;
  publisherTagId?: Maybe<Scalars['String']>;
  sendNotSyncedUsers: Scalars['Boolean'];
  siteDomain?: Maybe<Scalars['String']>;
  siteName?: Maybe<Scalars['String']>;
  sitePage?: Maybe<Scalars['String']>;
  status: ProgrammaticConnectorStatus;
  truncateGpsCoords: Scalars['Boolean'];
  truncateIpAddress: Scalars['Boolean'];
  userSyncSecureUrl?: Maybe<Scalars['String']>;
  userSyncUrl?: Maybe<Scalars['String']>;
  vastVersions: Array<VastVersion>;
};

export type ProgrammaticConnectorAttributes = {
  allowOpenSeatDspTargeting: Scalars['Boolean'];
  appBundle?: InputMaybe<Scalars['String']>;
  appDomain?: InputMaybe<Scalars['String']>;
  appName?: InputMaybe<Scalars['String']>;
  consentVendorId?: InputMaybe<Scalars['NonNegativeInt']>;
  currency: Scalars['Currency'];
  currencyPrecision?: InputMaybe<Scalars['NonNegativeInt']>;
  dspProvider?: InputMaybe<DspProvider>;
  gzipCompressed: Scalars['Boolean'];
  kvps1stPartyData?: InputMaybe<Scalars['String']>;
  mediaType: MediaType;
  name: Scalars['String'];
  passAll1stPartyDataValues: Scalars['Boolean'];
  passAllAppValues: Scalars['Boolean'];
  passAllGeoDataValues: Scalars['Boolean'];
  passAllIpDataValues: Scalars['Boolean'];
  passAllListenerIdValues: Scalars['Boolean'];
  passAllPublisherValues: Scalars['Boolean'];
  passAllSiteValues: Scalars['Boolean'];
  publisherDomain?: InputMaybe<Scalars['String']>;
  publisherId?: InputMaybe<Scalars['String']>;
  publisherName?: InputMaybe<Scalars['String']>;
  publisherTagId?: InputMaybe<Scalars['String']>;
  sendNotSyncedUsers: Scalars['Boolean'];
  siteDomain?: InputMaybe<Scalars['String']>;
  siteName?: InputMaybe<Scalars['String']>;
  sitePage?: InputMaybe<Scalars['String']>;
  truncateGpsCoords: Scalars['Boolean'];
  truncateIpAddress: Scalars['Boolean'];
  userSyncSecureUrl?: InputMaybe<Scalars['Url']>;
  userSyncUrl?: InputMaybe<Scalars['Url']>;
  vastVersions: Array<VastVersion>;
};

export type ProgrammaticConnectorMinimal = Node & {
  __typename?: 'ProgrammaticConnectorMinimal';
  id: Scalars['ID'];
  mediaType: MediaType;
  name: Scalars['String'];
  status: ProgrammaticConnectorStatus;
};

export type ProgrammaticConnectorOffsetPaginationResponse = {
  __typename?: 'ProgrammaticConnectorOffsetPaginationResponse';
  pageMetaData: PageMetaData;
  programmaticConnectors: Array<ProgrammaticConnectorMinimal>;
};

export enum ProgrammaticConnectorStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type ProgrammaticCreative = {
  __typename?: 'ProgrammaticCreative';
  /** The domain of the external advertiser. */
  advertiserDomains: Array<Scalars['String']>;
  /** The date this creative has been approved. */
  approvalDate?: Maybe<Scalars['LocalDateTime']>;
  /** Deprecated. To be removed */
  deal?: Maybe<DealLegacy>;
  /** Deals which have been associated with this creative. */
  deals: Array<DealLegacy>;
  /** The external ID of the creative. */
  externalId: Scalars['String'];
  /** The date the bid for the creative has been won. */
  firstBidDate?: Maybe<Scalars['LocalDateTime']>;
  /** The deal associated with this creative the first time the creative was seen. */
  firstSeenDeal?: Maybe<DealLegacy>;
  /** List of associated IAB categories. */
  iabCategoryCodes: Array<Scalars['String']>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The name of the programmatic creative. */
  name?: Maybe<Scalars['String']>;
  /** The programmatic spec. */
  spec?: Maybe<ProgrammaticCreativeSpec>;
  /** The approval status of the programmatic creative. */
  status?: Maybe<ApprovalStatus>;
  /** The list of territories assigned to the programmatic creative. */
  territories: Array<Territory>;
  /** The type of the programmatic creative. */
  type?: Maybe<ProgrammaticCreativeType>;
  /** The media URL of the programmatic creative. */
  url?: Maybe<Scalars['Url']>;
};

export type ProgrammaticCreativeAudioSpec = {
  __typename?: 'ProgrammaticCreativeAudioSpec';
  /** The duration in seconds of the programmatic creative audio */
  duration?: Maybe<Scalars['NonNegativeFloat']>;
};

export type ProgrammaticCreativeConnection = {
  __typename?: 'ProgrammaticCreativeConnection';
  edges: Array<Maybe<ProgrammaticCreativeEdge>>;
  pageInfo: PageInfo;
};

export type ProgrammaticCreativeEdge = {
  __typename?: 'ProgrammaticCreativeEdge';
  cursor: Scalars['String'];
  node: ProgrammaticCreative;
};

export type ProgrammaticCreativeFilter = {
  /** Filters by partial match on any field on the entity. Only supported on pagination. */
  anyPartialMatch?: InputMaybe<Scalars['String']>;
  /** Filters by deal id in collection. Only supported on pagination. */
  dealIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters by creatives first seen after the given date time. Only supported on pagination. */
  firstBidDateOnOrAfter?: InputMaybe<Scalars['LocalDateTime']>;
  /** Filters by creatives first seen before the given date time. Only supported on pagination. */
  firstBidDateOnOrBefore?: InputMaybe<Scalars['LocalDateTime']>;
  /** Filters by partial match on any single advertiser domain. Only supported on pagination. */
  partialAdvertiserDomainMatch?: InputMaybe<Scalars['String']>;
  /** Filters by partial match on deal name field on the entity. Only supported on pagination. */
  partialDealNameMatch?: InputMaybe<Scalars['String']>;
  /** Filters by partial match on duration field on the entity. Only supported on pagination. */
  partialDurationMatch?: InputMaybe<Scalars['String']>;
  /** Filters by partial match on first bid date field on the entity. Only supported on pagination. */
  partialFirstBidDateMatch?: InputMaybe<Scalars['String']>;
  /** Filters by partial match on any single iab category. Only supported on pagination. */
  partialIabCategoryMatch?: InputMaybe<Scalars['String']>;
  /** Filters by partial match on name field on the entity. Only supported on pagination. */
  partialNameMatch?: InputMaybe<Scalars['String']>;
  status_in?: InputMaybe<Array<ApprovalStatus>>;
};

export type ProgrammaticCreativeImageSpec = {
  __typename?: 'ProgrammaticCreativeImageSpec';
  /** The height of the programmatic creative image. */
  height?: Maybe<Scalars['NonNegativeInt']>;
  /** The width of the programmatic creative image. */
  width?: Maybe<Scalars['NonNegativeInt']>;
};

export enum ProgrammaticCreativeOrderable {
  AdvertiserDomain = 'ADVERTISER_DOMAIN',
  DealName = 'DEAL_NAME',
  Duration = 'DURATION',
  FirstBidDate = 'FIRST_BID_DATE',
  IabCategory = 'IAB_CATEGORY',
  Name = 'NAME',
  Status = 'STATUS',
  Territory = 'TERRITORY'
}

export type ProgrammaticCreativeOrdering = {
  direction?: InputMaybe<OrderingDirection>;
  orderableField?: InputMaybe<ProgrammaticCreativeOrderable>;
};

/** The programmatic specs used for quarantining. */
export type ProgrammaticCreativeSpec = ProgrammaticCreativeAudioSpec | ProgrammaticCreativeImageSpec;

export enum ProgrammaticCreativeType {
  /** A programmatic audio creative. */
  ProgrammaticAudio = 'PROGRAMMATIC_AUDIO',
  /** A programmatic image creative. */
  ProgrammaticImage = 'PROGRAMMATIC_IMAGE'
}

export type Proposal = {
  __typename?: 'Proposal';
  billingLines: Array<BillingLine>;
  brand: Brand;
  businessId?: Maybe<Scalars['String']>;
  deliveryType: ProposalDeliveryType;
  endDate?: Maybe<Scalars['LocalDateTime']>;
  entityType: EntityType;
  iabCategories: Array<IabCategory>;
  id: Scalars['ID'];
  modifiedDate: Scalars['LocalDateTime'];
  name: Scalars['String'];
  order: OrderLine;
  owner: User;
  programmaticBillingLines: Array<ProgrammaticBillingLine>;
  proposedFlights: Array<ProposedFlight>;
  startDate?: Maybe<Scalars['LocalDateTime']>;
  status: ProposalStatus;
  territory: Territory;
  timeZone: Scalars['ZoneId'];
  totalImpressions?: Maybe<Scalars['Long']>;
};

export type ProposalAttributes = {
  name: Scalars['String'];
  territory: Territory;
};

export enum ProposalDeliveryType {
  Direct = 'DIRECT',
  Programmatic = 'PROGRAMMATIC'
}

export type ProposalFilter = {
  owner?: InputMaybe<Scalars['ID']>;
};

export type ProposalForecastAttributes = {
  /** The targeting details of all the flights on this forecast */
  flightTargetingAttributes: Array<FlightTargetingAttributes>;
  /** The list of IAB category codes */
  iabCategoryCodes?: InputMaybe<Array<Scalars['ID']>>;
  /** Includes the Forecast payload in the response */
  includeJsonPayload?: InputMaybe<Scalars['Boolean']>;
  /** Required if targetingDefinition is set */
  territory: Territory;
  /** The time zone in IANA format (e.g. Europe/London) */
  timeZone: Scalars['ZoneId'];
};

export type ProposalOffsetPaginationResponse = {
  __typename?: 'ProposalOffsetPaginationResponse';
  pageMetaData?: Maybe<PageMetaData>;
  proposals?: Maybe<Array<Maybe<Proposal>>>;
};

export enum ProposalOrderableField {
  ModifiedDate = 'MODIFIED_DATE',
  ProposalId = 'PROPOSAL_ID'
}

export enum ProposalStatus {
  Amending = 'AMENDING',
  AmendChangesRequired = 'AMEND_CHANGES_REQUIRED',
  AmendPendingApproval = 'AMEND_PENDING_APPROVAL',
  Booked = 'BOOKED',
  BookingApprovalRequired = 'BOOKING_APPROVAL_REQUIRED',
  BookingApproved = 'BOOKING_APPROVED',
  BookingChangesRequired = 'BOOKING_CHANGES_REQUIRED',
  BookingPendingApproval = 'BOOKING_PENDING_APPROVAL',
  Cancelled = 'CANCELLED',
  CreditApprovalRequired = 'CREDIT_APPROVAL_REQUIRED',
  Draft = 'DRAFT',
  InBasket = 'IN_BASKET',
  NotAvailable = 'NOT_AVAILABLE',
  Optioned = 'OPTIONED',
  PendingCancellation = 'PENDING_CANCELLATION'
}

export type ProposedFlight = {
  __typename?: 'ProposedFlight';
  barterType?: Maybe<BarterType>;
  billableCpm?: Maybe<Scalars['BigDecimal']>;
  billableCpmChangeReason?: Maybe<BillableCpmChangeReasonType>;
  billedImpressions?: Maybe<Scalars['Long']>;
  billingTypeInfo: FlightBillingTypeInfo;
  boltOns: Array<FlightBoltOnType>;
  budgetStrategy: FlightBudgetStrategy;
  cashValue?: Maybe<Scalars['BigDecimal']>;
  cpm: Scalars['BigDecimal'];
  creativeLength: Scalars['NonNegativeFloat'];
  dataCost: Scalars['BigDecimal'];
  endDate?: Maybe<Scalars['LocalDateTime']>;
  entityType: EntityType;
  flightType: FlightTypeInfo;
  id: Scalars['ID'];
  locality: Locality;
  mediaType: MediaType;
  name: Scalars['String'];
  nonSpotShowId?: Maybe<Scalars['ID']>;
  objectiveImpressions?: Maybe<Scalars['Long']>;
  optionQueue?: Maybe<ProposedFlightOptionQueue>;
  periods: Array<VideoPeriod>;
  platforms: Array<ShowHostingPlatformType>;
  proposal: Proposal;
  proposalId: Scalars['ID'];
  restrictions: Array<FlightRestrictionType>;
  socialPeriods: Array<SocialPeriod>;
  spendingBudget?: Maybe<Scalars['BigDecimal']>;
  startDate: Scalars['LocalDateTime'];
  status: ProposedFlightStatus;
  targetingStrategies: Array<TargetingStrategy>;
  territory: Territory;
  timeZone: Scalars['ZoneId'];
  tradeValue?: Maybe<Scalars['BigDecimal']>;
};

export type ProposedFlightAttributes = {
  barter?: InputMaybe<FlightBarterAttributes>;
  billingType: FlightBillingType;
  boltOns: Array<FlightBoltOnType>;
  budget: FlightBudgetAttributes;
  creativeLength: Scalars['NonNegativeFloat'];
  dateRange: DateRangeAttributes;
  name: Scalars['String'];
  nonSpotShowId?: InputMaybe<Scalars['ID']>;
  restrictions: Array<FlightRestrictionType>;
  territory?: InputMaybe<Territory>;
};

export enum ProposedFlightAvailabilityStatus {
  Booked = 'BOOKED',
  Draft = 'DRAFT',
  NotAvailable = 'NOT_AVAILABLE',
  Optioned = 'OPTIONED'
}

export type ProposedFlightForecastAttributes = {
  /** The targeting related attributes for this flight */
  flightTargetingAttributes: FlightTargetingAttributes;
  /** Determines the maximum number of impressions per listener. */
  frequencyCapCount?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Determines the time unit which the frequency cap value represents a multiple of. */
  frequencyCapTimeUnit?: InputMaybe<FrequencyCapTimeUnit>;
  /** Determines the time period value for which to deliver the number of ad impressions. */
  frequencyCapValue?: InputMaybe<Scalars['NonNegativeInt']>;
  /** The list of IAB category codes */
  iabCategoryCodes?: InputMaybe<Array<Scalars['ID']>>;
  /** Required if targetingDefinition is set */
  territory: Territory;
  /** The time zone in IANA format (e.g. Europe/London) */
  timeZone: Scalars['ZoneId'];
};

export type ProposedFlightOptionQueue = {
  __typename?: 'ProposedFlightOptionQueue';
  adPositionQueues: Array<OptionQueue>;
  availabilityStatus: ProposedFlightAvailabilityStatus;
  placeInQueue?: Maybe<Scalars['String']>;
  placeInQueueIndex?: Maybe<Scalars['Int']>;
  proposedFlightId: Scalars['ID'];
  queueSize: Scalars['Int'];
  releaseFrequency?: Maybe<Scalars['Int']>;
};

export enum ProposedFlightStatus {
  Amending = 'AMENDING',
  AmendChangesRequired = 'AMEND_CHANGES_REQUIRED',
  AmendPendingApproval = 'AMEND_PENDING_APPROVAL',
  Booked = 'BOOKED',
  BookingApprovalRequired = 'BOOKING_APPROVAL_REQUIRED',
  BookingApproved = 'BOOKING_APPROVED',
  BookingChangesRequired = 'BOOKING_CHANGES_REQUIRED',
  BookingPendingApproval = 'BOOKING_PENDING_APPROVAL',
  Cancelled = 'CANCELLED',
  CreditApprovalRequired = 'CREDIT_APPROVAL_REQUIRED',
  Draft = 'DRAFT',
  InBasket = 'IN_BASKET',
  PendingCancellation = 'PENDING_CANCELLATION'
}

export type Publisher = {
  __typename?: 'Publisher';
  audioAdsRequested: Scalars['Long'];
  audioImpressions: Scalars['Long'];
  blockedDomains: Array<Scalars['DomainName']>;
  blockedIabCategories: Array<IabCategory>;
  currency: Scalars['Currency'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  network: Network;
  state: EntityState;
  status: SupplyStatus;
};

export type PublisherCategory = {
  __typename?: 'PublisherCategory';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PublisherContract = {
  __typename?: 'PublisherContract';
  currency: Scalars['Currency'];
  endDate?: Maybe<Scalars['LocalDateTime']>;
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  paymentConfigs: Array<PublisherContractPaymentConfig>;
  publisher: Publisher;
  startDate: Scalars['LocalDateTime'];
  status: PublisherContractStatus;
};

export type PublisherContractLegacy = {
  __typename?: 'PublisherContractLegacy';
  altId: Scalars['Int'];
  currency?: Maybe<Scalars['Currency']>;
  directSpotCpm?: Maybe<Scalars['NonNegativeFloat']>;
  endDate?: Maybe<Scalars['LocalDateTime']>;
  hostReadCpm?: Maybe<Scalars['NonNegativeFloat']>;
  hostReadRevenueShare?: Maybe<Scalars['NonNegativeFloat']>;
  id: Scalars['ID'];
  maxInventoryGuaranteed?: Maybe<Scalars['NonNegativeFloat']>;
  minInventoryGuaranteed?: Maybe<Scalars['NonNegativeFloat']>;
  minRevenueGuaranteed?: Maybe<Scalars['NonNegativeFloat']>;
  minRevenueIdeal?: Maybe<Scalars['NonNegativeFloat']>;
  notes?: Maybe<Scalars['String']>;
  percentFillGuaranteed?: Maybe<Scalars['Int']>;
  programmaticSpotCpm?: Maybe<Scalars['NonNegativeFloat']>;
  publisher: PublisherLegacy;
  publisherCategories?: Maybe<Array<PublisherCategory>>;
  publisherRtbType?: Maybe<PublisherRtbType>;
  sponsorshipRevenueShare?: Maybe<Scalars['NonNegativeFloat']>;
  spotRevenueShare?: Maybe<Scalars['NonNegativeFloat']>;
  startDate: Scalars['LocalDateTime'];
  territories: Array<Territory>;
};

export type PublisherContractLegacyAttributes = {
  currency?: InputMaybe<Scalars['Currency']>;
  directSpotCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  hostReadCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  hostReadRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  maxInventoryGuaranteed?: InputMaybe<Scalars['NonNegativeFloat']>;
  minInventoryGuaranteed?: InputMaybe<Scalars['NonNegativeFloat']>;
  minRevenueGuaranteed?: InputMaybe<Scalars['NonNegativeFloat']>;
  minRevenueIdeal?: InputMaybe<Scalars['NonNegativeFloat']>;
  notes?: InputMaybe<Scalars['String']>;
  percentFillGuaranteed?: InputMaybe<Scalars['Int']>;
  programmaticSpotCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  publisherCategories?: InputMaybe<Array<Scalars['String']>>;
  publisherRtbType?: InputMaybe<PublisherRtbType>;
  sponsorshipRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  spotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  territories?: InputMaybe<Array<Territory>>;
};

export type PublisherContractPaymentConfig = {
  __typename?: 'PublisherContractPaymentConfig';
  audioNonSpotRevenueShare?: Maybe<Scalars['BigDecimal']>;
  audioNonSpotRevenueSharePreferredRate?: Maybe<Scalars['BigDecimal']>;
  audioSpotCpm?: Maybe<Scalars['BigDecimal']>;
  audioSpotRevenueShare?: Maybe<Scalars['BigDecimal']>;
  countries: Array<Country>;
  /** The minimum amount impressions may be sold for. */
  floor?: Maybe<Scalars['BigDecimal']>;
  socialNonSpotRevenueShare?: Maybe<Scalars['BigDecimal']>;
  socialNonSpotRevenueSharePreferredRate?: Maybe<Scalars['BigDecimal']>;
  useSpecificNonSpotRevenueSharePerMediaType: Scalars['Boolean'];
  videoNonSpotRevenueShare?: Maybe<Scalars['BigDecimal']>;
  videoNonSpotRevenueSharePreferredRate?: Maybe<Scalars['BigDecimal']>;
  videoSpotRevenueShare?: Maybe<Scalars['BigDecimal']>;
};

export type PublisherContractPaymentConfigAttributes = {
  audioNonSpotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  audioNonSpotRevenueSharePreferredRate?: InputMaybe<Scalars['NonNegativeFloat']>;
  audioSpotCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  audioSpotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  countryCodes: Array<Scalars['String']>;
  /** The minimum amount impressions may be sold for. */
  floor?: InputMaybe<Scalars['NonNegativeFloat']>;
  socialNonSpotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  socialNonSpotRevenueSharePreferredRate?: InputMaybe<Scalars['NonNegativeFloat']>;
  useSpecificNonSpotRevenueSharePerMediaType: Scalars['Boolean'];
  videoNonSpotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  videoNonSpotRevenueSharePreferredRate?: InputMaybe<Scalars['NonNegativeFloat']>;
  videoSpotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
};

export enum PublisherContractStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE'
}

export type PublisherFilter = {
  networkId?: InputMaybe<Scalars['ID']>;
};

export type PublisherInsightsBreakdown = {
  __typename?: 'PublisherInsightsBreakdown';
  breakdownPoints?: Maybe<Array<PublisherInsightsBreakdownPoint>>;
  currency: Scalars['Currency'];
};

export type PublisherInsightsBreakdownPoint = {
  __typename?: 'PublisherInsightsBreakdownPoint';
  currency: Scalars['Currency'];
  displayName: Scalars['String'];
  id: Scalars['String'];
  percentage?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};

export type PublisherInsightsFilter = {
  __typename?: 'PublisherInsightsFilter';
  type: PublisherInsightsFilterType;
  values: Array<Maybe<PublisherInsightsFilterValue>>;
};

export type PublisherInsightsFilterAttributes = {
  ids: Array<Scalars['String']>;
  type: PublisherInsightsFilterType;
};

export type PublisherInsightsFilterCategory = {
  __typename?: 'PublisherInsightsFilterCategory';
  displayName: Scalars['String'];
  type: PublisherInsightsFilterType;
};

export enum PublisherInsightsFilterType {
  Advertiser = 'ADVERTISER',
  AdPosition = 'AD_POSITION',
  AdType = 'AD_TYPE',
  Agency = 'AGENCY',
  BillingType = 'BILLING_TYPE',
  Channel = 'CHANNEL',
  Country = 'COUNTRY',
  DemandType = 'DEMAND_TYPE',
  DeviceType = 'DEVICE_TYPE',
  Dsp = 'DSP',
  GdprStatus = 'GDPR_STATUS',
  IabCategoryCode = 'IAB_CATEGORY_CODE',
  Network = 'NETWORK',
  OperatingSystem = 'OPERATING_SYSTEM',
  Publisher = 'PUBLISHER',
  Show = 'SHOW'
}

export type PublisherInsightsFilterValue = {
  __typename?: 'PublisherInsightsFilterValue';
  displayName: Scalars['String'];
  id: Scalars['String'];
};

/** Represents the metrics for publisher insights */
export enum PublisherInsightsMetric {
  AdsRequested = 'ADS_REQUESTED',
  AdsRequestedEcpm = 'ADS_REQUESTED_ECPM',
  AdsServed = 'ADS_SERVED',
  AdBreaks = 'AD_BREAKS',
  AdInventory = 'AD_INVENTORY',
  Ecpm = 'ECPM',
  FillRate = 'FILL_RATE',
  Impressions = 'IMPRESSIONS',
  Ltr = 'LTR',
  PaidImpressions = 'PAID_IMPRESSIONS',
  PublisherRevenue = 'PUBLISHER_REVENUE',
  SellThroughRate = 'SELL_THROUGH_RATE'
}

export enum PublisherInsightsMetricAggregationType {
  Sum = 'SUM',
  WeightedAverage = 'WEIGHTED_AVERAGE'
}

/** Represents the metric types for publisher insights e.g. IMPRESSIONS is NUMBER, LTR is PERCENT */
export enum PublisherInsightsMetricType {
  Financial = 'FINANCIAL',
  Number = 'NUMBER',
  Percent = 'PERCENT'
}

export type PublisherInsightsTimeSeries = {
  __typename?: 'PublisherInsightsTimeSeries';
  currency: Scalars['Currency'];
  metric: PublisherInsightsMetric;
  metricAggregationType: PublisherInsightsMetricAggregationType;
  metricType: PublisherInsightsMetricType;
  timeseries: TimeSeries;
  /** Either sum or average (depending on metricType) across the whole date range */
  totalValue: Scalars['Float'];
  /** If metricAggregationType==WEIGHTED_AVERAGE use this metric as the weight for each point when calculating the average */
  weightingMetric?: Maybe<PublisherInsightsMetric>;
};

export enum PublisherInsightsTimeSeriesUnit {
  Day = 'DAY',
  Hour = 'HOUR'
}

export type PublisherLegacy = Node & {
  __typename?: 'PublisherLegacy';
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** Ads associated to the publisher, optionally filtered by status. */
  associatedAds: Array<AdLegacy>;
  /** Deals associcated to the publisher, optionally filtered by status. */
  associatedDeals: Array<DealLegacy>;
  /** List of domains blacklisted by the publisher. */
  blacklistedDomains: Array<Scalars['DomainName']>;
  /** List of IAB categories blacklisted by the publisher. */
  blacklistedIabCategories: Array<IabCategory>;
  /** The list of channels created by this publisher. */
  channels: Array<ChannelLegacy>;
  /** The currency of the publisher. */
  currency?: Maybe<Scalars['Currency']>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** Time series of publisher impressions. */
  impressionsTimeSeries?: Maybe<TimeSeries>;
  /** The name of the publisher. */
  name?: Maybe<Scalars['String']>;
  /** The parent network to which this publisher belongs. */
  network?: Maybe<NetworkLegacy>;
  /** The amount for pricing, based on the type. */
  pricingAmount?: Maybe<Scalars['BigDecimal']>;
  /** The type of the pricing. */
  pricingType?: Maybe<PricingType>;
  /** The status of the given publisher. */
  status?: Maybe<PublisherStatus>;
  /** The list of territories assigned to the publisher. */
  territories: Array<Territory>;
};


export type PublisherLegacyAssociatedAdsArgs = {
  adTypes?: InputMaybe<Array<AdType>>;
  filter?: InputMaybe<AdFilterLegacy>;
  territories: Array<Territory>;
};


export type PublisherLegacyAssociatedDealsArgs = {
  filter?: InputMaybe<DealLegacyFilter>;
  territories: Array<Territory>;
};


export type PublisherLegacyChannelsArgs = {
  filter?: InputMaybe<ChannelLegacyFilter>;
  territories: Array<Territory>;
};


export type PublisherLegacyImpressionsTimeSeriesArgs = {
  params?: InputMaybe<TimeSeriesParams>;
};

export type PublisherLegacyAttributes = {
  /** List of domains blacklisted by the publisher. */
  blacklistedDomains?: InputMaybe<Array<Scalars['DomainName']>>;
  /** List of IAB categories blacklisted by the publisher. */
  blacklistedIabCategoryCodes?: InputMaybe<Array<Scalars['ID']>>;
  /** The currency of the publisher. */
  currency?: InputMaybe<Scalars['Currency']>;
  /** The name of the publisher. */
  name?: InputMaybe<Scalars['String']>;
  /** The amount for pricing, based on the type. Must be between 0 and 100 for RevShare. */
  pricingAmount?: InputMaybe<Scalars['BigDecimal']>;
  /** The type of the pricing. */
  pricingType?: InputMaybe<PricingType>;
  /** The status of the given publisher. */
  status?: InputMaybe<PublisherStatus>;
  /** The list of territories assigned to the publisher. */
  territories?: InputMaybe<Array<Territory>>;
};

export type PublisherLegacyFilter = {
  status_in?: InputMaybe<Array<PublisherStatus>>;
};

export type PublisherOffsetPaginationResponse = {
  __typename?: 'PublisherOffsetPaginationResponse';
  pageMetaData?: Maybe<PageMetaData>;
  publishers: Array<Publisher>;
};

export type PublisherPaymentConfig = {
  __typename?: 'PublisherPaymentConfig';
  audioNonSpotRevenueShare?: Maybe<Scalars['BigDecimal']>;
  audioNonSpotRevenueSharePreferredRate?: Maybe<Scalars['BigDecimal']>;
  audioSpotCpm?: Maybe<Scalars['BigDecimal']>;
  audioSpotRevenueShare?: Maybe<Scalars['BigDecimal']>;
  countries: Array<Country>;
  socialNonSpotRevenueShare?: Maybe<Scalars['BigDecimal']>;
  socialNonSpotRevenueSharePreferredRate?: Maybe<Scalars['BigDecimal']>;
  useSpecificNonSpotRevenueSharePerMediaType: Scalars['Boolean'];
  videoNonSpotRevenueShare?: Maybe<Scalars['BigDecimal']>;
  videoNonSpotRevenueSharePreferredRate?: Maybe<Scalars['BigDecimal']>;
  videoSpotRevenueShare?: Maybe<Scalars['BigDecimal']>;
};

export type PublisherPaymentConfigAttributes = {
  audioNonSpotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  audioNonSpotRevenueSharePreferredRate?: InputMaybe<Scalars['NonNegativeFloat']>;
  audioSpotCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  audioSpotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  countryCodes: Array<Scalars['String']>;
  socialNonSpotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  socialNonSpotRevenueSharePreferredRate?: InputMaybe<Scalars['NonNegativeFloat']>;
  useSpecificNonSpotRevenueSharePerMediaType: Scalars['Boolean'];
  videoNonSpotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  videoNonSpotRevenueSharePreferredRate?: InputMaybe<Scalars['NonNegativeFloat']>;
  videoSpotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
};

export enum PublisherRtbType {
  FmamBroadcast = 'FMAM_BROADCAST',
  MusicService = 'MUSIC_SERVICE',
  Podcast = 'PODCAST'
}

export enum PublisherStatus {
  /** The status of the publisher once deleted. */
  Deleted = 'DELETED',
  /** Publisher is disabled. */
  Disabled = 'DISABLED',
  /** The default value when the publisher is first created. */
  Draft = 'DRAFT',
  /** Publisher is enabled. */
  Enabled = 'ENABLED'
}

export type PublisherTargeting = {
  __typename?: 'PublisherTargeting';
  channels?: Maybe<Array<ChannelTargeting>>;
  clusivity?: Maybe<Clusivity>;
  id: Scalars['String'];
};

export type PublisherTimeSeries = {
  __typename?: 'PublisherTimeSeries';
  impresssions?: Maybe<TimeSeries>;
};

export type Query = {
  __typename?: 'Query';
  activeBusinessSharedInventoryGroups: Array<SharedInventoryGroup>;
  activePlatformStatusMessage?: Maybe<PlatformStatusMessage>;
  activeUserBusiness: Business;
  activeUserBusinessInventory: Array<InventoryParameterValue>;
  activeUserBusinessReferences: Array<BusinessReference>;
  activityHistoryFilterCategories: Array<ActivityHistoryFilterCategory>;
  activityHistoryFilterValues: Array<ActivityHistoryFilterValue>;
  ad: Ad;
  adByAltIdLegacy?: Maybe<AdLegacy>;
  adLegacy?: Maybe<AdLegacy>;
  adsCount: Scalars['NonNegativeInt'];
  /** @deprecated No longer used in new DAX 2.0 platform */
  advertiserLegacy?: Maybe<Advertiser>;
  agency: Agency;
  /** @deprecated No longer used in new DAX 2.0 platform */
  agencyLegacy?: Maybe<Agency>;
  allAdFormats: Array<AdFormatInfo>;
  allAdFormatsForShow: Array<AdFormatDetail>;
  allAdRequestEnrichmentAudienceParameterValues?: Maybe<Array<AudienceParameterValue>>;
  allAdRequestEnrichmentAudienceParameters?: Maybe<Array<AudienceParameterInfo>>;
  allAddedValueTypes: Array<AddedValueTypeInfo>;
  /** If a campaignId is provided, it will retrieve all ads for the given campaign. */
  allAdsLegacy: Array<AdLegacy>;
  /**
   * If an agencyId is provided, it will retrieve all advertisers for the given agency.
   * @deprecated No longer used in new DAX 2.0 platform
   */
  allAdvertisersLegacy: Array<Advertiser>;
  allAffectedEntities: Array<EntityIdentity>;
  allAgencies: Array<Agency>;
  /** @deprecated No longer used in new DAX 2.0 platform */
  allAgenciesLegacy: Array<Agency>;
  allAudienceParameters?: Maybe<Array<AudienceParameterInfo>>;
  allAudienceSegments: Array<AudienceSegment>;
  allBarterTypes: Array<BarterTypeInfo>;
  allBillableCpmChangeReasonsByBillingType: Array<BillableCpmChangeReasonInfo>;
  allBillingLineBillingTypes: Array<BillingLineBillingTypeInfo>;
  allBillingLineTypes: Array<BillingLineTypeInfo>;
  allBillingTypes: Array<FlightBillingTypeInfo>;
  allBookingValidations: Array<BookingValidationTypeInfo>;
  allBrands: Array<Brand>;
  allBrowserLanguages: Array<BrowserLanguage>;
  /**
   *  TODO: temporary query to enable show creation until channel page is built
   * @deprecated No longer used in new DAX 2.0 platform
   */
  allBusinessChannelInventoryLegacy: Array<InventoryParameterValue>;
  allBusinessReferences: Array<BusinessReference>;
  allBusinessRules: Array<BusinessRuleTypeInfo>;
  /** If an orderId is provided, it will retrieve all campaigns for the given order. */
  allCampaigns: Array<Campaign>;
  allChannelContentCategories: Array<ChannelContentCategoryInfo>;
  allChannelInventoryTypes: Array<ChannelInventoryTypeInfo>;
  allChannelTypes: Array<ChannelTypeInfo>;
  /**
   * If a publisherId is provided, it will retrieve all channels for the given publisher.
   * If a transcodePresetId is provided, it will retrieve all channels which have this transcode preset assigned.
   * @deprecated No longer used in new DAX 2.0 platform
   */
  allChannelsLegacy: Array<ChannelLegacy>;
  allCities: Array<CityResponse>;
  allCountries: Array<Country>;
  allCountryGroups: Array<CountryGroup>;
  /**
   * If an advertiserId is provided, it will retrieve all creatives for the given advertiser.
   * @deprecated No longer used in new DAX 2.0 platform
   */
  allCreativesLegacy: Array<CreativeLegacy>;
  allCurrencyRates: Array<CurrencyRate>;
  /** If a technicalProviderId is provided, it will retrieve all Data Centers for the given technical provider. */
  allDataCentersLegacy: Array<DataCenterLegacy>;
  /** If a salesChannelId is provided, it will retrieve all deals for the given agency. */
  allDealsLegacy: Array<DealLegacy>;
  allDeliveryBreakdownMetrics: Array<DeliveryBreakdownMetricInfo>;
  allDeliveryDayAndHourMetrics: Array<DeliveryDayHourMetricInfo>;
  allDeliveryGeoMetrics: Array<DeliveryGeoMetricInfo>;
  allDeliveryTimeSeriesMetrics: Array<DeliveryTimeSeriesMetricInfo>;
  allDepartments: Array<Department>;
  allDeviceMakers: Array<DeviceMaker>;
  allDeviceOperatingSystems: Array<OperatingSystem>;
  allDeviceTypes: Array<Scalars['String']>;
  allDmas: Array<Dma>;
  allDmpSegments: Array<DmpSegment>;
  /** If a technicalProviderId is provided, it will retrieve all DSPs for the given technical provider. */
  allDspsLegacy: Array<DspLegacy>;
  /** FeatureFlag Queries */
  allFeatureFlags: Array<FeatureFlag>;
  allFlightBillingTypes: Array<FlightBillingTypeInfo>;
  allFlightBoltOns: Array<FlightBoltOnInfo>;
  allFlightRestrictions: Array<FlightRestrictionInfo>;
  allFlightTypes: Array<FlightTypeInfo>;
  allGenres: Array<Scalars['String']>;
  allHostingPlatformTypes: Array<ShowHostingPlatformInfo>;
  allIabCategories: Array<IabCategory>;
  allInventoryParameters?: Maybe<Array<InventoryParameterInfo>>;
  allItunesCategories: Array<ItunesCategory>;
  allLocationAccuracies: LocationAccuracies;
  allLocationParameters?: Maybe<Array<LocationParameterInfo>>;
  /** @deprecated No longer used in new DAX 2.0 platform */
  allNetworksLegacy: Array<NetworkLegacy>;
  allNotifications: Array<NotificationTypeInfo>;
  /** If an advertiserId is provided, it will retrieve all orders for the given advertiser. */
  allOrders: Array<Order>;
  allPostcodeGroups: Array<PostcodeGroup>;
  allPublisherCategories?: Maybe<Array<PublisherCategory>>;
  /** @deprecated No longer used in new DAX 2.0 platform */
  allPublisherContractsLegacy: Array<PublisherContractLegacy>;
  /**
   * If a networkId is provided, it will retrieve all publishers for the given network.
   * @deprecated No longer used in new DAX 2.0 platform
   */
  allPublishersLegacy: Array<PublisherLegacy>;
  allRegionPacks?: Maybe<Array<LocationParameterValue>>;
  allRegions: Array<GeoRegionResponse>;
  /** If an agencyId is provided, it will retrieve all sales channels for the given agency. */
  allSalesChannelsLegacy: Array<SalesChannelLegacy>;
  /** If a dspId is provided it will retrieve all seats for the given DSP. */
  allSeatsLegacy: Array<SeatLegacy>;
  allShowAdPositionTypes: Array<ShowAdPositionInfo>;
  allShowContracts: Array<ShowContract>;
  allShowsInventoryParameterValues: Array<InventoryParameterValue>;
  allShowsLegacy: Array<ShowLegacy>;
  allSubRegions: Array<GeoRegionResponse>;
  allTags: Array<Tag>;
  allTargetingRestrictions: Array<TargetingRestrictionTypeInfo>;
  allTargetingTemplates: Array<TargetingTemplate>;
  allTechnicalProvidersLegacy: Array<TechnicalProviderLegacy>;
  allTechnologyParameters?: Maybe<Array<TechnologyParameterInfo>>;
  allTimeZones: Array<Scalars['String']>;
  /** If a channelId is provided, it will retrieve all transcode presets for the given channel. */
  allTranscodePresets: Array<TranscodePreset>;
  allUserTypes: Array<UserTypeInfo>;
  allUsers: Array<User>;
  allVastVersions: Array<VastVersionInfo>;
  audienceParameterValues?: Maybe<Array<AudienceParameterValue>>;
  auditTrail: Array<AuditTrail>;
  availableBusinessPermissions: Array<PermissionV2Category>;
  billingLine: BillingLine;
  billingLinesByProposalId: Array<BillingLine>;
  brand: Brand;
  brandsByAgencyId: Array<Brand>;
  business: Business;
  /** Business Queries */
  businessBoltOns: Array<FlightBoltOnInfo>;
  businessInventory: Array<InventoryParameterValue>;
  businessRoleConfiguration: BusinessRoleConfiguration;
  businessTargetingGroups: Array<BusinessTargetingGroup>;
  businessUser: BusinessUser;
  businessUsers: Array<BusinessUser>;
  calculateCpm: Price;
  calculateDataCost: Price;
  calculatePriceBreakdown: Array<PriceBreakdown>;
  calculateTargetingName: Scalars['String'];
  campaign?: Maybe<Campaign>;
  changesByActivityId: Array<ActivityChange>;
  channel: Channel;
  /** @deprecated No longer used in new DAX 2.0 platform */
  channelByAltIdLegacy?: Maybe<ChannelLegacy>;
  /** @deprecated No longer used in new DAX 2.0 platform */
  channelLegacy?: Maybe<ChannelLegacy>;
  countryGroup?: Maybe<CountryGroup>;
  creative: Creative;
  /** @deprecated No longer used in new DAX 2.0 platform */
  creativeLegacy?: Maybe<CreativeLegacy>;
  currentUser?: Maybe<User>;
  dataCenter: DataCenter;
  dataCenterLegacy?: Maybe<DataCenterLegacy>;
  daxIdTagsByBrandId: Array<DaxIdTag>;
  daxShowContract: DaxShowContract;
  daxShowContracts: Array<DaxShowContract>;
  dealLegacy?: Maybe<DealLegacy>;
  defaultTargetingForFlightType: TargetingDefinitionV2;
  deliveryMetricsBreakdown: Array<BreakdownPoint>;
  deliveryMetricsDayAndHour: Array<DayAndHourPoint>;
  deliveryMetricsGeoData: Array<GeoDataPoint>;
  deliveryMetricsTimeSeries: TimeSeriesResponse;
  deliveryMetricsTotals: DeliveryTotalsPoint;
  demandParameterValues: Array<DemandParameterValue>;
  directSearch: DirectSearchResponse;
  directSearchFilterCategories?: Maybe<Array<DirectSearchFilterCategory>>;
  directSearchFilterValues?: Maybe<Array<DirectSearchFilterValue>>;
  directSearchFilters: Array<DirectSearchFilter>;
  directSearchOrderables: Array<DirectSearchOrderableInfo>;
  dsp: Dsp;
  dspLegacy?: Maybe<DspLegacy>;
  exchangeSearch: ExchangeSearchResponse;
  featureFlag: FeatureFlag;
  featureFlagsByUserId: Array<FeatureFlag>;
  flight: Flight;
  flightFilterCategories?: Maybe<Array<FlightFilterCategory>>;
  flightFilterValues?: Maybe<Array<FlightFilterValue>>;
  forecast?: Maybe<Forecast>;
  forecastMultipleProposedFlights: Array<Forecast>;
  forecastProposal?: Maybe<Forecast>;
  forecastProposedFlight?: Maybe<Forecast>;
  generatePreSignedUrl?: Maybe<PreSignedUrl>;
  /** Generate unique external id based on the ones that are already defined. */
  generateUniqueExternalId?: Maybe<Scalars['String']>;
  getBusinessDomainsById?: Maybe<Array<Maybe<Scalars['String']>>>;
  getLocationParameterValueByTerritory: LocationParameterValue;
  getNotesByOrderLineId: Array<Note>;
  getPublisherInsightsBreakdown?: Maybe<PublisherInsightsBreakdown>;
  globalBlacklistedDomains: Array<TerritoryToDomains>;
  globalBlacklistedIabCategories: Array<TerritoryToIabCategories>;
  inventoryParameterValues?: Maybe<Array<InventoryParameterValue>>;
  listDataCenters: Array<DataCenterMinimal>;
  listDsps: Array<DspMinimal>;
  liveFlightsByAgencyId: Array<Flight>;
  liveOrders: Array<Order>;
  liveOrdersForBusiness: Array<Order>;
  locationParameterValues?: Maybe<Array<LocationParameterValue>>;
  masterControls: Array<MasterControl>;
  /** Used when sharing a Flight with another Business */
  minimalFlight: MinimalFlight;
  /** Used when sharing an Order Line with another Business */
  minimalOrderLine: MinimalOrderLine;
  minimalShows: Array<MinimalShow>;
  network: Network;
  /** @deprecated No longer used in new DAX 2.0 platform */
  networkLegacy?: Maybe<NetworkLegacy>;
  offsetPaginateActivities: ActivityOffsetPaginationResponse;
  offsetPaginateAgencies?: Maybe<AgencyOffsetPaginationResponse>;
  offsetPaginateAgenciesForBusiness?: Maybe<AgencyOffsetPaginationResponse>;
  offsetPaginateBrands?: Maybe<BrandOffsetPaginationResponse>;
  offsetPaginateBrandsForBusiness?: Maybe<BrandOffsetPaginationResponse>;
  offsetPaginateBusinessUsers: BusinessUserPaginatedResponse;
  offsetPaginateBusinesses?: Maybe<BusinessOffsetPaginationResponse>;
  offsetPaginateCampaigns?: Maybe<CampaignOffsetPaginationResponse>;
  offsetPaginateChannels?: Maybe<ChannelOffsetPaginationResponse>;
  offsetPaginateCreatives?: Maybe<CreativeOffsetPaginationResponse>;
  offsetPaginateDaxIdTags: DaxIdTagOffsetPaginationResponse;
  offsetPaginateFlights?: Maybe<FlightOffsetPaginationResponse>;
  offsetPaginateMinimalOrderLines?: Maybe<MinimalOrderLineOffsetPaginationResponse>;
  offsetPaginateNetworks?: Maybe<NetworkOffsetPaginationResponse>;
  offsetPaginateOrderLines?: Maybe<OrderLineOffsetPaginationResponse>;
  offsetPaginateOrderLinesForBusiness?: Maybe<OrderLineOffsetPaginationResponse>;
  offsetPaginateOrders?: Maybe<OrderOffsetPaginationResponse>;
  offsetPaginateProgrammaticConnectors: ProgrammaticConnectorOffsetPaginationResponse;
  offsetPaginatePublishers?: Maybe<PublisherOffsetPaginationResponse>;
  offsetPaginateSeats: SeatOffsetPaginationResponse;
  offsetPaginateShows?: Maybe<ShowOffsetPaginationResponse>;
  offsetPaginateShowsAvailability?: Maybe<ShowAvailabilityOffsetPaginationResponse>;
  optionQueueForProposedFlight?: Maybe<ProposedFlightOptionQueue>;
  optionQueueForShow: OptionQueue;
  order?: Maybe<Order>;
  orderLine?: Maybe<OrderLine>;
  orderLineByOmOrderId?: Maybe<OrderLine>;
  orderLineFilterCategories?: Maybe<Array<OrderLineFilterCategory>>;
  orderLineFilterValues?: Maybe<Array<OrderLineFilterValue>>;
  paginateAds?: Maybe<AdLegacyConnection>;
  paginateAdvertisers?: Maybe<AdvertiserConnection>;
  paginateAgencies?: Maybe<AgencyConnection>;
  paginateCampaigns?: Maybe<CampaignConnection>;
  paginateCreatives?: Maybe<CreativeLegacyConnection>;
  paginateOrders?: Maybe<OrderConnection>;
  paginateProgrammaticCreatives?: Maybe<ProgrammaticCreativeConnection>;
  platformRoleConfiguration: PlatformRoleConfiguration;
  platformUser: PlatformUser;
  /** Platform Queries */
  platformUsers: Array<PlatformUser>;
  postcodeGroup?: Maybe<PostcodeGroup>;
  primaryControls: Array<PrimaryControl>;
  programmaticBillingLine: ProgrammaticBillingLine;
  programmaticBillingLinesByProposalId: Array<ProgrammaticBillingLine>;
  programmaticConnector: ProgrammaticConnector;
  proposal?: Maybe<Proposal>;
  proposalsByOrderLineId: Array<Proposal>;
  proposedFlight?: Maybe<ProposedFlight>;
  proposedFlightsByProposalId: Array<ProposedFlight>;
  publisher: Publisher;
  publisherContract: PublisherContract;
  /** @deprecated No longer used in new DAX 2.0 platform */
  publisherContractLegacy?: Maybe<PublisherContractLegacy>;
  publisherContracts: Array<PublisherContract>;
  publisherInsightsFilterCategories?: Maybe<Array<PublisherInsightsFilterCategory>>;
  publisherInsightsFilters?: Maybe<Array<PublisherInsightsFilter>>;
  publisherInsightsTimeSeries?: Maybe<Array<PublisherInsightsTimeSeries>>;
  /** @deprecated No longer used in new DAX 2.0 platform */
  publisherLegacy?: Maybe<PublisherLegacy>;
  reportAllOrderLines: Scalars['Boolean'];
  reportOrderLine: Scalars['String'];
  salesChannelLegacy?: Maybe<SalesChannelLegacy>;
  search: Array<Maybe<SearchResult>>;
  searchAudienceSegments: Array<AudienceSegment>;
  searchDmpSegments: Array<DmpSegment>;
  searchIsps: Array<Isp>;
  searchPostcodes: Array<Scalars['String']>;
  searchUsers: Array<User>;
  seat: Seat;
  seatLegacy?: Maybe<SeatLegacy>;
  sharedInventoryGroups: Array<SharedInventoryGroup>;
  sharedReportingGroups: Array<SharedReportingGroup>;
  show: Show;
  showAudioAvailability?: Maybe<ShowAvailabilityAudioResponse>;
  showAvailability: Array<ShowAvailabilityResponse>;
  showContract?: Maybe<ShowContract>;
  showFilterRefData: ShowFilterRefData;
  supplyAudienceParameters: Array<SupplyAudienceParameter>;
  supplySearch: SupplySearchResponse;
  supplySearchFilterCategories: Array<SupplySearchFilterCategory>;
  supplySearchFilterValues: Array<SupplySearchFilterValue>;
  tag?: Maybe<Tag>;
  targetingStrategy?: Maybe<TargetingStrategy>;
  targetingTemplate?: Maybe<TargetingTemplate>;
  technicalProviderLegacy?: Maybe<TechnicalProviderLegacy>;
  technologyParameterValues?: Maybe<Array<TechnologyParameterValue>>;
  totalProgrammaticCreatives?: Maybe<Scalars['Float']>;
  transcodePreset?: Maybe<TranscodePreset>;
  user?: Maybe<User>;
  validatePostcodes: ValidatePostcodesResponse;
};


export type QueryActiveUserBusinessInventoryArgs = {
  status?: InputMaybe<InventoryStatus>;
};


export type QueryActivityHistoryFilterValuesArgs = {
  filterType: ActivityHistoryFilterType;
};


export type QueryAdArgs = {
  id: Scalars['ID'];
};


export type QueryAdByAltIdLegacyArgs = {
  altId: Scalars['Int'];
};


export type QueryAdLegacyArgs = {
  id: Scalars['ID'];
};


export type QueryAdsCountArgs = {
  creativeId: Scalars['ID'];
};


export type QueryAdvertiserLegacyArgs = {
  id: Scalars['ID'];
};


export type QueryAgencyArgs = {
  id: Scalars['ID'];
};


export type QueryAgencyLegacyArgs = {
  id: Scalars['ID'];
};


export type QueryAllAdFormatsArgs = {
  mediaType: MediaType;
};


export type QueryAllAdFormatsForShowArgs = {
  id: Scalars['ID'];
};


export type QueryAllAdRequestEnrichmentAudienceParameterValuesArgs = {
  type: AudienceParameterType;
};


export type QueryAllAdsLegacyArgs = {
  adTypes?: InputMaybe<Array<AdType>>;
  campaignId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<AdFilterLegacy>;
  territories: Array<Territory>;
};


export type QueryAllAdvertisersLegacyArgs = {
  agencyId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<AdvertiserFilter>;
  territories: Array<Territory>;
};


export type QueryAllAffectedEntitiesArgs = {
  entityAttributes: EntityAttributes;
  targetStatus: EntityStatus;
};


export type QueryAllAgenciesArgs = {
  searchTerm?: InputMaybe<Scalars['String']>;
  territory?: InputMaybe<Territory>;
};


export type QueryAllAgenciesLegacyArgs = {
  filter?: InputMaybe<AgencyFilter>;
  territories: Array<Territory>;
};


export type QueryAllBillableCpmChangeReasonsByBillingTypeArgs = {
  billingType: FlightBillingType;
};


export type QueryAllBillingLineBillingTypesArgs = {
  orderLineId: Scalars['ID'];
};


export type QueryAllBrandsArgs = {
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryAllCampaignsArgs = {
  filter?: InputMaybe<CampaignFilter>;
  orderId?: InputMaybe<Scalars['ID']>;
  territories: Array<Territory>;
};


export type QueryAllChannelsLegacyArgs = {
  filter?: InputMaybe<ChannelLegacyFilter>;
  publisherId?: InputMaybe<Scalars['ID']>;
  territories: Array<Territory>;
  transcodePresetId?: InputMaybe<Scalars['ID']>;
};


export type QueryAllCitiesArgs = {
  countryCodes: Array<Scalars['String']>;
};


export type QueryAllCountryGroupsArgs = {
  territories: Array<Territory>;
};


export type QueryAllCreativesLegacyArgs = {
  advertiserId?: InputMaybe<Scalars['ID']>;
  allValues?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CreativeFilterLegacy>;
  territories: Array<Territory>;
  type: CreativeTypeLegacy;
};


export type QueryAllDataCentersLegacyArgs = {
  filter?: InputMaybe<DataCenterLegacyFilter>;
  technicalProviderId?: InputMaybe<Scalars['ID']>;
};


export type QueryAllDealsLegacyArgs = {
  filter?: InputMaybe<DealLegacyFilter>;
  salesChannelId?: InputMaybe<Scalars['ID']>;
  seatId?: InputMaybe<Scalars['ID']>;
  territories: Array<Territory>;
};


export type QueryAllDmpSegmentsArgs = {
  type: DmpSegmentType;
};


export type QueryAllDspsLegacyArgs = {
  filter?: InputMaybe<DspLegacyFilter>;
  technicalProviderId?: InputMaybe<Scalars['ID']>;
  territories: Array<Territory>;
};


export type QueryAllFlightBillingTypesArgs = {
  orderLineId: Scalars['ID'];
};


export type QueryAllHostingPlatformTypesArgs = {
  mediaType: MediaType;
};


export type QueryAllLocationParametersArgs = {
  territory?: InputMaybe<Territory>;
};


export type QueryAllNetworksLegacyArgs = {
  filter?: InputMaybe<NetworkLegacyFilter>;
  territories: Array<Territory>;
};


export type QueryAllOrdersArgs = {
  advertiserId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<OrderFilter>;
  territories: Array<Territory>;
};


export type QueryAllPostcodeGroupsArgs = {
  territories: Array<Territory>;
};


export type QueryAllPublisherContractsLegacyArgs = {
  publisherId?: InputMaybe<Scalars['ID']>;
};


export type QueryAllPublishersLegacyArgs = {
  filter?: InputMaybe<PublisherLegacyFilter>;
  networkId?: InputMaybe<Scalars['ID']>;
  territories: Array<Territory>;
};


export type QueryAllRegionPacksArgs = {
  territories: Array<Territory>;
};


export type QueryAllRegionsArgs = {
  countryCodes: Array<Scalars['String']>;
};


export type QueryAllSalesChannelsLegacyArgs = {
  agencyId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<SalesChannelLegacyFilter>;
  territories: Array<Territory>;
};


export type QueryAllSeatsLegacyArgs = {
  dspId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<SeatLegacyFilter>;
  territories: Array<Territory>;
};


export type QueryAllShowContractsArgs = {
  channelId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<ShowContractFilter>;
};


export type QueryAllShowsInventoryParameterValuesArgs = {
  billingLineType?: InputMaybe<BillingLineType>;
  channelIdsToExclude?: InputMaybe<Array<Scalars['ID']>>;
  territory?: InputMaybe<Territory>;
};


export type QueryAllSubRegionsArgs = {
  countryCode: Scalars['String'];
  regionCodes: Array<Scalars['String']>;
};


export type QueryAllTagsArgs = {
  adId?: InputMaybe<Scalars['ID']>;
  campaignId?: InputMaybe<Scalars['ID']>;
};


export type QueryAllTargetingTemplatesArgs = {
  filter?: InputMaybe<TargetingTemplateFilter>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  territories: Array<Territory>;
};


export type QueryAllTechnicalProvidersLegacyArgs = {
  filter?: InputMaybe<TechnicalProviderLegacyFilter>;
  territories: Array<Territory>;
};


export type QueryAllTranscodePresetsArgs = {
  channelId?: InputMaybe<Scalars['ID']>;
};


export type QueryAllUsersArgs = {
  permissions?: InputMaybe<Array<PermissionName>>;
  territories: Array<Territory>;
};


export type QueryAudienceParameterValuesArgs = {
  territory: Territory;
  type: AudienceParameterType;
};


export type QueryAuditTrailArgs = {
  for: AuditTrailFilter;
};


export type QueryBillingLineArgs = {
  id: Scalars['ID'];
};


export type QueryBillingLinesByProposalIdArgs = {
  endDateExclusive?: InputMaybe<Scalars['LocalDateTime']>;
  proposalId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
};


export type QueryBrandArgs = {
  id: Scalars['ID'];
};


export type QueryBrandsByAgencyIdArgs = {
  agencyId: Scalars['ID'];
};


export type QueryBusinessArgs = {
  id: Scalars['ID'];
};


export type QueryBusinessInventoryArgs = {
  businessId: Scalars['ID'];
  status?: InputMaybe<InventoryStatus>;
};


export type QueryBusinessRoleConfigurationArgs = {
  businessId: Scalars['ID'];
};


export type QueryBusinessUserArgs = {
  id: Scalars['ID'];
};


export type QueryBusinessUsersArgs = {
  excludedUserIds?: InputMaybe<Array<Scalars['ID']>>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryCalculateCpmArgs = {
  attributes: CalculateCpmAttributes;
  targetingDefinitions: Array<TargetingDefinitionV2Attributes>;
};


export type QueryCalculateDataCostArgs = {
  currency: Scalars['Currency'];
  departmentId?: InputMaybe<Scalars['ID']>;
  targetingDefinitions: Array<TargetingDefinitionV2Attributes>;
};


export type QueryCalculatePriceBreakdownArgs = {
  attributes: CalculatePriceBreakdownAttributes;
};


export type QueryCalculateTargetingNameArgs = {
  attributes: CalculateTargetingNameAttributes;
};


export type QueryCampaignArgs = {
  id: Scalars['ID'];
};


export type QueryChangesByActivityIdArgs = {
  activityId: Scalars['ID'];
};


export type QueryChannelArgs = {
  id: Scalars['ID'];
};


export type QueryChannelByAltIdLegacyArgs = {
  id: Scalars['ID'];
};


export type QueryChannelLegacyArgs = {
  id: Scalars['ID'];
};


export type QueryCountryGroupArgs = {
  id: Scalars['ID'];
};


export type QueryCreativeArgs = {
  id: Scalars['ID'];
};


export type QueryCreativeLegacyArgs = {
  id: Scalars['ID'];
  type: CreativeTypeLegacy;
};


export type QueryDataCenterArgs = {
  id: Scalars['ID'];
};


export type QueryDataCenterLegacyArgs = {
  id: Scalars['ID'];
};


export type QueryDaxIdTagsByBrandIdArgs = {
  brandId: Scalars['ID'];
};


export type QueryDaxShowContractArgs = {
  id: Scalars['ID'];
};


export type QueryDaxShowContractsArgs = {
  showId: Scalars['ID'];
};


export type QueryDealLegacyArgs = {
  id: Scalars['ID'];
};


export type QueryDefaultTargetingForFlightTypeArgs = {
  flightType: FlightType;
  inventoryParameters?: InputMaybe<Array<InventoryParameterAttributes>>;
  territory?: InputMaybe<Territory>;
};


export type QueryDeliveryMetricsBreakdownArgs = {
  breakdownField: DeliveryBreakdownField;
  breakdownMetric: DeliveryBreakdownMetric;
  endDate: Scalars['LocalDateTime'];
  entityTypeId: EntityTypeIdAttributes;
  startDate: Scalars['LocalDateTime'];
  territory: Territory;
};


export type QueryDeliveryMetricsDayAndHourArgs = {
  endDate: Scalars['LocalDateTime'];
  entityTypeId: EntityTypeIdAttributes;
  metric: DeliveryDayAndHourMetric;
  startDate: Scalars['LocalDateTime'];
  timeZone: Scalars['ZoneId'];
};


export type QueryDeliveryMetricsGeoDataArgs = {
  endDate: Scalars['LocalDateTime'];
  entityTypeId: EntityTypeIdAttributes;
  geoMetric: DeliveryGeoMetric;
  startDate: Scalars['LocalDateTime'];
  territory: Territory;
};


export type QueryDeliveryMetricsTimeSeriesArgs = {
  endDate: Scalars['LocalDateTime'];
  entityTypeId: EntityTypeIdAttributes;
  startDate: Scalars['LocalDateTime'];
  territory: Territory;
  timeSeriesMetric: DeliveryTimeSeriesMetric;
  timeZone: Scalars['ZoneId'];
};


export type QueryDeliveryMetricsTotalsArgs = {
  endDate: Scalars['LocalDateTime'];
  entityTypeId: EntityTypeIdAttributes;
  metrics: Array<DeliveryTotalsMetric>;
  startDate: Scalars['LocalDateTime'];
};


export type QueryDemandParameterValuesArgs = {
  businessId: Scalars['ID'];
};


export type QueryDirectSearchArgs = {
  filter?: InputMaybe<DirectSearchFilterNew>;
  itemsPerPage: Scalars['NonNegativeInt'];
  orderableField?: InputMaybe<DirectSearchOrderableField>;
  orderingDirection?: InputMaybe<OrderingDirection>;
  pageNumber: Scalars['NonNegativeInt'];
  searchFilters?: InputMaybe<Array<DirectSearchFilterAttributes>>;
  searchTerm: Scalars['String'];
  territory?: InputMaybe<Territory>;
};


export type QueryDirectSearchFilterValuesArgs = {
  filterType: DirectSearchFilterType;
  territory?: InputMaybe<Territory>;
};


export type QueryDspArgs = {
  id: Scalars['ID'];
};


export type QueryDspLegacyArgs = {
  id: Scalars['ID'];
};


export type QueryExchangeSearchArgs = {
  itemsPerPage: Scalars['NonNegativeInt'];
  pageNumber: Scalars['NonNegativeInt'];
  searchTerm: Scalars['String'];
};


export type QueryFeatureFlagArgs = {
  id: Scalars['ID'];
};


export type QueryFeatureFlagsByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryFlightArgs = {
  id: Scalars['ID'];
};


export type QueryFlightFilterValuesArgs = {
  filterType: FlightFilterType;
};


export type QueryForecastArgs = {
  attributes: ForecastAttributes;
};


export type QueryForecastMultipleProposedFlightsArgs = {
  attributes: MultipleProposedFlightsForecastAttributes;
};


export type QueryForecastProposalArgs = {
  attributes: ProposalForecastAttributes;
};


export type QueryForecastProposedFlightArgs = {
  attributes: ProposedFlightForecastAttributes;
};


export type QueryGeneratePreSignedUrlArgs = {
  attributes: PreSignedUrlAttributes;
};


export type QueryGetBusinessDomainsByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetLocationParameterValueByTerritoryArgs = {
  territory: Territory;
};


export type QueryGetNotesByOrderLineIdArgs = {
  orderLineId: Scalars['ID'];
};


export type QueryGetPublisherInsightsBreakdownArgs = {
  currency: Scalars['Currency'];
  dimension: Dimension;
  endDate: Scalars['LocalDateTime'];
  filters?: InputMaybe<Array<PublisherInsightsFilterAttributes>>;
  metric: PublisherInsightsMetric;
  startDate: Scalars['LocalDateTime'];
};


export type QueryGlobalBlacklistedDomainsArgs = {
  territories: Array<Territory>;
};


export type QueryGlobalBlacklistedIabCategoriesArgs = {
  territories: Array<Territory>;
};


export type QueryInventoryParameterValuesArgs = {
  parameterValuesLevel?: InputMaybe<InventoryParameterValuesLevel>;
  status?: InputMaybe<InventoryStatus>;
  territory?: InputMaybe<Territory>;
  type: InventoryParameterType;
};


export type QueryListDataCentersArgs = {
  programmaticConnectorId: Scalars['ID'];
};


export type QueryListDspsArgs = {
  programmaticConnectorId: Scalars['ID'];
};


export type QueryLiveFlightsByAgencyIdArgs = {
  agencyId: Scalars['ID'];
};


export type QueryLiveOrdersArgs = {
  agencyId?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
};


export type QueryLiveOrdersForBusinessArgs = {
  businessId?: InputMaybe<Scalars['ID']>;
};


export type QueryLocationParameterValuesArgs = {
  search?: InputMaybe<Scalars['String']>;
  type: LocationParameterType;
};


export type QueryMinimalFlightArgs = {
  id: Scalars['ID'];
};


export type QueryMinimalOrderLineArgs = {
  id: Scalars['ID'];
};


export type QueryNetworkArgs = {
  id: Scalars['ID'];
};


export type QueryNetworkLegacyArgs = {
  id: Scalars['ID'];
};


export type QueryOffsetPaginateActivitiesArgs = {
  filter?: InputMaybe<ActivityFilter>;
  itemsPerPage: Scalars['NonNegativeInt'];
  orderableField?: InputMaybe<ActivityOrderableField>;
  orderingDirection?: InputMaybe<OrderingDirection>;
  pageNumber: Scalars['NonNegativeInt'];
  territories?: InputMaybe<Array<Territory>>;
};


export type QueryOffsetPaginateAgenciesArgs = {
  itemsPerPage: Scalars['NonNegativeInt'];
  pageNumber: Scalars['NonNegativeInt'];
  territories: Array<Territory>;
};


export type QueryOffsetPaginateAgenciesForBusinessArgs = {
  itemsPerPage: Scalars['NonNegativeInt'];
  pageNumber: Scalars['NonNegativeInt'];
};


export type QueryOffsetPaginateBrandsArgs = {
  filter?: InputMaybe<BrandFilter>;
  itemsPerPage: Scalars['NonNegativeInt'];
  pageNumber: Scalars['NonNegativeInt'];
  territories: Array<Territory>;
};


export type QueryOffsetPaginateBrandsForBusinessArgs = {
  filter?: InputMaybe<BrandFilter>;
  itemsPerPage: Scalars['NonNegativeInt'];
  pageNumber: Scalars['NonNegativeInt'];
};


export type QueryOffsetPaginateBusinessUsersArgs = {
  itemsPerPage: Scalars['PositiveInt'];
  pageNumber: Scalars['NonNegativeInt'];
};


export type QueryOffsetPaginateBusinessesArgs = {
  itemsPerPage: Scalars['NonNegativeInt'];
  pageNumber: Scalars['NonNegativeInt'];
};


export type QueryOffsetPaginateCampaignsArgs = {
  filter?: InputMaybe<CampaignFilter>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['ID']>;
  orderable?: InputMaybe<CampaignOrdering>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  territories: Array<Territory>;
};


export type QueryOffsetPaginateChannelsArgs = {
  filter?: InputMaybe<ChannelFilter>;
  itemsPerPage: Scalars['PositiveInt'];
  pageNumber: Scalars['NonNegativeInt'];
};


export type QueryOffsetPaginateCreativesArgs = {
  filter?: InputMaybe<CreativeFilter>;
  itemsPerPage: Scalars['NonNegativeInt'];
  orderableField?: InputMaybe<CreativeOrderableField>;
  orderingDirection?: InputMaybe<OrderingDirection>;
  pageNumber: Scalars['NonNegativeInt'];
  territories?: InputMaybe<Array<Territory>>;
};


export type QueryOffsetPaginateDaxIdTagsArgs = {
  filter?: InputMaybe<DaxIdTagFilter>;
  itemsPerPage: Scalars['NonNegativeInt'];
  pageNumber: Scalars['NonNegativeInt'];
};


export type QueryOffsetPaginateFlightsArgs = {
  filter?: InputMaybe<FlightFilter>;
  itemsPerPage: Scalars['NonNegativeInt'];
  orderableField?: InputMaybe<FlightOrderableField>;
  orderingDirection?: InputMaybe<OrderingDirection>;
  pageNumber: Scalars['NonNegativeInt'];
  territories?: InputMaybe<Array<Territory>>;
};


export type QueryOffsetPaginateMinimalOrderLinesArgs = {
  filter?: InputMaybe<MinimalOrderLineFilter>;
  itemsPerPage: Scalars['NonNegativeInt'];
  orderableField?: InputMaybe<OrderLineOrderableField>;
  orderingDirection?: InputMaybe<OrderingDirection>;
  pageNumber: Scalars['NonNegativeInt'];
  searchTerm?: InputMaybe<Scalars['String']>;
  territories?: InputMaybe<Array<Territory>>;
};


export type QueryOffsetPaginateNetworksArgs = {
  itemsPerPage: Scalars['PositiveInt'];
  pageNumber: Scalars['NonNegativeInt'];
};


export type QueryOffsetPaginateOrderLinesArgs = {
  filter?: InputMaybe<OrderLineFilter>;
  itemsPerPage: Scalars['NonNegativeInt'];
  orderableField?: InputMaybe<OrderLineOrderableField>;
  orderingDirection?: InputMaybe<OrderingDirection>;
  pageNumber: Scalars['NonNegativeInt'];
  searchTerm?: InputMaybe<Scalars['String']>;
  territories?: InputMaybe<Array<Territory>>;
};


export type QueryOffsetPaginateOrderLinesForBusinessArgs = {
  filter?: InputMaybe<OrderLineFilter>;
  itemsPerPage: Scalars['NonNegativeInt'];
  orderableField?: InputMaybe<OrderLineOrderableField>;
  orderingDirection?: InputMaybe<OrderingDirection>;
  pageNumber: Scalars['NonNegativeInt'];
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryOffsetPaginateOrdersArgs = {
  filter?: InputMaybe<OrderFilter>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  orderable?: InputMaybe<OrderOrdering>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  territories: Array<Territory>;
};


export type QueryOffsetPaginateProgrammaticConnectorsArgs = {
  itemsPerPage: Scalars['NonNegativeInt'];
  pageNumber: Scalars['NonNegativeInt'];
};


export type QueryOffsetPaginatePublishersArgs = {
  filter?: InputMaybe<PublisherFilter>;
  itemsPerPage: Scalars['PositiveInt'];
  pageNumber: Scalars['NonNegativeInt'];
};


export type QueryOffsetPaginateSeatsArgs = {
  filter?: InputMaybe<SeatFilter>;
  itemsPerPage: Scalars['NonNegativeInt'];
  pageNumber: Scalars['NonNegativeInt'];
};


export type QueryOffsetPaginateShowsArgs = {
  filter?: InputMaybe<ShowFilter>;
  itemsPerPage: Scalars['PositiveInt'];
  pageNumber: Scalars['NonNegativeInt'];
};


export type QueryOffsetPaginateShowsAvailabilityArgs = {
  filter?: InputMaybe<ShowAvailabilityFilter>;
  itemsPerPage: Scalars['PositiveInt'];
  pageNumber: Scalars['NonNegativeInt'];
};


export type QueryOptionQueueForProposedFlightArgs = {
  proposedFlightId: Scalars['ID'];
};


export type QueryOptionQueueForShowArgs = {
  filter: OptionQueueFilter;
  showId: Scalars['ID'];
};


export type QueryOrderArgs = {
  id: Scalars['ID'];
};


export type QueryOrderLineArgs = {
  id: Scalars['ID'];
};


export type QueryOrderLineByOmOrderIdArgs = {
  id: Scalars['ID'];
};


export type QueryOrderLineFilterValuesArgs = {
  filterType: OrderLineFilterType;
};


export type QueryPaginateAdsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  campaignId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<AdFilterLegacy>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginateAdvertisersArgs = {
  after?: InputMaybe<Scalars['String']>;
  agencyId?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AdvertiserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  territories: Array<Territory>;
};


export type QueryPaginateAgenciesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AgencyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  territories: Array<Territory>;
};


export type QueryPaginateCampaignsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CampaignFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['ID']>;
  territories: Array<Territory>;
};


export type QueryPaginateCreativesArgs = {
  advertiserId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CreativeFilterLegacy>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  type: CreativeTypeLegacy;
};


export type QueryPaginateOrdersArgs = {
  advertiserId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  territories: Array<Territory>;
};


export type QueryPaginateProgrammaticCreativesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProgrammaticCreativeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<ProgrammaticCreativeOrdering>;
  territories: Array<Territory>;
};


export type QueryPlatformUserArgs = {
  userId: Scalars['ID'];
};


export type QueryPostcodeGroupArgs = {
  id: Scalars['ID'];
};


export type QueryProgrammaticBillingLineArgs = {
  id: Scalars['ID'];
};


export type QueryProgrammaticBillingLinesByProposalIdArgs = {
  proposalId: Scalars['ID'];
};


export type QueryProgrammaticConnectorArgs = {
  id: Scalars['ID'];
};


export type QueryProposalArgs = {
  id: Scalars['ID'];
};


export type QueryProposalsByOrderLineIdArgs = {
  orderLineId: Scalars['ID'];
};


export type QueryProposedFlightArgs = {
  id: Scalars['ID'];
};


export type QueryProposedFlightsByProposalIdArgs = {
  proposalId: Scalars['ID'];
};


export type QueryPublisherArgs = {
  id: Scalars['ID'];
};


export type QueryPublisherContractArgs = {
  id: Scalars['ID'];
};


export type QueryPublisherContractLegacyArgs = {
  id: Scalars['ID'];
};


export type QueryPublisherContractsArgs = {
  publisherId: Scalars['ID'];
};


export type QueryPublisherInsightsFiltersArgs = {
  territories?: InputMaybe<Array<Territory>>;
  types?: InputMaybe<Array<PublisherInsightsFilterType>>;
};


export type QueryPublisherInsightsTimeSeriesArgs = {
  currency: Scalars['Currency'];
  endDate: Scalars['LocalDateTime'];
  filters?: InputMaybe<Array<PublisherInsightsFilterAttributes>>;
  includeWeightingMetrics?: InputMaybe<Scalars['Boolean']>;
  metrics?: InputMaybe<Array<PublisherInsightsMetric>>;
  startDate: Scalars['LocalDateTime'];
  timeUnit: PublisherInsightsTimeSeriesUnit;
  timezone: Scalars['TimeZone'];
};


export type QueryPublisherLegacyArgs = {
  id: Scalars['ID'];
};


export type QueryReportAllOrderLinesArgs = {
  filter?: InputMaybe<OrderLineFilter>;
  territories: Array<Territory>;
};


export type QueryReportOrderLineArgs = {
  id: Scalars['ID'];
};


export type QuerySalesChannelLegacyArgs = {
  id: Scalars['ID'];
};


export type QuerySearchArgs = {
  filter: SearchFilter;
  territories: Array<Territory>;
};


export type QuerySearchAudienceSegmentsArgs = {
  text: Scalars['String'];
};


export type QuerySearchDmpSegmentsArgs = {
  text: Scalars['String'];
  type: DmpSegmentType;
};


export type QuerySearchIspsArgs = {
  text: Scalars['String'];
};


export type QuerySearchPostcodesArgs = {
  text: Scalars['String'];
};


export type QuerySearchUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  territory: Territory;
  text: Scalars['String'];
};


export type QuerySeatArgs = {
  id: Scalars['ID'];
};


export type QuerySeatLegacyArgs = {
  id: Scalars['ID'];
};


export type QuerySharedInventoryGroupsArgs = {
  businessId: Scalars['ID'];
};


export type QuerySharedReportingGroupsArgs = {
  businessId: Scalars['ID'];
};


export type QueryShowArgs = {
  id: Scalars['ID'];
};


export type QueryShowAudioAvailabilityArgs = {
  adFormatType?: InputMaybe<AdFormatType>;
  endDate: Scalars['LocalDate'];
  showId: Scalars['ID'];
  startDate: Scalars['LocalDate'];
};


export type QueryShowAvailabilityArgs = {
  adFormatType?: InputMaybe<AdFormatType>;
  endDate: Scalars['LocalDate'];
  mediaTypes: Array<MediaType>;
  proposalId?: InputMaybe<Scalars['ID']>;
  proposedFlightId?: InputMaybe<Scalars['ID']>;
  showId: Scalars['ID'];
  startDate: Scalars['LocalDate'];
  targetMarkets?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryShowContractArgs = {
  id: Scalars['ID'];
};


export type QuerySupplySearchArgs = {
  itemsPerPage: Scalars['NonNegativeInt'];
  pageNumber: Scalars['NonNegativeInt'];
  searchFilters?: InputMaybe<Array<SupplySearchFilterAttributes>>;
  searchTerm: Scalars['String'];
};


export type QuerySupplySearchFilterValuesArgs = {
  filterType: SupplySearchFilterType;
};


export type QueryTagArgs = {
  id: Scalars['ID'];
};


export type QueryTargetingStrategyArgs = {
  id: Scalars['ID'];
};


export type QueryTargetingTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryTechnicalProviderLegacyArgs = {
  id: Scalars['ID'];
};


export type QueryTechnologyParameterValuesArgs = {
  search?: InputMaybe<Scalars['String']>;
  type: TechnologyParameterType;
};


export type QueryTotalProgrammaticCreativesArgs = {
  filter?: InputMaybe<ProgrammaticCreativeFilter>;
  territories: Array<Territory>;
};


export type QueryTranscodePresetArgs = {
  id: Scalars['ID'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryValidatePostcodesArgs = {
  postcodes: Array<Scalars['String']>;
};

export enum Region {
  /** European Union. */
  Eu = 'EU',
  /** The default value when the region is not set. */
  RegionUnspecified = 'REGION_UNSPECIFIED',
  /** US East. */
  UsEast = 'US_EAST'
}

export type RegionAttributes = {
  /** The ISO 3166-2 region code of the targeted audience. */
  code: Scalars['String'];
  /** The region name of the targeted audience. */
  name: Scalars['String'];
  /** The list of sub-regions of the targeted audience. */
  subRegions?: InputMaybe<Array<SubRegionAttributes>>;
};

export type RegionParam = Subdivision & {
  __typename?: 'RegionParam';
  /** The ISO 3166-2 region code of the targeted audience. */
  code: Scalars['String'];
  /** The region name of the targeted audience. */
  name: Scalars['String'];
  /** The list of sub-regions of the targeted audience. */
  subRegions?: Maybe<Array<GeoRegion>>;
};

export type Role = {
  __typename?: 'Role';
  businessId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions: Array<PermissionV2Info>;
};

export type SalesChannelLegacy = Node & {
  __typename?: 'SalesChannelLegacy';
  /** The parent agency to which this sales channel belongs. */
  agency?: Maybe<Agency>;
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** The list of deals created for this sales channel. */
  deals: Array<DealLegacy>;
  /** The health of this deal. */
  health: Array<HealthMetric>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The name of the sales channel. */
  name?: Maybe<Scalars['String']>;
  /** The owner of this sales channel. */
  owner?: Maybe<User>;
  /** Programmatic creatives on this sales channel. */
  programmaticCreatives: Array<ProgrammaticCreative>;
  /** The status of the given sales channel. */
  status?: Maybe<SalesChannelLegacyStatus>;
  /** The territory assigned to this sales channel */
  territory: Territory;
};


export type SalesChannelLegacyDealsArgs = {
  filter?: InputMaybe<DealLegacyFilter>;
};


export type SalesChannelLegacyHealthArgs = {
  from?: InputMaybe<Scalars['LocalDate']>;
  until?: InputMaybe<Scalars['LocalDate']>;
};

export type SalesChannelLegacyAttributes = {
  /** The name of the sales channel. */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the owner of this sales channel. */
  ownerId?: InputMaybe<Scalars['ID']>;
  /** The status of the given sales channel. */
  status?: InputMaybe<SalesChannelLegacyStatus>;
  /** The territory assigned to the owner of this sales channel. */
  territory?: InputMaybe<Territory>;
};

export type SalesChannelLegacyFilter = {
  status_in?: InputMaybe<Array<SalesChannelLegacyStatus>>;
};

export enum SalesChannelLegacyStatus {
  /** Sales channel is active. */
  Active = 'ACTIVE',
  /** The status of the sales channel once deleted. */
  Deleted = 'DELETED',
  /** The default value when the sales channel is first created. */
  Draft = 'DRAFT',
  /** Sales channel is inactive. */
  Inactive = 'INACTIVE'
}

export type Sanity = {
  __typename?: 'Sanity';
  /** The id of the sanity. */
  id: Scalars['ID'];
  /** The name of the sanity. */
  name: Scalars['String'];
  /** The type of the sanity. */
  type: SanityType;
};

export enum SanityCode {
  AchievedObjective = 'ACHIEVED_OBJECTIVE',
  Delivering = 'DELIVERING',
  EndingSoon = 'ENDING_SOON',
  FailedObjective = 'FAILED_OBJECTIVE',
  IncompleteSequence = 'INCOMPLETE_SEQUENCE',
  MissingCreative = 'MISSING_CREATIVE',
  NotDelivering = 'NOT_DELIVERING',
  OverDelivering = 'OVER_DELIVERING',
  StartingSoon = 'STARTING_SOON',
  UnderDelivering = 'UNDER_DELIVERING'
}

export enum SanityType {
  /** The sanity is ok and healthy. */
  Healthy = 'HEALTHY',
  /** The sanity is not about health but exposes different information. */
  Other = 'OTHER',
  /** The default value when sanity type is not set. */
  SanityTypeUnspecified = 'SANITY_TYPE_UNSPECIFIED',
  /** The sanity is unhealthy. */
  Unhealthy = 'UNHEALTHY',
  /** The sanity is a warning. */
  Warning = 'WARNING'
}

export type SearchFilter = {
  searchType: SearchType;
  value: Scalars['String'];
};

export enum SearchFilterDisplayType {
  DateTime = 'DATE_TIME',
  Hierarchy = 'HIERARCHY',
  Values = 'VALUES'
}

export type SearchResult = {
  __typename?: 'SearchResult';
  altId: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  status?: Maybe<EntityStatus>;
  type: EntityType;
};

/** Represents one of the supported searches we provide */
export enum SearchType {
  Id = 'ID',
  Name = 'NAME'
}

export type Seat = Node & {
  __typename?: 'Seat';
  dsp: Dsp;
  entityState: EntityState;
  externalId: Scalars['String'];
  id: Scalars['ID'];
  mediaType: MediaType;
  name: Scalars['String'];
  sharedWithBusinesses: Array<BusinessReference>;
  status: SeatStatus;
};

export type SeatAttributes = {
  externalId: Scalars['String'];
  name: Scalars['String'];
  sharedWithBusinessIds: Array<Scalars['ID']>;
};

export type SeatFilter = {
  dspId: Scalars['ID'];
};

export type SeatLegacy = Node & {
  __typename?: 'SeatLegacy';
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** The list of deals associated with this seat. */
  deals: Array<DealLegacy>;
  /** The parent DSP that created this seat. */
  dsp?: Maybe<DspLegacy>;
  /** The external ID of the seat. */
  externalSeatId?: Maybe<Scalars['String']>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The name of the seat. */
  name?: Maybe<Scalars['String']>;
  /** The status of the given seat. */
  status?: Maybe<SeatLegacyStatus>;
  /** The list of territories assigned to the given seat. */
  territories: Array<Territory>;
};


export type SeatLegacyDealsArgs = {
  filter?: InputMaybe<DealLegacyFilter>;
  territories?: InputMaybe<Array<Territory>>;
};

export type SeatLegacyAttributes = {
  /** The external ID of the seat. */
  externalSeatId?: InputMaybe<Scalars['String']>;
  /** The name of the seat. */
  name?: InputMaybe<Scalars['String']>;
  /** The status of the given seat. */
  status?: InputMaybe<SeatLegacyStatus>;
  /** The list of territories assigned to the given seat. */
  territories?: InputMaybe<Array<Territory>>;
};

export type SeatLegacyFilter = {
  status_in?: InputMaybe<Array<SeatLegacyStatus>>;
};

export enum SeatLegacyStatus {
  /** Seat is active. */
  Active = 'ACTIVE',
  /** The status of the seat once deleted. */
  Deleted = 'DELETED',
  /** The default value when the seat is first created. */
  Draft = 'DRAFT',
  /** Seat is inactive. */
  Inactive = 'INACTIVE'
}

export type SeatMinimal = Node & {
  __typename?: 'SeatMinimal';
  id: Scalars['ID'];
  mediaType: MediaType;
  name: Scalars['String'];
  status: SeatStatus;
};

export type SeatOffsetPaginationResponse = {
  __typename?: 'SeatOffsetPaginationResponse';
  pageMetaData: PageMetaData;
  seats: Array<SeatMinimal>;
};

export enum SeatStatus {
  Disabled = 'DISABLED',
  DisabledInherited = 'DISABLED_INHERITED',
  Enabled = 'ENABLED'
}

export type SharedInventoryGroup = {
  __typename?: 'SharedInventoryGroup';
  businessId: Scalars['ID'];
  id?: Maybe<Scalars['String']>;
  sharedInventory: Array<Maybe<InventoryParameterValue>>;
  sharedWithBusinesses: Array<Maybe<BusinessReference>>;
};

export type SharedInventoryGroupAttributes = {
  sharedInventory: Array<InventoryParameterValueAttribute>;
  sharedWithBusinessIds: Array<Scalars['ID']>;
};

export type SharedReportingGroup = {
  __typename?: 'SharedReportingGroup';
  businessId: Scalars['ID'];
  id?: Maybe<Scalars['String']>;
  sharedEntities: Array<DemandParameterValue>;
  sharedWithBusiness: BusinessReference;
  sharedWithEmailAddresses: Array<Scalars['String']>;
};

export type SharedReportingGroupAttributes = {
  sharedEntityIds: Array<DemandParameterValueAttribute>;
  sharedWithBusinessId: Scalars['ID'];
  sharedWithEmailAddresses: Array<Scalars['String']>;
};

export type Show = {
  __typename?: 'Show';
  adFormats?: Maybe<Array<AdFormatDetail>>;
  adPositions?: Maybe<Array<ShowAdPositionDetail>>;
  ageGroups?: Maybe<Array<Scalars['String']>>;
  audienceParameters: Array<SupplyAudienceParameter>;
  audioAdsRequested?: Maybe<Scalars['Long']>;
  audioImpressions?: Maybe<Scalars['Long']>;
  audioImpressionsLastDay?: Maybe<Scalars['Long']>;
  averageWeeklyReach?: Maybe<Scalars['Long']>;
  blockedDomains: Array<Scalars['DomainName']>;
  blockedIabCategories: Array<IabCategory>;
  channel: ChannelLegacy;
  coverAssetUrl?: Maybe<AssetUrl>;
  coverUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['LocalDateTime']>;
  gender?: Maybe<Scalars['String']>;
  hostingPlatforms?: Maybe<Array<ShowHostingPlatformDetail>>;
  hosts?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  interests?: Maybe<Array<Scalars['String']>>;
  itunesCategories?: Maybe<Array<ItunesCategory>>;
  name: Scalars['String'];
  nodeHierarchyId?: Maybe<NodeHierarchyId>;
  startDate?: Maybe<Scalars['LocalDateTime']>;
  state: EntityState;
  status: SupplyStatus;
  supportedMediaTypes?: Maybe<Array<MediaType>>;
  weeklyReleaseFrequency?: Maybe<Scalars['PositiveInt']>;
};

export enum ShowAdPosition {
  Midroll_1 = 'MIDROLL_1',
  Midroll_2 = 'MIDROLL_2',
  Midroll_3 = 'MIDROLL_3',
  Post = 'POST',
  Postroll = 'POSTROLL',
  Preroll = 'PREROLL'
}

export type ShowAdPositionAttributes = {
  adPosition: ShowAdPosition;
  adSlots: Scalars['NonNegativeInt'];
  mediaType: MediaType;
};

export type ShowAdPositionDetail = {
  __typename?: 'ShowAdPositionDetail';
  adPosition: ShowAdPosition;
  adSlots: Scalars['Int'];
  mediaType: MediaType;
};

export type ShowAdPositionFilter = {
  adPositions?: InputMaybe<Array<ShowAdPosition>>;
  clusivity: ShowAdPositionFilterType;
};

export enum ShowAdPositionFilterType {
  AllOf = 'ALL_OF',
  AnyOf = 'ANY_OF'
}

export type ShowAdPositionInfo = {
  __typename?: 'ShowAdPositionInfo';
  displayName: Scalars['String'];
  type: ShowAdPosition;
};

export type ShowAvailability = {
  __typename?: 'ShowAvailability';
  adPositions?: Maybe<Array<ShowAdPositionDetail>>;
  ageGroups?: Maybe<Array<Scalars['String']>>;
  availabilityStatus?: Maybe<ShowAvailabilityStatus>;
  averageWeeklyReach?: Maybe<Scalars['Long']>;
  blockedBrandDomains: Array<Scalars['DomainName']>;
  blockedIabCategories: Array<IabCategory>;
  categories?: Maybe<Array<Scalars['String']>>;
  coverAssetUrl?: Maybe<AssetUrl>;
  coverUrl?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['LocalDateTime']>;
  gender?: Maybe<Scalars['String']>;
  hosts: Scalars['String'];
  id: Scalars['ID'];
  interests?: Maybe<Array<Scalars['String']>>;
  inventorySupplyId: Scalars['String'];
  itunesCategories?: Maybe<Array<ItunesCategory>>;
  name: Scalars['String'];
  startDate: Scalars['LocalDateTime'];
  supportedMediaTypes?: Maybe<Array<ShowAvailabilitySupportedMediaType>>;
  weeklyReleaseFrequency: Scalars['PositiveInt'];
};

export type ShowAvailabilityAdPosition = {
  __typename?: 'ShowAvailabilityAdPosition';
  adPosition: ShowAdPosition;
  adSlots?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['BigDecimal']>;
  impressionsCount?: Maybe<Scalars['Long']>;
  periods: Array<ShowAvailabilityPeriod>;
};

export type ShowAvailabilityAudioResponse = {
  __typename?: 'ShowAvailabilityAudioResponse';
  adPositionsAvailability: Array<ShowAvailabilityAdPosition>;
  weeklyReleaseFrequency?: Maybe<Scalars['Int']>;
};

export type ShowAvailabilityDateRange = {
  __typename?: 'ShowAvailabilityDateRange';
  endDate: Scalars['LocalDate'];
  startDate: Scalars['LocalDate'];
};

export type ShowAvailabilityDaysSpan = {
  __typename?: 'ShowAvailabilityDaysSpan';
  availabilityStatus: ShowAvailabilityStatus;
  dateRange: ShowAvailabilityDateRange;
};

export type ShowAvailabilityFilter = {
  adFormatType?: InputMaybe<AdFormatType>;
  adFormatTypes?: InputMaybe<Array<AdFormatType>>;
  audioAdPositionFilter?: InputMaybe<ShowAdPositionFilter>;
  availabilityPeriodEnd?: InputMaybe<Scalars['LocalDateTime']>;
  availabilityPeriodStart?: InputMaybe<Scalars['LocalDateTime']>;
  availabilityStatuses?: InputMaybe<Array<ShowAvailabilityStatus>>;
  endDateFilter?: InputMaybe<ShowDateFilter>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  mediaTypes?: InputMaybe<Array<MediaType>>;
  proposalId?: InputMaybe<Scalars['ID']>;
  startDateFilter?: InputMaybe<ShowDateFilter>;
  targetMarkets?: InputMaybe<Array<Scalars['String']>>;
  videoAdPositionFilter?: InputMaybe<ShowAdPositionFilter>;
};

export type ShowAvailabilityHostingPlatform = {
  __typename?: 'ShowAvailabilityHostingPlatform';
  hostingPlatform: ShowHostingPlatformType;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ShowAvailabilityOffsetPaginationResponse = {
  __typename?: 'ShowAvailabilityOffsetPaginationResponse';
  pageMetaData?: Maybe<PageMetaData>;
  shows: Array<ShowAvailability>;
};

export type ShowAvailabilityPeriod = {
  __typename?: 'ShowAvailabilityPeriod';
  availableCount: Scalars['Int'];
  bookedCount: Scalars['Int'];
  dateRange: ShowAvailabilityDateRange;
  days: Array<ShowAvailabilityDaysSpan>;
  inRequestedDateRange: Scalars['Boolean'];
  optionQueueSize?: Maybe<Scalars['Int']>;
  optionedCount: Scalars['Int'];
};

export type ShowAvailabilityResponse = {
  __typename?: 'ShowAvailabilityResponse';
  adFormatType?: Maybe<AdFormatType>;
  adPositionsAvailability: Array<ShowAvailabilityAdPosition>;
  cpm?: Maybe<Scalars['BigDecimal']>;
  currency?: Maybe<Scalars['String']>;
  mediaType: MediaType;
  platforms?: Maybe<Array<ShowAvailabilityHostingPlatform>>;
  weeklyReleaseFrequency?: Maybe<Scalars['Int']>;
};

export enum ShowAvailabilityStatus {
  Available = 'AVAILABLE',
  Blocked = 'BLOCKED',
  Booked = 'BOOKED',
  NotRunning = 'NOT_RUNNING',
  Optioned = 'OPTIONED'
}

export type ShowAvailabilitySupportedMediaType = {
  __typename?: 'ShowAvailabilitySupportedMediaType';
  mediaType: MediaType;
  supportedByAdFormatType: Scalars['Boolean'];
};

export type ShowContract = {
  __typename?: 'ShowContract';
  altId: Scalars['Int'];
  channel?: Maybe<ChannelLegacy>;
  currency?: Maybe<Scalars['Currency']>;
  directSpotCpm?: Maybe<Scalars['NonNegativeFloat']>;
  endDate?: Maybe<Scalars['LocalDateTime']>;
  hostReadCpm?: Maybe<Scalars['NonNegativeFloat']>;
  hostReadRevenueShare?: Maybe<Scalars['NonNegativeFloat']>;
  id: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  programmaticSpotCpm?: Maybe<Scalars['NonNegativeFloat']>;
  show: ShowLegacy;
  sponsorshipRevenueShare?: Maybe<Scalars['NonNegativeFloat']>;
  spotRevenueShare?: Maybe<Scalars['NonNegativeFloat']>;
  startDate: Scalars['LocalDateTime'];
  territories: Array<Territory>;
};

export type ShowContractAttributes = {
  currency?: InputMaybe<Scalars['Currency']>;
  directSpotCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  hostReadCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  hostReadRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  notes?: InputMaybe<Scalars['String']>;
  programmaticSpotCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  showId?: InputMaybe<Scalars['ID']>;
  sponsorshipRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  spotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  territories?: InputMaybe<Array<Territory>>;
};

export type ShowContractFilter = {
  showIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ShowDateFilter = {
  afterDate?: InputMaybe<Scalars['LocalDateTime']>;
  beforeDate?: InputMaybe<Scalars['LocalDateTime']>;
};

export type ShowFilter = {
  channelId?: InputMaybe<Scalars['ID']>;
  endDateFilter?: InputMaybe<ShowDateFilter>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  mediaTypes?: InputMaybe<Array<MediaType>>;
  startDateFilter?: InputMaybe<ShowDateFilter>;
};

export type ShowFilterRefData = {
  __typename?: 'ShowFilterRefData';
  adPosition: Array<ShowRefDataItem>;
  adPositionClusivity: Array<ShowRefDataItem>;
};

export type ShowHostingPlatformAttributes = {
  averageWeeklyReach: Scalars['Long'];
  channelId?: InputMaybe<Scalars['String']>;
  contentUrl: Scalars['Url'];
  externalShowId?: InputMaybe<Scalars['String']>;
  mediaType: MediaType;
  playlistId?: InputMaybe<Scalars['String']>;
  type: ShowHostingPlatformType;
};

export type ShowHostingPlatformDetail = {
  __typename?: 'ShowHostingPlatformDetail';
  averageWeeklyReach: Scalars['Long'];
  channelId?: Maybe<Scalars['String']>;
  contentUrl: Scalars['Url'];
  externalShowId?: Maybe<Scalars['String']>;
  mediaType: MediaType;
  playlistId?: Maybe<Scalars['String']>;
  type: ShowHostingPlatformType;
};

export type ShowHostingPlatformInfo = {
  __typename?: 'ShowHostingPlatformInfo';
  displayName: Scalars['String'];
  type: ShowHostingPlatformType;
};

export enum ShowHostingPlatformType {
  Audacy = 'AUDACY',
  Captivate = 'CAPTIVATE',
  Instagram = 'INSTAGRAM',
  IHeart = 'I_HEART',
  MediaManager = 'MEDIA_MANAGER',
  SoundStack = 'SOUND_STACK',
  Spreaker = 'SPREAKER',
  StreamGuys = 'STREAM_GUYS',
  Tiktok = 'TIKTOK',
  TuneIn = 'TUNE_IN',
  Youtube = 'YOUTUBE',
  YoutubeShorts = 'YOUTUBE_SHORTS'
}

export type ShowLegacy = {
  __typename?: 'ShowLegacy';
  hostingPlatform: Scalars['String'];
  name: Scalars['String'];
  show_id: Scalars['String'];
};

export type ShowOffsetPaginationResponse = {
  __typename?: 'ShowOffsetPaginationResponse';
  pageMetaData?: Maybe<PageMetaData>;
  shows: Array<Show>;
};

export type ShowRefDataItem = {
  __typename?: 'ShowRefDataItem';
  displayName: Scalars['String'];
  id: Scalars['String'];
};

export type ShowTargeting = {
  __typename?: 'ShowTargeting';
  clusivity: Clusivity;
  id: Scalars['String'];
};

export type SocialParameterAttributes = {
  type: SocialParameterType;
  values: Array<SocialParameterValueAttribute>;
};

export enum SocialParameterType {
  Platforms = 'PLATFORMS'
}

export type SocialParameterValueAttribute = {
  id: Scalars['ID'];
};

export type SocialPeriod = {
  __typename?: 'SocialPeriod';
  billedImpressions: Scalars['Long'];
  endDate: Scalars['LocalDate'];
  postCount: Scalars['Int'];
  startDate: Scalars['LocalDate'];
};

export type SocialPeriodAttributes = {
  billedImpressions: Scalars['Long'];
  dateRange: LocalDateRangeAttributes;
  platforms: Array<ShowHostingPlatformType>;
  postCount: Scalars['PositiveInt'];
};

export type SocialProposedFlightAttributes = {
  billingType: FlightBillingType;
  budget: FlightBudgetAttributes;
  name: Scalars['String'];
  nonSpotShowId?: InputMaybe<Scalars['ID']>;
  periods: Array<SocialPeriodAttributes>;
  territory?: InputMaybe<Territory>;
};

export type SocialTargetingAttributes = {
  parameters: Array<SocialParameterAttributes>;
};

export enum SoundMode {
  /** Joint-stereo sound. */
  JointStereo = 'JOINT_STEREO',
  /** The default value when the mode is not set. */
  ModeUnspecified = 'MODE_UNSPECIFIED',
  /** Monophonic sound. */
  Mono = 'MONO',
  /** Stereophonic sound. */
  Stereo = 'STEREO'
}

export type SubRegionAttributes = {
  /** The ISO 3166-2 sub-region code of the targeted audience. */
  code: Scalars['String'];
  /** The sub-region name of the targeted audience. */
  name: Scalars['String'];
};

/** Generic interface type for describing the subdivisions of a country (regions, sub-regions, cities). */
export type Subdivision = {
  name: Scalars['String'];
};

export type SupplyAudienceParameter = {
  __typename?: 'SupplyAudienceParameter';
  cardinality: Cardinality;
  name: Scalars['String'];
  type: AudienceParameterType;
  values: Array<AudienceParameterValue>;
};

export type SupplyAudienceParameterAttributes = {
  type: AudienceParameterType;
  values: Array<Scalars['ID']>;
};

export type SupplySearchFilterAttributes = {
  filterType: SupplySearchFilterType;
  ids: Array<Scalars['String']>;
};

export type SupplySearchFilterCategory = {
  __typename?: 'SupplySearchFilterCategory';
  displayName: Scalars['String'];
  filterDisplayType: SearchFilterDisplayType;
  filterType: SupplySearchFilterType;
};

export enum SupplySearchFilterType {
  EntityType = 'ENTITY_TYPE',
  Status = 'STATUS'
}

export type SupplySearchFilterValue = {
  __typename?: 'SupplySearchFilterValue';
  displayName: Scalars['String'];
  /** @deprecated Field no longer supported */
  filterType: SupplySearchFilterType;
  id: Scalars['ID'];
};

export type SupplySearchResponse = {
  __typename?: 'SupplySearchResponse';
  pageMetaData: PageMetaData;
  supplySearchResults?: Maybe<Array<SupplySearchResult>>;
};

export type SupplySearchResult = {
  __typename?: 'SupplySearchResult';
  id: Scalars['ID'];
  modifiedDate: Scalars['LocalDateTime'];
  name: Scalars['String'];
  status: SupplyStatus;
  type: EntityType;
};

export enum SupplyStatus {
  /** Supply entity is active. */
  Active = 'ACTIVE',
  /** Supply entity is disabled. */
  Disabled = 'DISABLED',
  /** Parent entity is disabled. */
  DisabledInherited = 'DISABLED_INHERITED',
  /** Supply entity is inactive. */
  Inactive = 'INACTIVE'
}

export type Tag = {
  __typename?: 'Tag';
  /** The description of the tag. */
  description?: Maybe<Scalars['String']>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The name of the tag. */
  name?: Maybe<Scalars['String']>;
};

export type TagAttributes = {
  /** The description of the tag. */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the tag. */
  name?: InputMaybe<Scalars['String']>;
};

export type TargetingDefinition = Node & {
  __typename?: 'TargetingDefinition';
  /** The general targeting group. */
  generalTargetingGroup?: Maybe<TargetingGroup>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The master targeting templates that are applied to this targeting definition. */
  masterTargetingTemplates: Array<TargetingTemplate>;
  /** The list of targeting groups. */
  targetingGroups: Array<TargetingGroup>;
};

export type TargetingDefinitionAttributes = {
  /** The general targeting group. */
  generalTargetingGroup?: InputMaybe<TargetingGroupAttributes>;
  /** The master targeting templates IDs that are applied to this targeting definition. */
  masterTargetingTemplateIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The list of targeting groups. */
  targetingGroups?: InputMaybe<Array<TargetingGroupAttributes>>;
};

export type TargetingDefinitionV2 = {
  __typename?: 'TargetingDefinitionV2';
  audienceTargeting?: Maybe<AudienceTargeting>;
  customTargeting?: Maybe<CustomTargeting>;
  dayTimeTargeting?: Maybe<DayTimeTargeting>;
  id: Scalars['ID'];
  inventoryTargeting?: Maybe<InventoryTargeting>;
  locationTargeting?: Maybe<LocationTargeting>;
  name?: Maybe<Scalars['String']>;
  technologyTargeting?: Maybe<TechnologyTargeting>;
};

export type TargetingDefinitionV2Attributes = {
  audienceTargeting?: InputMaybe<AudienceTargetingAttributes>;
  customTargeting?: InputMaybe<CustomTargetingAttributes>;
  dayTimeTargeting?: InputMaybe<DayTimeTargetingAttributes>;
  id?: InputMaybe<Scalars['ID']>;
  inventoryTargeting?: InputMaybe<InventoryTargetingAttributes>;
  locationTargeting?: InputMaybe<LocationTargetingAttributes>;
  name?: InputMaybe<Scalars['String']>;
  socialTargeting?: InputMaybe<SocialTargetingAttributes>;
  technologyTargeting?: InputMaybe<TechnologyTargetingAttributes>;
};

export type TargetingDefinitionWithAds = {
  __typename?: 'TargetingDefinitionWithAds';
  ads: Array<Ad>;
  targetingDefinition: TargetingDefinitionV2;
};

export enum TargetingGrade {
  Grade_1 = 'GRADE_1',
  Grade_2 = 'GRADE_2',
  Grade_3 = 'GRADE_3',
  Grade_4 = 'GRADE_4'
}

export type TargetingGroup = {
  __typename?: 'TargetingGroup';
  /** The list of audience params associated with the targeting group. */
  audienceParams: Array<AudienceParam>;
  /** Business targeting group id for Targeting V2 */
  businessTargetingGroupIds?: Maybe<Array<Scalars['PositiveInt']>>;
  /** The list of channels associated with the targeting group. */
  channels: Array<ChannelLegacy>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The radius of the user accuracy associated with the targeting group */
  listenerAccuracy?: Maybe<Scalars['NonNegativeFloat']>;
  /** The ID of the master targeting group that this targeting group extends. */
  masterTargetingGroupId?: Maybe<Scalars['ID']>;
  /** Network targeting for Targeting V2 */
  networks?: Maybe<Array<NetworkTargeting>>;
};


export type TargetingGroupChannelsArgs = {
  filter?: InputMaybe<ChannelLegacyFilter>;
};

export type TargetingGroupAttributes = {
  /** The list of audience params associated with the targeting group. */
  audienceParams: AudienceParamAttributes;
  /** The list of channels (by ID) associated with the targeting group. */
  channelIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The entity identifier as an UUID string. */
  id?: InputMaybe<Scalars['ID']>;
  /** The radius of the user accuracy associated with the targeting group. */
  listenerAccuracy?: InputMaybe<Scalars['NonNegativeFloat']>;
  /** The ID of the master targeting group that this targeting group extends. */
  masterTargetingGroupId?: InputMaybe<Scalars['ID']>;
};

export enum TargetingRestriction {
  CapSensitive = 'CAP_SENSITIVE',
  Hfss = 'HFSS',
  Liid = 'LIID',
  Local = 'LOCAL'
}

export type TargetingRestrictionTypeInfo = {
  __typename?: 'TargetingRestrictionTypeInfo';
  displayName: Scalars['String'];
  type: TargetingRestriction;
};

export type TargetingStrategy = {
  __typename?: 'TargetingStrategy';
  id: Scalars['ID'];
  targetingDefinition: TargetingDefinitionV2;
};

export type TargetingStrategyAttributes = {
  targetingDefinition: TargetingDefinitionV2Attributes;
};

export type TargetingTemplate = Node & {
  __typename?: 'TargetingTemplate';
  /** Entities that have this master targeting template assigned. */
  assignedTo?: Maybe<Array<TargetingTemplateLink>>;
  /** The description of the targeting template. */
  description?: Maybe<Scalars['String']>;
  /** The general targeting group. */
  generalTargetingGroup?: Maybe<TargetingGroup>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** Flag indicating whether this is a master targeting template or not. */
  isMasterTemplate?: Maybe<Scalars['Boolean']>;
  /** The name of the targeting template. */
  name?: Maybe<Scalars['String']>;
  /** The status of the given targeting template. */
  status?: Maybe<TargetingTemplateStatus>;
  /** The list of targeting groups. */
  targetingGroups: Array<TargetingGroup>;
  /** The territory of the given targeting template. */
  territory: Territory;
};

export type TargetingTemplateAttributes = {
  /** The description of the targeting template. */
  description?: InputMaybe<Scalars['String']>;
  /** The general targeting group. */
  generalTargetingGroup?: InputMaybe<TargetingGroupAttributes>;
  /** The name of the targeting template. */
  name?: InputMaybe<Scalars['String']>;
  /** The status of the given targeting template. */
  status?: InputMaybe<TargetingTemplateStatus>;
  /** The list of targeting groups. */
  targetingGroups?: InputMaybe<Array<TargetingGroupAttributes>>;
  /** The territory of the given targeting template. */
  territory?: InputMaybe<Territory>;
};

export type TargetingTemplateFilter = {
  status_in?: InputMaybe<Array<TargetingTemplateStatus>>;
};

/** Generic interface type for querying entities with a master targeting template assigned. */
export type TargetingTemplateLink = {
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The name of the linked entity. */
  name?: Maybe<Scalars['String']>;
};

export enum TargetingTemplateStatus {
  /** The default value when the targeting template is first created. */
  Created = 'CREATED',
  /** The status of the targeting template once deleted. */
  Deleted = 'DELETED'
}

export type TargetingV2Parameter = {
  clusivity: Clusivity;
  values: Array<TargetingV2ParameterValue>;
};

export type TargetingV2ParameterGroup = {
  parameters: Array<TargetingV2Parameter>;
};

/** TARGETING V2 */
export type TargetingV2ParameterInfo = {
  cardinality: Cardinality;
  name: Scalars['String'];
};

export type TargetingV2ParameterValue = {
  children: Array<Maybe<TargetingV2ParameterValue>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Parents of this value in descending order */
  parents: Array<Maybe<TargetingV2ParameterValue>>;
};

export enum TargetingVersion {
  /** DAX targeting model that is based on audience parameters */
  TargetingV1 = 'TARGETING_V1',
  /** DAX targeting model that is based on interests */
  TargetingV2 = 'TARGETING_V2'
}

export type Team = {
  __typename?: 'Team';
  departmentId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TeamAttributes = {
  departmentId: Scalars['ID'];
  name: Scalars['String'];
};

export type TechnicalProviderLegacy = Node & {
  __typename?: 'TechnicalProviderLegacy';
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** App bundle value */
  appBundle?: Maybe<Scalars['String']>;
  /** App domain (current returns default value 'thisisdax.com' from API). */
  appDomain?: Maybe<Scalars['String']>;
  /** App name (current returns default value 'dax' from API). */
  appName?: Maybe<Scalars['String']>;
  /** The currency preicision for the given technical provider. */
  bidFloorPrecision?: Maybe<Scalars['NonNegativeInt']>;
  /** Flag to determine whether to block 1st Party Data. */
  block1stPartyData?: Maybe<Scalars['Boolean']>;
  /** Flag to determine whether to block app (currently this value should be set as false). */
  blockApp?: Maybe<Scalars['Boolean']>;
  /** Flag to determine whether to block Geo Data. */
  blockGeoData?: Maybe<Scalars['Boolean']>;
  /** Flag to determine whether to block IP Data. */
  blockIpData?: Maybe<Scalars['Boolean']>;
  /** Flag to determine whether to block Listener ID. */
  blockListenerId?: Maybe<Scalars['Boolean']>;
  /** Flag to determine whether to block publisher (currently this value should be set as false). */
  blockPublisher?: Maybe<Scalars['Boolean']>;
  /** Flag to determine whether to block site (must be set to false). */
  blockSite?: Maybe<Scalars['Boolean']>;
  /** Consent vendor ID (for GDPR compliance). */
  consentVendorId?: Maybe<Scalars['NonNegativeInt']>;
  /** The currency of the technical provider. */
  currency?: Maybe<Scalars['Currency']>;
  /** The list of data centers created for this technical provider. */
  dataCenters: Array<DataCenterLegacy>;
  /** The dsp provider for the given technical provider. */
  dspProvider?: Maybe<DspProvider>;
  /** The list of dsps created for this technical provider. */
  dsps: Array<DspLegacy>;
  /** Flag to determine whether gzip compression is enabled for the technical provider. */
  gzipCompressed?: Maybe<Scalars['Boolean']>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The list of comma-separated KVPs to block against. */
  kvps1stPartyData?: Maybe<Scalars['String']>;
  /** The name of the technical provider. */
  name?: Maybe<Scalars['String']>;
  /** The DSP which has an open seat configured against it. */
  openSeatDsp?: Maybe<DspLegacy>;
  /** Publisher domain (current returns default value 'thisisdax.com' from API). */
  publisherDomain?: Maybe<Scalars['String']>;
  /** Publisher ID value. */
  publisherId?: Maybe<Scalars['String']>;
  /** Publisher name (current returns default value 'dax' from API) */
  publisherName?: Maybe<Scalars['String']>;
  /** Publisher tag ID value. */
  publisherTagId?: Maybe<Scalars['String']>;
  /** Flag to determine whether to send not synced users. */
  sendNotSyncedUsers?: Maybe<Scalars['Boolean']>;
  /** Site domain (current returns default value 'thisisdax.com' from API). */
  siteDomain?: Maybe<Scalars['String']>;
  /** Site name (current returns default value 'dax' from API). */
  siteName?: Maybe<Scalars['String']>;
  /** App domain (current returns default value 'thisisdax.com' from API). */
  sitePage?: Maybe<Scalars['String']>;
  /** The status of the given technical provider. */
  status?: Maybe<TechnicalProviderLegacyStatus>;
  /** The list of territories for the given technical provider. */
  territories: Array<Territory>;
  /** Flag to determine whether to truncate GPS Coordinates. */
  truncateGpsCoords?: Maybe<Scalars['Boolean']>;
  /** Flag to determine whether to truncate IP address. */
  truncateIpAddress?: Maybe<Scalars['Boolean']>;
  /** User Sync Secure URL for the technical provider. */
  userSyncSecureUrl?: Maybe<Scalars['Url']>;
  /** User Sync URL for the technical provider. */
  userSyncUrl?: Maybe<Scalars['Url']>;
  /** The VAST protocol versions that are supported for this provider. */
  vastVersions?: Maybe<Array<Maybe<VastVersion>>>;
};


export type TechnicalProviderLegacyDataCentersArgs = {
  filter?: InputMaybe<DataCenterLegacyFilter>;
};


export type TechnicalProviderLegacyDspsArgs = {
  filter?: InputMaybe<DspLegacyFilter>;
  territories?: InputMaybe<Array<Territory>>;
};

export type TechnicalProviderLegacyAttributes = {
  /** App bundle value. */
  appBundle?: InputMaybe<Scalars['String']>;
  /** The currency preicision for the given technical provider. */
  bidFloorPrecision?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Flag to determine whether to block 1st Party Data. */
  block1stPartyData?: InputMaybe<Scalars['Boolean']>;
  /** Flag to determine whether to block app (currently this value should be set as false). */
  blockApp?: InputMaybe<Scalars['Boolean']>;
  /** Flag to determine whether to block Geo Data. */
  blockGeoData?: InputMaybe<Scalars['Boolean']>;
  /** Flag to determine whether to block IP Data. */
  blockIpData?: InputMaybe<Scalars['Boolean']>;
  /** Flag to determine whether to block Listener ID. */
  blockListenerId?: InputMaybe<Scalars['Boolean']>;
  /** Flag to determine whether to block publisher (currently this value should be set as false). */
  blockPublisher?: InputMaybe<Scalars['Boolean']>;
  /** Flag to determine whether to block site (currently this value should be set as false). */
  blockSite?: InputMaybe<Scalars['Boolean']>;
  /** Consent vendor ID (for GDPR compliance). */
  consentVendorId?: InputMaybe<Scalars['NonNegativeInt']>;
  /** The currency of the technical provider. */
  currency?: InputMaybe<Scalars['Currency']>;
  /** The dsp provider of the given technical provider. */
  dspProvider?: InputMaybe<DspProvider>;
  /** Flag to determine whether gzip compression is enabled for the technical provider. */
  gzipCompressed?: InputMaybe<Scalars['Boolean']>;
  /** The list of comma-separated KVPs to block against. */
  kvps1stPartyData?: InputMaybe<Scalars['String']>;
  /** The name of the technical provider. */
  name?: InputMaybe<Scalars['String']>;
  /** Publisher ID value. */
  publisherId?: InputMaybe<Scalars['String']>;
  /** Publisher tag ID value. */
  publisherTagId?: InputMaybe<Scalars['String']>;
  /** Flag to determine whether to send not synced users. */
  sendNotSyncedUsers?: InputMaybe<Scalars['Boolean']>;
  /** The status of the given technical provider. */
  status?: InputMaybe<TechnicalProviderLegacyStatus>;
  /** The list of territories for the given technical provider. */
  territories?: InputMaybe<Array<Territory>>;
  /** Flag to determine whether to truncate GPS Coordinates. */
  truncateGpsCoords?: InputMaybe<Scalars['Boolean']>;
  /** Flag to determine whether to truncate IP address. */
  truncateIpAddress?: InputMaybe<Scalars['Boolean']>;
  /** User Sync Secure URL for the technical provider. */
  userSyncSecureUrl?: InputMaybe<Scalars['Url']>;
  /** User Sync URL for the technical provider. */
  userSyncUrl?: InputMaybe<Scalars['Url']>;
  /** The VAST protocol versions that are supported for this provider. */
  vastVersions?: InputMaybe<Array<InputMaybe<VastVersion>>>;
};

export type TechnicalProviderLegacyFilter = {
  status_in?: InputMaybe<Array<TechnicalProviderLegacyStatus>>;
};

export enum TechnicalProviderLegacyStatus {
  /** Technical provider is active. */
  Active = 'ACTIVE',
  /** The status of the technical provider once deleted. */
  Deleted = 'DELETED',
  /** The default value when the technical provider is first created. */
  Draft = 'DRAFT',
  /** Technical provider is inactive. */
  Inactive = 'INACTIVE'
}

export type TechnologyGroup = TargetingV2ParameterGroup & {
  __typename?: 'TechnologyGroup';
  parameters: Array<TechnologyParameter>;
};

export type TechnologyGroupAttributes = {
  parameters: Array<TechnologyParameterAttributes>;
};

export type TechnologyParameter = TargetingV2Parameter & {
  __typename?: 'TechnologyParameter';
  clusivity: Clusivity;
  type: TechnologyParameterType;
  values: Array<TechnologyParameterValue>;
};

export type TechnologyParameterAttributes = {
  clusivity: Clusivity;
  type: TechnologyParameterType;
  values: Array<TechnologyParameterValueAttribute>;
};

export type TechnologyParameterInfo = TargetingV2ParameterInfo & {
  __typename?: 'TechnologyParameterInfo';
  cardinality: Cardinality;
  name: Scalars['String'];
  type: TechnologyParameterType;
};

export enum TechnologyParameterType {
  BrowserLanguage = 'BROWSER_LANGUAGE',
  ConnectionType = 'CONNECTION_TYPE',
  DeviceModel = 'DEVICE_MODEL',
  DeviceOperatingSystem = 'DEVICE_OPERATING_SYSTEM',
  DeviceType = 'DEVICE_TYPE',
  Isp = 'ISP'
}

export type TechnologyParameterValue = TargetingV2ParameterValue & {
  __typename?: 'TechnologyParameterValue';
  children: Array<Maybe<TechnologyParameterValue>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parents: Array<Maybe<TechnologyParameterValue>>;
};

export type TechnologyParameterValueAttribute = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type TechnologyTargeting = {
  __typename?: 'TechnologyTargeting';
  technologies?: Maybe<Array<TechnologyGroup>>;
};

export type TechnologyTargetingAttributes = {
  technologies: Array<TechnologyGroupAttributes>;
};

export enum Territory {
  /** Territory assigned to users to access CA entities. */
  Ca = 'CA',
  /** Territory assigned to users to access UK entities. */
  Uk = 'UK',
  /** Territory assigned to users to access US entities. */
  Us = 'US'
}

export type TerritoryToDomains = {
  __typename?: 'TerritoryToDomains';
  domains: Array<Scalars['DomainName']>;
  territory: Territory;
};

export type TerritoryToIabCategories = {
  __typename?: 'TerritoryToIabCategories';
  iabCategories: Array<IabCategory>;
  territory: Territory;
};

export type TimeSeries = {
  __typename?: 'TimeSeries';
  /** The list of data points for the time series. */
  dataPoints: Array<TimeSeriesDataPoint>;
};

/** Deprecated: Use TimeSeriesPoint */
export type TimeSeriesDataPoint = {
  __typename?: 'TimeSeriesDataPoint';
  /** The data point time. */
  t?: Maybe<Scalars['LocalDateTime']>;
  /** The data point value. */
  v?: Maybe<Scalars['Float']>;
};

export type TimeSeriesParams = {
  /** Requested end date of the time series. */
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  /** Requested start date of the time series. */
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  /** Requested incremental time unit of the time series. */
  timeUnit?: InputMaybe<TimeSeriesTimeUnit>;
  /** The time zone in IANA format (e.g. Europe/London) */
  timeZone: Scalars['ZoneId'];
};

export type TimeSeriesPoint = {
  __typename?: 'TimeSeriesPoint';
  /** The data point time. */
  t: Scalars['LocalDateTime'];
  /** The data point value. */
  v: Scalars['Float'];
  weight?: Maybe<Scalars['Float']>;
};

export type TimeSeriesResponse = {
  __typename?: 'TimeSeriesResponse';
  points: Array<TimeSeriesPoint>;
  total?: Maybe<Scalars['BigDecimal']>;
};

export enum TimeSeriesTimeUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  /** The default value when the time series time unit is not set. */
  TimeUnitUnspecified = 'TIME_UNIT_UNSPECIFIED'
}

export enum TimeZoneTargeting {
  /** Targeting for date/time in the channel's time zone. */
  Channel = 'CHANNEL',
  /** Targeting for date/time in the agency's time zone. */
  Demand = 'DEMAND',
  /** Targeting for date/time in the user's time zone. */
  User = 'USER'
}

export type TrackingUrl = {
  __typename?: 'TrackingUrl';
  /** Consent vendor ID (for GDPR compliance). */
  consentVendorId?: Maybe<Scalars['NonNegativeInt']>;
  /** Tracking URL. */
  url: Scalars['Url'];
};

export type TrackingUrlAttributes = {
  /** Consent vendor ID (for GDPR compliance). */
  consentVendorId?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Tracking URL. */
  url: Scalars['Url'];
};

export type TranscodePreset = Node & {
  __typename?: 'TranscodePreset';
  /** Used for internal purposes to map the UUID to an integer. */
  altId: Scalars['Int'];
  /** The number of bits that are processed over an amount of time in kbit/s (e.g. 128). */
  bitRate: Scalars['PositiveInt'];
  /** The file extension of the audio file. */
  extension?: Maybe<Scalars['String']>;
  /** The content type of the audio file (e.g. "audio/wav"). */
  format: Scalars['String'];
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The sound mode. */
  mode: SoundMode;
  /** Unique system generated string based on attributes. */
  name: Scalars['String'];
  /** The number of samples of audio carried per second in Hz (e.g. 44100). */
  sampleRate: Scalars['PositiveInt'];
  /** The status of the given transcode preset. */
  status?: Maybe<TranscodePresetStatus>;
  /** The volume of the audio in dB (-5 is maximum and loudest). */
  volume: Scalars['NegativeInt'];
};

export type TranscodePresetAttributes = {
  /** The number of bits that are processed over an amount of time in kbit/s (e.g. 128). */
  bitRate: Scalars['PositiveInt'];
  /** The file extension of the audio file. */
  extension?: InputMaybe<Scalars['String']>;
  /** The content type of the audio file (e.g. "audio/wav"). */
  format: Scalars['String'];
  /** The sound mode. */
  mode: SoundMode;
  /** The number of samples of audio carried per second in Hz (e.g. 44100). */
  sampleRate: Scalars['PositiveInt'];
  /** The status of the given transcode preset. */
  status?: InputMaybe<TranscodePresetStatus>;
  /** The volume of the audio in dB (-5 is maximum and loudest). */
  volume: Scalars['NegativeInt'];
};

export enum TranscodePresetStatus {
  /** The default value when the transcode preset is first created. */
  Created = 'CREATED'
}

export type UpdateAdAttributes = {
  adExclusive: Scalars['Boolean'];
  dateRange: InheritableDateRangeAttributes;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: AdStatus;
  weight?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type UpdateChannelAttributes = {
  channelType: ChannelType;
  contentCategories?: InputMaybe<Array<ChannelContentCategory>>;
  enforceTenSecondMultiples: Scalars['Boolean'];
  externalDealId?: InputMaybe<Scalars['String']>;
  floorCpm?: InputMaybe<Scalars['BigDecimal']>;
  inventoryType: InventoryType;
  maxAdDuration?: InputMaybe<Scalars['PositiveInt']>;
  maxFilterableTrafficPercentage: Scalars['NonNegativeInt'];
  minAdDuration?: InputMaybe<Scalars['PositiveInt']>;
  name: Scalars['String'];
  overrideConsentSignal: Scalars['Boolean'];
  supportedAdLanguages: Array<Scalars['String']>;
  trafficAcceptancePercentage: Scalars['NonNegativeInt'];
  vastVersion: VastVersion;
};

export type UpdateCompanionBannerAttributes = {
  attributes: CompanionBannerAttributes;
  id?: InputMaybe<Scalars['ID']>;
};

export type UpdateCompanionBannerGroupAttributes = {
  clickThroughUrl: Scalars['Url'];
  companionBannerAttributes: Array<UpdateCompanionBannerAttributes>;
  trackingUrls: Array<TrackingUrlAttributes>;
};

export type UpdateCreativeAttributes = {
  approvalStatus: CreativeApprovalStatus;
  companionBannerGroupAttributes?: InputMaybe<UpdateCompanionBannerGroupAttributes>;
  creativeAudioAttributes?: InputMaybe<UpdateCreativeAudioAttributes>;
  creativeFileAttributes?: InputMaybe<Array<UpdateCreativeFileAttributes>>;
  creativeTagAttributes?: InputMaybe<UpdateCreativeTagAttributes>;
  name: Scalars['String'];
};

export type UpdateCreativeAudioAttributes = {
  attributes: CreativeAudioAttributes;
  id?: InputMaybe<Scalars['ID']>;
};

export type UpdateCreativeFileAttributes = {
  attributes: CreativeFileAttributes;
  id?: InputMaybe<Scalars['ID']>;
};

export type UpdateCreativeTagAttributes = {
  attributes: CreativeTagAttributes;
  id: Scalars['ID'];
};

export type UpdateDaxShowContractAttributes = {
  dateRange: DateRangeAttributes;
  notes?: InputMaybe<Scalars['String']>;
  publisherPaymentConfigs?: InputMaybe<Array<PublisherPaymentConfigAttributes>>;
};

export type UpdateNetworkAttributes = {
  name: Scalars['String'];
  state: EntityState;
};

export type UpdateProposedFlightAttributes = {
  id: Scalars['ID'];
  proposedFlightAttributes: ProposedFlightAttributes;
};

export type UpdatePublisherAttributes = {
  /** The domains blocked by the publisher. */
  blockedDomains: Array<Scalars['DomainName']>;
  /** The IAB categories blocked by the publisher. */
  blockedIabCategoryCodes: Array<Scalars['ID']>;
  /** The currency of the publisher. */
  currency: Scalars['Currency'];
  /** The name of the publisher. */
  name: Scalars['String'];
};

export type UpdatePublisherContractAttributes = {
  dateRange: DateRangeAttributes;
  notes?: InputMaybe<Scalars['String']>;
  paymentConfigs?: InputMaybe<Array<PublisherContractPaymentConfigAttributes>>;
};

export type UpdateShowAttributes = {
  adFormats: Array<AdFormatAttributes>;
  adPositions: Array<ShowAdPositionAttributes>;
  audienceParameters: Array<SupplyAudienceParameterAttributes>;
  blockedDomains: Array<Scalars['DomainName']>;
  blockedIabCategoryCodes: Array<Scalars['ID']>;
  coverUrl?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  hostNames: Scalars['String'];
  hostingPlatforms: Array<ShowHostingPlatformAttributes>;
  itunesCategoryIds: Array<Scalars['ID']>;
  name: Scalars['String'];
  startDate: Scalars['LocalDateTime'];
  state: EntityState;
  supportAudio?: InputMaybe<Scalars['Boolean']>;
  supportSocial?: InputMaybe<Scalars['Boolean']>;
  supportVideo?: InputMaybe<Scalars['Boolean']>;
  weeklyReleaseFrequency: Scalars['PositiveInt'];
};

export type UpdateVideoProposedFlightAttributes = {
  id: Scalars['ID'];
  proposedFlightAttributes: VideoProposedFlightAttributes;
};

export type User = Node & {
  __typename?: 'User';
  /** Sets the user's active business-user profile */
  businessUserProfile?: Maybe<BusinessUserProfile>;
  /** Determines the user's default business */
  defaultBusinessId?: Maybe<Scalars['ID']>;
  /** The user's email. */
  email?: Maybe<Scalars['String']>;
  /** The entity permissions assigned to this user. */
  entityPermissions?: Maybe<Array<EntityPermission>>;
  /** The entity identifier as an UUID string. */
  id: Scalars['ID'];
  /** The display name of the user */
  name?: Maybe<Scalars['String']>;
  /** The list of permissions assigned to the user. */
  permissions: Array<Permission>;
  /** V2 Permissions list */
  permissionsV2?: Maybe<Array<PermissionV2>>;
  /** Determines the user's primary territory */
  primaryTerritory?: Maybe<Territory>;
  /** The user's status. */
  status?: Maybe<UserStatus>;
  /** The list of territories assigned to the user. */
  territories?: Maybe<Array<Territory>>;
  /** The user's type. */
  userType?: Maybe<UserType>;
};

export type UserAttributes = {
  /** The user's email. */
  email?: InputMaybe<Scalars['String']>;
  /** The permissions assigned to this user. */
  entityPermissions?: InputMaybe<Array<EntityPermissionAttributes>>;
  /** The list of permissions assigned to the user. */
  permissions?: InputMaybe<Array<PermissionName>>;
  /** Determines the user's primary territory */
  primaryTerritory?: InputMaybe<Territory>;
  /** The list of territories assigned to the user. */
  territories?: InputMaybe<Array<Territory>>;
  /** The type of user */
  userType?: InputMaybe<UserType>;
};

export type UserFilter = {
  excludedUserIds?: InputMaybe<Array<Scalars['ID']>>;
  permissions?: InputMaybe<Array<PermissionName>>;
};

export enum UserStatus {
  /** The default value when the user is first created. */
  Active = 'ACTIVE',
  /** User has been deleted but we still want to be able to retrieve users for auditing purposes. */
  Inactive = 'INACTIVE'
}

export enum UserType {
  AdOps = 'AD_OPS',
  LocalSales = 'LOCAL_SALES',
  NationalSales = 'NATIONAL_SALES'
}

export type UserTypeInfo = {
  __typename?: 'UserTypeInfo';
  displayName: Scalars['String'];
  userType: UserType;
};

export enum UserV2Type {
  External = 'EXTERNAL',
  Standard = 'STANDARD'
}

export type ValidatePostcodesResponse = {
  __typename?: 'ValidatePostcodesResponse';
  invalid: Array<Scalars['String']>;
  valid: Array<Scalars['String']>;
};

export enum VastVersion {
  /** VAST version 4.0 */
  Four = 'FOUR',
  /** VAST version 4.1 */
  FourOne = 'FOUR_ONE',
  /** VAST version 3.0 */
  Three = 'THREE',
  /** VAST version 2.0 */
  Two = 'TWO',
  /** The default value when the VAST version is not set. */
  VastVersionUnspecified = 'VAST_VERSION_UNSPECIFIED'
}

export type VastVersionInfo = {
  __typename?: 'VastVersionInfo';
  displayName: Scalars['String'];
  type: VastVersion;
};

export type VideoPeriod = {
  __typename?: 'VideoPeriod';
  endDate: Scalars['LocalDate'];
  episodeCount: Scalars['Int'];
  startDate: Scalars['LocalDate'];
};

export type VideoProposedFlightAttributes = {
  billingType: FlightBillingType;
  boltOns?: InputMaybe<Array<FlightBoltOnType>>;
  budget: FlightBudgetAttributes;
  name: Scalars['String'];
  nonSpotShowId?: InputMaybe<Scalars['ID']>;
  periods: Array<Period>;
  territory?: InputMaybe<Territory>;
};

export type AuditTrailQueryVariables = Exact<{
  filter: AuditTrailFilter;
}>;


export type AuditTrailQuery = { __typename?: 'Query', auditTrail: Array<{ __typename?: 'AuditTrail', changeType?: AuditChangeType, changedAt?: any, changedBy?: { __typename?: 'User', email?: string, status?: UserStatus }, changedByAssumed?: { __typename?: 'User', email?: string, status?: UserStatus } }> };

export type CreateAdLegacyMutationVariables = Exact<{
  creativeAudioId?: InputMaybe<Scalars['ID']>;
  creativeImageIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  creativeRedirectId?: InputMaybe<Scalars['ID']>;
  campaignId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<InheritableLocalDateTimeAttributes>;
  endDate?: InputMaybe<InheritableLocalDateTimeAttributes>;
  status?: InputMaybe<AdStatusLegacy>;
  frequencyCapCount?: InputMaybe<Scalars['NonNegativeInt']>;
  frequencyCapValue?: InputMaybe<Scalars['NonNegativeInt']>;
  frequencyCapTimeUnit?: InputMaybe<FrequencyCapTimeUnit>;
  weighting?: InputMaybe<Scalars['NonNegativeInt']>;
  sequence?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  duration?: InputMaybe<Scalars['NonNegativeFloat']>;
  tagIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  tagsAreInherited?: InputMaybe<Scalars['Boolean']>;
  dailyCap?: InputMaybe<Scalars['NonNegativeInt']>;
  targetingDefinition?: InputMaybe<TargetingDefinitionAttributes>;
  targetingDefinitionV2?: InputMaybe<TargetingDefinitionV2Attributes>;
  adExclusive?: InputMaybe<Scalars['Boolean']>;
  territory?: InputMaybe<Territory>;
}>;


export type CreateAdLegacyMutation = { __typename?: 'Mutation', createAdLegacy?: { __typename?: 'AdLegacy', id: string, altId: number, name?: string, frequencyCapCount?: any, frequencyCapValue?: any, frequencyCapTimeUnit?: FrequencyCapTimeUnit, weighting?: any, duration?: any, status?: AdStatusLegacy, adExclusive?: boolean, tagsAreInherited: boolean, dailyCap?: any, territory: Territory, startDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, endDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, creativeRedirect?: { __typename?: 'CreativeRedirectLegacy', id: string, url?: any, trackingUrls: Array<{ __typename?: 'TrackingUrl', url: any }> }, creativeAudio?: { __typename?: 'CreativeAudioLegacy', fileName?: string, id: string, name?: string, url?: any, resourceAltId: number }, sequence: Array<{ __typename?: 'AdLegacy', id: string, name?: string }>, creativeImages: Array<{ __typename?: 'CreativeImageLegacy', fileName?: string, id: string, landingPageUrl?: any, mimeType?: string, name?: string, size?: string, url?: any, resourceAltId: number }>, campaign?: { __typename?: 'Campaign', id: string, name?: string, cpm?: any }, tags: Array<{ __typename?: 'Tag', id: string, name?: string }>, inheritedTags: Array<{ __typename?: 'Tag', id: string, name?: string }> } };

export type UpdateAdLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<InheritableLocalDateTimeAttributes>;
  endDate?: InputMaybe<InheritableLocalDateTimeAttributes>;
  status?: InputMaybe<AdStatusLegacy>;
  frequencyCapCount?: InputMaybe<Scalars['NonNegativeInt']>;
  frequencyCapValue?: InputMaybe<Scalars['NonNegativeInt']>;
  frequencyCapTimeUnit?: InputMaybe<FrequencyCapTimeUnit>;
  weighting?: InputMaybe<Scalars['NonNegativeInt']>;
  sequence?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  sequenceStart?: InputMaybe<Scalars['Boolean']>;
  creativeAudioId?: InputMaybe<Scalars['ID']>;
  creativeImageIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  creativeRedirectId?: InputMaybe<Scalars['ID']>;
  duration?: InputMaybe<Scalars['NonNegativeFloat']>;
  tagIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  tagsAreInherited?: InputMaybe<Scalars['Boolean']>;
  dailyCap?: InputMaybe<Scalars['NonNegativeInt']>;
  targetingDefinition?: InputMaybe<TargetingDefinitionAttributes>;
  targetingDefinitionV2?: InputMaybe<TargetingDefinitionV2Attributes>;
  adExclusive?: InputMaybe<Scalars['Boolean']>;
  territory?: InputMaybe<Territory>;
}>;


export type UpdateAdLegacyMutation = { __typename?: 'Mutation', updateAdLegacy?: { __typename?: 'AdLegacy', id: string, altId: number, duration?: any, name?: string, frequencyCapCount?: any, frequencyCapValue?: any, frequencyCapTimeUnit?: FrequencyCapTimeUnit, weighting?: any, status?: AdStatusLegacy, adExclusive?: boolean, sequenceStart?: boolean, tagsAreInherited: boolean, dailyCap?: any, territory: Territory, startDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, endDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, creativeAudio?: { __typename?: 'CreativeAudioLegacy', fileName?: string, id: string, name?: string, url?: any }, creativeRedirect?: { __typename?: 'CreativeRedirectLegacy', id: string, url?: any, trackingUrls: Array<{ __typename?: 'TrackingUrl', url: any }> }, creativeImages: Array<{ __typename?: 'CreativeImageLegacy', fileName?: string, id: string, landingPageUrl?: any, mimeType?: string, name?: string, size?: string, url?: any }>, campaign?: { __typename?: 'Campaign', name?: string, id: string, startDate?: any, endDate?: any, cpm?: any }, sequence: Array<{ __typename?: 'AdLegacy', id: string, name?: string }>, tags: Array<{ __typename?: 'Tag', id: string, name?: string }>, inheritedTags: Array<{ __typename?: 'Tag', id: string, name?: string }> } };

export type CloneAdLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CloneAdLegacyMutation = { __typename?: 'Mutation', cloneAdLegacy?: { __typename?: 'AdLegacy', id: string, territory: Territory } };

export type AdFragmentFragment = { __typename?: 'AdLegacy', altId: number, duration?: any, targetingRestrictions: Array<TargetingRestriction>, startDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, endDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, targetingDefinition?: { __typename?: 'TargetingDefinition', id: string, masterTargetingTemplates: Array<{ __typename?: 'TargetingTemplate', id: string, name?: string, description?: string, isMasterTemplate?: boolean, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> }>, generalTargetingGroup?: { __typename?: 'TargetingGroup', id: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> }, targetingDefinitionV2?: { __typename?: 'TargetingDefinitionV2', id: string, audienceTargeting?: { __typename?: 'AudienceTargeting', audiences?: Array<{ __typename?: 'AudienceGroup', parameters: Array<{ __typename?: 'AudienceParameter', type: AudienceParameterType, clusivity: Clusivity, enabledGrades?: Array<TargetingGrade>, values: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string, active: boolean, activeGrades?: Array<TargetingGrade> }> }> }> }, locationTargeting?: { __typename?: 'LocationTargeting', locations?: Array<{ __typename?: 'LocationGroup', accuracyRadius?: number, limitLocationParameterValue?: { __typename?: 'LocationParameterValue', id: string }, parameters: Array<{ __typename?: 'LocationParameter', type: LocationParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'LocationParameterValue', id: string, name: string, parents: Array<{ __typename?: 'LocationParameterValue', id: string, name: string }> }> }> }> }, technologyTargeting?: { __typename?: 'TechnologyTargeting', technologies?: Array<{ __typename?: 'TechnologyGroup', parameters: Array<{ __typename?: 'TechnologyParameter', type: TechnologyParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'TechnologyParameterValue', id: string, name: string }> }> }> }, inventoryTargeting?: { __typename?: 'InventoryTargeting', inventories?: Array<{ __typename?: 'InventoryGroup', parameters: Array<{ __typename?: 'InventoryParameter', type: InventoryParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'InventoryParameterValue', id: string, name: string, active: boolean, parents: Array<{ __typename?: 'InventoryParameterValue', id: string, name: string }> }> }> }> }, dayTimeTargeting?: { __typename?: 'DayTimeTargeting', clusivity: Clusivity, timeZone: TimeZoneTargeting, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> }, customTargeting?: { __typename?: 'CustomTargeting', customGroups?: Array<{ __typename?: 'CustomGroup', parameters: Array<{ __typename?: 'CustomParameter', clusivity: Clusivity, customKvps: Array<{ __typename?: 'KeyValue', key: string, value: string }> }> }> } } };

export type CampaignFragmentFragment = { __typename?: 'Campaign', timeZone?: any, targetingVersion: TargetingVersion };

export type AdLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
  territories: Array<Territory> | Territory;
}>;


export type AdLegacyQuery = { __typename?: 'Query', adLegacy?: { __typename?: 'AdLegacy', id: string, name?: string, territory: Territory, weighting?: any, status?: AdStatusLegacy, adExclusive?: boolean, tagsAreInherited: boolean, frequencyCapCount?: any, frequencyCapValue?: any, frequencyCapTimeUnit?: FrequencyCapTimeUnit, dailyCap?: any, altId: number, duration?: any, targetingRestrictions: Array<TargetingRestriction>, creativeAudio?: { __typename?: 'CreativeAudioLegacy', fileName?: string, id: string, name?: string, url?: any, status?: CreativeStatusLegacy, resourceAltId: number, altId: number, trackingUrls: Array<{ __typename?: 'TrackingUrl', url: any, consentVendorId?: any }> }, creativeRedirect?: { __typename?: 'CreativeRedirectLegacy', id: string, url?: any, consentVendorId?: any, trackingUrls: Array<{ __typename?: 'TrackingUrl', url: any, consentVendorId?: any }> }, creativeImages: Array<{ __typename?: 'CreativeImageLegacy', fileName?: string, id: string, landingPageUrl?: any, mimeType?: string, name?: string, size?: string, url?: any, status?: CreativeStatusLegacy, resourceAltId: number, altId: number, trackingUrls: Array<{ __typename?: 'TrackingUrl', url: any, consentVendorId?: any }> }>, sequence: Array<{ __typename?: 'AdLegacy', id: string }>, tags: Array<{ __typename?: 'Tag', id: string, name?: string }>, inheritedTags: Array<{ __typename?: 'Tag', id: string, name?: string }>, campaign?: { __typename?: 'Campaign', id: string, name?: string, cpm?: any, startDate?: any, endDate?: any, objective?: any, dailyCap?: any, status?: CampaignStatus, timeZone?: any, targetingVersion: TargetingVersion, order?: { __typename?: 'Order', id: string, name?: string, endDate?: any, timeZone?: any, advertiser?: { __typename?: 'Advertiser', id: string, name?: string, agency?: { __typename?: 'Agency', id: string, name?: string } } }, tags: Array<{ __typename?: 'Tag', id: string, name?: string }>, ads: Array<{ __typename?: 'AdLegacy', id: string, name?: string }>, targetingDefinitionV2?: { __typename?: 'TargetingDefinitionV2', id: string } }, startDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, endDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, targetingDefinition?: { __typename?: 'TargetingDefinition', id: string, masterTargetingTemplates: Array<{ __typename?: 'TargetingTemplate', id: string, name?: string, description?: string, isMasterTemplate?: boolean, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> }>, generalTargetingGroup?: { __typename?: 'TargetingGroup', id: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> }, targetingDefinitionV2?: { __typename?: 'TargetingDefinitionV2', id: string, audienceTargeting?: { __typename?: 'AudienceTargeting', audiences?: Array<{ __typename?: 'AudienceGroup', parameters: Array<{ __typename?: 'AudienceParameter', type: AudienceParameterType, clusivity: Clusivity, enabledGrades?: Array<TargetingGrade>, values: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string, active: boolean, activeGrades?: Array<TargetingGrade> }> }> }> }, locationTargeting?: { __typename?: 'LocationTargeting', locations?: Array<{ __typename?: 'LocationGroup', accuracyRadius?: number, limitLocationParameterValue?: { __typename?: 'LocationParameterValue', id: string }, parameters: Array<{ __typename?: 'LocationParameter', type: LocationParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'LocationParameterValue', id: string, name: string, parents: Array<{ __typename?: 'LocationParameterValue', id: string, name: string }> }> }> }> }, technologyTargeting?: { __typename?: 'TechnologyTargeting', technologies?: Array<{ __typename?: 'TechnologyGroup', parameters: Array<{ __typename?: 'TechnologyParameter', type: TechnologyParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'TechnologyParameterValue', id: string, name: string }> }> }> }, inventoryTargeting?: { __typename?: 'InventoryTargeting', inventories?: Array<{ __typename?: 'InventoryGroup', parameters: Array<{ __typename?: 'InventoryParameter', type: InventoryParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'InventoryParameterValue', id: string, name: string, active: boolean, parents: Array<{ __typename?: 'InventoryParameterValue', id: string, name: string }> }> }> }> }, dayTimeTargeting?: { __typename?: 'DayTimeTargeting', clusivity: Clusivity, timeZone: TimeZoneTargeting, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> }, customTargeting?: { __typename?: 'CustomTargeting', customGroups?: Array<{ __typename?: 'CustomGroup', parameters: Array<{ __typename?: 'CustomParameter', clusivity: Clusivity, customKvps: Array<{ __typename?: 'KeyValue', key: string, value: string }> }> }> } } } };

export type AdByAltIdLegacyQueryVariables = Exact<{
  altId: Scalars['Int'];
}>;


export type AdByAltIdLegacyQuery = { __typename?: 'Query', adByAltIdLegacy?: { __typename?: 'AdLegacy', altId: number, duration?: any, targetingRestrictions: Array<TargetingRestriction>, campaign?: { __typename?: 'Campaign', timeZone?: any, targetingVersion: TargetingVersion, iabCategories: Array<{ __typename?: 'IabCategory', code: string }> }, startDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, endDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, targetingDefinition?: { __typename?: 'TargetingDefinition', id: string, masterTargetingTemplates: Array<{ __typename?: 'TargetingTemplate', id: string, name?: string, description?: string, isMasterTemplate?: boolean, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> }>, generalTargetingGroup?: { __typename?: 'TargetingGroup', id: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> }, targetingDefinitionV2?: { __typename?: 'TargetingDefinitionV2', id: string, audienceTargeting?: { __typename?: 'AudienceTargeting', audiences?: Array<{ __typename?: 'AudienceGroup', parameters: Array<{ __typename?: 'AudienceParameter', type: AudienceParameterType, clusivity: Clusivity, enabledGrades?: Array<TargetingGrade>, values: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string, active: boolean, activeGrades?: Array<TargetingGrade> }> }> }> }, locationTargeting?: { __typename?: 'LocationTargeting', locations?: Array<{ __typename?: 'LocationGroup', accuracyRadius?: number, limitLocationParameterValue?: { __typename?: 'LocationParameterValue', id: string }, parameters: Array<{ __typename?: 'LocationParameter', type: LocationParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'LocationParameterValue', id: string, name: string, parents: Array<{ __typename?: 'LocationParameterValue', id: string, name: string }> }> }> }> }, technologyTargeting?: { __typename?: 'TechnologyTargeting', technologies?: Array<{ __typename?: 'TechnologyGroup', parameters: Array<{ __typename?: 'TechnologyParameter', type: TechnologyParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'TechnologyParameterValue', id: string, name: string }> }> }> }, inventoryTargeting?: { __typename?: 'InventoryTargeting', inventories?: Array<{ __typename?: 'InventoryGroup', parameters: Array<{ __typename?: 'InventoryParameter', type: InventoryParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'InventoryParameterValue', id: string, name: string, active: boolean, parents: Array<{ __typename?: 'InventoryParameterValue', id: string, name: string }> }> }> }> }, dayTimeTargeting?: { __typename?: 'DayTimeTargeting', clusivity: Clusivity, timeZone: TimeZoneTargeting, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> }, customTargeting?: { __typename?: 'CustomTargeting', customGroups?: Array<{ __typename?: 'CustomGroup', parameters: Array<{ __typename?: 'CustomParameter', clusivity: Clusivity, customKvps: Array<{ __typename?: 'KeyValue', key: string, value: string }> }> }> } } } };

export type CreateAdvertiserMutationVariables = Exact<{
  agencyId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSystemId?: InputMaybe<Scalars['String']>;
  domains?: InputMaybe<Array<Scalars['DomainName']> | Scalars['DomainName']>;
  adSeparation?: InputMaybe<Scalars['NonNegativeFloat']>;
  iabCategoryCodes?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  territory?: InputMaybe<Territory>;
}>;


export type CreateAdvertiserMutation = { __typename?: 'Mutation', createAdvertiserLegacy?: { __typename?: 'Advertiser', id: string, altId: number, name?: string, externalId?: string, externalSystemId?: string, domains: Array<any>, status?: AdvertiserStatus, adSeparation?: any, territory: Territory, iabCategories: Array<{ __typename?: 'IabCategory', name?: string, code: string }> } };

export type UpdateAdvertiserMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdvertiserStatus>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSystemId?: InputMaybe<Scalars['String']>;
  domains?: InputMaybe<Array<Scalars['DomainName']> | Scalars['DomainName']>;
  adSeparation?: InputMaybe<Scalars['NonNegativeFloat']>;
  iabCategoryCodes?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateAdvertiserMutation = { __typename?: 'Mutation', updateAdvertiserLegacy?: { __typename?: 'Advertiser', id: string, altId: number, name?: string, externalId?: string, externalSystemId?: string, domains: Array<any>, status?: AdvertiserStatus, adSeparation?: any, territory: Territory, iabCategories: Array<{ __typename?: 'IabCategory', name?: string, code: string }>, agency?: { __typename?: 'Agency', id: string, name?: string } } };

export type AdvertiserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdvertiserQuery = { __typename?: 'Query', advertiserLegacy?: { __typename?: 'Advertiser', id: string, altId: number, name?: string, externalId?: string, externalSystemId?: string, domains: Array<any>, status?: AdvertiserStatus, adSeparation?: any, territory: Territory, iabCategories: Array<{ __typename?: 'IabCategory', code: string }>, agency?: { __typename?: 'Agency', id: string, name?: string, status: AgencyStatus, advertisers: Array<{ __typename?: 'Advertiser', id: string, name?: string, externalSystemId?: string }> }, orders: Array<{ __typename?: 'Order', id: string, name?: string }> } };

export type AllAdvertisersQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  territories: Array<Territory> | Territory;
}>;


export type AllAdvertisersQuery = { __typename?: 'Query', allAdvertisersLegacy: Array<{ __typename?: 'Advertiser', id: string, name?: string }> };

export type CreateAgencyMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSystemId?: InputMaybe<Scalars['String']>;
  territory?: InputMaybe<Territory>;
}>;


export type CreateAgencyMutation = { __typename?: 'Mutation', createAgencyLegacy?: { __typename?: 'Agency', id: string, altId: number, status: AgencyStatus, name?: string, externalId?: string, externalSystemId?: string, territory: Territory } };

export type UpdateAgencyMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AgencyStatus>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSystemId?: InputMaybe<Scalars['String']>;
  territory?: InputMaybe<Territory>;
}>;


export type UpdateAgencyMutation = { __typename?: 'Mutation', updateAgencyLegacy?: { __typename?: 'Agency', id: string, altId: number, name?: string, status: AgencyStatus, externalId?: string, externalSystemId?: string, territory: Territory } };

export type AgencyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AgencyQuery = { __typename?: 'Query', agencyLegacy?: { __typename?: 'Agency', id: string, altId: number, name?: string, externalId?: string, externalSystemId?: string, status: AgencyStatus, territory: Territory, advertisers: Array<{ __typename?: 'Advertiser', id: string, name?: string, altId: number, domains: Array<any>, status?: AdvertiserStatus }> } };

export type AgencyMinimalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AgencyMinimalQuery = { __typename?: 'Query', agencyLegacy?: { __typename?: 'Agency', id: string, name?: string, territory: Territory } };

export type AllAgenciesQueryVariables = Exact<{
  territories: Array<Territory> | Territory;
}>;


export type AllAgenciesQuery = { __typename?: 'Query', allAgenciesLegacy: Array<{ __typename?: 'Agency', id: string, altId: number, name?: string, status: AgencyStatus, externalId?: string, externalSystemId?: string }> };

export type AllAgenciesMinimalQueryVariables = Exact<{
  territories: Array<Territory> | Territory;
}>;


export type AllAgenciesMinimalQuery = { __typename?: 'Query', allAgenciesLegacy: Array<{ __typename?: 'Agency', id: string, name?: string }> };

export type CreateCampaignMutationVariables = Exact<{
  orderId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  pacing?: InputMaybe<Pacing>;
  timeZone?: InputMaybe<Scalars['ZoneId']>;
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  billingType?: InputMaybe<BillingType>;
  objective?: InputMaybe<Scalars['NonNegativeInt']>;
  dailyCap?: InputMaybe<Scalars['NonNegativeInt']>;
  currency?: InputMaybe<Scalars['Currency']>;
  cpm?: InputMaybe<Scalars['BigDecimal']>;
  frequencyCapCount?: InputMaybe<Scalars['NonNegativeInt']>;
  frequencyCapValue?: InputMaybe<Scalars['NonNegativeInt']>;
  frequencyCapTimeUnit?: InputMaybe<FrequencyCapTimeUnit>;
  iabCategoryCodes?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  offsetCpm?: InputMaybe<Scalars['BigDecimal']>;
  priority?: InputMaybe<Scalars['NonNegativeInt']>;
  tagIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  targetingDefinition?: InputMaybe<TargetingDefinitionAttributes>;
  sponsorshipRevenue?: InputMaybe<Scalars['NonNegativeFloat']>;
  territory?: InputMaybe<Territory>;
  targetingVersion?: InputMaybe<TargetingVersion>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<CampaignExternalSystem>;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutation', createCampaign?: { __typename?: 'Campaign', offsetCpm?: any, priority?: any, id: string, altId: number, status?: CampaignStatus, name?: string, pacing?: Pacing, startDate?: any, endDate?: any, billingType?: BillingType, timeZone?: any, currency?: any, cpm?: any, dailyCap?: any, frequencyCapCount?: any, frequencyCapValue?: any, frequencyCapTimeUnit?: FrequencyCapTimeUnit, sponsorshipRevenue?: any, territory: Territory, targetingVersion: TargetingVersion, iabCategories: Array<{ __typename?: 'IabCategory', name?: string, code: string }>, order?: { __typename?: 'Order', id: string, name?: string }, tags: Array<{ __typename?: 'Tag', id: string, name?: string }>, owner?: { __typename?: 'User', id: string, email?: string }, targetingDefinition?: { __typename?: 'TargetingDefinition', id: string, masterTargetingTemplates: Array<{ __typename?: 'TargetingTemplate', id: string, name?: string }>, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any }> } } };

export type UpdateCampaignMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  pacing?: InputMaybe<Pacing>;
  billingType?: InputMaybe<BillingType>;
  timeZone?: InputMaybe<Scalars['ZoneId']>;
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  status?: InputMaybe<CampaignStatus>;
  objective?: InputMaybe<Scalars['NonNegativeInt']>;
  dailyCap?: InputMaybe<Scalars['NonNegativeInt']>;
  currency?: InputMaybe<Scalars['Currency']>;
  cpm?: InputMaybe<Scalars['BigDecimal']>;
  frequencyCapCount?: InputMaybe<Scalars['NonNegativeInt']>;
  frequencyCapValue?: InputMaybe<Scalars['NonNegativeInt']>;
  frequencyCapTimeUnit?: InputMaybe<FrequencyCapTimeUnit>;
  iabCategoryCodes?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  offsetCpm?: InputMaybe<Scalars['BigDecimal']>;
  priority?: InputMaybe<Scalars['NonNegativeInt']>;
  tagIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  targetingDefinition?: InputMaybe<TargetingDefinitionAttributes>;
  archived?: InputMaybe<Scalars['Boolean']>;
  sponsorshipRevenue?: InputMaybe<Scalars['NonNegativeFloat']>;
  targetingVersion?: InputMaybe<TargetingVersion>;
  externalId?: InputMaybe<Scalars['String']>;
  targetingRestrictions?: InputMaybe<Array<TargetingRestriction> | TargetingRestriction>;
  targetingDefinitionV2?: InputMaybe<TargetingDefinitionV2Attributes>;
}>;


export type UpdateCampaignMutation = { __typename?: 'Mutation', updateCampaign?: { __typename?: 'Campaign', offsetCpm?: any, priority?: any, id: string, altId: number, status?: CampaignStatus, name?: string, pacing?: Pacing, startDate?: any, endDate?: any, billingType?: BillingType, timeZone?: any, currency?: any, cpm?: any, targetingRestrictions?: Array<TargetingRestriction>, frequencyCapCount?: any, frequencyCapValue?: any, frequencyCapTimeUnit?: FrequencyCapTimeUnit, sponsorshipRevenue?: any, objective?: any, dailyCap?: any, archived: boolean, territory: Territory, targetingVersion: TargetingVersion, iabCategories: Array<{ __typename?: 'IabCategory', name?: string, code: string }>, tags: Array<{ __typename?: 'Tag', id: string, name?: string }>, owner?: { __typename?: 'User', id: string, email?: string }, targetingDefinition?: { __typename?: 'TargetingDefinition', id: string, masterTargetingTemplates: Array<{ __typename?: 'TargetingTemplate', id: string, name?: string }>, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any }> } } };

export type CloneCampaignMutationVariables = Exact<{
  id: Scalars['ID'];
  disableCascade?: InputMaybe<Scalars['Boolean']>;
}>;


export type CloneCampaignMutation = { __typename?: 'Mutation', cloneCampaign?: { __typename?: 'Campaign', id: string } };

export type CampaignQueryVariables = Exact<{
  id: Scalars['ID'];
  territories: Array<Territory> | Territory;
}>;


export type CampaignQuery = { __typename?: 'Query', campaign?: { __typename?: 'Campaign', id: string, altId: number, name?: string, pacing?: Pacing, startDate?: any, endDate?: any, billingType?: BillingType, timeZone?: any, currency?: any, cpm?: any, frequencyCapCount?: any, frequencyCapValue?: any, frequencyCapTimeUnit?: FrequencyCapTimeUnit, objective?: any, impressions?: any, dailyCap?: any, offsetCpm?: any, priority?: any, status?: CampaignStatus, territory: Territory, sponsorshipRevenue?: any, targetingVersion: TargetingVersion, externalId?: string, externalSystem?: CampaignExternalSystem, targetingRestrictions?: Array<TargetingRestriction>, sanities: Array<{ __typename?: 'Sanity', id: string, type: SanityType, name: string }>, tags: Array<{ __typename?: 'Tag', id: string, name?: string }>, order?: { __typename?: 'Order', id: string, name?: string, startDate?: any, endDate?: any, objective?: any, status?: OrderStatus, externalSystemId?: string, advertiser?: { __typename?: 'Advertiser', id: string, name?: string, agency?: { __typename?: 'Agency', id: string, name?: string } }, campaigns: Array<{ __typename?: 'Campaign', id: string, name?: string, objective?: any }>, owner?: { __typename?: 'User', id: string, email?: string, status?: UserStatus } }, iabCategories: Array<{ __typename?: 'IabCategory', code: string }>, owner?: { __typename?: 'User', id: string, email?: string, status?: UserStatus }, targetingDefinition?: { __typename?: 'TargetingDefinition', id: string, masterTargetingTemplates: Array<{ __typename?: 'TargetingTemplate', id: string, name?: string, description?: string, isMasterTemplate?: boolean, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> }>, generalTargetingGroup?: { __typename?: 'TargetingGroup', id: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> }, targetingDefinitionV2?: { __typename?: 'TargetingDefinitionV2', id: string, audienceTargeting?: { __typename?: 'AudienceTargeting', audiences?: Array<{ __typename?: 'AudienceGroup', parameters: Array<{ __typename?: 'AudienceParameter', type: AudienceParameterType, clusivity: Clusivity, enabledGrades?: Array<TargetingGrade>, values: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string, active: boolean, activeGrades?: Array<TargetingGrade> }> }> }> }, locationTargeting?: { __typename?: 'LocationTargeting', locations?: Array<{ __typename?: 'LocationGroup', accuracyRadius?: number, limitLocationParameterValue?: { __typename?: 'LocationParameterValue', id: string }, parameters: Array<{ __typename?: 'LocationParameter', type: LocationParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'LocationParameterValue', id: string, name: string, parents: Array<{ __typename?: 'LocationParameterValue', id: string, name: string }> }> }> }> }, technologyTargeting?: { __typename?: 'TechnologyTargeting', technologies?: Array<{ __typename?: 'TechnologyGroup', parameters: Array<{ __typename?: 'TechnologyParameter', type: TechnologyParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'TechnologyParameterValue', id: string, name: string }> }> }> }, inventoryTargeting?: { __typename?: 'InventoryTargeting', inventories?: Array<{ __typename?: 'InventoryGroup', parameters: Array<{ __typename?: 'InventoryParameter', type: InventoryParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'InventoryParameterValue', id: string, name: string, active: boolean, parents: Array<{ __typename?: 'InventoryParameterValue', id: string, name: string }> }> }> }> }, dayTimeTargeting?: { __typename?: 'DayTimeTargeting', clusivity: Clusivity, timeZone: TimeZoneTargeting, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> }, customTargeting?: { __typename?: 'CustomTargeting', customGroups?: Array<{ __typename?: 'CustomGroup', parameters: Array<{ __typename?: 'CustomParameter', clusivity: Clusivity, customKvps: Array<{ __typename?: 'KeyValue', key: string, value: string }> }> }> } }, ads: Array<{ __typename?: 'AdLegacy', id: string, altId: number, name?: string, weighting?: any, impressions?: any, dailyCap?: any, status?: AdStatusLegacy, frequencyCapCount?: any, frequencyCapValue?: any, frequencyCapTimeUnit?: FrequencyCapTimeUnit, sequenceStart?: boolean, startDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, endDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, creativeAudio?: { __typename?: 'CreativeAudioLegacy', id: string }, creativeImages: Array<{ __typename?: 'CreativeImageLegacy', id: string }>, creativeRedirect?: { __typename?: 'CreativeRedirectLegacy', id: string }, sequence: Array<{ __typename?: 'AdLegacy', id: string, name?: string }>, tags: Array<{ __typename?: 'Tag', id: string, name?: string }> }> } };

export type CampaignTimeSeriesQueryVariables = Exact<{
  id: Scalars['ID'];
  timeZone: Scalars['ZoneId'];
  territories: Array<Territory> | Territory;
}>;


export type CampaignTimeSeriesQuery = { __typename?: 'Query', campaign?: { __typename?: 'Campaign', id: string, timeZone?: any, objective?: any, impressions?: any, companionImpressions?: any, pacing?: Pacing, ltr?: any, clickThroughRate?: any, sanities: Array<{ __typename?: 'Sanity', id: string, type: SanityType, name: string }>, timeSeries?: { __typename?: 'CampaignTimeSeries', impressions: { __typename?: 'TimeSeries', dataPoints: Array<{ __typename?: 'TimeSeriesDataPoint', t?: any, v?: number }> }, ltr: { __typename?: 'TimeSeries', dataPoints: Array<{ __typename?: 'TimeSeriesDataPoint', t?: any, v?: number }> } }, ads: Array<{ __typename?: 'AdLegacy', creativeImages: Array<{ __typename?: 'CreativeImageLegacy', id: string }>, creativeRedirect?: { __typename?: 'CreativeRedirectLegacy', id: string } }> } };

export type InitialDataForCreateAdQueryVariables = Exact<{
  id: Scalars['ID'];
  territory: Territory;
}>;


export type InitialDataForCreateAdQuery = { __typename?: 'Query', getLocationParameterValueByTerritory: { __typename?: 'LocationParameterValue', id: string }, campaign?: { __typename?: 'Campaign', id: string, name?: string, startDate?: any, endDate?: any, timeZone?: any, cpm?: any, dailyCap?: any, objective?: any, territory: Territory, targetingVersion: TargetingVersion, order?: { __typename?: 'Order', id: string, endDate?: any, timeZone?: any, advertiser?: { __typename?: 'Advertiser', id: string } }, tags: Array<{ __typename?: 'Tag', id: string, name?: string }>, targetingDefinitionV2?: { __typename?: 'TargetingDefinitionV2', id: string }, targetingDefinition?: { __typename?: 'TargetingDefinition', id: string, masterTargetingTemplates: Array<{ __typename?: 'TargetingTemplate', id: string, name?: string, description?: string, isMasterTemplate?: boolean, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> }>, generalTargetingGroup?: { __typename?: 'TargetingGroup', id: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> } } };

export type AllCampaignsForGraphDataQueryVariables = Exact<{
  filter?: InputMaybe<CampaignFilter>;
  territories: Array<Territory> | Territory;
}>;


export type AllCampaignsForGraphDataQuery = { __typename?: 'Query', allCampaigns: Array<{ __typename?: 'Campaign', id: string, startDate?: any, endDate?: any, timeZone?: any, status?: CampaignStatus, sanities: Array<{ __typename?: 'Sanity', id: string, type: SanityType, name: string }> }> };

export type OffsetPaginateCampaignsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  orderable?: InputMaybe<CampaignOrdering>;
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CampaignFilter>;
  territories: Array<Territory> | Territory;
  orderId?: InputMaybe<Scalars['ID']>;
}>;


export type OffsetPaginateCampaignsQuery = { __typename?: 'Query', offsetPaginateCampaigns?: { __typename?: 'CampaignOffsetPaginationResponse', campaigns?: Array<{ __typename?: 'Campaign', id: string, altId: number, name?: string, pacing?: Pacing, priority?: any, startDate?: any, endDate?: any, status?: CampaignStatus, billingType?: BillingType, timeZone?: any, currency?: any, cpm?: any, frequencyCapCount?: any, frequencyCapValue?: any, frequencyCapTimeUnit?: FrequencyCapTimeUnit, objective?: any, impressions?: any, companionImpressions?: any, estimatedCompletion?: any, ltr?: any, deliveryPace?: any, ownerName?: string, clickThroughRate?: any, archived: boolean, sanities: Array<{ __typename?: 'Sanity', id: string, type: SanityType, name: string }>, order?: { __typename?: 'Order', id: string, name?: string, externalId?: string, advertiser?: { __typename?: 'Advertiser', id: string, name?: string } }, owner?: { __typename?: 'User', id: string, email?: string, status?: UserStatus } }>, pageMetaData?: { __typename?: 'PageMetaData', pageNumber?: number, totalPages?: number, totalItems?: number } } };

export type CampaignAdsQueryVariables = Exact<{
  id: Scalars['ID'];
  territories: Array<Territory> | Territory;
}>;


export type CampaignAdsQuery = { __typename?: 'Query', campaign?: { __typename?: 'Campaign', id: string, altId: number, name?: string, cpm?: any, frequencyCapCount?: any, frequencyCapValue?: any, frequencyCapTimeUnit?: FrequencyCapTimeUnit, dailyCap?: any, owner?: { __typename?: 'User', id: string, email?: string, status?: UserStatus }, order?: { __typename?: 'Order', name?: string, id: string }, ads: Array<{ __typename?: 'AdLegacy', id: string, altId: number, name?: string, status?: AdStatusLegacy, targetingDefinition?: { __typename?: 'TargetingDefinition', id: string, masterTargetingTemplates: Array<{ __typename?: 'TargetingTemplate', id: string, name?: string, description?: string, isMasterTemplate?: boolean, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> }>, generalTargetingGroup?: { __typename?: 'TargetingGroup', id: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> } }> } };

export type CreateCreativeAudioLegacyMutationVariables = Exact<{
  advertiserId: Scalars['ID'];
  type: CreativeTypeLegacy;
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['Url']>;
  trackingUrls?: InputMaybe<Array<TrackingUrlAttributes> | TrackingUrlAttributes>;
  fileName?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['NonNegativeFloat']>;
  uploadedDate?: InputMaybe<Scalars['LocalDateTime']>;
  mimeType?: InputMaybe<Scalars['String']>;
  territory?: InputMaybe<Territory>;
}>;


export type CreateCreativeAudioLegacyMutation = { __typename?: 'Mutation', createCreativeLegacy?: { __typename?: 'CreativeAudioLegacy', id: string, altId: number, name?: string, status?: CreativeStatusLegacy, url?: any, fileName?: string, duration?: any, uploadedDate?: any, resourceAltId: number, mimeType?: string, territory: Territory, trackingUrls: Array<{ __typename?: 'TrackingUrl', url: any, consentVendorId?: any }>, advertiser?: { __typename?: 'Advertiser', name?: string, id: string } } | { __typename?: 'CreativeImageLegacy' } | { __typename?: 'CreativeRedirectLegacy' } };

export type CreateCreativeImageLegacyMutationVariables = Exact<{
  advertiserId: Scalars['ID'];
  type: CreativeTypeLegacy;
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['Url']>;
  trackingUrls?: InputMaybe<Array<TrackingUrlAttributes> | TrackingUrlAttributes>;
  size?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  landingPageUrl?: InputMaybe<Scalars['Url']>;
  fileName?: InputMaybe<Scalars['String']>;
  uploadedDate?: InputMaybe<Scalars['LocalDateTime']>;
  territory?: InputMaybe<Territory>;
}>;


export type CreateCreativeImageLegacyMutation = { __typename?: 'Mutation', createCreativeLegacy?: { __typename?: 'CreativeAudioLegacy' } | { __typename?: 'CreativeImageLegacy', id: string, altId: number, name?: string, status?: CreativeStatusLegacy, url?: any, size?: string, mimeType?: string, landingPageUrl?: any, fileName?: string, uploadedDate?: any, resourceAltId: number, territory: Territory, trackingUrls: Array<{ __typename?: 'TrackingUrl', url: any, consentVendorId?: any }>, advertiser?: { __typename?: 'Advertiser', name?: string, id: string } } | { __typename?: 'CreativeRedirectLegacy' } };

export type CreateCreativeRedirectLegacyMutationVariables = Exact<{
  advertiserId: Scalars['ID'];
  type: CreativeTypeLegacy;
  url?: InputMaybe<Scalars['Url']>;
  trackingUrls?: InputMaybe<Array<TrackingUrlAttributes> | TrackingUrlAttributes>;
  consentVendorId?: InputMaybe<Scalars['NonNegativeInt']>;
  territory?: InputMaybe<Territory>;
}>;


export type CreateCreativeRedirectLegacyMutation = { __typename?: 'Mutation', createCreativeLegacy?: { __typename?: 'CreativeAudioLegacy' } | { __typename?: 'CreativeImageLegacy' } | { __typename?: 'CreativeRedirectLegacy', id: string, url?: any, consentVendorId?: any, territory: Territory, trackingUrls: Array<{ __typename?: 'TrackingUrl', url: any, consentVendorId?: any }> } };

export type UpdateCreativeAudioLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
  type: CreativeTypeLegacy;
  trackingUrls?: InputMaybe<Array<TrackingUrlAttributes> | TrackingUrlAttributes>;
  status?: InputMaybe<CreativeStatusLegacy>;
}>;


export type UpdateCreativeAudioLegacyMutation = { __typename?: 'Mutation', updateCreativeLegacy?: { __typename?: 'CreativeAudioLegacy', id: string } | { __typename?: 'CreativeImageLegacy' } | { __typename?: 'CreativeRedirectLegacy' } };

export type UpdateCreativeImageLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
  type: CreativeTypeLegacy;
  trackingUrls?: InputMaybe<Array<TrackingUrlAttributes> | TrackingUrlAttributes>;
  status?: InputMaybe<CreativeStatusLegacy>;
  landingPageUrl?: InputMaybe<Scalars['Url']>;
}>;


export type UpdateCreativeImageLegacyMutation = { __typename?: 'Mutation', updateCreativeLegacy?: { __typename?: 'CreativeAudioLegacy' } | { __typename?: 'CreativeImageLegacy', id: string } | { __typename?: 'CreativeRedirectLegacy' } };

export type UpdateCreativeRedirectLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
  type: CreativeTypeLegacy;
  url?: InputMaybe<Scalars['Url']>;
  trackingUrls?: InputMaybe<Array<TrackingUrlAttributes> | TrackingUrlAttributes>;
  consentVendorId?: InputMaybe<Scalars['NonNegativeInt']>;
}>;


export type UpdateCreativeRedirectLegacyMutation = { __typename?: 'Mutation', updateCreativeLegacy?: { __typename?: 'CreativeAudioLegacy' } | { __typename?: 'CreativeImageLegacy' } | { __typename?: 'CreativeRedirectLegacy', id: string } };

export type AllAudioCreativesLegacyQueryVariables = Exact<{
  advertiserId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<CreativeFilterLegacy>;
  territories: Array<Territory> | Territory;
}>;


export type AllAudioCreativesLegacyQuery = { __typename?: 'Query', allCreativesLegacy: Array<{ __typename?: 'CreativeAudioLegacy', id: string, name?: string, fileName?: string, url?: any, status?: CreativeStatusLegacy, duration?: any, mimeType?: string, uploadedDate?: any, resourceAltId: number, altId: number, territory: Territory, advertiser?: { __typename?: 'Advertiser', id: string, name?: string } } | { __typename?: 'CreativeImageLegacy' } | { __typename?: 'CreativeRedirectLegacy' }> };

export type AllImageCreativesLegacyQueryVariables = Exact<{
  advertiserId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<CreativeFilterLegacy>;
  territories: Array<Territory> | Territory;
}>;


export type AllImageCreativesLegacyQuery = { __typename?: 'Query', allCreativesLegacy: Array<{ __typename?: 'CreativeAudioLegacy' } | { __typename?: 'CreativeImageLegacy', id: string, name?: string, fileName?: string, url?: any, size?: string, mimeType?: string, status?: CreativeStatusLegacy, uploadedDate?: any, resourceAltId: number, altId: number, territory: Territory, advertiser?: { __typename?: 'Advertiser', id: string, name?: string } } | { __typename?: 'CreativeRedirectLegacy' }> };

export type GeneratePresignedUrlQueryVariables = Exact<{
  contentType?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileSize?: InputMaybe<Scalars['Long']>;
  httpMethod: HttpMethod;
}>;


export type GeneratePresignedUrlQuery = { __typename?: 'Query', generatePreSignedUrl?: { __typename?: 'PreSignedUrl', url: any, assetUrl: any, contentType?: string, uploadedDate: any } };

export type CreateOrderMutationVariables = Exact<{
  advertiserId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSystemId?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['ZoneId']>;
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  objective?: InputMaybe<Scalars['NonNegativeInt']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  frequencyCapCount?: InputMaybe<Scalars['NonNegativeInt']>;
  frequencyCapValue?: InputMaybe<Scalars['NonNegativeInt']>;
  frequencyCapTimeUnit?: InputMaybe<FrequencyCapTimeUnit>;
  territory?: InputMaybe<Territory>;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder?: { __typename?: 'Order', id: string, altId: number, name?: string, startDate?: any, endDate?: any, status?: OrderStatus, externalId?: string, externalSystemId?: string, timeZone?: any, objective?: any, frequencyCapCount?: any, frequencyCapValue?: any, frequencyCapTimeUnit?: FrequencyCapTimeUnit, territory?: Territory, owner?: { __typename?: 'User', id: string, email?: string } } };

export type UpdateOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSystemId?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['ZoneId']>;
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  status?: InputMaybe<OrderStatus>;
  objective?: InputMaybe<Scalars['NonNegativeInt']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  frequencyCapCount?: InputMaybe<Scalars['NonNegativeInt']>;
  frequencyCapValue?: InputMaybe<Scalars['NonNegativeInt']>;
  frequencyCapTimeUnit?: InputMaybe<FrequencyCapTimeUnit>;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder?: { __typename?: 'Order', id: string, name?: string, externalId?: string, externalSystemId?: string, timeZone?: any, startDate?: any, endDate?: any, status?: OrderStatus, objective?: any, frequencyCapCount?: any, frequencyCapValue?: any, frequencyCapTimeUnit?: FrequencyCapTimeUnit, territory?: Territory, owner?: { __typename?: 'User', id: string, email?: string } } };

export type CloneOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  disableCascade?: InputMaybe<Scalars['Boolean']>;
}>;


export type CloneOrderMutation = { __typename?: 'Mutation', cloneOrder?: { __typename?: 'Order', id: string, territory?: Territory } };

export type OrderMinimalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrderMinimalQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, name?: string, startDate?: any, endDate?: any, objective?: any, timeZone?: any, territory?: Territory, externalSystemId?: string, campaigns: Array<{ __typename?: 'Campaign', id: string, objective?: any }>, advertiser?: { __typename?: 'Advertiser', id: string, iabCategories: Array<{ __typename?: 'IabCategory', code: string }> } } };

export type OrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, altId: number, name?: string, startDate?: any, endDate?: any, status?: OrderStatus, externalId?: string, externalSystemId?: string, timeZone?: any, objective?: any, impressions?: any, frequencyCapCount?: any, frequencyCapValue?: any, frequencyCapTimeUnit?: FrequencyCapTimeUnit, territory?: Territory, advertiser?: { __typename?: 'Advertiser', id: string, name?: string, status?: AdvertiserStatus, agency?: { __typename?: 'Agency', id: string, name?: string }, orders: Array<{ __typename?: 'Order', id: string, name?: string }> }, owner?: { __typename?: 'User', id: string, email?: string, status?: UserStatus }, campaigns: Array<{ __typename?: 'Campaign', id: string, altId: number, name?: string, pacing?: Pacing, priority?: any, startDate?: any, endDate?: any, status?: CampaignStatus, timeZone?: any, objective?: any, impressions?: any, companionImpressions?: any, deliveryPace?: any, clickThroughRate?: any, sanities: Array<{ __typename?: 'Sanity', id: string, type: SanityType, name: string }>, owner?: { __typename?: 'User', id: string, email?: string, status?: UserStatus }, order?: { __typename?: 'Order', id: string, advertiser?: { __typename?: 'Advertiser', id: string, name?: string } } }> } };

export type AllOrdersQueryVariables = Exact<{
  advertiserId?: InputMaybe<Scalars['ID']>;
  territories: Array<Territory> | Territory;
}>;


export type AllOrdersQuery = { __typename?: 'Query', allOrders: Array<{ __typename?: 'Order', id: string, altId: number, name?: string, startDate?: any, endDate?: any, timeZone?: any, status?: OrderStatus, externalId?: string, externalSystemId?: string, objective?: any, impressions?: any, territory?: Territory, owner?: { __typename?: 'User', id: string, email?: string, status?: UserStatus } }> };

export type AllOrdersMinimalQueryVariables = Exact<{
  advertiserId?: InputMaybe<Scalars['ID']>;
  territories: Array<Territory> | Territory;
}>;


export type AllOrdersMinimalQuery = { __typename?: 'Query', allOrders: Array<{ __typename?: 'Order', id: string, name?: string, startDate?: any, endDate?: any, objective?: any, territory?: Territory, externalSystemId?: string, campaigns: Array<{ __typename?: 'Campaign', id: string, objective?: any }>, advertiser?: { __typename?: 'Advertiser', id: string, iabCategories: Array<{ __typename?: 'IabCategory', code: string }> } }> };

export type AllIabCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllIabCategoriesQuery = { __typename?: 'Query', allIabCategories: Array<{ __typename?: 'IabCategory', code: string, name?: string, subIabCategories: Array<{ __typename?: 'IabCategory', code: string, name?: string }> }> };

export type PublisherInsightsTimeSeriesQueryVariables = Exact<{
  startDate: Scalars['LocalDateTime'];
  endDate: Scalars['LocalDateTime'];
  metrics?: InputMaybe<Array<PublisherInsightsMetric> | PublisherInsightsMetric>;
  timeZone: Scalars['TimeZone'];
  timeUnit: PublisherInsightsTimeSeriesUnit;
  filters?: InputMaybe<Array<PublisherInsightsFilterAttributes> | PublisherInsightsFilterAttributes>;
  currency: Scalars['Currency'];
  includeWeightingMetrics?: InputMaybe<Scalars['Boolean']>;
}>;


export type PublisherInsightsTimeSeriesQuery = { __typename?: 'Query', publisherInsightsTimeSeries?: Array<{ __typename?: 'PublisherInsightsTimeSeries', metric: PublisherInsightsMetric, metricType: PublisherInsightsMetricType, totalValue: number, currency: any, metricAggregationType: PublisherInsightsMetricAggregationType, weightingMetric?: PublisherInsightsMetric, timeseries: { __typename?: 'TimeSeries', dataPoints: Array<{ __typename?: 'TimeSeriesDataPoint', t?: any, v?: number }> } }> };

export type PublisherInsightsTimeSeriesMinimalQueryVariables = Exact<{
  startDate: Scalars['LocalDateTime'];
  endDate: Scalars['LocalDateTime'];
  metrics?: InputMaybe<Array<PublisherInsightsMetric> | PublisherInsightsMetric>;
  timeZone: Scalars['TimeZone'];
  timeUnit: PublisherInsightsTimeSeriesUnit;
  filters?: InputMaybe<Array<PublisherInsightsFilterAttributes> | PublisherInsightsFilterAttributes>;
  currency: Scalars['Currency'];
}>;


export type PublisherInsightsTimeSeriesMinimalQuery = { __typename?: 'Query', publisherInsightsTimeSeries?: Array<{ __typename?: 'PublisherInsightsTimeSeries', metric: PublisherInsightsMetric, metricType: PublisherInsightsMetricType, totalValue: number, currency: any }> };

export type GetPublisherInsightsFilterCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublisherInsightsFilterCategoriesQuery = { __typename?: 'Query', publisherInsightsFilterCategories?: Array<{ __typename?: 'PublisherInsightsFilterCategory', displayName: string, type: PublisherInsightsFilterType }> };

export type GetPublisherInsightsFiltersQueryVariables = Exact<{
  types?: InputMaybe<Array<PublisherInsightsFilterType> | PublisherInsightsFilterType>;
  territories?: InputMaybe<Array<Territory> | Territory>;
}>;


export type GetPublisherInsightsFiltersQuery = { __typename?: 'Query', publisherInsightsFilters?: Array<{ __typename?: 'PublisherInsightsFilter', type: PublisherInsightsFilterType, values: Array<{ __typename?: 'PublisherInsightsFilterValue', id: string, displayName: string }> }> };

export type InsightsTier2PermissionEntitiesQueryVariables = Exact<{
  territories: Array<Territory> | Territory;
}>;


export type InsightsTier2PermissionEntitiesQuery = { __typename?: 'Query', allNetworksLegacy: Array<{ __typename?: 'NetworkLegacy', id: string, name?: string, publishers: Array<{ __typename?: 'PublisherLegacy', id: string, name?: string, channels: Array<{ __typename?: 'ChannelLegacy', id: string, name?: string, shows: Array<{ __typename?: 'ShowLegacy', show_id: string, name: string }> }> }> }> };

export type CreateChannelLegacyMutationVariables = Exact<{
  floorCpm?: InputMaybe<Scalars['BigDecimal']>;
  locale?: InputMaybe<Scalars['Locale']>;
  name?: InputMaybe<Scalars['String']>;
  publisherId: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['ZoneId']>;
  defaultTranscodePresetId?: InputMaybe<Scalars['ID']>;
  transcodePresetIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  type?: InputMaybe<ChannelType>;
  inventoryType?: InputMaybe<InventoryType>;
  vastVersion?: InputMaybe<VastVersion>;
  blacklistedIabCategoryCodes?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  blacklistedDomains?: InputMaybe<Array<Scalars['DomainName']> | Scalars['DomainName']>;
  blockedKeyValues?: InputMaybe<Array<BlockedKeyValueAttributes> | BlockedKeyValueAttributes>;
  overrideConsentSignal?: InputMaybe<Scalars['Boolean']>;
  trafficAcceptancePercentage?: InputMaybe<Scalars['NonNegativeFloat']>;
  externalDealId?: InputMaybe<Scalars['String']>;
  minAdDuration?: InputMaybe<Scalars['NonNegativeFloat']>;
  maxAdDuration?: InputMaybe<Scalars['NonNegativeFloat']>;
  territories?: InputMaybe<Array<Territory> | Territory>;
  adRequestEnrichment?: InputMaybe<AdRequestEnrichmentAttributes>;
  includedInDefaultInventoryTargeting?: InputMaybe<Scalars['Boolean']>;
  targetingRestrictions?: InputMaybe<Array<TargetingRestriction> | TargetingRestriction>;
}>;


export type CreateChannelLegacyMutation = { __typename?: 'Mutation', createChannelLegacy?: { __typename?: 'ChannelLegacy', territories: Array<Territory>, id: string, altId: number, name?: string, vastVersion?: VastVersion, type?: ChannelType, locale?: any, timeZone?: any, floorCpm?: any, blacklistedDomains: Array<any>, status?: ChannelStatus, externalDealId?: string, overrideConsentSignal?: boolean, trafficAcceptancePercentage?: any, includedInDefaultInventoryTargeting: boolean, minAdDuration?: any, maxAdDuration?: any, defaultTranscodePreset?: { __typename?: 'TranscodePreset', id: string }, transcodePresets: Array<{ __typename?: 'TranscodePreset', id: string, altId: number, name: string, bitRate: any, format: string, mode: SoundMode, sampleRate: any, volume: any }>, publisher?: { __typename?: 'PublisherLegacy', id: string, name?: string }, blacklistedIabCategories: Array<{ __typename?: 'IabCategory', name?: string, code: string }>, adRequestEnrichment?: { __typename?: 'AdRequestEnrichment', parameters: Array<{ __typename?: 'AudienceParameter', type: AudienceParameterType, values: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string }> }>, customKvps: Array<{ __typename?: 'CustomKvp', key: string, value: string, override: boolean }> } } };

export type UpdateChannelLegacyMutationVariables = Exact<{
  territories?: InputMaybe<Array<Territory> | Territory>;
  floorCpm?: InputMaybe<Scalars['BigDecimal']>;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['Locale']>;
  name?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['ZoneId']>;
  defaultTranscodePresetId?: InputMaybe<Scalars['ID']>;
  transcodePresetIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  type?: InputMaybe<ChannelType>;
  inventoryType?: InputMaybe<InventoryType>;
  vastVersion?: InputMaybe<VastVersion>;
  blacklistedIabCategoryCodes?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  blacklistedDomains?: InputMaybe<Array<Scalars['DomainName']> | Scalars['DomainName']>;
  blockedKeyValues?: InputMaybe<Array<BlockedKeyValueAttributes> | BlockedKeyValueAttributes>;
  status?: InputMaybe<ChannelStatus>;
  overrideConsentSignal?: InputMaybe<Scalars['Boolean']>;
  trafficAcceptancePercentage?: InputMaybe<Scalars['NonNegativeFloat']>;
  externalDealId?: InputMaybe<Scalars['String']>;
  minAdDuration?: InputMaybe<Scalars['NonNegativeFloat']>;
  maxAdDuration?: InputMaybe<Scalars['NonNegativeFloat']>;
  adRequestEnrichment?: InputMaybe<AdRequestEnrichmentAttributes>;
  includedInDefaultInventoryTargeting?: InputMaybe<Scalars['Boolean']>;
  targetingRestrictions?: InputMaybe<Array<TargetingRestriction> | TargetingRestriction>;
}>;


export type UpdateChannelLegacyMutation = { __typename?: 'Mutation', updateChannelLegacy?: { __typename?: 'ChannelLegacy', territories: Array<Territory>, id: string, name?: string, vastVersion?: VastVersion, type?: ChannelType, locale?: any, timeZone?: any, floorCpm?: any, blacklistedDomains: Array<any>, status?: ChannelStatus, externalDealId?: string, overrideConsentSignal?: boolean, trafficAcceptancePercentage?: any, includedInDefaultInventoryTargeting: boolean, minAdDuration?: any, maxAdDuration?: any, defaultTranscodePreset?: { __typename?: 'TranscodePreset', id: string }, transcodePresets: Array<{ __typename?: 'TranscodePreset', id: string, altId: number, name: string, bitRate: any, format: string, mode: SoundMode, sampleRate: any, volume: any }>, publisher?: { __typename?: 'PublisherLegacy', id: string }, blacklistedIabCategories: Array<{ __typename?: 'IabCategory', name?: string, code: string }>, adRequestEnrichment?: { __typename?: 'AdRequestEnrichment', parameters: Array<{ __typename?: 'AudienceParameter', type: AudienceParameterType, values: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string }> }>, customKvps: Array<{ __typename?: 'CustomKvp', key: string, value: string, override: boolean }> } } };

export type CreateShowContractMutationVariables = Exact<{
  channelId: Scalars['ID'];
  showId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  directSpotCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  programmaticSpotCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  spotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  sponsorshipRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  hostReadRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  hostReadCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  territories?: InputMaybe<Array<Territory> | Territory>;
  currency?: InputMaybe<Scalars['Currency']>;
  notes?: InputMaybe<Scalars['String']>;
}>;


export type CreateShowContractMutation = { __typename?: 'Mutation', createShowContract?: { __typename?: 'ShowContract', id: string, altId: number, startDate: any, endDate?: any, directSpotCpm?: any, programmaticSpotCpm?: any, spotRevenueShare?: any, hostReadRevenueShare?: any, hostReadCpm?: any, sponsorshipRevenueShare?: any, territories: Array<Territory>, currency?: any, notes?: string, show: { __typename?: 'ShowLegacy', show_id: string, name: string, hostingPlatform: string } } };

export type UpdateShowContractMutationVariables = Exact<{
  id: Scalars['ID'];
  showId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  directSpotCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  programmaticSpotCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  spotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  sponsorshipRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  hostReadRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  hostReadCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  territories?: InputMaybe<Array<Territory> | Territory>;
  currency?: InputMaybe<Scalars['Currency']>;
  notes?: InputMaybe<Scalars['String']>;
}>;


export type UpdateShowContractMutation = { __typename?: 'Mutation', updateShowContract?: { __typename?: 'ShowContract', id: string, altId: number, startDate: any, endDate?: any, directSpotCpm?: any, programmaticSpotCpm?: any, spotRevenueShare?: any, hostReadRevenueShare?: any, hostReadCpm?: any, sponsorshipRevenueShare?: any, territories: Array<Territory>, currency?: any, notes?: string, show: { __typename?: 'ShowLegacy', show_id: string, name: string, hostingPlatform: string } } };

export type ChannelLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ChannelLegacyQuery = { __typename?: 'Query', channelLegacy?: { __typename?: 'ChannelLegacy', id: string, altId: number, territories: Array<Territory>, name?: string, vastVersion?: VastVersion, externalDealId?: string, type?: ChannelType, inventoryType: InventoryType, locale?: any, timeZone?: any, floorCpm?: any, blacklistedDomains: Array<any>, status?: ChannelStatus, overrideConsentSignal?: boolean, trafficAcceptancePercentage?: any, includedInDefaultInventoryTargeting: boolean, targetingRestrictions: Array<TargetingRestriction>, minAdDuration?: any, maxAdDuration?: any, publisher?: { __typename?: 'PublisherLegacy', id: string, name?: string, status?: PublisherStatus, territories: Array<Territory> }, blockedKeyValues: Array<{ __typename?: 'BlockedKeyValues', key: string, values: Array<string> }>, defaultTranscodePreset?: { __typename?: 'TranscodePreset', id: string }, transcodePresets: Array<{ __typename?: 'TranscodePreset', id: string, altId: number, name: string }>, blacklistedIabCategories: Array<{ __typename?: 'IabCategory', name?: string, code: string }>, adRequestEnrichment?: { __typename?: 'AdRequestEnrichment', parameters: Array<{ __typename?: 'AudienceParameter', type: AudienceParameterType, values: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string }> }>, customKvps: Array<{ __typename?: 'CustomKvp', key: string, value: string, override: boolean }> } } };

export type ChannelAssociatedAdsLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
  territories: Array<Territory> | Territory;
}>;


export type ChannelAssociatedAdsLegacyQuery = { __typename?: 'Query', channelLegacy?: { __typename?: 'ChannelLegacy', id: string, associatedAds: Array<{ __typename?: 'AdLegacy', id: string, altId: number, name?: string, status?: AdStatusLegacy, startDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, endDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, campaign?: { __typename?: 'Campaign', id: string, name?: string, timeZone?: any, pacing?: Pacing, owner?: { __typename?: 'User', id: string, email?: string } } }> } };

export type ChannelAssociatedDealsLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
  territories: Array<Territory> | Territory;
}>;


export type ChannelAssociatedDealsLegacyQuery = { __typename?: 'Query', channelLegacy?: { __typename?: 'ChannelLegacy', id: string, associatedDeals: Array<{ __typename?: 'DealLegacy', id: string, altId: number, name?: string, startDate?: any, endDate?: any, timeZone?: any, status?: DealLegacyStatus, priority?: any, salesChannel?: { __typename?: 'SalesChannelLegacy', id: string, name?: string, owner?: { __typename?: 'User', id: string, email?: string } } }> } };

export type ChannelTimeSeriesLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
  timeZone: Scalars['ZoneId'];
}>;


export type ChannelTimeSeriesLegacyQuery = { __typename?: 'Query', channelLegacy?: { __typename?: 'ChannelLegacy', id: string, timeZone?: any, timeSeries?: { __typename?: 'ChannelTimeSeries', impressions?: { __typename?: 'TimeSeries', dataPoints: Array<{ __typename?: 'TimeSeriesDataPoint', t?: any, v?: number }> } } } };

export type AllChannelsMinimalLegacyQueryVariables = Exact<{
  publisherId?: InputMaybe<Scalars['ID']>;
  territories: Array<Territory> | Territory;
}>;


export type AllChannelsMinimalLegacyQuery = { __typename?: 'Query', allChannelsLegacy: Array<{ __typename?: 'ChannelLegacy', id: string, altId: number, name?: string }> };

export type AllChannelsLegacyQueryVariables = Exact<{
  publisherId?: InputMaybe<Scalars['ID']>;
  territories: Array<Territory> | Territory;
}>;


export type AllChannelsLegacyQuery = { __typename?: 'Query', allChannelsLegacy: Array<{ __typename?: 'ChannelLegacy', id: string, altId: number, name?: string, trafficAcceptancePercentage?: any, type?: ChannelType, status?: ChannelStatus, publisher?: { __typename?: 'PublisherLegacy', name?: string, id: string, network?: { __typename?: 'NetworkLegacy', name?: string, id: string } } }> };

export type AllShowContractsQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<ShowContractFilter>;
}>;


export type AllShowContractsQuery = { __typename?: 'Query', allShowContracts: Array<{ __typename?: 'ShowContract', id: string, altId: number, startDate: any, endDate?: any, directSpotCpm?: any, programmaticSpotCpm?: any, spotRevenueShare?: any, hostReadRevenueShare?: any, hostReadCpm?: any, sponsorshipRevenueShare?: any, territories: Array<Territory>, currency?: any, notes?: string, show: { __typename?: 'ShowLegacy', show_id: string, name: string, hostingPlatform: string } }> };

export type AllShowsLegacyQueryVariables = Exact<{ [key: string]: never; }>;


export type AllShowsLegacyQuery = { __typename?: 'Query', allShowsLegacy: Array<{ __typename?: 'ShowLegacy', show_id: string, name: string, hostingPlatform: string }> };

export type AllAdRequestEnrichmentAudienceParametersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAdRequestEnrichmentAudienceParametersQuery = { __typename?: 'Query', allAdRequestEnrichmentAudienceParameters?: Array<{ __typename?: 'AudienceParameterInfo', type: AudienceParameterType, name: string, cardinality: Cardinality }> };

export type AllAdRequestEnrichmentAudienceParameterValuesQueryVariables = Exact<{
  type: AudienceParameterType;
}>;


export type AllAdRequestEnrichmentAudienceParameterValuesQuery = { __typename?: 'Query', allAdRequestEnrichmentAudienceParameterValues?: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string, active: boolean, children: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string, active: boolean, children: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string, active: boolean, children: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string, active: boolean }> }> }> }> };

export type CreateNetworkLegacyMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  territories?: InputMaybe<Array<Territory> | Territory>;
}>;


export type CreateNetworkLegacyMutation = { __typename?: 'Mutation', createNetworkLegacy?: { __typename?: 'NetworkLegacy', id: string, name?: string, altId: number, status?: NetworkStatus, territories: Array<Territory> } };

export type UpdateNetworkLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<NetworkStatus>;
  territories?: InputMaybe<Array<Territory> | Territory>;
}>;


export type UpdateNetworkLegacyMutation = { __typename?: 'Mutation', updateNetworkLegacy?: { __typename?: 'NetworkLegacy', id: string, altId: number, name?: string, status?: NetworkStatus, territories: Array<Territory> } };

export type NetworkLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
  territories: Array<Territory> | Territory;
}>;


export type NetworkLegacyQuery = { __typename?: 'Query', networkLegacy?: { __typename?: 'NetworkLegacy', id: string, altId: number, name?: string, status?: NetworkStatus, territories: Array<Territory>, publishers: Array<{ __typename?: 'PublisherLegacy', id: string, altId: number, name?: string, status?: PublisherStatus, pricingType?: PricingType, pricingAmount?: any, territories: Array<Territory> }> } };

export type NetworkMinimalLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NetworkMinimalLegacyQuery = { __typename?: 'Query', networkLegacy?: { __typename?: 'NetworkLegacy', id: string, name?: string, territories: Array<Territory> } };

export type AllNetworksLegacyQueryVariables = Exact<{
  territories: Array<Territory> | Territory;
}>;


export type AllNetworksLegacyQuery = { __typename?: 'Query', allNetworksLegacy: Array<{ __typename?: 'NetworkLegacy', id: string, altId: number, name?: string, status?: NetworkStatus, territories: Array<Territory> }> };

export type CreatePublisherLegacyMutationVariables = Exact<{
  networkId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  pricingType?: InputMaybe<PricingType>;
  pricingAmount?: InputMaybe<Scalars['BigDecimal']>;
  blacklistedIabCategoryCodes?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  blacklistedDomains?: InputMaybe<Array<Scalars['DomainName']> | Scalars['DomainName']>;
  currency?: InputMaybe<Scalars['Currency']>;
  territories?: InputMaybe<Array<Territory> | Territory>;
}>;


export type CreatePublisherLegacyMutation = { __typename?: 'Mutation', createPublisherLegacy?: { __typename?: 'PublisherLegacy', id: string, altId: number, status?: PublisherStatus, name?: string, currency?: any, territories: Array<Territory>, pricingType?: PricingType, pricingAmount?: any, blacklistedDomains: Array<any>, network?: { __typename?: 'NetworkLegacy', id: string }, blacklistedIabCategories: Array<{ __typename?: 'IabCategory', name?: string, code: string }> } };

export type UpdatePublisherLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  pricingType?: InputMaybe<PricingType>;
  pricingAmount?: InputMaybe<Scalars['BigDecimal']>;
  blacklistedIabCategoryCodes?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  blacklistedDomains?: InputMaybe<Array<Scalars['DomainName']> | Scalars['DomainName']>;
  currency?: InputMaybe<Scalars['Currency']>;
  status?: InputMaybe<PublisherStatus>;
  territories?: InputMaybe<Array<Territory> | Territory>;
}>;


export type UpdatePublisherLegacyMutation = { __typename?: 'Mutation', updatePublisherLegacy?: { __typename?: 'PublisherLegacy', id: string, name?: string, currency?: any, territories: Array<Territory>, pricingType?: PricingType, pricingAmount?: any, blacklistedDomains: Array<any>, status?: PublisherStatus, network?: { __typename?: 'NetworkLegacy', id: string }, blacklistedIabCategories: Array<{ __typename?: 'IabCategory', name?: string, code: string }> } };

export type CreatePublisherContractLegacyMutationVariables = Exact<{
  publisherId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  publisherCategories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  directSpotCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  programmaticSpotCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  hostReadCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  spotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  sponsorshipRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  hostReadRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  minRevenueGuaranteed?: InputMaybe<Scalars['NonNegativeFloat']>;
  minRevenueIdeal?: InputMaybe<Scalars['NonNegativeFloat']>;
  percentFillGuaranteed?: InputMaybe<Scalars['Int']>;
  minInventoryGuaranteed?: InputMaybe<Scalars['NonNegativeFloat']>;
  maxInventoryGuaranteed?: InputMaybe<Scalars['NonNegativeFloat']>;
  currency?: InputMaybe<Scalars['Currency']>;
  territories?: InputMaybe<Array<Territory> | Territory>;
  notes?: InputMaybe<Scalars['String']>;
}>;


export type CreatePublisherContractLegacyMutation = { __typename?: 'Mutation', createPublisherContractLegacy?: { __typename?: 'PublisherContractLegacy', id: string, altId: number, startDate: any, endDate?: any, directSpotCpm?: any, programmaticSpotCpm?: any, hostReadCpm?: any, spotRevenueShare?: any, hostReadRevenueShare?: any, sponsorshipRevenueShare?: any, minRevenueGuaranteed?: any, minRevenueIdeal?: any, minInventoryGuaranteed?: any, maxInventoryGuaranteed?: any, percentFillGuaranteed?: number, currency?: any, territories: Array<Territory>, notes?: string, publisher: { __typename?: 'PublisherLegacy', id: string, name?: string }, publisherCategories?: Array<{ __typename?: 'PublisherCategory', id: string, name: string }> } };

export type UpdatePublisherContractLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  publisherCategories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  directSpotCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  programmaticSpotCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  hostReadCpm?: InputMaybe<Scalars['NonNegativeFloat']>;
  spotRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  sponsorshipRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  hostReadRevenueShare?: InputMaybe<Scalars['NonNegativeFloat']>;
  minRevenueGuaranteed?: InputMaybe<Scalars['NonNegativeFloat']>;
  minRevenueIdeal?: InputMaybe<Scalars['NonNegativeFloat']>;
  percentFillGuaranteed?: InputMaybe<Scalars['Int']>;
  minInventoryGuaranteed?: InputMaybe<Scalars['NonNegativeFloat']>;
  maxInventoryGuaranteed?: InputMaybe<Scalars['NonNegativeFloat']>;
  currency?: InputMaybe<Scalars['Currency']>;
  territories?: InputMaybe<Array<Territory> | Territory>;
  notes?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePublisherContractLegacyMutation = { __typename?: 'Mutation', updatePublisherContractLegacy?: { __typename?: 'PublisherContractLegacy', id: string, altId: number, startDate: any, endDate?: any, directSpotCpm?: any, programmaticSpotCpm?: any, hostReadCpm?: any, spotRevenueShare?: any, hostReadRevenueShare?: any, sponsorshipRevenueShare?: any, minRevenueGuaranteed?: any, minRevenueIdeal?: any, minInventoryGuaranteed?: any, maxInventoryGuaranteed?: any, percentFillGuaranteed?: number, currency?: any, territories: Array<Territory>, notes?: string, publisher: { __typename?: 'PublisherLegacy', id: string, name?: string }, publisherCategories?: Array<{ __typename?: 'PublisherCategory', id: string, name: string }> } };

export type PublisherMinimalLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublisherMinimalLegacyQuery = { __typename?: 'Query', publisherLegacy?: { __typename?: 'PublisherLegacy', id: string, name?: string, blacklistedDomains: Array<any>, territories: Array<Territory>, blacklistedIabCategories: Array<{ __typename?: 'IabCategory', name?: string, code: string }> } };

export type PublisherLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
  territories: Array<Territory> | Territory;
}>;


export type PublisherLegacyQuery = { __typename?: 'Query', publisherLegacy?: { __typename?: 'PublisherLegacy', territories: Array<Territory>, id: string, altId: number, currency?: any, name?: string, pricingType?: PricingType, pricingAmount?: any, blacklistedDomains: Array<any>, status?: PublisherStatus, channels: Array<{ __typename?: 'ChannelLegacy', id: string, altId: number, name?: string, vastVersion?: VastVersion, type?: ChannelType, locale?: any, timeZone?: any, blacklistedDomains: Array<any>, status?: ChannelStatus, territories: Array<Territory>, publisher?: { __typename?: 'PublisherLegacy', id: string, name?: string }, blacklistedIabCategories: Array<{ __typename?: 'IabCategory', name?: string, code: string }> }>, network?: { __typename?: 'NetworkLegacy', id: string, name?: string, status?: NetworkStatus, territories: Array<Territory> }, blacklistedIabCategories: Array<{ __typename?: 'IabCategory', name?: string, code: string }> } };

export type PublisherAssociatedAdsLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
  territories: Array<Territory> | Territory;
}>;


export type PublisherAssociatedAdsLegacyQuery = { __typename?: 'Query', publisherLegacy?: { __typename?: 'PublisherLegacy', id: string, associatedAds: Array<{ __typename?: 'AdLegacy', id: string, altId: number, name?: string, status?: AdStatusLegacy, startDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, endDate: { __typename?: 'InheritableLocalDateTime', isInherited: boolean, value?: any }, campaign?: { __typename?: 'Campaign', id: string, name?: string, timeZone?: any, pacing?: Pacing, owner?: { __typename?: 'User', id: string, email?: string } } }> } };

export type PublisherAssociatedDealsLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
  territories: Array<Territory> | Territory;
}>;


export type PublisherAssociatedDealsLegacyQuery = { __typename?: 'Query', publisherLegacy?: { __typename?: 'PublisherLegacy', id: string, associatedDeals: Array<{ __typename?: 'DealLegacy', id: string, altId: number, name?: string, startDate?: any, endDate?: any, timeZone?: any, status?: DealLegacyStatus, priority?: any, salesChannel?: { __typename?: 'SalesChannelLegacy', id: string, name?: string, owner?: { __typename?: 'User', id: string, email?: string } } }> } };

export type PublisherTimeSeriesLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
  timeZone: Scalars['ZoneId'];
}>;


export type PublisherTimeSeriesLegacyQuery = { __typename?: 'Query', publisherLegacy?: { __typename?: 'PublisherLegacy', id: string, impressionsTimeSeries?: { __typename?: 'TimeSeries', dataPoints: Array<{ __typename?: 'TimeSeriesDataPoint', t?: any, v?: number }> } } };

export type AllPublishersAndChannelsLegacyQueryVariables = Exact<{
  networkId?: InputMaybe<Scalars['ID']>;
  territories: Array<Territory> | Territory;
}>;


export type AllPublishersAndChannelsLegacyQuery = { __typename?: 'Query', allPublishersLegacy: Array<{ __typename?: 'PublisherLegacy', id: string, name?: string, channels: Array<{ __typename?: 'ChannelLegacy', id: string, name?: string }> }> };

export type AllPublisherContractsLegacyQueryVariables = Exact<{
  publisherId: Scalars['ID'];
}>;


export type AllPublisherContractsLegacyQuery = { __typename?: 'Query', allPublisherContractsLegacy: Array<{ __typename?: 'PublisherContractLegacy', id: string, altId: number, startDate: any, endDate?: any, directSpotCpm?: any, programmaticSpotCpm?: any, hostReadCpm?: any, spotRevenueShare?: any, hostReadRevenueShare?: any, sponsorshipRevenueShare?: any, minRevenueGuaranteed?: any, minRevenueIdeal?: any, minInventoryGuaranteed?: any, maxInventoryGuaranteed?: any, percentFillGuaranteed?: number, currency?: any, territories: Array<Territory>, notes?: string, publisher: { __typename?: 'PublisherLegacy', id: string, name?: string }, publisherCategories?: Array<{ __typename?: 'PublisherCategory', id: string, name: string }> }> };

export type AllPublisherCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPublisherCategoriesQuery = { __typename?: 'Query', allPublisherCategories?: Array<{ __typename?: 'PublisherCategory', id: string, name: string }> };

export type CreateTranscodePresetMutationVariables = Exact<{
  bitRate: Scalars['PositiveInt'];
  format: Scalars['String'];
  mode: SoundMode;
  sampleRate: Scalars['PositiveInt'];
  volume: Scalars['NegativeInt'];
  extension?: InputMaybe<Scalars['String']>;
}>;


export type CreateTranscodePresetMutation = { __typename?: 'Mutation', createTranscodePreset?: { __typename?: 'TranscodePreset', id: string, altId: number, name: string, bitRate: any, format: string, mode: SoundMode, sampleRate: any, volume: any, extension?: string } };

export type TranscodePresetQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TranscodePresetQuery = { __typename?: 'Query', transcodePreset?: { __typename?: 'TranscodePreset', id: string, altId: number, name: string, bitRate: any, format: string, mode: SoundMode, sampleRate: any, volume: any } };

export type PrimaryControlMutationVariables = Exact<{
  entity: PrimaryControlEntity;
  state: PrimaryControlState;
  entries: Array<PrimaryControlEntryInput> | PrimaryControlEntryInput;
}>;


export type PrimaryControlMutation = { __typename?: 'Mutation', primaryControl: Array<{ __typename?: 'PrimaryControlEntry', enabled: boolean, territory: Territory }> };

export type UpdateGlobalBlocklistMutationVariables = Exact<{
  domains: Array<Scalars['DomainName']> | Scalars['DomainName'];
  iabCategories: Array<Scalars['ID']> | Scalars['ID'];
  territory: Territory;
}>;


export type UpdateGlobalBlocklistMutation = { __typename?: 'Mutation', updateGlobalBlacklistedDomains: Array<{ __typename?: 'TerritoryToDomains', domains: Array<any> }>, updateGlobalBlacklistedIabCategories: Array<{ __typename?: 'TerritoryToIabCategories', iabCategories: Array<{ __typename?: 'IabCategory', code: string }> }> };

export type PrimaryControlsQueryVariables = Exact<{ [key: string]: never; }>;


export type PrimaryControlsQuery = { __typename?: 'Query', primaryControls: Array<{ __typename?: 'PrimaryControl', entity: PrimaryControlEntity, entries: Array<{ __typename?: 'PrimaryControlEntry', enabled: boolean, territory: Territory }> }> };

export type GlobalBlocklistsQueryVariables = Exact<{
  territories: Array<Territory> | Territory;
}>;


export type GlobalBlocklistsQuery = { __typename?: 'Query', globalBlacklistedDomains: Array<{ __typename?: 'TerritoryToDomains', territory: Territory, domains: Array<any> }>, globalBlacklistedIabCategories: Array<{ __typename?: 'TerritoryToIabCategories', territory: Territory, iabCategories: Array<{ __typename?: 'IabCategory', code: string, name?: string }> }> };

export type UpdateProgrammaticCreativeMutationVariables = Exact<{
  id: Scalars['ID'];
  status?: InputMaybe<ApprovalStatus>;
}>;


export type UpdateProgrammaticCreativeMutation = { __typename?: 'Mutation', updateProgrammaticCreative?: { __typename?: 'ProgrammaticCreative', id: string, status?: ApprovalStatus } };

export type PaginatedProgrammaticCreativesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<ProgrammaticCreativeOrdering>;
  filter?: InputMaybe<ProgrammaticCreativeFilter>;
  territories: Array<Territory> | Territory;
}>;


export type PaginatedProgrammaticCreativesQuery = { __typename?: 'Query', paginateProgrammaticCreatives?: { __typename?: 'ProgrammaticCreativeConnection', edges: Array<{ __typename?: 'ProgrammaticCreativeEdge', cursor: string, node: { __typename?: 'ProgrammaticCreative', id: string, name?: string, type?: ProgrammaticCreativeType, status?: ApprovalStatus, url?: any, iabCategoryCodes: Array<string>, advertiserDomains: Array<string>, firstBidDate?: any, approvalDate?: any, territories: Array<Territory>, spec?: { __typename?: 'ProgrammaticCreativeAudioSpec', duration?: any } | { __typename?: 'ProgrammaticCreativeImageSpec', width?: any, height?: any }, firstSeenDeal?: { __typename?: 'DealLegacy', id: string, name?: string }, deals: Array<{ __typename?: 'DealLegacy', id: string, name?: string }> } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string, endCursor?: string } } };

export type TotalProgrammaticCreativesQueryVariables = Exact<{
  filter?: InputMaybe<ProgrammaticCreativeFilter>;
  territories: Array<Territory> | Territory;
}>;


export type TotalProgrammaticCreativesQuery = { __typename?: 'Query', totalProgrammaticCreatives?: number };

export type AllProgrammaticCreativesMinimalQueryVariables = Exact<{
  filter?: InputMaybe<ProgrammaticCreativeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  territories: Array<Territory> | Territory;
}>;


export type AllProgrammaticCreativesMinimalQuery = { __typename?: 'Query', paginateProgrammaticCreatives?: { __typename?: 'ProgrammaticCreativeConnection', edges: Array<{ __typename?: 'ProgrammaticCreativeEdge', node: { __typename?: 'ProgrammaticCreative', id: string, status?: ApprovalStatus } }> } };

export type CreateDataCenterLegacyMutationVariables = Exact<{
  technicalProviderId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Region>;
  bidUrl?: InputMaybe<Scalars['Url']>;
  maxQps?: InputMaybe<Scalars['NonNegativeInt']>;
}>;


export type CreateDataCenterLegacyMutation = { __typename?: 'Mutation', createDataCenterLegacy?: { __typename?: 'DataCenterLegacy', id: string, altId: number, name?: string, region?: Region, bidUrl?: any, maxQps?: any, status?: DataCenterLegacyStatus, technicalProvider?: { __typename?: 'TechnicalProviderLegacy', id: string } } };

export type UpdateDataCenterLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DataCenterLegacyStatus>;
  region?: InputMaybe<Region>;
  bidUrl?: InputMaybe<Scalars['Url']>;
  maxQps?: InputMaybe<Scalars['NonNegativeInt']>;
}>;


export type UpdateDataCenterLegacyMutation = { __typename?: 'Mutation', updateDataCenterLegacy?: { __typename?: 'DataCenterLegacy', id: string, altId: number, name?: string, status?: DataCenterLegacyStatus, region?: Region, bidUrl?: any, maxQps?: any, technicalProvider?: { __typename?: 'TechnicalProviderLegacy', id: string } } };

export type AllDataCentersLegacyQueryVariables = Exact<{
  technicalProviderId?: InputMaybe<Scalars['ID']>;
}>;


export type AllDataCentersLegacyQuery = { __typename?: 'Query', allDataCentersLegacy: Array<{ __typename?: 'DataCenterLegacy', id: string, altId: number, name?: string, region?: Region, bidUrl?: any, maxQps?: any }> };

export type DataCenterLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DataCenterLegacyQuery = { __typename?: 'Query', dataCenterLegacy?: { __typename?: 'DataCenterLegacy', id: string, altId: number, name?: string, region?: Region, bidUrl?: any, maxQps?: any, status?: DataCenterLegacyStatus, technicalProvider?: { __typename?: 'TechnicalProviderLegacy', id: string, name?: string, status?: TechnicalProviderLegacyStatus } } };

export type CreateDealLegacyMutationVariables = Exact<{
  salesChannelId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  floorCpm?: InputMaybe<Scalars['BigDecimal']>;
  timeZone?: InputMaybe<Scalars['ZoneId']>;
  externalId?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['Currency']>;
  auctionType?: InputMaybe<AuctionType>;
  overridePublisherFloor?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['NonNegativeInt']>;
  privateAuction?: InputMaybe<Scalars['Boolean']>;
  offsetCpm?: InputMaybe<Scalars['BigDecimal']>;
  trusted?: InputMaybe<Scalars['Boolean']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  targetingDefinition?: InputMaybe<TargetingDefinitionAttributes>;
  targetingDefinitionV2?: InputMaybe<TargetingDefinitionV2Attributes>;
  adSeparation?: InputMaybe<Scalars['NonNegativeFloat']>;
  adExclusive?: InputMaybe<Scalars['Boolean']>;
  seatAllocation?: InputMaybe<MultiSeatAllocation>;
  territory?: InputMaybe<Territory>;
  dspIncludedSeats?: InputMaybe<DspIncludedSeats>;
  targetingVersion?: InputMaybe<TargetingVersion>;
}>;


export type CreateDealLegacyMutation = { __typename?: 'Mutation', createDealLegacy?: { __typename?: 'DealLegacy', id: string, altId: number, name?: string, startDate?: any, endDate?: any, floorCpm?: any, timeZone?: any, auctionType?: AuctionType, currency?: any, externalId?: string, overridePublisherFloor?: boolean, priority?: any, privateAuction?: boolean, offsetCpm?: any, status?: DealLegacyStatus, trusted?: boolean, adSeparation?: any, adExclusive?: boolean, dspIncludedSeats: DspIncludedSeats, targetingVersion: TargetingVersion, salesChannel?: { __typename?: 'SalesChannelLegacy', id: string }, owner?: { __typename?: 'User', id: string, email?: string }, dsp?: { __typename?: 'DspLegacy', id: string }, seats: Array<{ __typename?: 'SeatLegacy', id: string }> } };

export type UpdateDealLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['LocalDateTime']>;
  endDate?: InputMaybe<Scalars['LocalDateTime']>;
  status?: InputMaybe<DealLegacyStatus>;
  floorCpm?: InputMaybe<Scalars['BigDecimal']>;
  timeZone?: InputMaybe<Scalars['ZoneId']>;
  externalId?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['Currency']>;
  auctionType?: InputMaybe<AuctionType>;
  overridePublisherFloor?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['NonNegativeInt']>;
  privateAuction?: InputMaybe<Scalars['Boolean']>;
  offsetCpm?: InputMaybe<Scalars['BigDecimal']>;
  trusted?: InputMaybe<Scalars['Boolean']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  targetingDefinition?: InputMaybe<TargetingDefinitionAttributes>;
  targetingDefinitionV2?: InputMaybe<TargetingDefinitionV2Attributes>;
  adSeparation?: InputMaybe<Scalars['NonNegativeFloat']>;
  adExclusive?: InputMaybe<Scalars['Boolean']>;
  seatAllocation?: InputMaybe<MultiSeatAllocation>;
  dspIncludedSeats?: InputMaybe<DspIncludedSeats>;
  territory?: InputMaybe<Territory>;
  targetingVersion?: InputMaybe<TargetingVersion>;
}>;


export type UpdateDealLegacyMutation = { __typename?: 'Mutation', updateDealLegacy?: { __typename?: 'DealLegacy', id: string, altId: number, adSeparation?: any, name?: string, startDate?: any, endDate?: any, status?: DealLegacyStatus, floorCpm?: any, timeZone?: any, auctionType?: AuctionType, currency?: any, externalId?: string, overridePublisherFloor?: boolean, priority?: any, privateAuction?: boolean, offsetCpm?: any, trusted?: boolean, adExclusive?: boolean, dspIncludedSeats: DspIncludedSeats, targetingVersion: TargetingVersion, salesChannel?: { __typename?: 'SalesChannelLegacy', id: string }, owner?: { __typename?: 'User', id: string, email?: string }, dsp?: { __typename?: 'DspLegacy', id: string }, seats: Array<{ __typename?: 'SeatLegacy', id: string }> } };

export type CloneDealLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CloneDealLegacyMutation = { __typename?: 'Mutation', cloneDealLegacy?: { __typename?: 'DealLegacy', id: string } };

export type DealLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DealLegacyQuery = { __typename?: 'Query', dealLegacy?: { __typename?: 'DealLegacy', id: string, altId: number, adSeparation?: any, name?: string, startDate?: any, endDate?: any, status?: DealLegacyStatus, floorCpm?: any, timeZone?: any, auctionType?: AuctionType, currency?: any, externalId?: string, overridePublisherFloor?: boolean, priority?: any, privateAuction?: boolean, offsetCpm?: any, trusted?: boolean, adExclusive?: boolean, territory: Territory, targetingVersion: TargetingVersion, dspIncludedSeats: DspIncludedSeats, seats: Array<{ __typename?: 'SeatLegacy', id: string, name?: string }>, dsp?: { __typename?: 'DspLegacy', id: string, name?: string }, salesChannel?: { __typename?: 'SalesChannelLegacy', id: string, name?: string, status?: SalesChannelLegacyStatus, owner?: { __typename?: 'User', id: string, email?: string, status?: UserStatus } }, programmaticCreatives: Array<{ __typename?: 'ProgrammaticCreative', id: string, name?: string, type?: ProgrammaticCreativeType, status?: ApprovalStatus, url?: any, iabCategoryCodes: Array<string>, advertiserDomains: Array<string>, firstBidDate?: any, approvalDate?: any, spec?: { __typename?: 'ProgrammaticCreativeAudioSpec', duration?: any } | { __typename?: 'ProgrammaticCreativeImageSpec', width?: any, height?: any } }>, owner?: { __typename?: 'User', id: string, email?: string, status?: UserStatus }, targetingDefinition?: { __typename?: 'TargetingDefinition', id: string, masterTargetingTemplates: Array<{ __typename?: 'TargetingTemplate', id: string, name?: string, description?: string, isMasterTemplate?: boolean, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> }>, generalTargetingGroup?: { __typename?: 'TargetingGroup', id: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> }, targetingDefinitionV2?: { __typename?: 'TargetingDefinitionV2', id: string, audienceTargeting?: { __typename?: 'AudienceTargeting', audiences?: Array<{ __typename?: 'AudienceGroup', parameters: Array<{ __typename?: 'AudienceParameter', type: AudienceParameterType, clusivity: Clusivity, enabledGrades?: Array<TargetingGrade>, values: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string, active: boolean, activeGrades?: Array<TargetingGrade> }> }> }> }, locationTargeting?: { __typename?: 'LocationTargeting', locations?: Array<{ __typename?: 'LocationGroup', accuracyRadius?: number, limitLocationParameterValue?: { __typename?: 'LocationParameterValue', id: string }, parameters: Array<{ __typename?: 'LocationParameter', type: LocationParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'LocationParameterValue', id: string, name: string, parents: Array<{ __typename?: 'LocationParameterValue', id: string, name: string }> }> }> }> }, technologyTargeting?: { __typename?: 'TechnologyTargeting', technologies?: Array<{ __typename?: 'TechnologyGroup', parameters: Array<{ __typename?: 'TechnologyParameter', type: TechnologyParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'TechnologyParameterValue', id: string, name: string }> }> }> }, inventoryTargeting?: { __typename?: 'InventoryTargeting', inventories?: Array<{ __typename?: 'InventoryGroup', parameters: Array<{ __typename?: 'InventoryParameter', type: InventoryParameterType, clusivity: Clusivity, values: Array<{ __typename?: 'InventoryParameterValue', id: string, name: string, active: boolean, parents: Array<{ __typename?: 'InventoryParameterValue', id: string, name: string }> }> }> }> }, dayTimeTargeting?: { __typename?: 'DayTimeTargeting', clusivity: Clusivity, timeZone: TimeZoneTargeting, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> }, customTargeting?: { __typename?: 'CustomTargeting', customGroups?: Array<{ __typename?: 'CustomGroup', parameters: Array<{ __typename?: 'CustomParameter', clusivity: Clusivity, customKvps: Array<{ __typename?: 'KeyValue', key: string, value: string }> }> }> } } } };

export type DealTimeSeriesQueryVariables = Exact<{
  id: Scalars['ID'];
  timeZone: Scalars['ZoneId'];
  currency: Scalars['Currency'];
}>;


export type DealTimeSeriesQuery = { __typename?: 'Query', dealLegacy?: { __typename?: 'DealLegacy', id: string, timeZone?: any, timeSeries?: { __typename?: 'DealTimeSeries', impressions?: { __typename?: 'TimeSeries', dataPoints: Array<{ __typename?: 'TimeSeriesDataPoint', t?: any, v?: number }> }, eCpm?: { __typename?: 'TimeSeries', dataPoints: Array<{ __typename?: 'TimeSeriesDataPoint', t?: any, v?: number }> }, advPayout?: { __typename?: 'TimeSeries', dataPoints: Array<{ __typename?: 'TimeSeriesDataPoint', t?: any, v?: number }> }, ltr?: { __typename?: 'TimeSeries', dataPoints: Array<{ __typename?: 'TimeSeriesDataPoint', t?: any, v?: number }> } } } };

export type DealHealthLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
  from?: InputMaybe<Scalars['LocalDate']>;
  until?: InputMaybe<Scalars['LocalDate']>;
}>;


export type DealHealthLegacyQuery = { __typename?: 'Query', dealLegacy?: { __typename?: 'DealLegacy', id: string, health: Array<{ __typename?: 'HealthMetric', id: number, name: string, parentId?: number, childrenIds?: Array<number>, value: number, percentOfParent?: number, category?: HealthMetricCategory, breakdown?: Array<{ __typename?: 'BreakdownEntry', name: string, value: number }> }> } };

export type AllActiveDealsLegacyQueryVariables = Exact<{
  salesChannelId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<DealLegacyFilter>;
  territories: Array<Territory> | Territory;
}>;


export type AllActiveDealsLegacyQuery = { __typename?: 'Query', allDealsLegacy: Array<{ __typename?: 'DealLegacy', id: string, altId: number, name?: string, floorCpm?: any, startDate?: any, endDate?: any, timeZone?: any, status?: DealLegacyStatus, priority?: any, externalId?: string, trusted?: boolean, territory: Territory, owner?: { __typename?: 'User', id: string, email?: string, status?: UserStatus } }> };

export type CreateDspLegacyMutationVariables = Exact<{
  technicalProviderId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  dailyCap?: InputMaybe<Scalars['NonNegativeInt']>;
  maxAds?: InputMaybe<Scalars['NonNegativeInt']>;
  territories?: InputMaybe<Array<Territory> | Territory>;
}>;


export type CreateDspLegacyMutation = { __typename?: 'Mutation', createDspLegacy?: { __typename?: 'DspLegacy', id: string, name?: string, dailyCap?: any, maxAds: any, altId: number, status?: DspLegacyStatus, territories: Array<Territory> } };

export type UpdateDspLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DspLegacyStatus>;
  dailyCap?: InputMaybe<Scalars['NonNegativeInt']>;
  maxAds?: InputMaybe<Scalars['NonNegativeInt']>;
  territories?: InputMaybe<Array<Territory> | Territory>;
}>;


export type UpdateDspLegacyMutation = { __typename?: 'Mutation', updateDspLegacy?: { __typename?: 'DspLegacy', id: string, name?: string, status?: DspLegacyStatus, dailyCap?: any, maxAds: any, altId: number, territories: Array<Territory> } };

export type DspMinimalLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DspMinimalLegacyQuery = { __typename?: 'Query', dspLegacy?: { __typename?: 'DspLegacy', id: string, name?: string, territories: Array<Territory> } };

export type DspLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
  territories?: InputMaybe<Array<Territory> | Territory>;
}>;


export type DspLegacyQuery = { __typename?: 'Query', dspLegacy?: { __typename?: 'DspLegacy', id: string, dailyCap?: any, maxAds: any, name?: string, altId: number, status?: DspLegacyStatus, territories: Array<Territory>, seats: Array<{ __typename?: 'SeatLegacy', id: string, altId: number, name?: string, status?: SeatLegacyStatus, externalSeatId?: string }>, technicalProvider?: { __typename?: 'TechnicalProviderLegacy', id: string, name?: string, status?: TechnicalProviderLegacyStatus, territories: Array<Territory> } } };

export type AllDspsLegacyQueryVariables = Exact<{
  technicalProviderId?: InputMaybe<Scalars['ID']>;
  territories: Array<Territory> | Territory;
}>;


export type AllDspsLegacyQuery = { __typename?: 'Query', allDspsLegacy: Array<{ __typename?: 'DspLegacy', id: string, name?: string, dailyCap?: any, seats: Array<{ __typename?: 'SeatLegacy', id: string, name?: string }>, technicalProvider?: { __typename?: 'TechnicalProviderLegacy', id: string, openSeatDsp?: { __typename?: 'DspLegacy', id: string } } }> };

export type CreateSalesChannelLegacyMutationVariables = Exact<{
  agencyId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['ID']>;
  territory?: InputMaybe<Territory>;
}>;


export type CreateSalesChannelLegacyMutation = { __typename?: 'Mutation', createSalesChannelLegacy?: { __typename?: 'SalesChannelLegacy', id: string, name?: string, altId: number, status?: SalesChannelLegacyStatus, territory: Territory, agency?: { __typename?: 'Agency', id: string, name?: string }, owner?: { __typename?: 'User', id: string, email?: string } } };

export type UpdateSalesChannelLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<SalesChannelLegacyStatus>;
  ownerId?: InputMaybe<Scalars['ID']>;
  territory?: InputMaybe<Territory>;
}>;


export type UpdateSalesChannelLegacyMutation = { __typename?: 'Mutation', updateSalesChannelLegacy?: { __typename?: 'SalesChannelLegacy', id: string, name?: string, status?: SalesChannelLegacyStatus, territory: Territory, agency?: { __typename?: 'Agency', id: string, name?: string }, owner?: { __typename?: 'User', id: string, email?: string } } };

export type AllSalesChannelsLegacyQueryVariables = Exact<{
  agencyId?: InputMaybe<Scalars['ID']>;
  territories: Array<Territory> | Territory;
}>;


export type AllSalesChannelsLegacyQuery = { __typename?: 'Query', allSalesChannelsLegacy: Array<{ __typename?: 'SalesChannelLegacy', id: string, altId: number, name?: string, status?: SalesChannelLegacyStatus, territory: Territory, owner?: { __typename?: 'User', id: string, email?: string, status?: UserStatus } }> };

export type SalesChannelMinimalLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SalesChannelMinimalLegacyQuery = { __typename?: 'Query', salesChannelLegacy?: { __typename?: 'SalesChannelLegacy', id: string, name?: string, territory: Territory, owner?: { __typename?: 'User', id: string, email?: string, status?: UserStatus } } };

export type SalesChannelLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SalesChannelLegacyQuery = { __typename?: 'Query', salesChannelLegacy?: { __typename?: 'SalesChannelLegacy', id: string, altId: number, name?: string, status?: SalesChannelLegacyStatus, territory: Territory, health: Array<{ __typename?: 'HealthMetric', id: number, name: string, parentId?: number, childrenIds?: Array<number>, value: number, percentOfParent?: number, category?: HealthMetricCategory }>, deals: Array<{ __typename?: 'DealLegacy', id: string, altId: number, name?: string, floorCpm?: any, startDate?: any, endDate?: any, timeZone?: any, status?: DealLegacyStatus, priority?: any, externalId?: string, trusted?: boolean, owner?: { __typename?: 'User', id: string, email?: string, status?: UserStatus } }>, agency?: { __typename?: 'Agency', id: string, name?: string, status: AgencyStatus }, owner?: { __typename?: 'User', id: string, email?: string, status?: UserStatus } } };

export type SalesChannelHealthLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
  from?: InputMaybe<Scalars['LocalDate']>;
  until?: InputMaybe<Scalars['LocalDate']>;
}>;


export type SalesChannelHealthLegacyQuery = { __typename?: 'Query', salesChannelLegacy?: { __typename?: 'SalesChannelLegacy', id: string, health: Array<{ __typename?: 'HealthMetric', id: number, name: string, parentId?: number, childrenIds?: Array<number>, value: number, percentOfParent?: number, category?: HealthMetricCategory }> } };

export type CreateSeatLegacyMutationVariables = Exact<{
  dspId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  externalSeatId?: InputMaybe<Scalars['String']>;
  territories?: InputMaybe<Array<Territory> | Territory>;
}>;


export type CreateSeatLegacyMutation = { __typename?: 'Mutation', createSeatLegacy?: { __typename?: 'SeatLegacy', altId: number, externalSeatId?: string, id: string, name?: string, status?: SeatLegacyStatus, territories: Array<Territory> } };

export type UpdateSeatLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<SeatLegacyStatus>;
  externalSeatId?: InputMaybe<Scalars['String']>;
  territories?: InputMaybe<Array<Territory> | Territory>;
}>;


export type UpdateSeatLegacyMutation = { __typename?: 'Mutation', updateSeatLegacy?: { __typename?: 'SeatLegacy', altId: number, externalSeatId?: string, id: string, name?: string, status?: SeatLegacyStatus, territories: Array<Territory> } };

export type SeatLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SeatLegacyQuery = { __typename?: 'Query', seatLegacy?: { __typename?: 'SeatLegacy', altId: number, externalSeatId?: string, id: string, name?: string, status?: SeatLegacyStatus, territories: Array<Territory>, dsp?: { __typename?: 'DspLegacy', id: string, name?: string, status?: DspLegacyStatus, territories: Array<Territory> } } };

export type GenerateUniqueExternalIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GenerateUniqueExternalIdQuery = { __typename?: 'Query', generateUniqueExternalId?: string };

export type CreateTechnicalProviderLegacyMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  userSyncUrl?: InputMaybe<Scalars['Url']>;
  userSyncSecureUrl?: InputMaybe<Scalars['Url']>;
  currency?: InputMaybe<Scalars['Currency']>;
  blockGeoData?: InputMaybe<Scalars['Boolean']>;
  truncateGpsCoords?: InputMaybe<Scalars['Boolean']>;
  blockIpData?: InputMaybe<Scalars['Boolean']>;
  truncateIpAddress?: InputMaybe<Scalars['Boolean']>;
  block1stPartyData?: InputMaybe<Scalars['Boolean']>;
  blockListenerId?: InputMaybe<Scalars['Boolean']>;
  kvps1stPartyData?: InputMaybe<Scalars['String']>;
  gzipCompressed?: InputMaybe<Scalars['Boolean']>;
  sendNotSyncedUsers?: InputMaybe<Scalars['Boolean']>;
  blockSite?: InputMaybe<Scalars['Boolean']>;
  blockApp?: InputMaybe<Scalars['Boolean']>;
  appBundle?: InputMaybe<Scalars['String']>;
  blockPublisher?: InputMaybe<Scalars['Boolean']>;
  publisherId?: InputMaybe<Scalars['String']>;
  publisherTagId?: InputMaybe<Scalars['String']>;
  consentVendorId?: InputMaybe<Scalars['NonNegativeInt']>;
  vastVersions?: InputMaybe<Array<InputMaybe<VastVersion>> | InputMaybe<VastVersion>>;
  dspProvider?: InputMaybe<DspProvider>;
  territories?: InputMaybe<Array<Territory> | Territory>;
  bidFloorPrecision?: InputMaybe<Scalars['NonNegativeInt']>;
}>;


export type CreateTechnicalProviderLegacyMutation = { __typename?: 'Mutation', createTechnicalProviderLegacy?: { __typename?: 'TechnicalProviderLegacy', id: string, altId: number, name?: string, userSyncUrl?: any, userSyncSecureUrl?: any, currency?: any, status?: TechnicalProviderLegacyStatus, blockGeoData?: boolean, truncateGpsCoords?: boolean, blockIpData?: boolean, truncateIpAddress?: boolean, block1stPartyData?: boolean, blockListenerId?: boolean, kvps1stPartyData?: string, gzipCompressed?: boolean, sendNotSyncedUsers?: boolean, blockSite?: boolean, siteName?: string, siteDomain?: string, blockApp?: boolean, appBundle?: string, appName?: string, appDomain?: string, blockPublisher?: boolean, publisherId?: string, publisherName?: string, publisherDomain?: string, publisherTagId?: string, consentVendorId?: any, vastVersions?: Array<VastVersion>, dspProvider?: DspProvider, territories: Array<Territory>, bidFloorPrecision?: any } };

export type UpdateTechnicalProviderLegacyMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TechnicalProviderLegacyStatus>;
  userSyncUrl?: InputMaybe<Scalars['Url']>;
  userSyncSecureUrl?: InputMaybe<Scalars['Url']>;
  currency?: InputMaybe<Scalars['Currency']>;
  blockGeoData?: InputMaybe<Scalars['Boolean']>;
  truncateGpsCoords?: InputMaybe<Scalars['Boolean']>;
  blockIpData?: InputMaybe<Scalars['Boolean']>;
  truncateIpAddress?: InputMaybe<Scalars['Boolean']>;
  block1stPartyData?: InputMaybe<Scalars['Boolean']>;
  blockListenerId?: InputMaybe<Scalars['Boolean']>;
  kvps1stPartyData?: InputMaybe<Scalars['String']>;
  gzipCompressed?: InputMaybe<Scalars['Boolean']>;
  sendNotSyncedUsers?: InputMaybe<Scalars['Boolean']>;
  blockSite?: InputMaybe<Scalars['Boolean']>;
  blockApp?: InputMaybe<Scalars['Boolean']>;
  appBundle?: InputMaybe<Scalars['String']>;
  blockPublisher?: InputMaybe<Scalars['Boolean']>;
  publisherId?: InputMaybe<Scalars['String']>;
  publisherTagId?: InputMaybe<Scalars['String']>;
  consentVendorId?: InputMaybe<Scalars['NonNegativeInt']>;
  vastVersions?: InputMaybe<Array<InputMaybe<VastVersion>> | InputMaybe<VastVersion>>;
  dspProvider?: InputMaybe<DspProvider>;
  territories?: InputMaybe<Array<Territory> | Territory>;
  bidFloorPrecision?: InputMaybe<Scalars['NonNegativeInt']>;
}>;


export type UpdateTechnicalProviderLegacyMutation = { __typename?: 'Mutation', updateTechnicalProviderLegacy?: { __typename?: 'TechnicalProviderLegacy', id: string, altId: number, name?: string, status?: TechnicalProviderLegacyStatus, userSyncUrl?: any, userSyncSecureUrl?: any, currency?: any, blockGeoData?: boolean, truncateGpsCoords?: boolean, blockIpData?: boolean, truncateIpAddress?: boolean, block1stPartyData?: boolean, blockListenerId?: boolean, kvps1stPartyData?: string, gzipCompressed?: boolean, sendNotSyncedUsers?: boolean, blockSite?: boolean, siteName?: string, siteDomain?: string, blockApp?: boolean, appBundle?: string, appName?: string, appDomain?: string, blockPublisher?: boolean, publisherId?: string, publisherName?: string, publisherDomain?: string, publisherTagId?: string, consentVendorId?: any, vastVersions?: Array<VastVersion>, dspProvider?: DspProvider, territories: Array<Territory>, bidFloorPrecision?: any } };

export type AllTechnicalProvidersLegacyQueryVariables = Exact<{
  territories: Array<Territory> | Territory;
}>;


export type AllTechnicalProvidersLegacyQuery = { __typename?: 'Query', allTechnicalProvidersLegacy: Array<{ __typename?: 'TechnicalProviderLegacy', id: string, altId: number, name?: string, status?: TechnicalProviderLegacyStatus, userSyncUrl?: any, userSyncSecureUrl?: any }> };

export type TechnicalProviderLegacyMinimalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TechnicalProviderLegacyMinimalQuery = { __typename?: 'Query', technicalProviderLegacy?: { __typename?: 'TechnicalProviderLegacy', id: string, name?: string, territories: Array<Territory> } };

export type TechnicalProviderLegacyQueryVariables = Exact<{
  id: Scalars['ID'];
  territories?: InputMaybe<Array<Territory> | Territory>;
}>;


export type TechnicalProviderLegacyQuery = { __typename?: 'Query', technicalProviderLegacy?: { __typename?: 'TechnicalProviderLegacy', id: string, altId: number, name?: string, userSyncUrl?: any, userSyncSecureUrl?: any, currency?: any, blockGeoData?: boolean, truncateGpsCoords?: boolean, blockIpData?: boolean, truncateIpAddress?: boolean, block1stPartyData?: boolean, blockListenerId?: boolean, kvps1stPartyData?: string, gzipCompressed?: boolean, sendNotSyncedUsers?: boolean, blockSite?: boolean, siteName?: string, siteDomain?: string, blockApp?: boolean, appBundle?: string, appName?: string, appDomain?: string, blockPublisher?: boolean, publisherId?: string, publisherName?: string, publisherDomain?: string, publisherTagId?: string, status?: TechnicalProviderLegacyStatus, consentVendorId?: any, dspProvider?: DspProvider, vastVersions?: Array<VastVersion>, territories: Array<Territory>, bidFloorPrecision?: any, dataCenters: Array<{ __typename?: 'DataCenterLegacy', id: string, altId: number, name?: string, status?: DataCenterLegacyStatus }>, dsps: Array<{ __typename?: 'DspLegacy', id: string, name?: string, altId: number, status?: DspLegacyStatus }> } };

export type CreateTagMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag?: { __typename?: 'Tag', id: string, name?: string, description?: string } };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag?: { __typename?: 'Tag', id: string, name?: string, description?: string } };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag?: { __typename?: 'Tag', id: string, name?: string, description?: string } };

export type AllTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTagsQuery = { __typename?: 'Query', allTags: Array<{ __typename?: 'Tag', id: string, name?: string, description?: string }> };

export type ListAudienceQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAudienceQuery = { __typename?: 'Query', allAudienceSegments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> };

export type AllBrowserLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBrowserLanguagesQuery = { __typename?: 'Query', allBrowserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> };

export type ListCitiesQueryVariables = Exact<{
  countryCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type ListCitiesQuery = { __typename?: 'Query', allCities: Array<{ __typename?: 'CityResponse', countryCode: string, cities: Array<{ __typename?: 'City', name: string, regionCode?: string, subRegionCode?: string }> }> };

export type AllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCountriesQuery = { __typename?: 'Query', allCountries: Array<{ __typename?: 'Country', code: string, name: string }> };

export type AllDeviceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDeviceTypesQuery = { __typename?: 'Query', allDeviceTypes: Array<string> };

export type AllDeviceOsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDeviceOsQuery = { __typename?: 'Query', allDeviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', name: string, versions: Array<string> }> };

export type AllDeviceMakersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDeviceMakersQuery = { __typename?: 'Query', allDeviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> };

export type ListDmasQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDmasQuery = { __typename?: 'Query', allDmas: Array<{ __typename?: 'Dma', code: number, name: string }> };

export type ListDmpSegmentsQueryVariables = Exact<{
  type: DmpSegmentType;
}>;


export type ListDmpSegmentsQuery = { __typename?: 'Query', allDmpSegments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> };

export type SearchDmpSegmentsQueryVariables = Exact<{
  type: DmpSegmentType;
  text: Scalars['String'];
}>;


export type SearchDmpSegmentsQuery = { __typename?: 'Query', searchDmpSegments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> };

export type AllGenresQueryVariables = Exact<{ [key: string]: never; }>;


export type AllGenresQuery = { __typename?: 'Query', allGenres: Array<string> };

export type SearchIspsQueryVariables = Exact<{
  text: Scalars['String'];
}>;


export type SearchIspsQuery = { __typename?: 'Query', searchIsps: Array<{ __typename?: 'Isp', id: any, name?: string }> };

export type AllItunesCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllItunesCategoriesQuery = { __typename?: 'Query', allItunesCategories: Array<{ __typename?: 'ItunesCategory', name?: string, subItunesCategories: Array<{ __typename?: 'ItunesCategory', name?: string }> }> };

export type CreateCountryGroupMutationVariables = Exact<{
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  countries: Array<CountryGroupElementAttributes> | CountryGroupElementAttributes;
  territory?: InputMaybe<Territory>;
}>;


export type CreateCountryGroupMutation = { __typename?: 'Mutation', createCountryGroup?: { __typename?: 'CountryGroup', id: string, name: string, description?: string, territory: Territory } };

export type UpdateCountryGroupMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  countries: Array<CountryGroupElementAttributes> | CountryGroupElementAttributes;
  territory?: InputMaybe<Territory>;
}>;


export type UpdateCountryGroupMutation = { __typename?: 'Mutation', updateCountryGroup?: { __typename?: 'CountryGroup', id: string, name: string, description?: string, territory: Territory } };

export type DeleteCountryGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCountryGroupMutation = { __typename?: 'Mutation', deleteCountryGroup?: { __typename?: 'CountryGroup', id: string, name: string, description?: string } };

export type ListRegionsQueryVariables = Exact<{
  countryCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type ListRegionsQuery = { __typename?: 'Query', allRegions: Array<{ __typename?: 'GeoRegionResponse', countryCode: string, regions: Array<{ __typename?: 'GeoRegion', code: string, name: string }> }> };

export type AllCountryGroupsQueryVariables = Exact<{
  territories: Array<Territory> | Territory;
}>;


export type AllCountryGroupsQuery = { __typename?: 'Query', allCountryGroups: Array<{ __typename?: 'CountryGroup', id: string, name: string, description?: string, territory: Territory }> };

export type CountryGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CountryGroupQuery = { __typename?: 'Query', countryGroup?: { __typename?: 'CountryGroup', id: string, name: string, description?: string, territory: Territory, countries: Array<{ __typename?: 'CountryGroupElement', code: string, name: string, subdivisions?: Array<{ __typename?: 'CityParam' } | { __typename?: 'RegionParam', code: string, name: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> }> } };

export type ListSubRegionsQueryVariables = Exact<{
  countryCode: Scalars['String'];
  regionCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type ListSubRegionsQuery = { __typename?: 'Query', allSubRegions: Array<{ __typename?: 'GeoRegionResponse', countryCode: string, regions: Array<{ __typename?: 'GeoRegion', code: string, name: string }> }> };

export type AllAudienceParametersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAudienceParametersQuery = { __typename?: 'Query', allAudienceParameters?: Array<{ __typename?: 'AudienceParameterInfo', type: AudienceParameterType, name: string, cardinality: Cardinality }> };

export type AudienceParameterValuesQueryVariables = Exact<{
  type: AudienceParameterType;
  territory: Territory;
}>;


export type AudienceParameterValuesQuery = { __typename?: 'Query', audienceParameterValues?: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string, active: boolean, activeGrades?: Array<TargetingGrade>, children: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string, active: boolean, activeGrades?: Array<TargetingGrade>, children: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string, active: boolean, activeGrades?: Array<TargetingGrade>, children: Array<{ __typename?: 'AudienceParameterValue', id: string, name: string, active: boolean, activeGrades?: Array<TargetingGrade> }> }> }> }> };

export type AllInventoryParametersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllInventoryParametersQuery = { __typename?: 'Query', allInventoryParameters?: Array<{ __typename?: 'InventoryParameterInfo', type: InventoryParameterType, name: string, cardinality: Cardinality }> };

export type InventoryParameterValuesQueryVariables = Exact<{
  type: InventoryParameterType;
  territory: Territory;
  status?: InputMaybe<InventoryStatus>;
}>;


export type InventoryParameterValuesQuery = { __typename?: 'Query', inventoryParameterValues?: Array<{ __typename?: 'InventoryParameterValue', id: string, name: string, children: Array<{ __typename?: 'InventoryParameterValue', id: string, name: string, children: Array<{ __typename?: 'InventoryParameterValue', id: string, name: string, children: Array<{ __typename?: 'InventoryParameterValue', id: string, name: string }> }> }> }> };

export type AllLocationParametersQueryVariables = Exact<{
  territory?: InputMaybe<Territory>;
}>;


export type AllLocationParametersQuery = { __typename?: 'Query', allLocationParameters?: Array<{ __typename?: 'LocationParameterInfo', type: LocationParameterType, name: string, cardinality: Cardinality }> };

export type LocationParameterValuesQueryVariables = Exact<{
  type: LocationParameterType;
  search?: InputMaybe<Scalars['String']>;
}>;


export type LocationParameterValuesQuery = { __typename?: 'Query', locationParameterValues?: Array<{ __typename?: 'LocationParameterValue', id: string, name: string, children: Array<{ __typename?: 'LocationParameterValue', id: string, name: string, children: Array<{ __typename?: 'LocationParameterValue', id: string, name: string, children: Array<{ __typename?: 'LocationParameterValue', id: string, name: string }> }> }> }> };

export type AllLocationAccuraciesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllLocationAccuraciesQuery = { __typename?: 'Query', allLocationAccuracies: { __typename?: 'LocationAccuracies', defaultValue: number, allValues?: Array<number> } };

export type GetLocationParameterValueByTerritoryQueryVariables = Exact<{
  territory: Territory;
}>;


export type GetLocationParameterValueByTerritoryQuery = { __typename?: 'Query', getLocationParameterValueByTerritory: { __typename?: 'LocationParameterValue', id: string } };

export type AllRegionPacksQueryVariables = Exact<{
  territories: Array<Territory> | Territory;
}>;


export type AllRegionPacksQuery = { __typename?: 'Query', allRegionPacks?: Array<{ __typename?: 'LocationParameterValue', id: string, name: string }> };

export type ValidateZipcodesQueryVariables = Exact<{
  postcodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type ValidateZipcodesQuery = { __typename?: 'Query', validatePostcodes: { __typename?: 'ValidatePostcodesResponse', valid: Array<string>, invalid: Array<string> } };

export type AllTechnologyParametersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTechnologyParametersQuery = { __typename?: 'Query', allTechnologyParameters?: Array<{ __typename?: 'TechnologyParameterInfo', type: TechnologyParameterType, name: string, cardinality: Cardinality }> };

export type TechnologyParameterValuesQueryVariables = Exact<{
  type: TechnologyParameterType;
  search?: InputMaybe<Scalars['String']>;
}>;


export type TechnologyParameterValuesQuery = { __typename?: 'Query', technologyParameterValues?: Array<{ __typename?: 'TechnologyParameterValue', id: string, name: string, children: Array<{ __typename?: 'TechnologyParameterValue', id: string, name: string }> }> };

export type CreateUserMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<PermissionName> | PermissionName>;
  territories: Array<Territory> | Territory;
  primaryTerritory?: InputMaybe<Territory>;
  entityPermissions?: InputMaybe<Array<EntityPermissionAttributes> | EntityPermissionAttributes>;
  userType?: InputMaybe<UserType>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', id: string, email?: string, territories?: Array<Territory>, primaryTerritory?: Territory, userType?: UserType, permissions: Array<{ __typename?: 'Permission', id: string, name?: PermissionName }>, entityPermissions?: Array<{ __typename?: 'EntityPermission', entityName?: string, entityId: string, entityType: EntityType }> } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<PermissionName> | PermissionName>;
  territories: Array<Territory> | Territory;
  primaryTerritory?: InputMaybe<Territory>;
  entityPermissions?: InputMaybe<Array<EntityPermissionAttributes> | EntityPermissionAttributes>;
  userType?: InputMaybe<UserType>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, email?: string, territories?: Array<Territory>, primaryTerritory?: Territory, userType?: UserType, permissions: Array<{ __typename?: 'Permission', id: string, name?: PermissionName }>, entityPermissions?: Array<{ __typename?: 'EntityPermission', entityName?: string, entityId: string, entityType: EntityType }> } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'User', id: string, email?: string, permissions: Array<{ __typename?: 'Permission', id: string, name?: PermissionName }> } };

export type InviteUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser?: { __typename?: 'User', email?: string } };

export type AllUserTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUserTypesQuery = { __typename?: 'Query', allUserTypes: Array<{ __typename?: 'UserTypeInfo', userType: UserType, displayName: string }> };

export type AllUsersQueryVariables = Exact<{
  permissions?: InputMaybe<Array<PermissionName> | PermissionName>;
  territories: Array<Territory> | Territory;
}>;


export type AllUsersQuery = { __typename?: 'Query', allUsers: Array<{ __typename?: 'User', id: string, email?: string, status?: UserStatus, permissions: Array<{ __typename?: 'Permission', id: string, name?: PermissionName }> }> };

export type UserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email?: string, status?: UserStatus, territories?: Array<Territory>, primaryTerritory?: Territory, userType?: UserType, permissions: Array<{ __typename?: 'Permission', id: string, name?: PermissionName }>, entityPermissions?: Array<{ __typename?: 'EntityPermission', entityName?: string, entityId: string, entityType: EntityType }> } };

export type AllAffectedEntitiesQueryVariables = Exact<{
  targetStatus: EntityStatus;
  entityAttributes: EntityAttributes;
}>;


export type AllAffectedEntitiesQuery = { __typename?: 'Query', allAffectedEntities: Array<{ __typename?: 'EntityIdentity', id: string, entityType: EntityType }> };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, email?: string, primaryTerritory?: Territory, territories?: Array<Territory>, userType?: UserType, permissions: Array<{ __typename?: 'Permission', id: string, name?: PermissionName, featureToggles: Array<{ __typename?: 'FeatureToggle', id: string, name?: string, toggled?: boolean }> }>, entityPermissions?: Array<{ __typename?: 'EntityPermission', entityId: string, entityType: EntityType }> } };

export type SearchPostcodesQueryVariables = Exact<{
  postcode: Scalars['String'];
}>;


export type SearchPostcodesQuery = { __typename?: 'Query', searchPostcodes: Array<string> };

export type ValidatePostcodesQueryVariables = Exact<{
  postcodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type ValidatePostcodesQuery = { __typename?: 'Query', validatePostcodes: { __typename?: 'ValidatePostcodesResponse', valid: Array<string>, invalid: Array<string> } };

export type SearchQueryVariables = Exact<{
  filter: SearchFilter;
  territories: Array<Territory> | Territory;
}>;


export type SearchQuery = { __typename?: 'Query', search: Array<{ __typename?: 'SearchResult', id: string, altId: number, name: string, type: EntityType, status?: EntityStatus }> };

export type CreatePostcodeGroupMutationVariables = Exact<{
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  postcodes: Array<Scalars['String']> | Scalars['String'];
  territory?: InputMaybe<Territory>;
}>;


export type CreatePostcodeGroupMutation = { __typename?: 'Mutation', createPostcodeGroup?: { __typename?: 'PostcodeGroup', id: string, name: string, description?: string, territory: Territory } };

export type UpdatePostcodeGroupMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  postcodes: Array<Scalars['String']> | Scalars['String'];
  territory?: InputMaybe<Territory>;
}>;


export type UpdatePostcodeGroupMutation = { __typename?: 'Mutation', updatePostcodeGroup?: { __typename?: 'PostcodeGroup', id: string, name: string, description?: string, territory: Territory } };

export type DeletePostcodeGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePostcodeGroupMutation = { __typename?: 'Mutation', deletePostcodeGroup?: { __typename?: 'PostcodeGroup', id: string, name: string, description?: string } };

export type PostcodeGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostcodeGroupQuery = { __typename?: 'Query', postcodeGroup?: { __typename?: 'PostcodeGroup', id: string, name: string, description?: string, postcodes: Array<string>, territory: Territory } };

export type AllPostcodeGroupsQueryVariables = Exact<{
  territories: Array<Territory> | Territory;
}>;


export type AllPostcodeGroupsQuery = { __typename?: 'Query', allPostcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string, description?: string, territory: Territory }> };

export type CreateTargetingTemplateMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  isMasterTemplate?: InputMaybe<Scalars['Boolean']>;
  generalTargetingGroup?: InputMaybe<TargetingGroupAttributes>;
  targetingGroups?: InputMaybe<Array<TargetingGroupAttributes> | TargetingGroupAttributes>;
  territory?: InputMaybe<Territory>;
}>;


export type CreateTargetingTemplateMutation = { __typename?: 'Mutation', createTargetingTemplate?: { __typename?: 'TargetingTemplate', id: string, name?: string, description?: string, isMasterTemplate?: boolean, territory: Territory, targetingGroups: Array<{ __typename?: 'TargetingGroup', listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> } };

export type UpdateTargetingTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  generalTargetingGroup?: InputMaybe<TargetingGroupAttributes>;
  targetingGroups?: InputMaybe<Array<TargetingGroupAttributes> | TargetingGroupAttributes>;
  territory?: InputMaybe<Territory>;
}>;


export type UpdateTargetingTemplateMutation = { __typename?: 'Mutation', updateTargetingTemplate?: { __typename?: 'TargetingTemplate', id: string, name?: string, description?: string, isMasterTemplate?: boolean, territory: Territory, targetingGroups: Array<{ __typename?: 'TargetingGroup', listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> } };

export type TargetingTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TargetingTemplateQuery = { __typename?: 'Query', targetingTemplate?: { __typename?: 'TargetingTemplate', id: string, name?: string, description?: string, isMasterTemplate?: boolean, status?: TargetingTemplateStatus, territory: Territory, assignedTo?: Array<{ __typename: 'AdLegacy', id: string, name?: string, altId: number, adStatus?: AdStatusLegacy } | { __typename: 'DealLegacy', id: string, name?: string, altId: number, dealStatus?: DealLegacyStatus }>, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, listenerAccuracy?: any, channels: Array<{ __typename?: 'ChannelLegacy', id: string, name?: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> } };

export type AllTargetingTemplatesQueryVariables = Exact<{
  territories: Array<Territory> | Territory;
}>;


export type AllTargetingTemplatesQuery = { __typename?: 'Query', allTargetingTemplates: Array<{ __typename?: 'TargetingTemplate', id: string, name?: string, description?: string, isMasterTemplate?: boolean, status?: TargetingTemplateStatus, targetingGroups: Array<{ __typename?: 'TargetingGroup', id: string, masterTargetingGroupId?: string, channels: Array<{ __typename?: 'ChannelLegacy', id: string, name?: string }>, audienceParams: Array<{ __typename?: 'AdPositionParam', clusivity: Clusivity, positions: Array<{ __typename?: 'AdPositionUnit', position: AdPosition, midRollPositions: Array<any> }> } | { __typename?: 'AgeParam', clusivity: Clusivity, ageRange: { __typename?: 'AgeRange', minAge: any, maxAge: any } } | { __typename?: 'AudienceSegmentParam', clusivity: Clusivity, segments: Array<{ __typename?: 'AudienceSegment', id: number, displayName: string }> } | { __typename?: 'BrowserLanguageParam', clusivity: Clusivity, browserLanguages: Array<{ __typename?: 'BrowserLanguage', description: string, code: string }> } | { __typename?: 'ComplexKvpParam' } | { __typename?: 'ConnectionTypeParam', clusivity: Clusivity, connectionTypes: Array<ConnectionType> } | { __typename?: 'CountryParam', code?: string, name?: string, clusivity: Clusivity, countryGroups: Array<{ __typename?: 'CountryGroup', name: string, id: string }>, subdivisions?: Array<{ __typename?: 'CityParam', name: string, regionCode?: string, subRegionCode?: string } | { __typename?: 'RegionParam', name: string, code: string, subRegions?: Array<{ __typename?: 'GeoRegion', name: string, code: string }> }> } | { __typename?: 'DayAndTimeParam', timeZone: TimeZoneTargeting, clusivity: Clusivity, daysOfWeek: Array<{ __typename?: 'DayOfWeek', day: DayTargeting, hours: Array<any> }> } | { __typename?: 'DeviceMakerParam', clusivity: Clusivity, deviceMakers: Array<{ __typename?: 'DeviceMaker', name: string, models: Array<string> }> } | { __typename?: 'DeviceOperatingSystemParam', clusivity: Clusivity, deviceOperatingSystems: Array<{ __typename?: 'OperatingSystem', versions: Array<string>, name: string }> } | { __typename?: 'DeviceTypeParam', deviceTypes: Array<string>, clusivity: Clusivity } | { __typename?: 'DmaParam', clusivity: Clusivity, dmas: Array<{ __typename?: 'Dma', code: number, name: string }> } | { __typename?: 'DmpSegmentParam', segmentType: DmpSegmentType, clusivity: Clusivity, segments: Array<{ __typename?: 'NielsenSegment', id: number, fullName: string }> } | { __typename?: 'GenderParam', genders: Array<Gender>, clusivity: Clusivity } | { __typename?: 'GenreParam', genres: Array<string>, clusivity: Clusivity } | { __typename?: 'IspParam', clusivity: Clusivity, isps: Array<{ __typename?: 'Isp', id: any, name?: string }> } | { __typename?: 'ItunesCategoryParam', categories: Array<string>, clusivity: Clusivity } | { __typename?: 'KeyValueGroupParam', clusivity: Clusivity, keyValues: Array<{ __typename?: 'KeyValue', key: string, value: string }> } | { __typename?: 'LocationParam', clusivity: Clusivity, positions: Array<{ __typename?: 'Position', latitude: number, longitude: number, radius: number }> } | { __typename?: 'PodcastParam', clusivity: Clusivity, podcastTargets: Array<{ __typename?: 'PodcastTarget', collectionId?: string, episodeId?: string, showId?: string, name?: string }> } | { __typename?: 'PostalCodeParam', postalCodes: Array<string>, clusivity: Clusivity, postcodeGroups: Array<{ __typename?: 'PostcodeGroup', id: string, name: string }> }> }> }> };

export type AllTargetingTemplatesMinimalQueryVariables = Exact<{
  territories: Array<Territory> | Territory;
}>;


export type AllTargetingTemplatesMinimalQuery = { __typename?: 'Query', allTargetingTemplates: Array<{ __typename?: 'TargetingTemplate', id: string, name?: string, description?: string, isMasterTemplate?: boolean, status?: TargetingTemplateStatus }> };

export const AdFragmentFragmentDoc = gql`
    fragment AdFragment on AdLegacy {
  altId
  startDate {
    isInherited
    value
  }
  endDate {
    isInherited
    value
  }
  duration
  targetingRestrictions
  targetingDefinition {
    id
    masterTargetingTemplates {
      id
      name
      description
      isMasterTemplate
      targetingGroups {
        id
        masterTargetingGroupId
        listenerAccuracy
        channels {
          id
        }
        audienceParams {
          ... on KeyValueGroupParam {
            keyValues {
              key
              value
            }
            clusivity
          }
          ... on AgeParam {
            ageRange {
              minAge
              maxAge
            }
            clusivity
          }
          ... on GenderParam {
            genders
            clusivity
          }
          ... on DayAndTimeParam {
            timeZone
            daysOfWeek {
              day
              hours
            }
            clusivity
          }
          ... on DeviceTypeParam {
            deviceTypes
            clusivity
          }
          ... on DeviceOperatingSystemParam {
            deviceOperatingSystems {
              versions
              name
            }
            clusivity
          }
          ... on ConnectionTypeParam {
            clusivity
            connectionTypes
          }
          ... on DeviceMakerParam {
            deviceMakers {
              name
              models
            }
            clusivity
          }
          ... on BrowserLanguageParam {
            browserLanguages {
              description
              code
            }
            clusivity
          }
          ... on PostalCodeParam {
            postalCodes
            postcodeGroups {
              id
              name
            }
            clusivity
          }
          ... on LocationParam {
            positions {
              latitude
              longitude
              radius
            }
            clusivity
          }
          ... on DmpSegmentParam {
            segmentType
            segments {
              ... on NielsenSegment {
                id
                fullName
              }
            }
            clusivity
          }
          ... on DmaParam {
            dmas {
              code
              name
            }
            clusivity
          }
          ... on AudienceSegmentParam {
            segments {
              id
              displayName
            }
            clusivity
          }
          ... on GenreParam {
            genres
            clusivity
          }
          ... on ItunesCategoryParam {
            categories
            clusivity
          }
          ... on PodcastParam {
            podcastTargets {
              collectionId
              episodeId
              showId
              name
            }
            clusivity
          }
          ... on AdPositionParam {
            positions {
              position
              midRollPositions
            }
            clusivity
          }
          ... on IspParam {
            isps {
              id
              name
            }
            clusivity
          }
          ... on CountryParam {
            code
            name
            clusivity
            countryGroups {
              name
              id
            }
            subdivisions {
              ... on CityParam {
                name
                regionCode
                subRegionCode
              }
              ... on RegionParam {
                name
                code
                subRegions {
                  name
                  code
                }
              }
            }
          }
        }
      }
    }
    generalTargetingGroup {
      id
      listenerAccuracy
      channels {
        id
      }
      audienceParams {
        ... on KeyValueGroupParam {
          keyValues {
            key
            value
          }
          clusivity
        }
        ... on AgeParam {
          ageRange {
            minAge
            maxAge
          }
          clusivity
        }
        ... on GenderParam {
          genders
          clusivity
        }
        ... on DayAndTimeParam {
          timeZone
          daysOfWeek {
            day
            hours
          }
          clusivity
        }
        ... on DeviceTypeParam {
          deviceTypes
          clusivity
        }
        ... on DeviceOperatingSystemParam {
          deviceOperatingSystems {
            versions
            name
          }
          clusivity
        }
        ... on ConnectionTypeParam {
          clusivity
          connectionTypes
        }
        ... on DeviceMakerParam {
          deviceMakers {
            name
            models
          }
          clusivity
        }
        ... on BrowserLanguageParam {
          browserLanguages {
            description
            code
          }
          clusivity
        }
        ... on PostalCodeParam {
          postalCodes
          postcodeGroups {
            id
            name
          }
          clusivity
        }
        ... on LocationParam {
          positions {
            latitude
            longitude
            radius
          }
          clusivity
        }
        ... on DmpSegmentParam {
          segmentType
          segments {
            ... on NielsenSegment {
              id
              fullName
            }
          }
          clusivity
        }
        ... on DmaParam {
          dmas {
            code
            name
          }
          clusivity
        }
        ... on AudienceSegmentParam {
          segments {
            id
            displayName
          }
          clusivity
        }
        ... on GenreParam {
          genres
          clusivity
        }
        ... on ItunesCategoryParam {
          categories
          clusivity
        }
        ... on PodcastParam {
          podcastTargets {
            collectionId
            episodeId
            showId
            name
          }
          clusivity
        }
        ... on AdPositionParam {
          positions {
            position
            midRollPositions
          }
          clusivity
        }
        ... on IspParam {
          isps {
            id
            name
          }
          clusivity
        }
        ... on CountryParam {
          code
          name
          clusivity
          countryGroups {
            name
            id
          }
          subdivisions {
            ... on CityParam {
              name
              regionCode
              subRegionCode
            }
            ... on RegionParam {
              name
              code
              subRegions {
                name
                code
              }
            }
          }
        }
      }
    }
    targetingGroups {
      id
      masterTargetingGroupId
      listenerAccuracy
      channels {
        id
      }
      audienceParams {
        ... on KeyValueGroupParam {
          keyValues {
            key
            value
          }
          clusivity
        }
        ... on AgeParam {
          ageRange {
            minAge
            maxAge
          }
          clusivity
        }
        ... on GenderParam {
          genders
          clusivity
        }
        ... on DayAndTimeParam {
          timeZone
          daysOfWeek {
            day
            hours
          }
          clusivity
        }
        ... on DeviceTypeParam {
          deviceTypes
          clusivity
        }
        ... on DeviceOperatingSystemParam {
          deviceOperatingSystems {
            versions
            name
          }
          clusivity
        }
        ... on ConnectionTypeParam {
          clusivity
          connectionTypes
        }
        ... on DeviceMakerParam {
          deviceMakers {
            name
            models
          }
          clusivity
        }
        ... on BrowserLanguageParam {
          browserLanguages {
            description
            code
          }
          clusivity
        }
        ... on PostalCodeParam {
          postalCodes
          postcodeGroups {
            id
            name
          }
          clusivity
        }
        ... on LocationParam {
          positions {
            latitude
            longitude
            radius
          }
          clusivity
        }
        ... on DmpSegmentParam {
          segmentType
          segments {
            ... on NielsenSegment {
              id
              fullName
            }
          }
          clusivity
        }
        ... on DmaParam {
          dmas {
            code
            name
          }
          clusivity
        }
        ... on AudienceSegmentParam {
          segments {
            id
            displayName
          }
          clusivity
        }
        ... on GenreParam {
          genres
          clusivity
        }
        ... on ItunesCategoryParam {
          categories
          clusivity
        }
        ... on PodcastParam {
          podcastTargets {
            collectionId
            episodeId
            showId
            name
          }
          clusivity
        }
        ... on AdPositionParam {
          positions {
            position
            midRollPositions
          }
          clusivity
        }
        ... on IspParam {
          isps {
            id
            name
          }
          clusivity
        }
        ... on CountryParam {
          code
          name
          clusivity
          countryGroups {
            name
            id
          }
          subdivisions {
            ... on CityParam {
              name
              regionCode
              subRegionCode
            }
            ... on RegionParam {
              name
              code
              subRegions {
                name
                code
              }
            }
          }
        }
      }
    }
  }
  targetingDefinitionV2 {
    id
    audienceTargeting {
      audiences {
        parameters {
          type
          clusivity
          values {
            id
            name
            active
            activeGrades
          }
          enabledGrades
        }
      }
    }
    locationTargeting {
      locations {
        limitLocationParameterValue {
          id
        }
        accuracyRadius
        parameters {
          type
          clusivity
          values {
            id
            name
            parents {
              id
              name
            }
          }
        }
      }
    }
    technologyTargeting {
      technologies {
        parameters {
          type
          clusivity
          values {
            id
            name
          }
        }
      }
    }
    inventoryTargeting {
      inventories {
        parameters {
          type
          clusivity
          values {
            id
            name
            active
            parents {
              id
              name
            }
          }
        }
      }
    }
    dayTimeTargeting {
      clusivity
      timeZone
      daysOfWeek {
        day
        hours
      }
    }
    customTargeting {
      customGroups {
        parameters {
          clusivity
          customKvps {
            key
            value
          }
        }
      }
    }
  }
}
    `;
export const CampaignFragmentFragmentDoc = gql`
    fragment CampaignFragment on Campaign {
  timeZone
  targetingVersion
}
    `;
export const AuditTrailDocument = gql`
    query AuditTrail($filter: AuditTrailFilter!) {
  auditTrail(for: $filter) {
    changeType
    changedAt
    changedBy {
      email
      status
    }
    changedByAssumed {
      email
      status
    }
  }
}
    `;

/**
 * __useAuditTrailQuery__
 *
 * To run a query within a React component, call `useAuditTrailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditTrailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditTrailQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAuditTrailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AuditTrailQuery, AuditTrailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AuditTrailQuery, AuditTrailQueryVariables>(AuditTrailDocument, options);
      }
export function useAuditTrailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AuditTrailQuery, AuditTrailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AuditTrailQuery, AuditTrailQueryVariables>(AuditTrailDocument, options);
        }
export type AuditTrailQueryHookResult = ReturnType<typeof useAuditTrailQuery>;
export type AuditTrailLazyQueryHookResult = ReturnType<typeof useAuditTrailLazyQuery>;
export type AuditTrailQueryResult = ApolloReactCommon.QueryResult<AuditTrailQuery, AuditTrailQueryVariables>;
export const CreateAdLegacyDocument = gql`
    mutation createAdLegacy($creativeAudioId: ID, $creativeImageIds: [ID!], $creativeRedirectId: ID, $campaignId: ID!, $name: String, $startDate: InheritableLocalDateTimeAttributes, $endDate: InheritableLocalDateTimeAttributes, $status: AdStatusLegacy, $frequencyCapCount: NonNegativeInt, $frequencyCapValue: NonNegativeInt, $frequencyCapTimeUnit: FrequencyCapTimeUnit, $weighting: NonNegativeInt, $sequence: [ID!], $duration: NonNegativeFloat, $tagIds: [ID!], $tagsAreInherited: Boolean, $dailyCap: NonNegativeInt, $targetingDefinition: TargetingDefinitionAttributes, $targetingDefinitionV2: TargetingDefinitionV2Attributes, $adExclusive: Boolean, $territory: Territory) {
  createAdLegacy(
    campaignId: $campaignId
    attributes: {name: $name, startDate: $startDate, endDate: $endDate, status: $status, frequencyCapCount: $frequencyCapCount, frequencyCapValue: $frequencyCapValue, frequencyCapTimeUnit: $frequencyCapTimeUnit, weighting: $weighting, sequence: $sequence, creativeAudioId: $creativeAudioId, creativeImageIds: $creativeImageIds, duration: $duration, creativeRedirectId: $creativeRedirectId, tagIds: $tagIds, tagsAreInherited: $tagsAreInherited, dailyCap: $dailyCap, targetingDefinition: $targetingDefinition, targetingDefinitionV2: $targetingDefinitionV2, adExclusive: $adExclusive, territory: $territory}
  ) {
    id
    altId
    name
    startDate {
      isInherited
      value
    }
    endDate {
      isInherited
      value
    }
    frequencyCapCount
    frequencyCapValue
    frequencyCapTimeUnit
    weighting
    duration
    status
    adExclusive
    creativeRedirect {
      id
      url
      trackingUrls {
        url
      }
    }
    creativeAudio {
      fileName
      id
      name
      url
      resourceAltId
    }
    sequence {
      id
      name
    }
    creativeImages {
      fileName
      id
      landingPageUrl
      mimeType
      name
      size
      url
      resourceAltId
    }
    campaign {
      id
      name
      cpm
    }
    tags {
      id
      name
    }
    tagsAreInherited
    inheritedTags {
      id
      name
    }
    dailyCap
    territory
  }
}
    `;
export type CreateAdLegacyMutationFn = ApolloReactCommon.MutationFunction<CreateAdLegacyMutation, CreateAdLegacyMutationVariables>;

/**
 * __useCreateAdLegacyMutation__
 *
 * To run a mutation, you first call `useCreateAdLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdLegacyMutation, { data, loading, error }] = useCreateAdLegacyMutation({
 *   variables: {
 *      creativeAudioId: // value for 'creativeAudioId'
 *      creativeImageIds: // value for 'creativeImageIds'
 *      creativeRedirectId: // value for 'creativeRedirectId'
 *      campaignId: // value for 'campaignId'
 *      name: // value for 'name'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      status: // value for 'status'
 *      frequencyCapCount: // value for 'frequencyCapCount'
 *      frequencyCapValue: // value for 'frequencyCapValue'
 *      frequencyCapTimeUnit: // value for 'frequencyCapTimeUnit'
 *      weighting: // value for 'weighting'
 *      sequence: // value for 'sequence'
 *      duration: // value for 'duration'
 *      tagIds: // value for 'tagIds'
 *      tagsAreInherited: // value for 'tagsAreInherited'
 *      dailyCap: // value for 'dailyCap'
 *      targetingDefinition: // value for 'targetingDefinition'
 *      targetingDefinitionV2: // value for 'targetingDefinitionV2'
 *      adExclusive: // value for 'adExclusive'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useCreateAdLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAdLegacyMutation, CreateAdLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAdLegacyMutation, CreateAdLegacyMutationVariables>(CreateAdLegacyDocument, options);
      }
export type CreateAdLegacyMutationHookResult = ReturnType<typeof useCreateAdLegacyMutation>;
export type CreateAdLegacyMutationResult = ApolloReactCommon.MutationResult<CreateAdLegacyMutation>;
export type CreateAdLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAdLegacyMutation, CreateAdLegacyMutationVariables>;
export const UpdateAdLegacyDocument = gql`
    mutation updateAdLegacy($id: ID!, $name: String, $startDate: InheritableLocalDateTimeAttributes, $endDate: InheritableLocalDateTimeAttributes, $status: AdStatusLegacy, $frequencyCapCount: NonNegativeInt, $frequencyCapValue: NonNegativeInt, $frequencyCapTimeUnit: FrequencyCapTimeUnit, $weighting: NonNegativeInt, $sequence: [ID!], $sequenceStart: Boolean, $creativeAudioId: ID, $creativeImageIds: [ID!], $creativeRedirectId: ID, $duration: NonNegativeFloat, $tagIds: [ID!], $tagsAreInherited: Boolean, $dailyCap: NonNegativeInt, $targetingDefinition: TargetingDefinitionAttributes, $targetingDefinitionV2: TargetingDefinitionV2Attributes, $adExclusive: Boolean, $territory: Territory) {
  updateAdLegacy(
    id: $id
    attributes: {name: $name, duration: $duration, startDate: $startDate, endDate: $endDate, status: $status, frequencyCapCount: $frequencyCapCount, frequencyCapValue: $frequencyCapValue, frequencyCapTimeUnit: $frequencyCapTimeUnit, weighting: $weighting, sequence: $sequence, sequenceStart: $sequenceStart, creativeAudioId: $creativeAudioId, creativeImageIds: $creativeImageIds, creativeRedirectId: $creativeRedirectId, tagIds: $tagIds, tagsAreInherited: $tagsAreInherited, dailyCap: $dailyCap, targetingDefinition: $targetingDefinition, targetingDefinitionV2: $targetingDefinitionV2, adExclusive: $adExclusive, territory: $territory}
  ) {
    id
    altId
    duration
    name
    startDate {
      isInherited
      value
    }
    endDate {
      isInherited
      value
    }
    frequencyCapCount
    frequencyCapValue
    frequencyCapTimeUnit
    weighting
    status
    adExclusive
    creativeAudio {
      fileName
      id
      name
      url
    }
    creativeRedirect {
      id
      url
      trackingUrls {
        url
      }
    }
    creativeImages {
      fileName
      id
      landingPageUrl
      mimeType
      name
      size
      url
    }
    campaign {
      name
      id
      startDate
      endDate
      cpm
    }
    sequenceStart
    sequence {
      id
      name
    }
    tags {
      id
      name
    }
    tagsAreInherited
    inheritedTags {
      id
      name
    }
    dailyCap
    territory
  }
}
    `;
export type UpdateAdLegacyMutationFn = ApolloReactCommon.MutationFunction<UpdateAdLegacyMutation, UpdateAdLegacyMutationVariables>;

/**
 * __useUpdateAdLegacyMutation__
 *
 * To run a mutation, you first call `useUpdateAdLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdLegacyMutation, { data, loading, error }] = useUpdateAdLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      status: // value for 'status'
 *      frequencyCapCount: // value for 'frequencyCapCount'
 *      frequencyCapValue: // value for 'frequencyCapValue'
 *      frequencyCapTimeUnit: // value for 'frequencyCapTimeUnit'
 *      weighting: // value for 'weighting'
 *      sequence: // value for 'sequence'
 *      sequenceStart: // value for 'sequenceStart'
 *      creativeAudioId: // value for 'creativeAudioId'
 *      creativeImageIds: // value for 'creativeImageIds'
 *      creativeRedirectId: // value for 'creativeRedirectId'
 *      duration: // value for 'duration'
 *      tagIds: // value for 'tagIds'
 *      tagsAreInherited: // value for 'tagsAreInherited'
 *      dailyCap: // value for 'dailyCap'
 *      targetingDefinition: // value for 'targetingDefinition'
 *      targetingDefinitionV2: // value for 'targetingDefinitionV2'
 *      adExclusive: // value for 'adExclusive'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useUpdateAdLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdLegacyMutation, UpdateAdLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdLegacyMutation, UpdateAdLegacyMutationVariables>(UpdateAdLegacyDocument, options);
      }
export type UpdateAdLegacyMutationHookResult = ReturnType<typeof useUpdateAdLegacyMutation>;
export type UpdateAdLegacyMutationResult = ApolloReactCommon.MutationResult<UpdateAdLegacyMutation>;
export type UpdateAdLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdLegacyMutation, UpdateAdLegacyMutationVariables>;
export const CloneAdLegacyDocument = gql`
    mutation cloneAdLegacy($id: ID!) {
  cloneAdLegacy(id: $id) {
    id
    territory
  }
}
    `;
export type CloneAdLegacyMutationFn = ApolloReactCommon.MutationFunction<CloneAdLegacyMutation, CloneAdLegacyMutationVariables>;

/**
 * __useCloneAdLegacyMutation__
 *
 * To run a mutation, you first call `useCloneAdLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneAdLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneAdLegacyMutation, { data, loading, error }] = useCloneAdLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloneAdLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CloneAdLegacyMutation, CloneAdLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CloneAdLegacyMutation, CloneAdLegacyMutationVariables>(CloneAdLegacyDocument, options);
      }
export type CloneAdLegacyMutationHookResult = ReturnType<typeof useCloneAdLegacyMutation>;
export type CloneAdLegacyMutationResult = ApolloReactCommon.MutationResult<CloneAdLegacyMutation>;
export type CloneAdLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CloneAdLegacyMutation, CloneAdLegacyMutationVariables>;
export const AdLegacyDocument = gql`
    query adLegacy($id: ID!, $territories: [Territory!]!) {
  adLegacy(id: $id) {
    id
    name
    territory
    weighting
    status
    adExclusive
    creativeAudio {
      fileName
      id
      name
      url
      trackingUrls {
        url
        consentVendorId
      }
      status
      resourceAltId
      altId
    }
    creativeRedirect {
      id
      url
      consentVendorId
      trackingUrls {
        url
        consentVendorId
      }
    }
    creativeImages {
      fileName
      id
      landingPageUrl
      mimeType
      name
      size
      url
      trackingUrls {
        url
        consentVendorId
      }
      status
      resourceAltId
      altId
    }
    sequence {
      id
    }
    tags {
      id
      name
    }
    tagsAreInherited
    inheritedTags {
      id
      name
    }
    frequencyCapCount
    frequencyCapValue
    frequencyCapTimeUnit
    dailyCap
    territory
    campaign {
      id
      name
      cpm
      startDate
      endDate
      objective
      order {
        id
        name
        endDate
        timeZone
        advertiser {
          id
          name
          agency {
            id
            name
          }
        }
      }
      tags {
        id
        name
      }
      dailyCap
      status
      ads(territories: $territories) {
        id
        name
      }
      targetingDefinitionV2 {
        id
      }
      ...CampaignFragment
    }
    ...AdFragment
  }
}
    ${CampaignFragmentFragmentDoc}
${AdFragmentFragmentDoc}`;

/**
 * __useAdLegacyQuery__
 *
 * To run a query within a React component, call `useAdLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAdLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdLegacyQuery, AdLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdLegacyQuery, AdLegacyQueryVariables>(AdLegacyDocument, options);
      }
export function useAdLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdLegacyQuery, AdLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdLegacyQuery, AdLegacyQueryVariables>(AdLegacyDocument, options);
        }
export type AdLegacyQueryHookResult = ReturnType<typeof useAdLegacyQuery>;
export type AdLegacyLazyQueryHookResult = ReturnType<typeof useAdLegacyLazyQuery>;
export type AdLegacyQueryResult = ApolloReactCommon.QueryResult<AdLegacyQuery, AdLegacyQueryVariables>;
export const AdByAltIdLegacyDocument = gql`
    query adByAltIdLegacy($altId: Int!) {
  adByAltIdLegacy(altId: $altId) {
    campaign {
      iabCategories {
        code
      }
      ...CampaignFragment
    }
    ...AdFragment
  }
}
    ${CampaignFragmentFragmentDoc}
${AdFragmentFragmentDoc}`;

/**
 * __useAdByAltIdLegacyQuery__
 *
 * To run a query within a React component, call `useAdByAltIdLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdByAltIdLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdByAltIdLegacyQuery({
 *   variables: {
 *      altId: // value for 'altId'
 *   },
 * });
 */
export function useAdByAltIdLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdByAltIdLegacyQuery, AdByAltIdLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdByAltIdLegacyQuery, AdByAltIdLegacyQueryVariables>(AdByAltIdLegacyDocument, options);
      }
export function useAdByAltIdLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdByAltIdLegacyQuery, AdByAltIdLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdByAltIdLegacyQuery, AdByAltIdLegacyQueryVariables>(AdByAltIdLegacyDocument, options);
        }
export type AdByAltIdLegacyQueryHookResult = ReturnType<typeof useAdByAltIdLegacyQuery>;
export type AdByAltIdLegacyLazyQueryHookResult = ReturnType<typeof useAdByAltIdLegacyLazyQuery>;
export type AdByAltIdLegacyQueryResult = ApolloReactCommon.QueryResult<AdByAltIdLegacyQuery, AdByAltIdLegacyQueryVariables>;
export const CreateAdvertiserDocument = gql`
    mutation CreateAdvertiser($agencyId: ID!, $name: String, $externalId: String, $externalSystemId: String, $domains: [DomainName!], $adSeparation: NonNegativeFloat, $iabCategoryCodes: [ID!], $territory: Territory) {
  createAdvertiserLegacy(
    agencyId: $agencyId
    attributes: {name: $name, externalId: $externalId, externalSystemId: $externalSystemId, domains: $domains, adSeparation: $adSeparation, iabCategoryCodes: $iabCategoryCodes, territory: $territory}
  ) {
    id
    altId
    name
    externalId
    externalSystemId
    domains
    status
    adSeparation
    iabCategories {
      name
      code
    }
    territory
  }
}
    `;
export type CreateAdvertiserMutationFn = ApolloReactCommon.MutationFunction<CreateAdvertiserMutation, CreateAdvertiserMutationVariables>;

/**
 * __useCreateAdvertiserMutation__
 *
 * To run a mutation, you first call `useCreateAdvertiserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdvertiserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdvertiserMutation, { data, loading, error }] = useCreateAdvertiserMutation({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      name: // value for 'name'
 *      externalId: // value for 'externalId'
 *      externalSystemId: // value for 'externalSystemId'
 *      domains: // value for 'domains'
 *      adSeparation: // value for 'adSeparation'
 *      iabCategoryCodes: // value for 'iabCategoryCodes'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useCreateAdvertiserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAdvertiserMutation, CreateAdvertiserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAdvertiserMutation, CreateAdvertiserMutationVariables>(CreateAdvertiserDocument, options);
      }
export type CreateAdvertiserMutationHookResult = ReturnType<typeof useCreateAdvertiserMutation>;
export type CreateAdvertiserMutationResult = ApolloReactCommon.MutationResult<CreateAdvertiserMutation>;
export type CreateAdvertiserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAdvertiserMutation, CreateAdvertiserMutationVariables>;
export const UpdateAdvertiserDocument = gql`
    mutation UpdateAdvertiser($id: ID!, $name: String, $status: AdvertiserStatus, $externalId: String, $externalSystemId: String, $domains: [DomainName!], $adSeparation: NonNegativeFloat, $iabCategoryCodes: [ID!]) {
  updateAdvertiserLegacy(
    id: $id
    attributes: {name: $name, status: $status, externalId: $externalId, externalSystemId: $externalSystemId, domains: $domains, adSeparation: $adSeparation, iabCategoryCodes: $iabCategoryCodes}
  ) {
    id
    altId
    name
    externalId
    externalSystemId
    domains
    status
    adSeparation
    iabCategories {
      name
      code
    }
    agency {
      id
      name
    }
    territory
  }
}
    `;
export type UpdateAdvertiserMutationFn = ApolloReactCommon.MutationFunction<UpdateAdvertiserMutation, UpdateAdvertiserMutationVariables>;

/**
 * __useUpdateAdvertiserMutation__
 *
 * To run a mutation, you first call `useUpdateAdvertiserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdvertiserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdvertiserMutation, { data, loading, error }] = useUpdateAdvertiserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      externalId: // value for 'externalId'
 *      externalSystemId: // value for 'externalSystemId'
 *      domains: // value for 'domains'
 *      adSeparation: // value for 'adSeparation'
 *      iabCategoryCodes: // value for 'iabCategoryCodes'
 *   },
 * });
 */
export function useUpdateAdvertiserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdvertiserMutation, UpdateAdvertiserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdvertiserMutation, UpdateAdvertiserMutationVariables>(UpdateAdvertiserDocument, options);
      }
export type UpdateAdvertiserMutationHookResult = ReturnType<typeof useUpdateAdvertiserMutation>;
export type UpdateAdvertiserMutationResult = ApolloReactCommon.MutationResult<UpdateAdvertiserMutation>;
export type UpdateAdvertiserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdvertiserMutation, UpdateAdvertiserMutationVariables>;
export const AdvertiserDocument = gql`
    query Advertiser($id: ID!) {
  advertiserLegacy(id: $id) {
    id
    altId
    name
    externalId
    externalSystemId
    domains
    status
    adSeparation
    territory
    iabCategories {
      code
    }
    agency {
      id
      name
      status
      advertisers {
        id
        name
        externalSystemId
      }
    }
    orders {
      id
      name
    }
  }
}
    `;

/**
 * __useAdvertiserQuery__
 *
 * To run a query within a React component, call `useAdvertiserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertiserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertiserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdvertiserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdvertiserQuery, AdvertiserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdvertiserQuery, AdvertiserQueryVariables>(AdvertiserDocument, options);
      }
export function useAdvertiserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdvertiserQuery, AdvertiserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdvertiserQuery, AdvertiserQueryVariables>(AdvertiserDocument, options);
        }
export type AdvertiserQueryHookResult = ReturnType<typeof useAdvertiserQuery>;
export type AdvertiserLazyQueryHookResult = ReturnType<typeof useAdvertiserLazyQuery>;
export type AdvertiserQueryResult = ApolloReactCommon.QueryResult<AdvertiserQuery, AdvertiserQueryVariables>;
export const AllAdvertisersDocument = gql`
    query AllAdvertisers($id: ID, $territories: [Territory!]!) {
  allAdvertisersLegacy(agencyId: $id, territories: $territories) {
    id
    name
  }
}
    `;

/**
 * __useAllAdvertisersQuery__
 *
 * To run a query within a React component, call `useAllAdvertisersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAdvertisersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAdvertisersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllAdvertisersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllAdvertisersQuery, AllAdvertisersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllAdvertisersQuery, AllAdvertisersQueryVariables>(AllAdvertisersDocument, options);
      }
export function useAllAdvertisersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllAdvertisersQuery, AllAdvertisersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllAdvertisersQuery, AllAdvertisersQueryVariables>(AllAdvertisersDocument, options);
        }
export type AllAdvertisersQueryHookResult = ReturnType<typeof useAllAdvertisersQuery>;
export type AllAdvertisersLazyQueryHookResult = ReturnType<typeof useAllAdvertisersLazyQuery>;
export type AllAdvertisersQueryResult = ApolloReactCommon.QueryResult<AllAdvertisersQuery, AllAdvertisersQueryVariables>;
export const CreateAgencyDocument = gql`
    mutation CreateAgency($name: String, $externalId: String, $externalSystemId: String, $territory: Territory) {
  createAgencyLegacy(
    attributes: {name: $name, externalId: $externalId, externalSystemId: $externalSystemId, territory: $territory}
  ) {
    id
    altId
    status
    name
    status
    externalId
    externalSystemId
    territory
  }
}
    `;
export type CreateAgencyMutationFn = ApolloReactCommon.MutationFunction<CreateAgencyMutation, CreateAgencyMutationVariables>;

/**
 * __useCreateAgencyMutation__
 *
 * To run a mutation, you first call `useCreateAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyMutation, { data, loading, error }] = useCreateAgencyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      externalId: // value for 'externalId'
 *      externalSystemId: // value for 'externalSystemId'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useCreateAgencyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAgencyMutation, CreateAgencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAgencyMutation, CreateAgencyMutationVariables>(CreateAgencyDocument, options);
      }
export type CreateAgencyMutationHookResult = ReturnType<typeof useCreateAgencyMutation>;
export type CreateAgencyMutationResult = ApolloReactCommon.MutationResult<CreateAgencyMutation>;
export type CreateAgencyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAgencyMutation, CreateAgencyMutationVariables>;
export const UpdateAgencyDocument = gql`
    mutation UpdateAgency($id: ID!, $name: String, $status: AgencyStatus, $externalId: String, $externalSystemId: String, $territory: Territory) {
  updateAgencyLegacy(
    id: $id
    attributes: {name: $name, status: $status, externalId: $externalId, externalSystemId: $externalSystemId, territory: $territory}
  ) {
    id
    altId
    name
    status
    externalId
    externalSystemId
    territory
  }
}
    `;
export type UpdateAgencyMutationFn = ApolloReactCommon.MutationFunction<UpdateAgencyMutation, UpdateAgencyMutationVariables>;

/**
 * __useUpdateAgencyMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyMutation, { data, loading, error }] = useUpdateAgencyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      externalId: // value for 'externalId'
 *      externalSystemId: // value for 'externalSystemId'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useUpdateAgencyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAgencyMutation, UpdateAgencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAgencyMutation, UpdateAgencyMutationVariables>(UpdateAgencyDocument, options);
      }
export type UpdateAgencyMutationHookResult = ReturnType<typeof useUpdateAgencyMutation>;
export type UpdateAgencyMutationResult = ApolloReactCommon.MutationResult<UpdateAgencyMutation>;
export type UpdateAgencyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAgencyMutation, UpdateAgencyMutationVariables>;
export const AgencyDocument = gql`
    query Agency($id: ID!) {
  agencyLegacy(id: $id) {
    id
    altId
    name
    externalId
    externalSystemId
    status
    territory
    advertisers {
      id
      name
      altId
      domains
      status
    }
  }
}
    `;

/**
 * __useAgencyQuery__
 *
 * To run a query within a React component, call `useAgencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgencyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AgencyQuery, AgencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AgencyQuery, AgencyQueryVariables>(AgencyDocument, options);
      }
export function useAgencyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AgencyQuery, AgencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AgencyQuery, AgencyQueryVariables>(AgencyDocument, options);
        }
export type AgencyQueryHookResult = ReturnType<typeof useAgencyQuery>;
export type AgencyLazyQueryHookResult = ReturnType<typeof useAgencyLazyQuery>;
export type AgencyQueryResult = ApolloReactCommon.QueryResult<AgencyQuery, AgencyQueryVariables>;
export const AgencyMinimalDocument = gql`
    query AgencyMinimal($id: ID!) {
  agencyLegacy(id: $id) {
    id
    name
    territory
  }
}
    `;

/**
 * __useAgencyMinimalQuery__
 *
 * To run a query within a React component, call `useAgencyMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyMinimalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgencyMinimalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AgencyMinimalQuery, AgencyMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AgencyMinimalQuery, AgencyMinimalQueryVariables>(AgencyMinimalDocument, options);
      }
export function useAgencyMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AgencyMinimalQuery, AgencyMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AgencyMinimalQuery, AgencyMinimalQueryVariables>(AgencyMinimalDocument, options);
        }
export type AgencyMinimalQueryHookResult = ReturnType<typeof useAgencyMinimalQuery>;
export type AgencyMinimalLazyQueryHookResult = ReturnType<typeof useAgencyMinimalLazyQuery>;
export type AgencyMinimalQueryResult = ApolloReactCommon.QueryResult<AgencyMinimalQuery, AgencyMinimalQueryVariables>;
export const AllAgenciesDocument = gql`
    query AllAgencies($territories: [Territory!]!) {
  allAgenciesLegacy(territories: $territories) {
    id
    altId
    name
    status
    externalId
    externalSystemId
  }
}
    `;

/**
 * __useAllAgenciesQuery__
 *
 * To run a query within a React component, call `useAllAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAgenciesQuery({
 *   variables: {
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllAgenciesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllAgenciesQuery, AllAgenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllAgenciesQuery, AllAgenciesQueryVariables>(AllAgenciesDocument, options);
      }
export function useAllAgenciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllAgenciesQuery, AllAgenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllAgenciesQuery, AllAgenciesQueryVariables>(AllAgenciesDocument, options);
        }
export type AllAgenciesQueryHookResult = ReturnType<typeof useAllAgenciesQuery>;
export type AllAgenciesLazyQueryHookResult = ReturnType<typeof useAllAgenciesLazyQuery>;
export type AllAgenciesQueryResult = ApolloReactCommon.QueryResult<AllAgenciesQuery, AllAgenciesQueryVariables>;
export const AllAgenciesMinimalDocument = gql`
    query AllAgenciesMinimal($territories: [Territory!]!) {
  allAgenciesLegacy(territories: $territories) {
    id
    name
  }
}
    `;

/**
 * __useAllAgenciesMinimalQuery__
 *
 * To run a query within a React component, call `useAllAgenciesMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAgenciesMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAgenciesMinimalQuery({
 *   variables: {
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllAgenciesMinimalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllAgenciesMinimalQuery, AllAgenciesMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllAgenciesMinimalQuery, AllAgenciesMinimalQueryVariables>(AllAgenciesMinimalDocument, options);
      }
export function useAllAgenciesMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllAgenciesMinimalQuery, AllAgenciesMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllAgenciesMinimalQuery, AllAgenciesMinimalQueryVariables>(AllAgenciesMinimalDocument, options);
        }
export type AllAgenciesMinimalQueryHookResult = ReturnType<typeof useAllAgenciesMinimalQuery>;
export type AllAgenciesMinimalLazyQueryHookResult = ReturnType<typeof useAllAgenciesMinimalLazyQuery>;
export type AllAgenciesMinimalQueryResult = ApolloReactCommon.QueryResult<AllAgenciesMinimalQuery, AllAgenciesMinimalQueryVariables>;
export const CreateCampaignDocument = gql`
    mutation CreateCampaign($orderId: ID!, $name: String, $pacing: Pacing, $timeZone: ZoneId, $startDate: LocalDateTime, $endDate: LocalDateTime, $billingType: BillingType, $objective: NonNegativeInt, $dailyCap: NonNegativeInt, $currency: Currency, $cpm: BigDecimal, $frequencyCapCount: NonNegativeInt, $frequencyCapValue: NonNegativeInt, $frequencyCapTimeUnit: FrequencyCapTimeUnit, $iabCategoryCodes: [ID!], $offsetCpm: BigDecimal, $priority: NonNegativeInt, $tagIds: [ID!], $ownerId: ID, $targetingDefinition: TargetingDefinitionAttributes, $sponsorshipRevenue: NonNegativeFloat, $territory: Territory, $targetingVersion: TargetingVersion, $externalId: String, $externalSystem: CampaignExternalSystem) {
  createCampaign(
    orderId: $orderId
    attributes: {offsetCpm: $offsetCpm, priority: $priority, name: $name, pacing: $pacing, billingType: $billingType, timeZone: $timeZone, startDate: $startDate, endDate: $endDate, objective: $objective, dailyCap: $dailyCap, currency: $currency, cpm: $cpm, iabCategoryCodes: $iabCategoryCodes, frequencyCapCount: $frequencyCapCount, frequencyCapValue: $frequencyCapValue, frequencyCapTimeUnit: $frequencyCapTimeUnit, tagIds: $tagIds, ownerId: $ownerId, targetingDefinition: $targetingDefinition, sponsorshipRevenue: $sponsorshipRevenue, territory: $territory, targetingVersion: $targetingVersion, externalId: $externalId, externalSystem: $externalSystem}
  ) {
    offsetCpm
    priority
    id
    altId
    status
    name
    pacing
    startDate
    endDate
    billingType
    timeZone
    currency
    cpm
    dailyCap
    iabCategories {
      name
      code
    }
    frequencyCapCount
    frequencyCapValue
    frequencyCapTimeUnit
    sponsorshipRevenue
    order {
      id
      name
    }
    tags {
      id
      name
    }
    owner {
      id
      email
    }
    targetingDefinition {
      id
      masterTargetingTemplates {
        id
        name
      }
      targetingGroups {
        id
        masterTargetingGroupId
        listenerAccuracy
      }
    }
    territory
    targetingVersion
  }
}
    `;
export type CreateCampaignMutationFn = ApolloReactCommon.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      name: // value for 'name'
 *      pacing: // value for 'pacing'
 *      timeZone: // value for 'timeZone'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      billingType: // value for 'billingType'
 *      objective: // value for 'objective'
 *      dailyCap: // value for 'dailyCap'
 *      currency: // value for 'currency'
 *      cpm: // value for 'cpm'
 *      frequencyCapCount: // value for 'frequencyCapCount'
 *      frequencyCapValue: // value for 'frequencyCapValue'
 *      frequencyCapTimeUnit: // value for 'frequencyCapTimeUnit'
 *      iabCategoryCodes: // value for 'iabCategoryCodes'
 *      offsetCpm: // value for 'offsetCpm'
 *      priority: // value for 'priority'
 *      tagIds: // value for 'tagIds'
 *      ownerId: // value for 'ownerId'
 *      targetingDefinition: // value for 'targetingDefinition'
 *      sponsorshipRevenue: // value for 'sponsorshipRevenue'
 *      territory: // value for 'territory'
 *      targetingVersion: // value for 'targetingVersion'
 *      externalId: // value for 'externalId'
 *      externalSystem: // value for 'externalSystem'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = ApolloReactCommon.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const UpdateCampaignDocument = gql`
    mutation UpdateCampaign($id: ID!, $name: String, $pacing: Pacing, $billingType: BillingType, $timeZone: ZoneId, $startDate: LocalDateTime, $endDate: LocalDateTime, $status: CampaignStatus, $objective: NonNegativeInt, $dailyCap: NonNegativeInt, $currency: Currency, $cpm: BigDecimal, $frequencyCapCount: NonNegativeInt, $frequencyCapValue: NonNegativeInt, $frequencyCapTimeUnit: FrequencyCapTimeUnit, $iabCategoryCodes: [ID!], $offsetCpm: BigDecimal, $priority: NonNegativeInt, $tagIds: [ID!], $ownerId: ID, $targetingDefinition: TargetingDefinitionAttributes, $archived: Boolean, $sponsorshipRevenue: NonNegativeFloat, $targetingVersion: TargetingVersion, $externalId: String, $targetingRestrictions: [TargetingRestriction!], $targetingDefinitionV2: TargetingDefinitionV2Attributes) {
  updateCampaign(
    id: $id
    attributes: {offsetCpm: $offsetCpm, priority: $priority, name: $name, pacing: $pacing, billingType: $billingType, timeZone: $timeZone, startDate: $startDate, endDate: $endDate, status: $status, objective: $objective, dailyCap: $dailyCap, currency: $currency, cpm: $cpm, iabCategoryCodes: $iabCategoryCodes, frequencyCapCount: $frequencyCapCount, frequencyCapValue: $frequencyCapValue, frequencyCapTimeUnit: $frequencyCapTimeUnit, tagIds: $tagIds, ownerId: $ownerId, targetingDefinition: $targetingDefinition, archived: $archived, sponsorshipRevenue: $sponsorshipRevenue, targetingVersion: $targetingVersion, externalId: $externalId, targetingRestrictions: $targetingRestrictions, targetingDefinitionV2: $targetingDefinitionV2}
  ) {
    offsetCpm
    priority
    id
    altId
    status
    name
    pacing
    startDate
    endDate
    billingType
    timeZone
    currency
    cpm
    iabCategories {
      name
      code
    }
    targetingRestrictions
    frequencyCapCount
    frequencyCapValue
    frequencyCapTimeUnit
    sponsorshipRevenue
    objective
    dailyCap
    tags {
      id
      name
    }
    owner {
      id
      email
    }
    targetingDefinition {
      id
      masterTargetingTemplates {
        id
        name
      }
      targetingGroups {
        id
        masterTargetingGroupId
        listenerAccuracy
      }
    }
    archived
    territory
    targetingVersion
  }
}
    `;
export type UpdateCampaignMutationFn = ApolloReactCommon.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      pacing: // value for 'pacing'
 *      billingType: // value for 'billingType'
 *      timeZone: // value for 'timeZone'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      status: // value for 'status'
 *      objective: // value for 'objective'
 *      dailyCap: // value for 'dailyCap'
 *      currency: // value for 'currency'
 *      cpm: // value for 'cpm'
 *      frequencyCapCount: // value for 'frequencyCapCount'
 *      frequencyCapValue: // value for 'frequencyCapValue'
 *      frequencyCapTimeUnit: // value for 'frequencyCapTimeUnit'
 *      iabCategoryCodes: // value for 'iabCategoryCodes'
 *      offsetCpm: // value for 'offsetCpm'
 *      priority: // value for 'priority'
 *      tagIds: // value for 'tagIds'
 *      ownerId: // value for 'ownerId'
 *      targetingDefinition: // value for 'targetingDefinition'
 *      archived: // value for 'archived'
 *      sponsorshipRevenue: // value for 'sponsorshipRevenue'
 *      targetingVersion: // value for 'targetingVersion'
 *      externalId: // value for 'externalId'
 *      targetingRestrictions: // value for 'targetingRestrictions'
 *      targetingDefinitionV2: // value for 'targetingDefinitionV2'
 *   },
 * });
 */
export function useUpdateCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
      }
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = ApolloReactCommon.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const CloneCampaignDocument = gql`
    mutation CloneCampaign($id: ID!, $disableCascade: Boolean) {
  cloneCampaign(id: $id, disableCascade: $disableCascade) {
    id
  }
}
    `;
export type CloneCampaignMutationFn = ApolloReactCommon.MutationFunction<CloneCampaignMutation, CloneCampaignMutationVariables>;

/**
 * __useCloneCampaignMutation__
 *
 * To run a mutation, you first call `useCloneCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneCampaignMutation, { data, loading, error }] = useCloneCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      disableCascade: // value for 'disableCascade'
 *   },
 * });
 */
export function useCloneCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CloneCampaignMutation, CloneCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CloneCampaignMutation, CloneCampaignMutationVariables>(CloneCampaignDocument, options);
      }
export type CloneCampaignMutationHookResult = ReturnType<typeof useCloneCampaignMutation>;
export type CloneCampaignMutationResult = ApolloReactCommon.MutationResult<CloneCampaignMutation>;
export type CloneCampaignMutationOptions = ApolloReactCommon.BaseMutationOptions<CloneCampaignMutation, CloneCampaignMutationVariables>;
export const CampaignDocument = gql`
    query Campaign($id: ID!, $territories: [Territory!]!) {
  campaign(id: $id) {
    id
    altId
    name
    pacing
    startDate
    endDate
    billingType
    timeZone
    currency
    cpm
    frequencyCapCount
    frequencyCapValue
    frequencyCapTimeUnit
    objective
    impressions
    dailyCap
    offsetCpm
    priority
    pacing
    status
    territory
    sponsorshipRevenue
    targetingVersion
    externalId
    externalSystem
    sanities {
      id
      type
      name
    }
    tags {
      id
      name
    }
    order {
      id
      name
      advertiser {
        id
        name
        agency {
          id
          name
        }
      }
      campaigns {
        id
        name
        objective
      }
      startDate
      endDate
      objective
      owner {
        id
        email
        status
      }
      status
      externalSystemId
    }
    iabCategories {
      code
    }
    owner {
      id
      email
      status
    }
    targetingRestrictions
    targetingDefinition {
      id
      masterTargetingTemplates {
        id
        name
        description
        isMasterTemplate
        targetingGroups {
          id
          masterTargetingGroupId
          listenerAccuracy
          channels {
            id
          }
          audienceParams {
            ... on KeyValueGroupParam {
              keyValues {
                key
                value
              }
              clusivity
            }
            ... on AgeParam {
              ageRange {
                minAge
                maxAge
              }
              clusivity
            }
            ... on GenderParam {
              genders
              clusivity
            }
            ... on DayAndTimeParam {
              timeZone
              daysOfWeek {
                day
                hours
              }
              clusivity
            }
            ... on DeviceTypeParam {
              deviceTypes
              clusivity
            }
            ... on DeviceOperatingSystemParam {
              deviceOperatingSystems {
                versions
                name
              }
              clusivity
            }
            ... on ConnectionTypeParam {
              clusivity
              connectionTypes
            }
            ... on DeviceMakerParam {
              deviceMakers {
                name
                models
              }
              clusivity
            }
            ... on BrowserLanguageParam {
              browserLanguages {
                description
                code
              }
              clusivity
            }
            ... on PostalCodeParam {
              postalCodes
              postcodeGroups {
                id
                name
              }
              clusivity
            }
            ... on LocationParam {
              positions {
                latitude
                longitude
                radius
              }
              clusivity
            }
            ... on DmpSegmentParam {
              segmentType
              segments {
                ... on NielsenSegment {
                  id
                  fullName
                }
              }
              clusivity
            }
            ... on DmaParam {
              dmas {
                code
                name
              }
              clusivity
            }
            ... on AudienceSegmentParam {
              segments {
                id
                displayName
              }
              clusivity
            }
            ... on GenreParam {
              genres
              clusivity
            }
            ... on ItunesCategoryParam {
              categories
              clusivity
            }
            ... on PodcastParam {
              podcastTargets {
                collectionId
                episodeId
                showId
                name
              }
              clusivity
            }
            ... on AdPositionParam {
              positions {
                position
                midRollPositions
              }
              clusivity
            }
            ... on IspParam {
              isps {
                id
                name
              }
              clusivity
            }
            ... on CountryParam {
              code
              name
              clusivity
              countryGroups {
                name
                id
              }
              subdivisions {
                ... on CityParam {
                  name
                  regionCode
                  subRegionCode
                }
                ... on RegionParam {
                  name
                  code
                  subRegions {
                    name
                    code
                  }
                }
              }
            }
          }
        }
      }
      generalTargetingGroup {
        id
        listenerAccuracy
        channels {
          id
        }
        audienceParams {
          ... on KeyValueGroupParam {
            keyValues {
              key
              value
            }
            clusivity
          }
          ... on AgeParam {
            ageRange {
              minAge
              maxAge
            }
            clusivity
          }
          ... on GenderParam {
            genders
            clusivity
          }
          ... on DayAndTimeParam {
            timeZone
            daysOfWeek {
              day
              hours
            }
            clusivity
          }
          ... on DeviceTypeParam {
            deviceTypes
            clusivity
          }
          ... on DeviceOperatingSystemParam {
            deviceOperatingSystems {
              versions
              name
            }
            clusivity
          }
          ... on ConnectionTypeParam {
            clusivity
            connectionTypes
          }
          ... on DeviceMakerParam {
            deviceMakers {
              name
              models
            }
            clusivity
          }
          ... on BrowserLanguageParam {
            browserLanguages {
              description
              code
            }
            clusivity
          }
          ... on PostalCodeParam {
            postalCodes
            postcodeGroups {
              id
              name
            }
            clusivity
          }
          ... on LocationParam {
            positions {
              latitude
              longitude
              radius
            }
            clusivity
          }
          ... on DmpSegmentParam {
            segmentType
            segments {
              ... on NielsenSegment {
                id
                fullName
              }
            }
            clusivity
          }
          ... on DmaParam {
            dmas {
              code
              name
            }
            clusivity
          }
          ... on AudienceSegmentParam {
            segments {
              id
              displayName
            }
            clusivity
          }
          ... on GenreParam {
            genres
            clusivity
          }
          ... on ItunesCategoryParam {
            categories
            clusivity
          }
          ... on PodcastParam {
            podcastTargets {
              collectionId
              episodeId
              showId
              name
            }
            clusivity
          }
          ... on AdPositionParam {
            positions {
              position
              midRollPositions
            }
            clusivity
          }
          ... on IspParam {
            isps {
              id
              name
            }
            clusivity
          }
          ... on CountryParam {
            code
            name
            clusivity
            countryGroups {
              name
              id
            }
            subdivisions {
              ... on CityParam {
                name
                regionCode
                subRegionCode
              }
              ... on RegionParam {
                name
                code
                subRegions {
                  name
                  code
                }
              }
            }
          }
        }
      }
      targetingGroups {
        id
        masterTargetingGroupId
        listenerAccuracy
        channels {
          id
        }
        audienceParams {
          ... on KeyValueGroupParam {
            keyValues {
              key
              value
            }
            clusivity
          }
          ... on AgeParam {
            ageRange {
              minAge
              maxAge
            }
            clusivity
          }
          ... on GenderParam {
            genders
            clusivity
          }
          ... on DayAndTimeParam {
            timeZone
            daysOfWeek {
              day
              hours
            }
            clusivity
          }
          ... on DeviceTypeParam {
            deviceTypes
            clusivity
          }
          ... on DeviceOperatingSystemParam {
            deviceOperatingSystems {
              versions
              name
            }
            clusivity
          }
          ... on ConnectionTypeParam {
            clusivity
            connectionTypes
          }
          ... on DeviceMakerParam {
            deviceMakers {
              name
              models
            }
            clusivity
          }
          ... on BrowserLanguageParam {
            browserLanguages {
              description
              code
            }
            clusivity
          }
          ... on PostalCodeParam {
            postalCodes
            postcodeGroups {
              id
              name
            }
            clusivity
          }
          ... on LocationParam {
            positions {
              latitude
              longitude
              radius
            }
            clusivity
          }
          ... on DmpSegmentParam {
            segmentType
            segments {
              ... on NielsenSegment {
                id
                fullName
              }
            }
            clusivity
          }
          ... on DmaParam {
            dmas {
              code
              name
            }
            clusivity
          }
          ... on AudienceSegmentParam {
            segments {
              id
              displayName
            }
            clusivity
          }
          ... on GenreParam {
            genres
            clusivity
          }
          ... on ItunesCategoryParam {
            categories
            clusivity
          }
          ... on PodcastParam {
            podcastTargets {
              collectionId
              episodeId
              showId
              name
            }
            clusivity
          }
          ... on AdPositionParam {
            positions {
              position
              midRollPositions
            }
            clusivity
          }
          ... on IspParam {
            isps {
              id
              name
            }
            clusivity
          }
          ... on CountryParam {
            code
            name
            clusivity
            countryGroups {
              name
              id
            }
            subdivisions {
              ... on CityParam {
                name
                regionCode
                subRegionCode
              }
              ... on RegionParam {
                name
                code
                subRegions {
                  name
                  code
                }
              }
            }
          }
        }
      }
    }
    targetingDefinitionV2 {
      id
      audienceTargeting {
        audiences {
          parameters {
            type
            clusivity
            values {
              id
              name
              active
              activeGrades
            }
            enabledGrades
          }
        }
      }
      locationTargeting {
        locations {
          limitLocationParameterValue {
            id
          }
          accuracyRadius
          parameters {
            type
            clusivity
            values {
              id
              name
              parents {
                id
                name
              }
            }
          }
        }
      }
      technologyTargeting {
        technologies {
          parameters {
            type
            clusivity
            values {
              id
              name
            }
          }
        }
      }
      inventoryTargeting {
        inventories {
          parameters {
            type
            clusivity
            values {
              id
              name
              active
              parents {
                id
                name
              }
            }
          }
        }
      }
      dayTimeTargeting {
        clusivity
        timeZone
        daysOfWeek {
          day
          hours
        }
      }
      customTargeting {
        customGroups {
          parameters {
            clusivity
            customKvps {
              key
              value
            }
          }
        }
      }
    }
    ads(territories: $territories) {
      id
      altId
      name
      startDate {
        isInherited
        value
      }
      endDate {
        isInherited
        value
      }
      weighting
      impressions
      dailyCap
      status
      frequencyCapCount
      frequencyCapValue
      frequencyCapTimeUnit
      creativeAudio {
        id
      }
      creativeImages {
        id
      }
      creativeRedirect {
        id
      }
      sequenceStart
      sequence {
        id
        name
      }
      tags {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCampaignQuery__
 *
 * To run a query within a React component, call `useCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useCampaignQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
      }
export function useCampaignLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export type CampaignQueryHookResult = ReturnType<typeof useCampaignQuery>;
export type CampaignLazyQueryHookResult = ReturnType<typeof useCampaignLazyQuery>;
export type CampaignQueryResult = ApolloReactCommon.QueryResult<CampaignQuery, CampaignQueryVariables>;
export const CampaignTimeSeriesDocument = gql`
    query CampaignTimeSeries($id: ID!, $timeZone: ZoneId!, $territories: [Territory!]!) {
  campaign(id: $id) {
    id
    timeZone
    objective
    impressions
    companionImpressions
    pacing
    ltr
    sanities {
      id
      type
      name
    }
    timeSeries(params: {timeUnit: HOUR, timeZone: $timeZone}) {
      impressions {
        dataPoints {
          t
          v
        }
      }
      ltr {
        dataPoints {
          t
          v
        }
      }
    }
    clickThroughRate
    ads(territories: $territories) {
      creativeImages {
        id
      }
      creativeRedirect {
        id
      }
    }
  }
}
    `;

/**
 * __useCampaignTimeSeriesQuery__
 *
 * To run a query within a React component, call `useCampaignTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignTimeSeriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      timeZone: // value for 'timeZone'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useCampaignTimeSeriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CampaignTimeSeriesQuery, CampaignTimeSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignTimeSeriesQuery, CampaignTimeSeriesQueryVariables>(CampaignTimeSeriesDocument, options);
      }
export function useCampaignTimeSeriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignTimeSeriesQuery, CampaignTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignTimeSeriesQuery, CampaignTimeSeriesQueryVariables>(CampaignTimeSeriesDocument, options);
        }
export type CampaignTimeSeriesQueryHookResult = ReturnType<typeof useCampaignTimeSeriesQuery>;
export type CampaignTimeSeriesLazyQueryHookResult = ReturnType<typeof useCampaignTimeSeriesLazyQuery>;
export type CampaignTimeSeriesQueryResult = ApolloReactCommon.QueryResult<CampaignTimeSeriesQuery, CampaignTimeSeriesQueryVariables>;
export const InitialDataForCreateAdDocument = gql`
    query initialDataForCreateAd($id: ID!, $territory: Territory!) {
  getLocationParameterValueByTerritory(territory: $territory) {
    id
  }
  campaign(id: $id) {
    id
    name
    startDate
    endDate
    timeZone
    cpm
    dailyCap
    objective
    territory
    targetingVersion
    order {
      id
      endDate
      timeZone
      advertiser {
        id
      }
    }
    tags {
      id
      name
    }
    targetingDefinitionV2 {
      id
    }
    targetingDefinition {
      id
      masterTargetingTemplates {
        id
        name
        description
        isMasterTemplate
        targetingGroups {
          id
          masterTargetingGroupId
          listenerAccuracy
          channels {
            id
          }
          audienceParams {
            ... on KeyValueGroupParam {
              keyValues {
                key
                value
              }
              clusivity
            }
            ... on AgeParam {
              ageRange {
                minAge
                maxAge
              }
              clusivity
            }
            ... on GenderParam {
              genders
              clusivity
            }
            ... on DayAndTimeParam {
              timeZone
              daysOfWeek {
                day
                hours
              }
              clusivity
            }
            ... on DeviceTypeParam {
              deviceTypes
              clusivity
            }
            ... on DeviceOperatingSystemParam {
              deviceOperatingSystems {
                versions
                name
              }
              clusivity
            }
            ... on ConnectionTypeParam {
              clusivity
              connectionTypes
            }
            ... on DeviceMakerParam {
              deviceMakers {
                name
                models
              }
              clusivity
            }
            ... on BrowserLanguageParam {
              browserLanguages {
                description
                code
              }
              clusivity
            }
            ... on PostalCodeParam {
              postalCodes
              postcodeGroups {
                id
                name
              }
              clusivity
            }
            ... on LocationParam {
              positions {
                latitude
                longitude
                radius
              }
              clusivity
            }
            ... on DmpSegmentParam {
              segmentType
              segments {
                ... on NielsenSegment {
                  id
                  fullName
                }
              }
              clusivity
            }
            ... on DmaParam {
              dmas {
                code
                name
              }
              clusivity
            }
            ... on AudienceSegmentParam {
              segments {
                id
                displayName
              }
              clusivity
            }
            ... on GenreParam {
              genres
              clusivity
            }
            ... on ItunesCategoryParam {
              categories
              clusivity
            }
            ... on PodcastParam {
              podcastTargets {
                collectionId
                episodeId
                showId
                name
              }
              clusivity
            }
            ... on AdPositionParam {
              positions {
                position
                midRollPositions
              }
              clusivity
            }
            ... on IspParam {
              isps {
                id
                name
              }
              clusivity
            }
            ... on CountryParam {
              code
              name
              clusivity
              countryGroups {
                name
                id
              }
              subdivisions {
                ... on CityParam {
                  name
                  regionCode
                  subRegionCode
                }
                ... on RegionParam {
                  name
                  code
                  subRegions {
                    name
                    code
                  }
                }
              }
            }
          }
        }
      }
      generalTargetingGroup {
        id
        listenerAccuracy
        channels {
          id
        }
        audienceParams {
          ... on KeyValueGroupParam {
            keyValues {
              key
              value
            }
            clusivity
          }
          ... on AgeParam {
            ageRange {
              minAge
              maxAge
            }
            clusivity
          }
          ... on GenderParam {
            genders
            clusivity
          }
          ... on DayAndTimeParam {
            timeZone
            daysOfWeek {
              day
              hours
            }
            clusivity
          }
          ... on DeviceTypeParam {
            deviceTypes
            clusivity
          }
          ... on DeviceOperatingSystemParam {
            deviceOperatingSystems {
              versions
              name
            }
            clusivity
          }
          ... on ConnectionTypeParam {
            clusivity
            connectionTypes
          }
          ... on DeviceMakerParam {
            deviceMakers {
              name
              models
            }
            clusivity
          }
          ... on BrowserLanguageParam {
            browserLanguages {
              description
              code
            }
            clusivity
          }
          ... on PostalCodeParam {
            postalCodes
            postcodeGroups {
              id
              name
            }
            clusivity
          }
          ... on LocationParam {
            positions {
              latitude
              longitude
              radius
            }
            clusivity
          }
          ... on DmpSegmentParam {
            segmentType
            segments {
              ... on NielsenSegment {
                id
                fullName
              }
            }
            clusivity
          }
          ... on DmaParam {
            dmas {
              code
              name
            }
            clusivity
          }
          ... on AudienceSegmentParam {
            segments {
              id
              displayName
            }
            clusivity
          }
          ... on GenreParam {
            genres
            clusivity
          }
          ... on ItunesCategoryParam {
            categories
            clusivity
          }
          ... on PodcastParam {
            podcastTargets {
              collectionId
              episodeId
              showId
              name
            }
            clusivity
          }
          ... on AdPositionParam {
            positions {
              position
              midRollPositions
            }
            clusivity
          }
          ... on IspParam {
            isps {
              id
              name
            }
            clusivity
          }
          ... on CountryParam {
            code
            name
            clusivity
            countryGroups {
              name
              id
            }
            subdivisions {
              ... on CityParam {
                name
                regionCode
                subRegionCode
              }
              ... on RegionParam {
                name
                code
                subRegions {
                  name
                  code
                }
              }
            }
          }
        }
      }
      targetingGroups {
        id
        masterTargetingGroupId
        listenerAccuracy
        channels {
          id
        }
        audienceParams {
          ... on KeyValueGroupParam {
            keyValues {
              key
              value
            }
            clusivity
          }
          ... on AgeParam {
            ageRange {
              minAge
              maxAge
            }
            clusivity
          }
          ... on GenderParam {
            genders
            clusivity
          }
          ... on DayAndTimeParam {
            timeZone
            daysOfWeek {
              day
              hours
            }
            clusivity
          }
          ... on DeviceTypeParam {
            deviceTypes
            clusivity
          }
          ... on DeviceOperatingSystemParam {
            deviceOperatingSystems {
              versions
              name
            }
            clusivity
          }
          ... on ConnectionTypeParam {
            clusivity
            connectionTypes
          }
          ... on DeviceMakerParam {
            deviceMakers {
              name
              models
            }
            clusivity
          }
          ... on BrowserLanguageParam {
            browserLanguages {
              description
              code
            }
            clusivity
          }
          ... on PostalCodeParam {
            postalCodes
            postcodeGroups {
              id
              name
            }
            clusivity
          }
          ... on LocationParam {
            positions {
              latitude
              longitude
              radius
            }
            clusivity
          }
          ... on DmpSegmentParam {
            segmentType
            segments {
              ... on NielsenSegment {
                id
                fullName
              }
            }
            clusivity
          }
          ... on DmaParam {
            dmas {
              code
              name
            }
            clusivity
          }
          ... on AudienceSegmentParam {
            segments {
              id
              displayName
            }
            clusivity
          }
          ... on GenreParam {
            genres
            clusivity
          }
          ... on ItunesCategoryParam {
            categories
            clusivity
          }
          ... on PodcastParam {
            podcastTargets {
              collectionId
              episodeId
              showId
              name
            }
            clusivity
          }
          ... on AdPositionParam {
            positions {
              position
              midRollPositions
            }
            clusivity
          }
          ... on IspParam {
            isps {
              id
              name
            }
            clusivity
          }
          ... on CountryParam {
            code
            name
            clusivity
            countryGroups {
              name
              id
            }
            subdivisions {
              ... on CityParam {
                name
                regionCode
                subRegionCode
              }
              ... on RegionParam {
                name
                code
                subRegions {
                  name
                  code
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useInitialDataForCreateAdQuery__
 *
 * To run a query within a React component, call `useInitialDataForCreateAdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialDataForCreateAdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialDataForCreateAdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useInitialDataForCreateAdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InitialDataForCreateAdQuery, InitialDataForCreateAdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InitialDataForCreateAdQuery, InitialDataForCreateAdQueryVariables>(InitialDataForCreateAdDocument, options);
      }
export function useInitialDataForCreateAdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InitialDataForCreateAdQuery, InitialDataForCreateAdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InitialDataForCreateAdQuery, InitialDataForCreateAdQueryVariables>(InitialDataForCreateAdDocument, options);
        }
export type InitialDataForCreateAdQueryHookResult = ReturnType<typeof useInitialDataForCreateAdQuery>;
export type InitialDataForCreateAdLazyQueryHookResult = ReturnType<typeof useInitialDataForCreateAdLazyQuery>;
export type InitialDataForCreateAdQueryResult = ApolloReactCommon.QueryResult<InitialDataForCreateAdQuery, InitialDataForCreateAdQueryVariables>;
export const AllCampaignsForGraphDataDocument = gql`
    query AllCampaignsForGraphData($filter: CampaignFilter, $territories: [Territory!]!) {
  allCampaigns(filter: $filter, territories: $territories) {
    id
    startDate
    endDate
    timeZone
    status
    sanities {
      id
      type
      name
    }
  }
}
    `;

/**
 * __useAllCampaignsForGraphDataQuery__
 *
 * To run a query within a React component, call `useAllCampaignsForGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCampaignsForGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCampaignsForGraphDataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllCampaignsForGraphDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllCampaignsForGraphDataQuery, AllCampaignsForGraphDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllCampaignsForGraphDataQuery, AllCampaignsForGraphDataQueryVariables>(AllCampaignsForGraphDataDocument, options);
      }
export function useAllCampaignsForGraphDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllCampaignsForGraphDataQuery, AllCampaignsForGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllCampaignsForGraphDataQuery, AllCampaignsForGraphDataQueryVariables>(AllCampaignsForGraphDataDocument, options);
        }
export type AllCampaignsForGraphDataQueryHookResult = ReturnType<typeof useAllCampaignsForGraphDataQuery>;
export type AllCampaignsForGraphDataLazyQueryHookResult = ReturnType<typeof useAllCampaignsForGraphDataLazyQuery>;
export type AllCampaignsForGraphDataQueryResult = ApolloReactCommon.QueryResult<AllCampaignsForGraphDataQuery, AllCampaignsForGraphDataQueryVariables>;
export const OffsetPaginateCampaignsDocument = gql`
    query offsetPaginateCampaigns($pageNumber: Int, $itemsPerPage: Int, $orderable: CampaignOrdering, $search: String, $filter: CampaignFilter, $territories: [Territory!]!, $orderId: ID) {
  offsetPaginateCampaigns(
    pageNumber: $pageNumber
    itemsPerPage: $itemsPerPage
    orderable: $orderable
    search: $search
    filter: $filter
    territories: $territories
    orderId: $orderId
  ) {
    campaigns {
      id
      altId
      name
      pacing
      priority
      startDate
      endDate
      status
      billingType
      timeZone
      currency
      cpm
      frequencyCapCount
      frequencyCapValue
      frequencyCapTimeUnit
      objective
      impressions
      companionImpressions
      estimatedCompletion
      ltr
      sanities {
        id
        type
        name
      }
      deliveryPace
      order {
        id
        name
        externalId
        advertiser {
          id
          name
        }
      }
      owner {
        id
        email
        status
      }
      ownerName
      clickThroughRate
      archived
    }
    pageMetaData {
      pageNumber
      totalPages
      totalItems
    }
  }
}
    `;

/**
 * __useOffsetPaginateCampaignsQuery__
 *
 * To run a query within a React component, call `useOffsetPaginateCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffsetPaginateCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffsetPaginateCampaignsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      orderable: // value for 'orderable'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      territories: // value for 'territories'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOffsetPaginateCampaignsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OffsetPaginateCampaignsQuery, OffsetPaginateCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OffsetPaginateCampaignsQuery, OffsetPaginateCampaignsQueryVariables>(OffsetPaginateCampaignsDocument, options);
      }
export function useOffsetPaginateCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OffsetPaginateCampaignsQuery, OffsetPaginateCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OffsetPaginateCampaignsQuery, OffsetPaginateCampaignsQueryVariables>(OffsetPaginateCampaignsDocument, options);
        }
export type OffsetPaginateCampaignsQueryHookResult = ReturnType<typeof useOffsetPaginateCampaignsQuery>;
export type OffsetPaginateCampaignsLazyQueryHookResult = ReturnType<typeof useOffsetPaginateCampaignsLazyQuery>;
export type OffsetPaginateCampaignsQueryResult = ApolloReactCommon.QueryResult<OffsetPaginateCampaignsQuery, OffsetPaginateCampaignsQueryVariables>;
export const CampaignAdsDocument = gql`
    query CampaignAds($id: ID!, $territories: [Territory!]!) {
  campaign(id: $id) {
    id
    altId
    name
    owner {
      id
      email
      status
    }
    cpm
    frequencyCapCount
    frequencyCapValue
    frequencyCapTimeUnit
    dailyCap
    order {
      name
      id
    }
    ads(territories: $territories) {
      id
      altId
      name
      status
      targetingDefinition {
        id
        masterTargetingTemplates {
          id
          name
          description
          isMasterTemplate
          targetingGroups {
            id
            masterTargetingGroupId
            listenerAccuracy
            channels {
              id
            }
            audienceParams {
              ... on KeyValueGroupParam {
                keyValues {
                  key
                  value
                }
                clusivity
              }
              ... on AgeParam {
                ageRange {
                  minAge
                  maxAge
                }
                clusivity
              }
              ... on GenderParam {
                genders
                clusivity
              }
              ... on DayAndTimeParam {
                timeZone
                daysOfWeek {
                  day
                  hours
                }
                clusivity
              }
              ... on DeviceTypeParam {
                deviceTypes
                clusivity
              }
              ... on DeviceOperatingSystemParam {
                deviceOperatingSystems {
                  versions
                  name
                }
                clusivity
              }
              ... on ConnectionTypeParam {
                clusivity
                connectionTypes
              }
              ... on DeviceMakerParam {
                deviceMakers {
                  name
                  models
                }
                clusivity
              }
              ... on BrowserLanguageParam {
                browserLanguages {
                  description
                  code
                }
                clusivity
              }
              ... on PostalCodeParam {
                postalCodes
                postcodeGroups {
                  id
                  name
                }
                clusivity
              }
              ... on LocationParam {
                positions {
                  latitude
                  longitude
                  radius
                }
                clusivity
              }
              ... on DmpSegmentParam {
                segmentType
                segments {
                  ... on NielsenSegment {
                    id
                    fullName
                  }
                }
                clusivity
              }
              ... on DmaParam {
                dmas {
                  code
                  name
                }
                clusivity
              }
              ... on AudienceSegmentParam {
                segments {
                  id
                  displayName
                }
                clusivity
              }
              ... on GenreParam {
                genres
                clusivity
              }
              ... on ItunesCategoryParam {
                categories
                clusivity
              }
              ... on PodcastParam {
                podcastTargets {
                  collectionId
                  episodeId
                  showId
                  name
                }
                clusivity
              }
              ... on AdPositionParam {
                positions {
                  position
                  midRollPositions
                }
                clusivity
              }
              ... on IspParam {
                isps {
                  id
                  name
                }
                clusivity
              }
              ... on CountryParam {
                code
                name
                clusivity
                countryGroups {
                  name
                  id
                }
                subdivisions {
                  ... on CityParam {
                    name
                    regionCode
                    subRegionCode
                  }
                  ... on RegionParam {
                    name
                    code
                    subRegions {
                      name
                      code
                    }
                  }
                }
              }
            }
          }
        }
        generalTargetingGroup {
          id
          listenerAccuracy
          channels {
            id
          }
          audienceParams {
            ... on KeyValueGroupParam {
              keyValues {
                key
                value
              }
              clusivity
            }
            ... on AgeParam {
              ageRange {
                minAge
                maxAge
              }
              clusivity
            }
            ... on GenderParam {
              genders
              clusivity
            }
            ... on DayAndTimeParam {
              timeZone
              daysOfWeek {
                day
                hours
              }
              clusivity
            }
            ... on DeviceTypeParam {
              deviceTypes
              clusivity
            }
            ... on DeviceOperatingSystemParam {
              deviceOperatingSystems {
                versions
                name
              }
              clusivity
            }
            ... on ConnectionTypeParam {
              clusivity
              connectionTypes
            }
            ... on DeviceMakerParam {
              deviceMakers {
                name
                models
              }
              clusivity
            }
            ... on BrowserLanguageParam {
              browserLanguages {
                description
                code
              }
              clusivity
            }
            ... on PostalCodeParam {
              postalCodes
              postcodeGroups {
                id
                name
              }
              clusivity
            }
            ... on LocationParam {
              positions {
                latitude
                longitude
                radius
              }
              clusivity
            }
            ... on DmpSegmentParam {
              segmentType
              segments {
                ... on NielsenSegment {
                  id
                  fullName
                }
              }
              clusivity
            }
            ... on DmaParam {
              dmas {
                code
                name
              }
              clusivity
            }
            ... on AudienceSegmentParam {
              segments {
                id
                displayName
              }
              clusivity
            }
            ... on GenreParam {
              genres
              clusivity
            }
            ... on ItunesCategoryParam {
              categories
              clusivity
            }
            ... on PodcastParam {
              podcastTargets {
                collectionId
                episodeId
                showId
                name
              }
              clusivity
            }
            ... on AdPositionParam {
              positions {
                position
                midRollPositions
              }
              clusivity
            }
            ... on IspParam {
              isps {
                id
                name
              }
              clusivity
            }
            ... on CountryParam {
              code
              name
              clusivity
              countryGroups {
                name
                id
              }
              subdivisions {
                ... on CityParam {
                  name
                  regionCode
                  subRegionCode
                }
                ... on RegionParam {
                  name
                  code
                  subRegions {
                    name
                    code
                  }
                }
              }
            }
          }
        }
        targetingGroups {
          id
          masterTargetingGroupId
          listenerAccuracy
          channels {
            id
          }
          audienceParams {
            ... on KeyValueGroupParam {
              keyValues {
                key
                value
              }
              clusivity
            }
            ... on AgeParam {
              ageRange {
                minAge
                maxAge
              }
              clusivity
            }
            ... on GenderParam {
              genders
              clusivity
            }
            ... on DayAndTimeParam {
              timeZone
              daysOfWeek {
                day
                hours
              }
              clusivity
            }
            ... on DeviceTypeParam {
              deviceTypes
              clusivity
            }
            ... on DeviceOperatingSystemParam {
              deviceOperatingSystems {
                versions
                name
              }
              clusivity
            }
            ... on ConnectionTypeParam {
              clusivity
              connectionTypes
            }
            ... on DeviceMakerParam {
              deviceMakers {
                name
                models
              }
              clusivity
            }
            ... on BrowserLanguageParam {
              browserLanguages {
                description
                code
              }
              clusivity
            }
            ... on PostalCodeParam {
              postalCodes
              postcodeGroups {
                id
                name
              }
              clusivity
            }
            ... on LocationParam {
              positions {
                latitude
                longitude
                radius
              }
              clusivity
            }
            ... on DmpSegmentParam {
              segmentType
              segments {
                ... on NielsenSegment {
                  id
                  fullName
                }
              }
              clusivity
            }
            ... on DmaParam {
              dmas {
                code
                name
              }
              clusivity
            }
            ... on AudienceSegmentParam {
              segments {
                id
                displayName
              }
              clusivity
            }
            ... on GenreParam {
              genres
              clusivity
            }
            ... on ItunesCategoryParam {
              categories
              clusivity
            }
            ... on PodcastParam {
              podcastTargets {
                collectionId
                episodeId
                showId
                name
              }
              clusivity
            }
            ... on AdPositionParam {
              positions {
                position
                midRollPositions
              }
              clusivity
            }
            ... on IspParam {
              isps {
                id
                name
              }
              clusivity
            }
            ... on CountryParam {
              code
              name
              clusivity
              countryGroups {
                name
                id
              }
              subdivisions {
                ... on CityParam {
                  name
                  regionCode
                  subRegionCode
                }
                ... on RegionParam {
                  name
                  code
                  subRegions {
                    name
                    code
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignAdsQuery__
 *
 * To run a query within a React component, call `useCampaignAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignAdsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useCampaignAdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CampaignAdsQuery, CampaignAdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignAdsQuery, CampaignAdsQueryVariables>(CampaignAdsDocument, options);
      }
export function useCampaignAdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignAdsQuery, CampaignAdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignAdsQuery, CampaignAdsQueryVariables>(CampaignAdsDocument, options);
        }
export type CampaignAdsQueryHookResult = ReturnType<typeof useCampaignAdsQuery>;
export type CampaignAdsLazyQueryHookResult = ReturnType<typeof useCampaignAdsLazyQuery>;
export type CampaignAdsQueryResult = ApolloReactCommon.QueryResult<CampaignAdsQuery, CampaignAdsQueryVariables>;
export const CreateCreativeAudioLegacyDocument = gql`
    mutation CreateCreativeAudioLegacy($advertiserId: ID!, $type: CreativeTypeLegacy!, $name: String, $url: Url, $trackingUrls: [TrackingUrlAttributes!], $fileName: String, $duration: NonNegativeFloat, $uploadedDate: LocalDateTime, $mimeType: String, $territory: Territory) {
  createCreativeLegacy(
    advertiserId: $advertiserId
    type: $type
    audioAttributes: {name: $name, url: $url, trackingUrls: $trackingUrls, fileName: $fileName, duration: $duration, uploadedDate: $uploadedDate, mimeType: $mimeType, territory: $territory}
  ) {
    ... on CreativeAudioLegacy {
      id
      altId
      name
      status
      url
      fileName
      duration
      uploadedDate
      resourceAltId
      mimeType
      trackingUrls {
        url
        consentVendorId
      }
      advertiser {
        name
        id
      }
      territory
    }
  }
}
    `;
export type CreateCreativeAudioLegacyMutationFn = ApolloReactCommon.MutationFunction<CreateCreativeAudioLegacyMutation, CreateCreativeAudioLegacyMutationVariables>;

/**
 * __useCreateCreativeAudioLegacyMutation__
 *
 * To run a mutation, you first call `useCreateCreativeAudioLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreativeAudioLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreativeAudioLegacyMutation, { data, loading, error }] = useCreateCreativeAudioLegacyMutation({
 *   variables: {
 *      advertiserId: // value for 'advertiserId'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      url: // value for 'url'
 *      trackingUrls: // value for 'trackingUrls'
 *      fileName: // value for 'fileName'
 *      duration: // value for 'duration'
 *      uploadedDate: // value for 'uploadedDate'
 *      mimeType: // value for 'mimeType'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useCreateCreativeAudioLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCreativeAudioLegacyMutation, CreateCreativeAudioLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCreativeAudioLegacyMutation, CreateCreativeAudioLegacyMutationVariables>(CreateCreativeAudioLegacyDocument, options);
      }
export type CreateCreativeAudioLegacyMutationHookResult = ReturnType<typeof useCreateCreativeAudioLegacyMutation>;
export type CreateCreativeAudioLegacyMutationResult = ApolloReactCommon.MutationResult<CreateCreativeAudioLegacyMutation>;
export type CreateCreativeAudioLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCreativeAudioLegacyMutation, CreateCreativeAudioLegacyMutationVariables>;
export const CreateCreativeImageLegacyDocument = gql`
    mutation CreateCreativeImageLegacy($advertiserId: ID!, $type: CreativeTypeLegacy!, $name: String, $url: Url, $trackingUrls: [TrackingUrlAttributes!], $size: String, $mimeType: String, $landingPageUrl: Url, $fileName: String, $uploadedDate: LocalDateTime, $territory: Territory) {
  createCreativeLegacy(
    advertiserId: $advertiserId
    type: $type
    imageAttributes: {fileName: $fileName, name: $name, url: $url, trackingUrls: $trackingUrls, size: $size, mimeType: $mimeType, landingPageUrl: $landingPageUrl, uploadedDate: $uploadedDate, territory: $territory}
  ) {
    ... on CreativeImageLegacy {
      id
      altId
      name
      status
      url
      size
      mimeType
      trackingUrls {
        url
        consentVendorId
      }
      landingPageUrl
      fileName
      uploadedDate
      resourceAltId
      advertiser {
        name
        id
      }
      territory
    }
  }
}
    `;
export type CreateCreativeImageLegacyMutationFn = ApolloReactCommon.MutationFunction<CreateCreativeImageLegacyMutation, CreateCreativeImageLegacyMutationVariables>;

/**
 * __useCreateCreativeImageLegacyMutation__
 *
 * To run a mutation, you first call `useCreateCreativeImageLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreativeImageLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreativeImageLegacyMutation, { data, loading, error }] = useCreateCreativeImageLegacyMutation({
 *   variables: {
 *      advertiserId: // value for 'advertiserId'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      url: // value for 'url'
 *      trackingUrls: // value for 'trackingUrls'
 *      size: // value for 'size'
 *      mimeType: // value for 'mimeType'
 *      landingPageUrl: // value for 'landingPageUrl'
 *      fileName: // value for 'fileName'
 *      uploadedDate: // value for 'uploadedDate'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useCreateCreativeImageLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCreativeImageLegacyMutation, CreateCreativeImageLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCreativeImageLegacyMutation, CreateCreativeImageLegacyMutationVariables>(CreateCreativeImageLegacyDocument, options);
      }
export type CreateCreativeImageLegacyMutationHookResult = ReturnType<typeof useCreateCreativeImageLegacyMutation>;
export type CreateCreativeImageLegacyMutationResult = ApolloReactCommon.MutationResult<CreateCreativeImageLegacyMutation>;
export type CreateCreativeImageLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCreativeImageLegacyMutation, CreateCreativeImageLegacyMutationVariables>;
export const CreateCreativeRedirectLegacyDocument = gql`
    mutation CreateCreativeRedirectLegacy($advertiserId: ID!, $type: CreativeTypeLegacy!, $url: Url, $trackingUrls: [TrackingUrlAttributes!], $consentVendorId: NonNegativeInt, $territory: Territory) {
  createCreativeLegacy(
    advertiserId: $advertiserId
    type: $type
    redirectAttributes: {url: $url, consentVendorId: $consentVendorId, trackingUrls: $trackingUrls, territory: $territory}
  ) {
    ... on CreativeRedirectLegacy {
      id
      url
      consentVendorId
      trackingUrls {
        url
        consentVendorId
      }
      territory
    }
  }
}
    `;
export type CreateCreativeRedirectLegacyMutationFn = ApolloReactCommon.MutationFunction<CreateCreativeRedirectLegacyMutation, CreateCreativeRedirectLegacyMutationVariables>;

/**
 * __useCreateCreativeRedirectLegacyMutation__
 *
 * To run a mutation, you first call `useCreateCreativeRedirectLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreativeRedirectLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreativeRedirectLegacyMutation, { data, loading, error }] = useCreateCreativeRedirectLegacyMutation({
 *   variables: {
 *      advertiserId: // value for 'advertiserId'
 *      type: // value for 'type'
 *      url: // value for 'url'
 *      trackingUrls: // value for 'trackingUrls'
 *      consentVendorId: // value for 'consentVendorId'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useCreateCreativeRedirectLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCreativeRedirectLegacyMutation, CreateCreativeRedirectLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCreativeRedirectLegacyMutation, CreateCreativeRedirectLegacyMutationVariables>(CreateCreativeRedirectLegacyDocument, options);
      }
export type CreateCreativeRedirectLegacyMutationHookResult = ReturnType<typeof useCreateCreativeRedirectLegacyMutation>;
export type CreateCreativeRedirectLegacyMutationResult = ApolloReactCommon.MutationResult<CreateCreativeRedirectLegacyMutation>;
export type CreateCreativeRedirectLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCreativeRedirectLegacyMutation, CreateCreativeRedirectLegacyMutationVariables>;
export const UpdateCreativeAudioLegacyDocument = gql`
    mutation UpdateCreativeAudioLegacy($id: ID!, $type: CreativeTypeLegacy!, $trackingUrls: [TrackingUrlAttributes!], $status: CreativeStatusLegacy) {
  updateCreativeLegacy(
    id: $id
    type: $type
    audioAttributes: {status: $status, trackingUrls: $trackingUrls}
  ) {
    ... on CreativeAudioLegacy {
      id
    }
  }
}
    `;
export type UpdateCreativeAudioLegacyMutationFn = ApolloReactCommon.MutationFunction<UpdateCreativeAudioLegacyMutation, UpdateCreativeAudioLegacyMutationVariables>;

/**
 * __useUpdateCreativeAudioLegacyMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeAudioLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeAudioLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeAudioLegacyMutation, { data, loading, error }] = useUpdateCreativeAudioLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      trackingUrls: // value for 'trackingUrls'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateCreativeAudioLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCreativeAudioLegacyMutation, UpdateCreativeAudioLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCreativeAudioLegacyMutation, UpdateCreativeAudioLegacyMutationVariables>(UpdateCreativeAudioLegacyDocument, options);
      }
export type UpdateCreativeAudioLegacyMutationHookResult = ReturnType<typeof useUpdateCreativeAudioLegacyMutation>;
export type UpdateCreativeAudioLegacyMutationResult = ApolloReactCommon.MutationResult<UpdateCreativeAudioLegacyMutation>;
export type UpdateCreativeAudioLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCreativeAudioLegacyMutation, UpdateCreativeAudioLegacyMutationVariables>;
export const UpdateCreativeImageLegacyDocument = gql`
    mutation UpdateCreativeImageLegacy($id: ID!, $type: CreativeTypeLegacy!, $trackingUrls: [TrackingUrlAttributes!], $status: CreativeStatusLegacy, $landingPageUrl: Url) {
  updateCreativeLegacy(
    id: $id
    type: $type
    imageAttributes: {status: $status, landingPageUrl: $landingPageUrl, trackingUrls: $trackingUrls}
  ) {
    ... on CreativeImageLegacy {
      id
    }
  }
}
    `;
export type UpdateCreativeImageLegacyMutationFn = ApolloReactCommon.MutationFunction<UpdateCreativeImageLegacyMutation, UpdateCreativeImageLegacyMutationVariables>;

/**
 * __useUpdateCreativeImageLegacyMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeImageLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeImageLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeImageLegacyMutation, { data, loading, error }] = useUpdateCreativeImageLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      trackingUrls: // value for 'trackingUrls'
 *      status: // value for 'status'
 *      landingPageUrl: // value for 'landingPageUrl'
 *   },
 * });
 */
export function useUpdateCreativeImageLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCreativeImageLegacyMutation, UpdateCreativeImageLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCreativeImageLegacyMutation, UpdateCreativeImageLegacyMutationVariables>(UpdateCreativeImageLegacyDocument, options);
      }
export type UpdateCreativeImageLegacyMutationHookResult = ReturnType<typeof useUpdateCreativeImageLegacyMutation>;
export type UpdateCreativeImageLegacyMutationResult = ApolloReactCommon.MutationResult<UpdateCreativeImageLegacyMutation>;
export type UpdateCreativeImageLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCreativeImageLegacyMutation, UpdateCreativeImageLegacyMutationVariables>;
export const UpdateCreativeRedirectLegacyDocument = gql`
    mutation UpdateCreativeRedirectLegacy($id: ID!, $type: CreativeTypeLegacy!, $url: Url, $trackingUrls: [TrackingUrlAttributes!], $consentVendorId: NonNegativeInt) {
  updateCreativeLegacy(
    id: $id
    type: $type
    redirectAttributes: {url: $url, consentVendorId: $consentVendorId, trackingUrls: $trackingUrls}
  ) {
    ... on CreativeRedirectLegacy {
      id
    }
  }
}
    `;
export type UpdateCreativeRedirectLegacyMutationFn = ApolloReactCommon.MutationFunction<UpdateCreativeRedirectLegacyMutation, UpdateCreativeRedirectLegacyMutationVariables>;

/**
 * __useUpdateCreativeRedirectLegacyMutation__
 *
 * To run a mutation, you first call `useUpdateCreativeRedirectLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreativeRedirectLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreativeRedirectLegacyMutation, { data, loading, error }] = useUpdateCreativeRedirectLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      url: // value for 'url'
 *      trackingUrls: // value for 'trackingUrls'
 *      consentVendorId: // value for 'consentVendorId'
 *   },
 * });
 */
export function useUpdateCreativeRedirectLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCreativeRedirectLegacyMutation, UpdateCreativeRedirectLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCreativeRedirectLegacyMutation, UpdateCreativeRedirectLegacyMutationVariables>(UpdateCreativeRedirectLegacyDocument, options);
      }
export type UpdateCreativeRedirectLegacyMutationHookResult = ReturnType<typeof useUpdateCreativeRedirectLegacyMutation>;
export type UpdateCreativeRedirectLegacyMutationResult = ApolloReactCommon.MutationResult<UpdateCreativeRedirectLegacyMutation>;
export type UpdateCreativeRedirectLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCreativeRedirectLegacyMutation, UpdateCreativeRedirectLegacyMutationVariables>;
export const AllAudioCreativesLegacyDocument = gql`
    query AllAudioCreativesLegacy($advertiserId: ID, $filter: CreativeFilterLegacy, $territories: [Territory!]!) {
  allCreativesLegacy(
    advertiserId: $advertiserId
    type: AUDIO
    filter: $filter
    territories: $territories
  ) {
    ... on CreativeAudioLegacy {
      id
      name
      fileName
      url
      status
      duration
      mimeType
      uploadedDate
      resourceAltId
      altId
      advertiser {
        id
        name
      }
      territory
    }
  }
}
    `;

/**
 * __useAllAudioCreativesLegacyQuery__
 *
 * To run a query within a React component, call `useAllAudioCreativesLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAudioCreativesLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAudioCreativesLegacyQuery({
 *   variables: {
 *      advertiserId: // value for 'advertiserId'
 *      filter: // value for 'filter'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllAudioCreativesLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllAudioCreativesLegacyQuery, AllAudioCreativesLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllAudioCreativesLegacyQuery, AllAudioCreativesLegacyQueryVariables>(AllAudioCreativesLegacyDocument, options);
      }
export function useAllAudioCreativesLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllAudioCreativesLegacyQuery, AllAudioCreativesLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllAudioCreativesLegacyQuery, AllAudioCreativesLegacyQueryVariables>(AllAudioCreativesLegacyDocument, options);
        }
export type AllAudioCreativesLegacyQueryHookResult = ReturnType<typeof useAllAudioCreativesLegacyQuery>;
export type AllAudioCreativesLegacyLazyQueryHookResult = ReturnType<typeof useAllAudioCreativesLegacyLazyQuery>;
export type AllAudioCreativesLegacyQueryResult = ApolloReactCommon.QueryResult<AllAudioCreativesLegacyQuery, AllAudioCreativesLegacyQueryVariables>;
export const AllImageCreativesLegacyDocument = gql`
    query AllImageCreativesLegacy($advertiserId: ID, $filter: CreativeFilterLegacy, $territories: [Territory!]!) {
  allCreativesLegacy(
    advertiserId: $advertiserId
    type: IMAGE
    filter: $filter
    territories: $territories
  ) {
    ... on CreativeImageLegacy {
      id
      name
      fileName
      url
      size
      mimeType
      status
      uploadedDate
      resourceAltId
      altId
      advertiser {
        id
        name
      }
      territory
    }
  }
}
    `;

/**
 * __useAllImageCreativesLegacyQuery__
 *
 * To run a query within a React component, call `useAllImageCreativesLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllImageCreativesLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllImageCreativesLegacyQuery({
 *   variables: {
 *      advertiserId: // value for 'advertiserId'
 *      filter: // value for 'filter'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllImageCreativesLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllImageCreativesLegacyQuery, AllImageCreativesLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllImageCreativesLegacyQuery, AllImageCreativesLegacyQueryVariables>(AllImageCreativesLegacyDocument, options);
      }
export function useAllImageCreativesLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllImageCreativesLegacyQuery, AllImageCreativesLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllImageCreativesLegacyQuery, AllImageCreativesLegacyQueryVariables>(AllImageCreativesLegacyDocument, options);
        }
export type AllImageCreativesLegacyQueryHookResult = ReturnType<typeof useAllImageCreativesLegacyQuery>;
export type AllImageCreativesLegacyLazyQueryHookResult = ReturnType<typeof useAllImageCreativesLegacyLazyQuery>;
export type AllImageCreativesLegacyQueryResult = ApolloReactCommon.QueryResult<AllImageCreativesLegacyQuery, AllImageCreativesLegacyQueryVariables>;
export const GeneratePresignedUrlDocument = gql`
    query GeneratePresignedUrl($contentType: String, $fileName: String!, $fileSize: Long, $httpMethod: HttpMethod!) {
  generatePreSignedUrl(
    attributes: {contentType: $contentType, fileName: $fileName, fileSize: $fileSize, httpMethod: $httpMethod}
  ) {
    url
    assetUrl
    contentType
    uploadedDate
  }
}
    `;

/**
 * __useGeneratePresignedUrlQuery__
 *
 * To run a query within a React component, call `useGeneratePresignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneratePresignedUrlQuery({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      fileName: // value for 'fileName'
 *      fileSize: // value for 'fileSize'
 *      httpMethod: // value for 'httpMethod'
 *   },
 * });
 */
export function useGeneratePresignedUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GeneratePresignedUrlQuery, GeneratePresignedUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GeneratePresignedUrlQuery, GeneratePresignedUrlQueryVariables>(GeneratePresignedUrlDocument, options);
      }
export function useGeneratePresignedUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GeneratePresignedUrlQuery, GeneratePresignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GeneratePresignedUrlQuery, GeneratePresignedUrlQueryVariables>(GeneratePresignedUrlDocument, options);
        }
export type GeneratePresignedUrlQueryHookResult = ReturnType<typeof useGeneratePresignedUrlQuery>;
export type GeneratePresignedUrlLazyQueryHookResult = ReturnType<typeof useGeneratePresignedUrlLazyQuery>;
export type GeneratePresignedUrlQueryResult = ApolloReactCommon.QueryResult<GeneratePresignedUrlQuery, GeneratePresignedUrlQueryVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($advertiserId: ID!, $name: String, $externalId: String, $externalSystemId: String, $timeZone: ZoneId, $startDate: LocalDateTime, $endDate: LocalDateTime, $objective: NonNegativeInt, $ownerId: ID, $frequencyCapCount: NonNegativeInt, $frequencyCapValue: NonNegativeInt, $frequencyCapTimeUnit: FrequencyCapTimeUnit, $territory: Territory) {
  createOrder(
    advertiserId: $advertiserId
    attributes: {name: $name, externalId: $externalId, externalSystemId: $externalSystemId, timeZone: $timeZone, startDate: $startDate, endDate: $endDate, objective: $objective, ownerId: $ownerId, frequencyCapCount: $frequencyCapCount, frequencyCapValue: $frequencyCapValue, frequencyCapTimeUnit: $frequencyCapTimeUnit, territory: $territory}
  ) {
    id
    altId
    name
    startDate
    endDate
    status
    externalId
    externalSystemId
    timeZone
    objective
    frequencyCapCount
    frequencyCapValue
    frequencyCapTimeUnit
    owner {
      id
      email
    }
    territory
  }
}
    `;
export type CreateOrderMutationFn = ApolloReactCommon.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      advertiserId: // value for 'advertiserId'
 *      name: // value for 'name'
 *      externalId: // value for 'externalId'
 *      externalSystemId: // value for 'externalSystemId'
 *      timeZone: // value for 'timeZone'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      objective: // value for 'objective'
 *      ownerId: // value for 'ownerId'
 *      frequencyCapCount: // value for 'frequencyCapCount'
 *      frequencyCapValue: // value for 'frequencyCapValue'
 *      frequencyCapTimeUnit: // value for 'frequencyCapTimeUnit'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = ApolloReactCommon.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($id: ID!, $name: String, $externalId: String, $externalSystemId: String, $timeZone: ZoneId, $startDate: LocalDateTime, $endDate: LocalDateTime, $status: OrderStatus, $objective: NonNegativeInt, $ownerId: ID, $frequencyCapCount: NonNegativeInt, $frequencyCapValue: NonNegativeInt, $frequencyCapTimeUnit: FrequencyCapTimeUnit) {
  updateOrder(
    id: $id
    attributes: {name: $name, externalId: $externalId, externalSystemId: $externalSystemId, timeZone: $timeZone, startDate: $startDate, endDate: $endDate, status: $status, objective: $objective, ownerId: $ownerId, frequencyCapCount: $frequencyCapCount, frequencyCapValue: $frequencyCapValue, frequencyCapTimeUnit: $frequencyCapTimeUnit}
  ) {
    id
    name
    externalId
    externalSystemId
    timeZone
    startDate
    endDate
    status
    objective
    frequencyCapCount
    frequencyCapValue
    frequencyCapTimeUnit
    owner {
      id
      email
    }
    territory
  }
}
    `;
export type UpdateOrderMutationFn = ApolloReactCommon.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      externalId: // value for 'externalId'
 *      externalSystemId: // value for 'externalSystemId'
 *      timeZone: // value for 'timeZone'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      status: // value for 'status'
 *      objective: // value for 'objective'
 *      ownerId: // value for 'ownerId'
 *      frequencyCapCount: // value for 'frequencyCapCount'
 *      frequencyCapValue: // value for 'frequencyCapValue'
 *      frequencyCapTimeUnit: // value for 'frequencyCapTimeUnit'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = ApolloReactCommon.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const CloneOrderDocument = gql`
    mutation CloneOrder($id: ID!, $disableCascade: Boolean) {
  cloneOrder(id: $id, disableCascade: $disableCascade) {
    id
    territory
  }
}
    `;
export type CloneOrderMutationFn = ApolloReactCommon.MutationFunction<CloneOrderMutation, CloneOrderMutationVariables>;

/**
 * __useCloneOrderMutation__
 *
 * To run a mutation, you first call `useCloneOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneOrderMutation, { data, loading, error }] = useCloneOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      disableCascade: // value for 'disableCascade'
 *   },
 * });
 */
export function useCloneOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CloneOrderMutation, CloneOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CloneOrderMutation, CloneOrderMutationVariables>(CloneOrderDocument, options);
      }
export type CloneOrderMutationHookResult = ReturnType<typeof useCloneOrderMutation>;
export type CloneOrderMutationResult = ApolloReactCommon.MutationResult<CloneOrderMutation>;
export type CloneOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<CloneOrderMutation, CloneOrderMutationVariables>;
export const OrderMinimalDocument = gql`
    query OrderMinimal($id: ID!) {
  order(id: $id) {
    id
    name
    startDate
    endDate
    objective
    timeZone
    territory
    campaigns {
      id
      objective
    }
    advertiser {
      id
      iabCategories {
        code
      }
    }
    territory
    externalSystemId
  }
}
    `;

/**
 * __useOrderMinimalQuery__
 *
 * To run a query within a React component, call `useOrderMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderMinimalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderMinimalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrderMinimalQuery, OrderMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrderMinimalQuery, OrderMinimalQueryVariables>(OrderMinimalDocument, options);
      }
export function useOrderMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderMinimalQuery, OrderMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrderMinimalQuery, OrderMinimalQueryVariables>(OrderMinimalDocument, options);
        }
export type OrderMinimalQueryHookResult = ReturnType<typeof useOrderMinimalQuery>;
export type OrderMinimalLazyQueryHookResult = ReturnType<typeof useOrderMinimalLazyQuery>;
export type OrderMinimalQueryResult = ApolloReactCommon.QueryResult<OrderMinimalQuery, OrderMinimalQueryVariables>;
export const OrderDocument = gql`
    query Order($id: ID!) {
  order(id: $id) {
    id
    altId
    name
    startDate
    endDate
    status
    externalId
    externalSystemId
    timeZone
    objective
    impressions
    frequencyCapCount
    frequencyCapValue
    frequencyCapTimeUnit
    advertiser {
      id
      name
      status
      agency {
        id
        name
      }
      orders {
        id
        name
      }
    }
    owner {
      id
      email
      status
    }
    campaigns {
      id
      altId
      name
      pacing
      priority
      startDate
      endDate
      status
      timeZone
      objective
      impressions
      companionImpressions
      deliveryPace
      sanities {
        id
        type
        name
      }
      owner {
        id
        email
        status
      }
      order {
        id
        advertiser {
          id
          name
        }
      }
      clickThroughRate
    }
    territory
  }
}
    `;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = ApolloReactCommon.QueryResult<OrderQuery, OrderQueryVariables>;
export const AllOrdersDocument = gql`
    query AllOrders($advertiserId: ID, $territories: [Territory!]!) {
  allOrders(advertiserId: $advertiserId, territories: $territories) {
    id
    altId
    name
    startDate
    endDate
    timeZone
    status
    externalId
    externalSystemId
    objective
    impressions
    owner {
      id
      email
      status
    }
    territory
  }
}
    `;

/**
 * __useAllOrdersQuery__
 *
 * To run a query within a React component, call `useAllOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOrdersQuery({
 *   variables: {
 *      advertiserId: // value for 'advertiserId'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllOrdersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllOrdersQuery, AllOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllOrdersQuery, AllOrdersQueryVariables>(AllOrdersDocument, options);
      }
export function useAllOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllOrdersQuery, AllOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllOrdersQuery, AllOrdersQueryVariables>(AllOrdersDocument, options);
        }
export type AllOrdersQueryHookResult = ReturnType<typeof useAllOrdersQuery>;
export type AllOrdersLazyQueryHookResult = ReturnType<typeof useAllOrdersLazyQuery>;
export type AllOrdersQueryResult = ApolloReactCommon.QueryResult<AllOrdersQuery, AllOrdersQueryVariables>;
export const AllOrdersMinimalDocument = gql`
    query AllOrdersMinimal($advertiserId: ID, $territories: [Territory!]!) {
  allOrders(advertiserId: $advertiserId, territories: $territories) {
    id
    name
    startDate
    endDate
    objective
    campaigns {
      id
      objective
    }
    advertiser {
      id
      iabCategories {
        code
      }
    }
    territory
    externalSystemId
  }
}
    `;

/**
 * __useAllOrdersMinimalQuery__
 *
 * To run a query within a React component, call `useAllOrdersMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOrdersMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOrdersMinimalQuery({
 *   variables: {
 *      advertiserId: // value for 'advertiserId'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllOrdersMinimalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllOrdersMinimalQuery, AllOrdersMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllOrdersMinimalQuery, AllOrdersMinimalQueryVariables>(AllOrdersMinimalDocument, options);
      }
export function useAllOrdersMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllOrdersMinimalQuery, AllOrdersMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllOrdersMinimalQuery, AllOrdersMinimalQueryVariables>(AllOrdersMinimalDocument, options);
        }
export type AllOrdersMinimalQueryHookResult = ReturnType<typeof useAllOrdersMinimalQuery>;
export type AllOrdersMinimalLazyQueryHookResult = ReturnType<typeof useAllOrdersMinimalLazyQuery>;
export type AllOrdersMinimalQueryResult = ApolloReactCommon.QueryResult<AllOrdersMinimalQuery, AllOrdersMinimalQueryVariables>;
export const AllIabCategoriesDocument = gql`
    query AllIabCategories {
  allIabCategories {
    code
    name
    subIabCategories {
      code
      name
    }
  }
}
    `;

/**
 * __useAllIabCategoriesQuery__
 *
 * To run a query within a React component, call `useAllIabCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllIabCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllIabCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllIabCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllIabCategoriesQuery, AllIabCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllIabCategoriesQuery, AllIabCategoriesQueryVariables>(AllIabCategoriesDocument, options);
      }
export function useAllIabCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllIabCategoriesQuery, AllIabCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllIabCategoriesQuery, AllIabCategoriesQueryVariables>(AllIabCategoriesDocument, options);
        }
export type AllIabCategoriesQueryHookResult = ReturnType<typeof useAllIabCategoriesQuery>;
export type AllIabCategoriesLazyQueryHookResult = ReturnType<typeof useAllIabCategoriesLazyQuery>;
export type AllIabCategoriesQueryResult = ApolloReactCommon.QueryResult<AllIabCategoriesQuery, AllIabCategoriesQueryVariables>;
export const PublisherInsightsTimeSeriesDocument = gql`
    query PublisherInsightsTimeSeries($startDate: LocalDateTime!, $endDate: LocalDateTime!, $metrics: [PublisherInsightsMetric!], $timeZone: TimeZone!, $timeUnit: PublisherInsightsTimeSeriesUnit!, $filters: [PublisherInsightsFilterAttributes!], $currency: Currency!, $includeWeightingMetrics: Boolean) {
  publisherInsightsTimeSeries(
    startDate: $startDate
    endDate: $endDate
    metrics: $metrics
    timezone: $timeZone
    timeUnit: $timeUnit
    filters: $filters
    currency: $currency
    includeWeightingMetrics: $includeWeightingMetrics
  ) {
    metric
    metricType
    totalValue
    timeseries {
      dataPoints {
        t
        v
      }
    }
    currency
    metricAggregationType
    weightingMetric
  }
}
    `;

/**
 * __usePublisherInsightsTimeSeriesQuery__
 *
 * To run a query within a React component, call `usePublisherInsightsTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherInsightsTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherInsightsTimeSeriesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      metrics: // value for 'metrics'
 *      timeZone: // value for 'timeZone'
 *      timeUnit: // value for 'timeUnit'
 *      filters: // value for 'filters'
 *      currency: // value for 'currency'
 *      includeWeightingMetrics: // value for 'includeWeightingMetrics'
 *   },
 * });
 */
export function usePublisherInsightsTimeSeriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherInsightsTimeSeriesQuery, PublisherInsightsTimeSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherInsightsTimeSeriesQuery, PublisherInsightsTimeSeriesQueryVariables>(PublisherInsightsTimeSeriesDocument, options);
      }
export function usePublisherInsightsTimeSeriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherInsightsTimeSeriesQuery, PublisherInsightsTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherInsightsTimeSeriesQuery, PublisherInsightsTimeSeriesQueryVariables>(PublisherInsightsTimeSeriesDocument, options);
        }
export type PublisherInsightsTimeSeriesQueryHookResult = ReturnType<typeof usePublisherInsightsTimeSeriesQuery>;
export type PublisherInsightsTimeSeriesLazyQueryHookResult = ReturnType<typeof usePublisherInsightsTimeSeriesLazyQuery>;
export type PublisherInsightsTimeSeriesQueryResult = ApolloReactCommon.QueryResult<PublisherInsightsTimeSeriesQuery, PublisherInsightsTimeSeriesQueryVariables>;
export const PublisherInsightsTimeSeriesMinimalDocument = gql`
    query PublisherInsightsTimeSeriesMinimal($startDate: LocalDateTime!, $endDate: LocalDateTime!, $metrics: [PublisherInsightsMetric!], $timeZone: TimeZone!, $timeUnit: PublisherInsightsTimeSeriesUnit!, $filters: [PublisherInsightsFilterAttributes!], $currency: Currency!) {
  publisherInsightsTimeSeries(
    startDate: $startDate
    endDate: $endDate
    metrics: $metrics
    timezone: $timeZone
    timeUnit: $timeUnit
    filters: $filters
    currency: $currency
  ) {
    metric
    metricType
    totalValue
    currency
  }
}
    `;

/**
 * __usePublisherInsightsTimeSeriesMinimalQuery__
 *
 * To run a query within a React component, call `usePublisherInsightsTimeSeriesMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherInsightsTimeSeriesMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherInsightsTimeSeriesMinimalQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      metrics: // value for 'metrics'
 *      timeZone: // value for 'timeZone'
 *      timeUnit: // value for 'timeUnit'
 *      filters: // value for 'filters'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function usePublisherInsightsTimeSeriesMinimalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherInsightsTimeSeriesMinimalQuery, PublisherInsightsTimeSeriesMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherInsightsTimeSeriesMinimalQuery, PublisherInsightsTimeSeriesMinimalQueryVariables>(PublisherInsightsTimeSeriesMinimalDocument, options);
      }
export function usePublisherInsightsTimeSeriesMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherInsightsTimeSeriesMinimalQuery, PublisherInsightsTimeSeriesMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherInsightsTimeSeriesMinimalQuery, PublisherInsightsTimeSeriesMinimalQueryVariables>(PublisherInsightsTimeSeriesMinimalDocument, options);
        }
export type PublisherInsightsTimeSeriesMinimalQueryHookResult = ReturnType<typeof usePublisherInsightsTimeSeriesMinimalQuery>;
export type PublisherInsightsTimeSeriesMinimalLazyQueryHookResult = ReturnType<typeof usePublisherInsightsTimeSeriesMinimalLazyQuery>;
export type PublisherInsightsTimeSeriesMinimalQueryResult = ApolloReactCommon.QueryResult<PublisherInsightsTimeSeriesMinimalQuery, PublisherInsightsTimeSeriesMinimalQueryVariables>;
export const GetPublisherInsightsFilterCategoriesDocument = gql`
    query GetPublisherInsightsFilterCategories {
  publisherInsightsFilterCategories {
    displayName
    type
  }
}
    `;

/**
 * __useGetPublisherInsightsFilterCategoriesQuery__
 *
 * To run a query within a React component, call `useGetPublisherInsightsFilterCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublisherInsightsFilterCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublisherInsightsFilterCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublisherInsightsFilterCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPublisherInsightsFilterCategoriesQuery, GetPublisherInsightsFilterCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPublisherInsightsFilterCategoriesQuery, GetPublisherInsightsFilterCategoriesQueryVariables>(GetPublisherInsightsFilterCategoriesDocument, options);
      }
export function useGetPublisherInsightsFilterCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPublisherInsightsFilterCategoriesQuery, GetPublisherInsightsFilterCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPublisherInsightsFilterCategoriesQuery, GetPublisherInsightsFilterCategoriesQueryVariables>(GetPublisherInsightsFilterCategoriesDocument, options);
        }
export type GetPublisherInsightsFilterCategoriesQueryHookResult = ReturnType<typeof useGetPublisherInsightsFilterCategoriesQuery>;
export type GetPublisherInsightsFilterCategoriesLazyQueryHookResult = ReturnType<typeof useGetPublisherInsightsFilterCategoriesLazyQuery>;
export type GetPublisherInsightsFilterCategoriesQueryResult = ApolloReactCommon.QueryResult<GetPublisherInsightsFilterCategoriesQuery, GetPublisherInsightsFilterCategoriesQueryVariables>;
export const GetPublisherInsightsFiltersDocument = gql`
    query GetPublisherInsightsFilters($types: [PublisherInsightsFilterType!], $territories: [Territory!]) {
  publisherInsightsFilters(types: $types, territories: $territories) {
    type
    values {
      id
      displayName
    }
  }
}
    `;

/**
 * __useGetPublisherInsightsFiltersQuery__
 *
 * To run a query within a React component, call `useGetPublisherInsightsFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublisherInsightsFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublisherInsightsFiltersQuery({
 *   variables: {
 *      types: // value for 'types'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useGetPublisherInsightsFiltersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPublisherInsightsFiltersQuery, GetPublisherInsightsFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPublisherInsightsFiltersQuery, GetPublisherInsightsFiltersQueryVariables>(GetPublisherInsightsFiltersDocument, options);
      }
export function useGetPublisherInsightsFiltersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPublisherInsightsFiltersQuery, GetPublisherInsightsFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPublisherInsightsFiltersQuery, GetPublisherInsightsFiltersQueryVariables>(GetPublisherInsightsFiltersDocument, options);
        }
export type GetPublisherInsightsFiltersQueryHookResult = ReturnType<typeof useGetPublisherInsightsFiltersQuery>;
export type GetPublisherInsightsFiltersLazyQueryHookResult = ReturnType<typeof useGetPublisherInsightsFiltersLazyQuery>;
export type GetPublisherInsightsFiltersQueryResult = ApolloReactCommon.QueryResult<GetPublisherInsightsFiltersQuery, GetPublisherInsightsFiltersQueryVariables>;
export const InsightsTier2PermissionEntitiesDocument = gql`
    query InsightsTier2PermissionEntities($territories: [Territory!]!) {
  allNetworksLegacy(territories: $territories) {
    id
    name
    publishers(territories: $territories) {
      id
      name
      channels(territories: $territories) {
        id
        name
        shows {
          show_id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useInsightsTier2PermissionEntitiesQuery__
 *
 * To run a query within a React component, call `useInsightsTier2PermissionEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsTier2PermissionEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsTier2PermissionEntitiesQuery({
 *   variables: {
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useInsightsTier2PermissionEntitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InsightsTier2PermissionEntitiesQuery, InsightsTier2PermissionEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InsightsTier2PermissionEntitiesQuery, InsightsTier2PermissionEntitiesQueryVariables>(InsightsTier2PermissionEntitiesDocument, options);
      }
export function useInsightsTier2PermissionEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InsightsTier2PermissionEntitiesQuery, InsightsTier2PermissionEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InsightsTier2PermissionEntitiesQuery, InsightsTier2PermissionEntitiesQueryVariables>(InsightsTier2PermissionEntitiesDocument, options);
        }
export type InsightsTier2PermissionEntitiesQueryHookResult = ReturnType<typeof useInsightsTier2PermissionEntitiesQuery>;
export type InsightsTier2PermissionEntitiesLazyQueryHookResult = ReturnType<typeof useInsightsTier2PermissionEntitiesLazyQuery>;
export type InsightsTier2PermissionEntitiesQueryResult = ApolloReactCommon.QueryResult<InsightsTier2PermissionEntitiesQuery, InsightsTier2PermissionEntitiesQueryVariables>;
export const CreateChannelLegacyDocument = gql`
    mutation CreateChannelLegacy($floorCpm: BigDecimal, $locale: Locale, $name: String, $publisherId: ID!, $timeZone: ZoneId, $defaultTranscodePresetId: ID, $transcodePresetIds: [ID!], $type: ChannelType, $inventoryType: InventoryType, $vastVersion: VastVersion, $blacklistedIabCategoryCodes: [ID!], $blacklistedDomains: [DomainName!], $blockedKeyValues: [BlockedKeyValueAttributes!], $overrideConsentSignal: Boolean, $trafficAcceptancePercentage: NonNegativeFloat, $externalDealId: String, $minAdDuration: NonNegativeFloat, $maxAdDuration: NonNegativeFloat, $territories: [Territory!], $adRequestEnrichment: AdRequestEnrichmentAttributes, $includedInDefaultInventoryTargeting: Boolean, $targetingRestrictions: [TargetingRestriction!]) {
  createChannelLegacy(
    publisherId: $publisherId
    attributes: {territories: $territories, name: $name, vastVersion: $vastVersion, type: $type, inventoryType: $inventoryType, floorCpm: $floorCpm, locale: $locale, timeZone: $timeZone, defaultTranscodePresetId: $defaultTranscodePresetId, transcodePresetIds: $transcodePresetIds, blacklistedIabCategoryCodes: $blacklistedIabCategoryCodes, blacklistedDomains: $blacklistedDomains, blockedKeyValues: $blockedKeyValues, overrideConsentSignal: $overrideConsentSignal, trafficAcceptancePercentage: $trafficAcceptancePercentage, externalDealId: $externalDealId, minAdDuration: $minAdDuration, maxAdDuration: $maxAdDuration, adRequestEnrichment: $adRequestEnrichment, includedInDefaultInventoryTargeting: $includedInDefaultInventoryTargeting, targetingRestrictions: $targetingRestrictions}
  ) {
    territories
    id
    altId
    name
    vastVersion
    type
    locale
    timeZone
    floorCpm
    blacklistedDomains
    status
    externalDealId
    defaultTranscodePreset {
      id
    }
    transcodePresets {
      id
      altId
      name
      bitRate
      format
      mode
      sampleRate
      volume
    }
    publisher {
      id
      name
    }
    blacklistedIabCategories {
      name
      code
    }
    overrideConsentSignal
    trafficAcceptancePercentage
    includedInDefaultInventoryTargeting
    minAdDuration
    maxAdDuration
    adRequestEnrichment {
      parameters {
        type
        values {
          id
          name
        }
      }
      customKvps {
        key
        value
        override
      }
    }
  }
}
    `;
export type CreateChannelLegacyMutationFn = ApolloReactCommon.MutationFunction<CreateChannelLegacyMutation, CreateChannelLegacyMutationVariables>;

/**
 * __useCreateChannelLegacyMutation__
 *
 * To run a mutation, you first call `useCreateChannelLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelLegacyMutation, { data, loading, error }] = useCreateChannelLegacyMutation({
 *   variables: {
 *      floorCpm: // value for 'floorCpm'
 *      locale: // value for 'locale'
 *      name: // value for 'name'
 *      publisherId: // value for 'publisherId'
 *      timeZone: // value for 'timeZone'
 *      defaultTranscodePresetId: // value for 'defaultTranscodePresetId'
 *      transcodePresetIds: // value for 'transcodePresetIds'
 *      type: // value for 'type'
 *      inventoryType: // value for 'inventoryType'
 *      vastVersion: // value for 'vastVersion'
 *      blacklistedIabCategoryCodes: // value for 'blacklistedIabCategoryCodes'
 *      blacklistedDomains: // value for 'blacklistedDomains'
 *      blockedKeyValues: // value for 'blockedKeyValues'
 *      overrideConsentSignal: // value for 'overrideConsentSignal'
 *      trafficAcceptancePercentage: // value for 'trafficAcceptancePercentage'
 *      externalDealId: // value for 'externalDealId'
 *      minAdDuration: // value for 'minAdDuration'
 *      maxAdDuration: // value for 'maxAdDuration'
 *      territories: // value for 'territories'
 *      adRequestEnrichment: // value for 'adRequestEnrichment'
 *      includedInDefaultInventoryTargeting: // value for 'includedInDefaultInventoryTargeting'
 *      targetingRestrictions: // value for 'targetingRestrictions'
 *   },
 * });
 */
export function useCreateChannelLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateChannelLegacyMutation, CreateChannelLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateChannelLegacyMutation, CreateChannelLegacyMutationVariables>(CreateChannelLegacyDocument, options);
      }
export type CreateChannelLegacyMutationHookResult = ReturnType<typeof useCreateChannelLegacyMutation>;
export type CreateChannelLegacyMutationResult = ApolloReactCommon.MutationResult<CreateChannelLegacyMutation>;
export type CreateChannelLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateChannelLegacyMutation, CreateChannelLegacyMutationVariables>;
export const UpdateChannelLegacyDocument = gql`
    mutation UpdateChannelLegacy($territories: [Territory!], $floorCpm: BigDecimal, $id: ID!, $locale: Locale, $name: String, $timeZone: ZoneId, $defaultTranscodePresetId: ID, $transcodePresetIds: [ID!], $type: ChannelType, $inventoryType: InventoryType, $vastVersion: VastVersion, $blacklistedIabCategoryCodes: [ID!], $blacklistedDomains: [DomainName!], $blockedKeyValues: [BlockedKeyValueAttributes!], $status: ChannelStatus, $overrideConsentSignal: Boolean, $trafficAcceptancePercentage: NonNegativeFloat, $externalDealId: String, $minAdDuration: NonNegativeFloat, $maxAdDuration: NonNegativeFloat, $adRequestEnrichment: AdRequestEnrichmentAttributes, $includedInDefaultInventoryTargeting: Boolean, $targetingRestrictions: [TargetingRestriction!]) {
  updateChannelLegacy(
    id: $id
    attributes: {floorCpm: $floorCpm, locale: $locale, name: $name, timeZone: $timeZone, defaultTranscodePresetId: $defaultTranscodePresetId, transcodePresetIds: $transcodePresetIds, type: $type, inventoryType: $inventoryType, vastVersion: $vastVersion, blacklistedIabCategoryCodes: $blacklistedIabCategoryCodes, blacklistedDomains: $blacklistedDomains, blockedKeyValues: $blockedKeyValues, status: $status, overrideConsentSignal: $overrideConsentSignal, trafficAcceptancePercentage: $trafficAcceptancePercentage, externalDealId: $externalDealId, minAdDuration: $minAdDuration, maxAdDuration: $maxAdDuration, territories: $territories, adRequestEnrichment: $adRequestEnrichment, includedInDefaultInventoryTargeting: $includedInDefaultInventoryTargeting, targetingRestrictions: $targetingRestrictions}
  ) {
    territories
    id
    name
    vastVersion
    type
    locale
    timeZone
    floorCpm
    blacklistedDomains
    status
    externalDealId
    defaultTranscodePreset {
      id
    }
    transcodePresets {
      id
      altId
      name
      bitRate
      format
      mode
      sampleRate
      volume
    }
    publisher {
      id
    }
    blacklistedIabCategories {
      name
      code
    }
    overrideConsentSignal
    trafficAcceptancePercentage
    includedInDefaultInventoryTargeting
    minAdDuration
    maxAdDuration
    adRequestEnrichment {
      parameters {
        type
        values {
          id
          name
        }
      }
      customKvps {
        key
        value
        override
      }
    }
  }
}
    `;
export type UpdateChannelLegacyMutationFn = ApolloReactCommon.MutationFunction<UpdateChannelLegacyMutation, UpdateChannelLegacyMutationVariables>;

/**
 * __useUpdateChannelLegacyMutation__
 *
 * To run a mutation, you first call `useUpdateChannelLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelLegacyMutation, { data, loading, error }] = useUpdateChannelLegacyMutation({
 *   variables: {
 *      territories: // value for 'territories'
 *      floorCpm: // value for 'floorCpm'
 *      id: // value for 'id'
 *      locale: // value for 'locale'
 *      name: // value for 'name'
 *      timeZone: // value for 'timeZone'
 *      defaultTranscodePresetId: // value for 'defaultTranscodePresetId'
 *      transcodePresetIds: // value for 'transcodePresetIds'
 *      type: // value for 'type'
 *      inventoryType: // value for 'inventoryType'
 *      vastVersion: // value for 'vastVersion'
 *      blacklistedIabCategoryCodes: // value for 'blacklistedIabCategoryCodes'
 *      blacklistedDomains: // value for 'blacklistedDomains'
 *      blockedKeyValues: // value for 'blockedKeyValues'
 *      status: // value for 'status'
 *      overrideConsentSignal: // value for 'overrideConsentSignal'
 *      trafficAcceptancePercentage: // value for 'trafficAcceptancePercentage'
 *      externalDealId: // value for 'externalDealId'
 *      minAdDuration: // value for 'minAdDuration'
 *      maxAdDuration: // value for 'maxAdDuration'
 *      adRequestEnrichment: // value for 'adRequestEnrichment'
 *      includedInDefaultInventoryTargeting: // value for 'includedInDefaultInventoryTargeting'
 *      targetingRestrictions: // value for 'targetingRestrictions'
 *   },
 * });
 */
export function useUpdateChannelLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateChannelLegacyMutation, UpdateChannelLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateChannelLegacyMutation, UpdateChannelLegacyMutationVariables>(UpdateChannelLegacyDocument, options);
      }
export type UpdateChannelLegacyMutationHookResult = ReturnType<typeof useUpdateChannelLegacyMutation>;
export type UpdateChannelLegacyMutationResult = ApolloReactCommon.MutationResult<UpdateChannelLegacyMutation>;
export type UpdateChannelLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChannelLegacyMutation, UpdateChannelLegacyMutationVariables>;
export const CreateShowContractDocument = gql`
    mutation CreateShowContract($channelId: ID!, $showId: ID, $startDate: LocalDateTime, $endDate: LocalDateTime, $directSpotCpm: NonNegativeFloat, $programmaticSpotCpm: NonNegativeFloat, $spotRevenueShare: NonNegativeFloat, $sponsorshipRevenueShare: NonNegativeFloat, $hostReadRevenueShare: NonNegativeFloat, $hostReadCpm: NonNegativeFloat, $territories: [Territory!], $currency: Currency, $notes: String) {
  createShowContract(
    channelId: $channelId
    attributes: {showId: $showId, startDate: $startDate, endDate: $endDate, directSpotCpm: $directSpotCpm, programmaticSpotCpm: $programmaticSpotCpm, spotRevenueShare: $spotRevenueShare, sponsorshipRevenueShare: $sponsorshipRevenueShare, hostReadRevenueShare: $hostReadRevenueShare, hostReadCpm: $hostReadCpm, territories: $territories, currency: $currency, notes: $notes}
  ) {
    id
    altId
    startDate
    endDate
    show {
      show_id
      name
      hostingPlatform
    }
    directSpotCpm
    programmaticSpotCpm
    spotRevenueShare
    hostReadRevenueShare
    hostReadCpm
    sponsorshipRevenueShare
    territories
    currency
    notes
  }
}
    `;
export type CreateShowContractMutationFn = ApolloReactCommon.MutationFunction<CreateShowContractMutation, CreateShowContractMutationVariables>;

/**
 * __useCreateShowContractMutation__
 *
 * To run a mutation, you first call `useCreateShowContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShowContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShowContractMutation, { data, loading, error }] = useCreateShowContractMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      showId: // value for 'showId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      directSpotCpm: // value for 'directSpotCpm'
 *      programmaticSpotCpm: // value for 'programmaticSpotCpm'
 *      spotRevenueShare: // value for 'spotRevenueShare'
 *      sponsorshipRevenueShare: // value for 'sponsorshipRevenueShare'
 *      hostReadRevenueShare: // value for 'hostReadRevenueShare'
 *      hostReadCpm: // value for 'hostReadCpm'
 *      territories: // value for 'territories'
 *      currency: // value for 'currency'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useCreateShowContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateShowContractMutation, CreateShowContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateShowContractMutation, CreateShowContractMutationVariables>(CreateShowContractDocument, options);
      }
export type CreateShowContractMutationHookResult = ReturnType<typeof useCreateShowContractMutation>;
export type CreateShowContractMutationResult = ApolloReactCommon.MutationResult<CreateShowContractMutation>;
export type CreateShowContractMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateShowContractMutation, CreateShowContractMutationVariables>;
export const UpdateShowContractDocument = gql`
    mutation UpdateShowContract($id: ID!, $showId: ID, $startDate: LocalDateTime, $endDate: LocalDateTime, $directSpotCpm: NonNegativeFloat, $programmaticSpotCpm: NonNegativeFloat, $spotRevenueShare: NonNegativeFloat, $sponsorshipRevenueShare: NonNegativeFloat, $hostReadRevenueShare: NonNegativeFloat, $hostReadCpm: NonNegativeFloat, $territories: [Territory!], $currency: Currency, $notes: String) {
  updateShowContract(
    id: $id
    attributes: {showId: $showId, startDate: $startDate, endDate: $endDate, directSpotCpm: $directSpotCpm, programmaticSpotCpm: $programmaticSpotCpm, spotRevenueShare: $spotRevenueShare, sponsorshipRevenueShare: $sponsorshipRevenueShare, hostReadRevenueShare: $hostReadRevenueShare, hostReadCpm: $hostReadCpm, territories: $territories, currency: $currency, notes: $notes}
  ) {
    id
    altId
    startDate
    endDate
    show {
      show_id
      name
      hostingPlatform
    }
    directSpotCpm
    programmaticSpotCpm
    spotRevenueShare
    hostReadRevenueShare
    hostReadCpm
    sponsorshipRevenueShare
    territories
    currency
    notes
  }
}
    `;
export type UpdateShowContractMutationFn = ApolloReactCommon.MutationFunction<UpdateShowContractMutation, UpdateShowContractMutationVariables>;

/**
 * __useUpdateShowContractMutation__
 *
 * To run a mutation, you first call `useUpdateShowContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShowContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShowContractMutation, { data, loading, error }] = useUpdateShowContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *      showId: // value for 'showId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      directSpotCpm: // value for 'directSpotCpm'
 *      programmaticSpotCpm: // value for 'programmaticSpotCpm'
 *      spotRevenueShare: // value for 'spotRevenueShare'
 *      sponsorshipRevenueShare: // value for 'sponsorshipRevenueShare'
 *      hostReadRevenueShare: // value for 'hostReadRevenueShare'
 *      hostReadCpm: // value for 'hostReadCpm'
 *      territories: // value for 'territories'
 *      currency: // value for 'currency'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateShowContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateShowContractMutation, UpdateShowContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateShowContractMutation, UpdateShowContractMutationVariables>(UpdateShowContractDocument, options);
      }
export type UpdateShowContractMutationHookResult = ReturnType<typeof useUpdateShowContractMutation>;
export type UpdateShowContractMutationResult = ApolloReactCommon.MutationResult<UpdateShowContractMutation>;
export type UpdateShowContractMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateShowContractMutation, UpdateShowContractMutationVariables>;
export const ChannelLegacyDocument = gql`
    query ChannelLegacy($id: ID!) {
  channelLegacy(id: $id) {
    id
    altId
    territories
    publisher {
      id
      name
      status
      territories
    }
    name
    vastVersion
    externalDealId
    type
    inventoryType
    locale
    timeZone
    floorCpm
    blacklistedDomains
    blockedKeyValues {
      key
      values
    }
    status
    defaultTranscodePreset {
      id
    }
    transcodePresets {
      id
      altId
      name
    }
    blacklistedIabCategories {
      name
      code
    }
    overrideConsentSignal
    trafficAcceptancePercentage
    includedInDefaultInventoryTargeting
    targetingRestrictions
    minAdDuration
    maxAdDuration
    adRequestEnrichment {
      parameters {
        type
        values {
          id
          name
        }
      }
      customKvps {
        key
        value
        override
      }
    }
  }
}
    `;

/**
 * __useChannelLegacyQuery__
 *
 * To run a query within a React component, call `useChannelLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChannelLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChannelLegacyQuery, ChannelLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChannelLegacyQuery, ChannelLegacyQueryVariables>(ChannelLegacyDocument, options);
      }
export function useChannelLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChannelLegacyQuery, ChannelLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChannelLegacyQuery, ChannelLegacyQueryVariables>(ChannelLegacyDocument, options);
        }
export type ChannelLegacyQueryHookResult = ReturnType<typeof useChannelLegacyQuery>;
export type ChannelLegacyLazyQueryHookResult = ReturnType<typeof useChannelLegacyLazyQuery>;
export type ChannelLegacyQueryResult = ApolloReactCommon.QueryResult<ChannelLegacyQuery, ChannelLegacyQueryVariables>;
export const ChannelAssociatedAdsLegacyDocument = gql`
    query ChannelAssociatedAdsLegacy($id: ID!, $territories: [Territory!]!) {
  channelLegacy(id: $id) {
    id
    associatedAds(
      filter: {status_in: [LIVE, READY, PAUSED]}
      territories: $territories
    ) {
      id
      altId
      name
      startDate {
        isInherited
        value
      }
      endDate {
        isInherited
        value
      }
      status
      campaign {
        id
        name
        timeZone
        pacing
        owner {
          id
          email
        }
      }
    }
  }
}
    `;

/**
 * __useChannelAssociatedAdsLegacyQuery__
 *
 * To run a query within a React component, call `useChannelAssociatedAdsLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelAssociatedAdsLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelAssociatedAdsLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useChannelAssociatedAdsLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChannelAssociatedAdsLegacyQuery, ChannelAssociatedAdsLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChannelAssociatedAdsLegacyQuery, ChannelAssociatedAdsLegacyQueryVariables>(ChannelAssociatedAdsLegacyDocument, options);
      }
export function useChannelAssociatedAdsLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChannelAssociatedAdsLegacyQuery, ChannelAssociatedAdsLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChannelAssociatedAdsLegacyQuery, ChannelAssociatedAdsLegacyQueryVariables>(ChannelAssociatedAdsLegacyDocument, options);
        }
export type ChannelAssociatedAdsLegacyQueryHookResult = ReturnType<typeof useChannelAssociatedAdsLegacyQuery>;
export type ChannelAssociatedAdsLegacyLazyQueryHookResult = ReturnType<typeof useChannelAssociatedAdsLegacyLazyQuery>;
export type ChannelAssociatedAdsLegacyQueryResult = ApolloReactCommon.QueryResult<ChannelAssociatedAdsLegacyQuery, ChannelAssociatedAdsLegacyQueryVariables>;
export const ChannelAssociatedDealsLegacyDocument = gql`
    query ChannelAssociatedDealsLegacy($id: ID!, $territories: [Territory!]!) {
  channelLegacy(id: $id) {
    id
    associatedDeals(territories: $territories, filter: {status_in: [ACTIVE, READY]}) {
      id
      altId
      name
      startDate
      endDate
      timeZone
      status
      priority
      salesChannel {
        id
        name
        owner {
          id
          email
        }
      }
    }
  }
}
    `;

/**
 * __useChannelAssociatedDealsLegacyQuery__
 *
 * To run a query within a React component, call `useChannelAssociatedDealsLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelAssociatedDealsLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelAssociatedDealsLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useChannelAssociatedDealsLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChannelAssociatedDealsLegacyQuery, ChannelAssociatedDealsLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChannelAssociatedDealsLegacyQuery, ChannelAssociatedDealsLegacyQueryVariables>(ChannelAssociatedDealsLegacyDocument, options);
      }
export function useChannelAssociatedDealsLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChannelAssociatedDealsLegacyQuery, ChannelAssociatedDealsLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChannelAssociatedDealsLegacyQuery, ChannelAssociatedDealsLegacyQueryVariables>(ChannelAssociatedDealsLegacyDocument, options);
        }
export type ChannelAssociatedDealsLegacyQueryHookResult = ReturnType<typeof useChannelAssociatedDealsLegacyQuery>;
export type ChannelAssociatedDealsLegacyLazyQueryHookResult = ReturnType<typeof useChannelAssociatedDealsLegacyLazyQuery>;
export type ChannelAssociatedDealsLegacyQueryResult = ApolloReactCommon.QueryResult<ChannelAssociatedDealsLegacyQuery, ChannelAssociatedDealsLegacyQueryVariables>;
export const ChannelTimeSeriesLegacyDocument = gql`
    query ChannelTimeSeriesLegacy($id: ID!, $timeZone: ZoneId!) {
  channelLegacy(id: $id) {
    id
    timeZone
    timeSeries(params: {timeUnit: HOUR, timeZone: $timeZone}) {
      impressions {
        dataPoints {
          t
          v
        }
      }
    }
  }
}
    `;

/**
 * __useChannelTimeSeriesLegacyQuery__
 *
 * To run a query within a React component, call `useChannelTimeSeriesLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelTimeSeriesLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelTimeSeriesLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useChannelTimeSeriesLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChannelTimeSeriesLegacyQuery, ChannelTimeSeriesLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChannelTimeSeriesLegacyQuery, ChannelTimeSeriesLegacyQueryVariables>(ChannelTimeSeriesLegacyDocument, options);
      }
export function useChannelTimeSeriesLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChannelTimeSeriesLegacyQuery, ChannelTimeSeriesLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChannelTimeSeriesLegacyQuery, ChannelTimeSeriesLegacyQueryVariables>(ChannelTimeSeriesLegacyDocument, options);
        }
export type ChannelTimeSeriesLegacyQueryHookResult = ReturnType<typeof useChannelTimeSeriesLegacyQuery>;
export type ChannelTimeSeriesLegacyLazyQueryHookResult = ReturnType<typeof useChannelTimeSeriesLegacyLazyQuery>;
export type ChannelTimeSeriesLegacyQueryResult = ApolloReactCommon.QueryResult<ChannelTimeSeriesLegacyQuery, ChannelTimeSeriesLegacyQueryVariables>;
export const AllChannelsMinimalLegacyDocument = gql`
    query AllChannelsMinimalLegacy($publisherId: ID, $territories: [Territory!]!) {
  allChannelsLegacy(publisherId: $publisherId, territories: $territories) {
    id
    altId
    name
  }
}
    `;

/**
 * __useAllChannelsMinimalLegacyQuery__
 *
 * To run a query within a React component, call `useAllChannelsMinimalLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChannelsMinimalLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChannelsMinimalLegacyQuery({
 *   variables: {
 *      publisherId: // value for 'publisherId'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllChannelsMinimalLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllChannelsMinimalLegacyQuery, AllChannelsMinimalLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllChannelsMinimalLegacyQuery, AllChannelsMinimalLegacyQueryVariables>(AllChannelsMinimalLegacyDocument, options);
      }
export function useAllChannelsMinimalLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllChannelsMinimalLegacyQuery, AllChannelsMinimalLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllChannelsMinimalLegacyQuery, AllChannelsMinimalLegacyQueryVariables>(AllChannelsMinimalLegacyDocument, options);
        }
export type AllChannelsMinimalLegacyQueryHookResult = ReturnType<typeof useAllChannelsMinimalLegacyQuery>;
export type AllChannelsMinimalLegacyLazyQueryHookResult = ReturnType<typeof useAllChannelsMinimalLegacyLazyQuery>;
export type AllChannelsMinimalLegacyQueryResult = ApolloReactCommon.QueryResult<AllChannelsMinimalLegacyQuery, AllChannelsMinimalLegacyQueryVariables>;
export const AllChannelsLegacyDocument = gql`
    query AllChannelsLegacy($publisherId: ID, $territories: [Territory!]!) {
  allChannelsLegacy(publisherId: $publisherId, territories: $territories) {
    id
    altId
    name
    trafficAcceptancePercentage
    type
    publisher {
      network {
        name
        id
      }
      name
      id
    }
    status
  }
}
    `;

/**
 * __useAllChannelsLegacyQuery__
 *
 * To run a query within a React component, call `useAllChannelsLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChannelsLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChannelsLegacyQuery({
 *   variables: {
 *      publisherId: // value for 'publisherId'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllChannelsLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllChannelsLegacyQuery, AllChannelsLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllChannelsLegacyQuery, AllChannelsLegacyQueryVariables>(AllChannelsLegacyDocument, options);
      }
export function useAllChannelsLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllChannelsLegacyQuery, AllChannelsLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllChannelsLegacyQuery, AllChannelsLegacyQueryVariables>(AllChannelsLegacyDocument, options);
        }
export type AllChannelsLegacyQueryHookResult = ReturnType<typeof useAllChannelsLegacyQuery>;
export type AllChannelsLegacyLazyQueryHookResult = ReturnType<typeof useAllChannelsLegacyLazyQuery>;
export type AllChannelsLegacyQueryResult = ApolloReactCommon.QueryResult<AllChannelsLegacyQuery, AllChannelsLegacyQueryVariables>;
export const AllShowContractsDocument = gql`
    query allShowContracts($channelId: ID, $filter: ShowContractFilter) {
  allShowContracts(channelId: $channelId, filter: $filter) {
    id
    altId
    startDate
    endDate
    show {
      show_id
      name
      hostingPlatform
    }
    directSpotCpm
    programmaticSpotCpm
    spotRevenueShare
    hostReadRevenueShare
    hostReadCpm
    sponsorshipRevenueShare
    territories
    currency
    notes
  }
}
    `;

/**
 * __useAllShowContractsQuery__
 *
 * To run a query within a React component, call `useAllShowContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllShowContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllShowContractsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllShowContractsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllShowContractsQuery, AllShowContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllShowContractsQuery, AllShowContractsQueryVariables>(AllShowContractsDocument, options);
      }
export function useAllShowContractsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllShowContractsQuery, AllShowContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllShowContractsQuery, AllShowContractsQueryVariables>(AllShowContractsDocument, options);
        }
export type AllShowContractsQueryHookResult = ReturnType<typeof useAllShowContractsQuery>;
export type AllShowContractsLazyQueryHookResult = ReturnType<typeof useAllShowContractsLazyQuery>;
export type AllShowContractsQueryResult = ApolloReactCommon.QueryResult<AllShowContractsQuery, AllShowContractsQueryVariables>;
export const AllShowsLegacyDocument = gql`
    query allShowsLegacy {
  allShowsLegacy {
    show_id
    name
    hostingPlatform
  }
}
    `;

/**
 * __useAllShowsLegacyQuery__
 *
 * To run a query within a React component, call `useAllShowsLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllShowsLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllShowsLegacyQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllShowsLegacyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllShowsLegacyQuery, AllShowsLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllShowsLegacyQuery, AllShowsLegacyQueryVariables>(AllShowsLegacyDocument, options);
      }
export function useAllShowsLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllShowsLegacyQuery, AllShowsLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllShowsLegacyQuery, AllShowsLegacyQueryVariables>(AllShowsLegacyDocument, options);
        }
export type AllShowsLegacyQueryHookResult = ReturnType<typeof useAllShowsLegacyQuery>;
export type AllShowsLegacyLazyQueryHookResult = ReturnType<typeof useAllShowsLegacyLazyQuery>;
export type AllShowsLegacyQueryResult = ApolloReactCommon.QueryResult<AllShowsLegacyQuery, AllShowsLegacyQueryVariables>;
export const AllAdRequestEnrichmentAudienceParametersDocument = gql`
    query allAdRequestEnrichmentAudienceParameters {
  allAdRequestEnrichmentAudienceParameters {
    type
    name
    cardinality
  }
}
    `;

/**
 * __useAllAdRequestEnrichmentAudienceParametersQuery__
 *
 * To run a query within a React component, call `useAllAdRequestEnrichmentAudienceParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAdRequestEnrichmentAudienceParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAdRequestEnrichmentAudienceParametersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAdRequestEnrichmentAudienceParametersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllAdRequestEnrichmentAudienceParametersQuery, AllAdRequestEnrichmentAudienceParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllAdRequestEnrichmentAudienceParametersQuery, AllAdRequestEnrichmentAudienceParametersQueryVariables>(AllAdRequestEnrichmentAudienceParametersDocument, options);
      }
export function useAllAdRequestEnrichmentAudienceParametersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllAdRequestEnrichmentAudienceParametersQuery, AllAdRequestEnrichmentAudienceParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllAdRequestEnrichmentAudienceParametersQuery, AllAdRequestEnrichmentAudienceParametersQueryVariables>(AllAdRequestEnrichmentAudienceParametersDocument, options);
        }
export type AllAdRequestEnrichmentAudienceParametersQueryHookResult = ReturnType<typeof useAllAdRequestEnrichmentAudienceParametersQuery>;
export type AllAdRequestEnrichmentAudienceParametersLazyQueryHookResult = ReturnType<typeof useAllAdRequestEnrichmentAudienceParametersLazyQuery>;
export type AllAdRequestEnrichmentAudienceParametersQueryResult = ApolloReactCommon.QueryResult<AllAdRequestEnrichmentAudienceParametersQuery, AllAdRequestEnrichmentAudienceParametersQueryVariables>;
export const AllAdRequestEnrichmentAudienceParameterValuesDocument = gql`
    query AllAdRequestEnrichmentAudienceParameterValues($type: AudienceParameterType!) {
  allAdRequestEnrichmentAudienceParameterValues(type: $type) {
    id
    name
    active
    children {
      id
      name
      active
      children {
        id
        name
        active
        children {
          id
          name
          active
        }
      }
    }
  }
}
    `;

/**
 * __useAllAdRequestEnrichmentAudienceParameterValuesQuery__
 *
 * To run a query within a React component, call `useAllAdRequestEnrichmentAudienceParameterValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAdRequestEnrichmentAudienceParameterValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAdRequestEnrichmentAudienceParameterValuesQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAllAdRequestEnrichmentAudienceParameterValuesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllAdRequestEnrichmentAudienceParameterValuesQuery, AllAdRequestEnrichmentAudienceParameterValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllAdRequestEnrichmentAudienceParameterValuesQuery, AllAdRequestEnrichmentAudienceParameterValuesQueryVariables>(AllAdRequestEnrichmentAudienceParameterValuesDocument, options);
      }
export function useAllAdRequestEnrichmentAudienceParameterValuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllAdRequestEnrichmentAudienceParameterValuesQuery, AllAdRequestEnrichmentAudienceParameterValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllAdRequestEnrichmentAudienceParameterValuesQuery, AllAdRequestEnrichmentAudienceParameterValuesQueryVariables>(AllAdRequestEnrichmentAudienceParameterValuesDocument, options);
        }
export type AllAdRequestEnrichmentAudienceParameterValuesQueryHookResult = ReturnType<typeof useAllAdRequestEnrichmentAudienceParameterValuesQuery>;
export type AllAdRequestEnrichmentAudienceParameterValuesLazyQueryHookResult = ReturnType<typeof useAllAdRequestEnrichmentAudienceParameterValuesLazyQuery>;
export type AllAdRequestEnrichmentAudienceParameterValuesQueryResult = ApolloReactCommon.QueryResult<AllAdRequestEnrichmentAudienceParameterValuesQuery, AllAdRequestEnrichmentAudienceParameterValuesQueryVariables>;
export const CreateNetworkLegacyDocument = gql`
    mutation CreateNetworkLegacy($name: String, $territories: [Territory!]) {
  createNetworkLegacy(attributes: {name: $name, territories: $territories}) {
    id
    name
    altId
    status
    territories
  }
}
    `;
export type CreateNetworkLegacyMutationFn = ApolloReactCommon.MutationFunction<CreateNetworkLegacyMutation, CreateNetworkLegacyMutationVariables>;

/**
 * __useCreateNetworkLegacyMutation__
 *
 * To run a mutation, you first call `useCreateNetworkLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNetworkLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNetworkLegacyMutation, { data, loading, error }] = useCreateNetworkLegacyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useCreateNetworkLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNetworkLegacyMutation, CreateNetworkLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateNetworkLegacyMutation, CreateNetworkLegacyMutationVariables>(CreateNetworkLegacyDocument, options);
      }
export type CreateNetworkLegacyMutationHookResult = ReturnType<typeof useCreateNetworkLegacyMutation>;
export type CreateNetworkLegacyMutationResult = ApolloReactCommon.MutationResult<CreateNetworkLegacyMutation>;
export type CreateNetworkLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNetworkLegacyMutation, CreateNetworkLegacyMutationVariables>;
export const UpdateNetworkLegacyDocument = gql`
    mutation UpdateNetworkLegacy($id: ID!, $name: String, $status: NetworkStatus, $territories: [Territory!]) {
  updateNetworkLegacy(
    id: $id
    attributes: {name: $name, status: $status, territories: $territories}
  ) {
    id
    altId
    name
    status
    territories
  }
}
    `;
export type UpdateNetworkLegacyMutationFn = ApolloReactCommon.MutationFunction<UpdateNetworkLegacyMutation, UpdateNetworkLegacyMutationVariables>;

/**
 * __useUpdateNetworkLegacyMutation__
 *
 * To run a mutation, you first call `useUpdateNetworkLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNetworkLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNetworkLegacyMutation, { data, loading, error }] = useUpdateNetworkLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useUpdateNetworkLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNetworkLegacyMutation, UpdateNetworkLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateNetworkLegacyMutation, UpdateNetworkLegacyMutationVariables>(UpdateNetworkLegacyDocument, options);
      }
export type UpdateNetworkLegacyMutationHookResult = ReturnType<typeof useUpdateNetworkLegacyMutation>;
export type UpdateNetworkLegacyMutationResult = ApolloReactCommon.MutationResult<UpdateNetworkLegacyMutation>;
export type UpdateNetworkLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNetworkLegacyMutation, UpdateNetworkLegacyMutationVariables>;
export const NetworkLegacyDocument = gql`
    query NetworkLegacy($id: ID!, $territories: [Territory!]!) {
  networkLegacy(id: $id) {
    id
    altId
    name
    status
    territories
    publishers(territories: $territories) {
      id
      altId
      name
      status
      pricingType
      pricingAmount
      territories
    }
  }
}
    `;

/**
 * __useNetworkLegacyQuery__
 *
 * To run a query within a React component, call `useNetworkLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useNetworkLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NetworkLegacyQuery, NetworkLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NetworkLegacyQuery, NetworkLegacyQueryVariables>(NetworkLegacyDocument, options);
      }
export function useNetworkLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NetworkLegacyQuery, NetworkLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NetworkLegacyQuery, NetworkLegacyQueryVariables>(NetworkLegacyDocument, options);
        }
export type NetworkLegacyQueryHookResult = ReturnType<typeof useNetworkLegacyQuery>;
export type NetworkLegacyLazyQueryHookResult = ReturnType<typeof useNetworkLegacyLazyQuery>;
export type NetworkLegacyQueryResult = ApolloReactCommon.QueryResult<NetworkLegacyQuery, NetworkLegacyQueryVariables>;
export const NetworkMinimalLegacyDocument = gql`
    query NetworkMinimalLegacy($id: ID!) {
  networkLegacy(id: $id) {
    id
    name
    territories
  }
}
    `;

/**
 * __useNetworkMinimalLegacyQuery__
 *
 * To run a query within a React component, call `useNetworkMinimalLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkMinimalLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkMinimalLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNetworkMinimalLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NetworkMinimalLegacyQuery, NetworkMinimalLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NetworkMinimalLegacyQuery, NetworkMinimalLegacyQueryVariables>(NetworkMinimalLegacyDocument, options);
      }
export function useNetworkMinimalLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NetworkMinimalLegacyQuery, NetworkMinimalLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NetworkMinimalLegacyQuery, NetworkMinimalLegacyQueryVariables>(NetworkMinimalLegacyDocument, options);
        }
export type NetworkMinimalLegacyQueryHookResult = ReturnType<typeof useNetworkMinimalLegacyQuery>;
export type NetworkMinimalLegacyLazyQueryHookResult = ReturnType<typeof useNetworkMinimalLegacyLazyQuery>;
export type NetworkMinimalLegacyQueryResult = ApolloReactCommon.QueryResult<NetworkMinimalLegacyQuery, NetworkMinimalLegacyQueryVariables>;
export const AllNetworksLegacyDocument = gql`
    query AllNetworksLegacy($territories: [Territory!]!) {
  allNetworksLegacy(territories: $territories) {
    id
    altId
    name
    status
    territories
  }
}
    `;

/**
 * __useAllNetworksLegacyQuery__
 *
 * To run a query within a React component, call `useAllNetworksLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllNetworksLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllNetworksLegacyQuery({
 *   variables: {
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllNetworksLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllNetworksLegacyQuery, AllNetworksLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllNetworksLegacyQuery, AllNetworksLegacyQueryVariables>(AllNetworksLegacyDocument, options);
      }
export function useAllNetworksLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllNetworksLegacyQuery, AllNetworksLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllNetworksLegacyQuery, AllNetworksLegacyQueryVariables>(AllNetworksLegacyDocument, options);
        }
export type AllNetworksLegacyQueryHookResult = ReturnType<typeof useAllNetworksLegacyQuery>;
export type AllNetworksLegacyLazyQueryHookResult = ReturnType<typeof useAllNetworksLegacyLazyQuery>;
export type AllNetworksLegacyQueryResult = ApolloReactCommon.QueryResult<AllNetworksLegacyQuery, AllNetworksLegacyQueryVariables>;
export const CreatePublisherLegacyDocument = gql`
    mutation CreatePublisherLegacy($networkId: ID!, $name: String, $pricingType: PricingType, $pricingAmount: BigDecimal, $blacklistedIabCategoryCodes: [ID!], $blacklistedDomains: [DomainName!], $currency: Currency, $territories: [Territory!]) {
  createPublisherLegacy(
    networkId: $networkId
    attributes: {name: $name, pricingType: $pricingType, pricingAmount: $pricingAmount, blacklistedIabCategoryCodes: $blacklistedIabCategoryCodes, blacklistedDomains: $blacklistedDomains, currency: $currency, territories: $territories}
  ) {
    id
    altId
    status
    name
    currency
    territories
    network {
      id
    }
    pricingType
    pricingAmount
    blacklistedIabCategories {
      name
      code
    }
    blacklistedDomains
  }
}
    `;
export type CreatePublisherLegacyMutationFn = ApolloReactCommon.MutationFunction<CreatePublisherLegacyMutation, CreatePublisherLegacyMutationVariables>;

/**
 * __useCreatePublisherLegacyMutation__
 *
 * To run a mutation, you first call `useCreatePublisherLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublisherLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublisherLegacyMutation, { data, loading, error }] = useCreatePublisherLegacyMutation({
 *   variables: {
 *      networkId: // value for 'networkId'
 *      name: // value for 'name'
 *      pricingType: // value for 'pricingType'
 *      pricingAmount: // value for 'pricingAmount'
 *      blacklistedIabCategoryCodes: // value for 'blacklistedIabCategoryCodes'
 *      blacklistedDomains: // value for 'blacklistedDomains'
 *      currency: // value for 'currency'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useCreatePublisherLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePublisherLegacyMutation, CreatePublisherLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePublisherLegacyMutation, CreatePublisherLegacyMutationVariables>(CreatePublisherLegacyDocument, options);
      }
export type CreatePublisherLegacyMutationHookResult = ReturnType<typeof useCreatePublisherLegacyMutation>;
export type CreatePublisherLegacyMutationResult = ApolloReactCommon.MutationResult<CreatePublisherLegacyMutation>;
export type CreatePublisherLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePublisherLegacyMutation, CreatePublisherLegacyMutationVariables>;
export const UpdatePublisherLegacyDocument = gql`
    mutation UpdatePublisherLegacy($id: ID!, $name: String, $pricingType: PricingType, $pricingAmount: BigDecimal, $blacklistedIabCategoryCodes: [ID!], $blacklistedDomains: [DomainName!], $currency: Currency, $status: PublisherStatus, $territories: [Territory!]) {
  updatePublisherLegacy(
    id: $id
    attributes: {name: $name, pricingType: $pricingType, pricingAmount: $pricingAmount, blacklistedIabCategoryCodes: $blacklistedIabCategoryCodes, blacklistedDomains: $blacklistedDomains, currency: $currency, status: $status, territories: $territories}
  ) {
    id
    name
    currency
    territories
    network {
      id
    }
    pricingType
    pricingAmount
    blacklistedIabCategories {
      name
      code
    }
    blacklistedDomains
    status
  }
}
    `;
export type UpdatePublisherLegacyMutationFn = ApolloReactCommon.MutationFunction<UpdatePublisherLegacyMutation, UpdatePublisherLegacyMutationVariables>;

/**
 * __useUpdatePublisherLegacyMutation__
 *
 * To run a mutation, you first call `useUpdatePublisherLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublisherLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublisherLegacyMutation, { data, loading, error }] = useUpdatePublisherLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      pricingType: // value for 'pricingType'
 *      pricingAmount: // value for 'pricingAmount'
 *      blacklistedIabCategoryCodes: // value for 'blacklistedIabCategoryCodes'
 *      blacklistedDomains: // value for 'blacklistedDomains'
 *      currency: // value for 'currency'
 *      status: // value for 'status'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useUpdatePublisherLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePublisherLegacyMutation, UpdatePublisherLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePublisherLegacyMutation, UpdatePublisherLegacyMutationVariables>(UpdatePublisherLegacyDocument, options);
      }
export type UpdatePublisherLegacyMutationHookResult = ReturnType<typeof useUpdatePublisherLegacyMutation>;
export type UpdatePublisherLegacyMutationResult = ApolloReactCommon.MutationResult<UpdatePublisherLegacyMutation>;
export type UpdatePublisherLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePublisherLegacyMutation, UpdatePublisherLegacyMutationVariables>;
export const CreatePublisherContractLegacyDocument = gql`
    mutation CreatePublisherContractLegacy($publisherId: ID!, $startDate: LocalDateTime, $endDate: LocalDateTime, $publisherCategories: [String!], $directSpotCpm: NonNegativeFloat, $programmaticSpotCpm: NonNegativeFloat, $hostReadCpm: NonNegativeFloat, $spotRevenueShare: NonNegativeFloat, $sponsorshipRevenueShare: NonNegativeFloat, $hostReadRevenueShare: NonNegativeFloat, $minRevenueGuaranteed: NonNegativeFloat, $minRevenueIdeal: NonNegativeFloat, $percentFillGuaranteed: Int, $minInventoryGuaranteed: NonNegativeFloat, $maxInventoryGuaranteed: NonNegativeFloat, $currency: Currency, $territories: [Territory!], $notes: String) {
  createPublisherContractLegacy(
    publisherId: $publisherId
    attributes: {startDate: $startDate, endDate: $endDate, publisherCategories: $publisherCategories, directSpotCpm: $directSpotCpm, programmaticSpotCpm: $programmaticSpotCpm, hostReadCpm: $hostReadCpm, spotRevenueShare: $spotRevenueShare, sponsorshipRevenueShare: $sponsorshipRevenueShare, hostReadRevenueShare: $hostReadRevenueShare, minRevenueGuaranteed: $minRevenueGuaranteed, minRevenueIdeal: $minRevenueIdeal, percentFillGuaranteed: $percentFillGuaranteed, minInventoryGuaranteed: $minInventoryGuaranteed, maxInventoryGuaranteed: $maxInventoryGuaranteed, currency: $currency, territories: $territories, notes: $notes}
  ) {
    id
    altId
    startDate
    endDate
    publisher {
      id
      name
    }
    publisherCategories {
      id
      name
    }
    directSpotCpm
    programmaticSpotCpm
    hostReadCpm
    spotRevenueShare
    hostReadRevenueShare
    sponsorshipRevenueShare
    minRevenueGuaranteed
    minRevenueIdeal
    minInventoryGuaranteed
    maxInventoryGuaranteed
    percentFillGuaranteed
    currency
    territories
    notes
  }
}
    `;
export type CreatePublisherContractLegacyMutationFn = ApolloReactCommon.MutationFunction<CreatePublisherContractLegacyMutation, CreatePublisherContractLegacyMutationVariables>;

/**
 * __useCreatePublisherContractLegacyMutation__
 *
 * To run a mutation, you first call `useCreatePublisherContractLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublisherContractLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublisherContractLegacyMutation, { data, loading, error }] = useCreatePublisherContractLegacyMutation({
 *   variables: {
 *      publisherId: // value for 'publisherId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      publisherCategories: // value for 'publisherCategories'
 *      directSpotCpm: // value for 'directSpotCpm'
 *      programmaticSpotCpm: // value for 'programmaticSpotCpm'
 *      hostReadCpm: // value for 'hostReadCpm'
 *      spotRevenueShare: // value for 'spotRevenueShare'
 *      sponsorshipRevenueShare: // value for 'sponsorshipRevenueShare'
 *      hostReadRevenueShare: // value for 'hostReadRevenueShare'
 *      minRevenueGuaranteed: // value for 'minRevenueGuaranteed'
 *      minRevenueIdeal: // value for 'minRevenueIdeal'
 *      percentFillGuaranteed: // value for 'percentFillGuaranteed'
 *      minInventoryGuaranteed: // value for 'minInventoryGuaranteed'
 *      maxInventoryGuaranteed: // value for 'maxInventoryGuaranteed'
 *      currency: // value for 'currency'
 *      territories: // value for 'territories'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useCreatePublisherContractLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePublisherContractLegacyMutation, CreatePublisherContractLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePublisherContractLegacyMutation, CreatePublisherContractLegacyMutationVariables>(CreatePublisherContractLegacyDocument, options);
      }
export type CreatePublisherContractLegacyMutationHookResult = ReturnType<typeof useCreatePublisherContractLegacyMutation>;
export type CreatePublisherContractLegacyMutationResult = ApolloReactCommon.MutationResult<CreatePublisherContractLegacyMutation>;
export type CreatePublisherContractLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePublisherContractLegacyMutation, CreatePublisherContractLegacyMutationVariables>;
export const UpdatePublisherContractLegacyDocument = gql`
    mutation UpdatePublisherContractLegacy($id: ID!, $startDate: LocalDateTime, $endDate: LocalDateTime, $publisherCategories: [String!], $directSpotCpm: NonNegativeFloat, $programmaticSpotCpm: NonNegativeFloat, $hostReadCpm: NonNegativeFloat, $spotRevenueShare: NonNegativeFloat, $sponsorshipRevenueShare: NonNegativeFloat, $hostReadRevenueShare: NonNegativeFloat, $minRevenueGuaranteed: NonNegativeFloat, $minRevenueIdeal: NonNegativeFloat, $percentFillGuaranteed: Int, $minInventoryGuaranteed: NonNegativeFloat, $maxInventoryGuaranteed: NonNegativeFloat, $currency: Currency, $territories: [Territory!], $notes: String) {
  updatePublisherContractLegacy(
    id: $id
    attributes: {startDate: $startDate, endDate: $endDate, publisherCategories: $publisherCategories, directSpotCpm: $directSpotCpm, programmaticSpotCpm: $programmaticSpotCpm, hostReadCpm: $hostReadCpm, spotRevenueShare: $spotRevenueShare, sponsorshipRevenueShare: $sponsorshipRevenueShare, hostReadRevenueShare: $hostReadRevenueShare, minRevenueGuaranteed: $minRevenueGuaranteed, minRevenueIdeal: $minRevenueIdeal, percentFillGuaranteed: $percentFillGuaranteed, minInventoryGuaranteed: $minInventoryGuaranteed, maxInventoryGuaranteed: $maxInventoryGuaranteed, currency: $currency, territories: $territories, notes: $notes}
  ) {
    id
    altId
    startDate
    endDate
    publisher {
      id
      name
    }
    publisherCategories {
      id
      name
    }
    directSpotCpm
    programmaticSpotCpm
    hostReadCpm
    spotRevenueShare
    hostReadRevenueShare
    sponsorshipRevenueShare
    minRevenueGuaranteed
    minRevenueIdeal
    minInventoryGuaranteed
    maxInventoryGuaranteed
    percentFillGuaranteed
    currency
    territories
    notes
  }
}
    `;
export type UpdatePublisherContractLegacyMutationFn = ApolloReactCommon.MutationFunction<UpdatePublisherContractLegacyMutation, UpdatePublisherContractLegacyMutationVariables>;

/**
 * __useUpdatePublisherContractLegacyMutation__
 *
 * To run a mutation, you first call `useUpdatePublisherContractLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublisherContractLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublisherContractLegacyMutation, { data, loading, error }] = useUpdatePublisherContractLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      publisherCategories: // value for 'publisherCategories'
 *      directSpotCpm: // value for 'directSpotCpm'
 *      programmaticSpotCpm: // value for 'programmaticSpotCpm'
 *      hostReadCpm: // value for 'hostReadCpm'
 *      spotRevenueShare: // value for 'spotRevenueShare'
 *      sponsorshipRevenueShare: // value for 'sponsorshipRevenueShare'
 *      hostReadRevenueShare: // value for 'hostReadRevenueShare'
 *      minRevenueGuaranteed: // value for 'minRevenueGuaranteed'
 *      minRevenueIdeal: // value for 'minRevenueIdeal'
 *      percentFillGuaranteed: // value for 'percentFillGuaranteed'
 *      minInventoryGuaranteed: // value for 'minInventoryGuaranteed'
 *      maxInventoryGuaranteed: // value for 'maxInventoryGuaranteed'
 *      currency: // value for 'currency'
 *      territories: // value for 'territories'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdatePublisherContractLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePublisherContractLegacyMutation, UpdatePublisherContractLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePublisherContractLegacyMutation, UpdatePublisherContractLegacyMutationVariables>(UpdatePublisherContractLegacyDocument, options);
      }
export type UpdatePublisherContractLegacyMutationHookResult = ReturnType<typeof useUpdatePublisherContractLegacyMutation>;
export type UpdatePublisherContractLegacyMutationResult = ApolloReactCommon.MutationResult<UpdatePublisherContractLegacyMutation>;
export type UpdatePublisherContractLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePublisherContractLegacyMutation, UpdatePublisherContractLegacyMutationVariables>;
export const PublisherMinimalLegacyDocument = gql`
    query PublisherMinimalLegacy($id: ID!) {
  publisherLegacy(id: $id) {
    id
    name
    blacklistedIabCategories {
      name
      code
    }
    blacklistedDomains
    territories
  }
}
    `;

/**
 * __usePublisherMinimalLegacyQuery__
 *
 * To run a query within a React component, call `usePublisherMinimalLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherMinimalLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherMinimalLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublisherMinimalLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherMinimalLegacyQuery, PublisherMinimalLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherMinimalLegacyQuery, PublisherMinimalLegacyQueryVariables>(PublisherMinimalLegacyDocument, options);
      }
export function usePublisherMinimalLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherMinimalLegacyQuery, PublisherMinimalLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherMinimalLegacyQuery, PublisherMinimalLegacyQueryVariables>(PublisherMinimalLegacyDocument, options);
        }
export type PublisherMinimalLegacyQueryHookResult = ReturnType<typeof usePublisherMinimalLegacyQuery>;
export type PublisherMinimalLegacyLazyQueryHookResult = ReturnType<typeof usePublisherMinimalLegacyLazyQuery>;
export type PublisherMinimalLegacyQueryResult = ApolloReactCommon.QueryResult<PublisherMinimalLegacyQuery, PublisherMinimalLegacyQueryVariables>;
export const PublisherLegacyDocument = gql`
    query PublisherLegacy($id: ID!, $territories: [Territory!]!) {
  publisherLegacy(id: $id) {
    territories
    channels(territories: $territories) {
      id
      altId
      name
      vastVersion
      type
      locale
      publisher {
        id
        name
      }
      timeZone
      blacklistedIabCategories {
        name
        code
      }
      blacklistedDomains
      status
      territories
    }
    id
    altId
    currency
    name
    network {
      id
      name
      status
      territories
    }
    pricingType
    pricingAmount
    blacklistedIabCategories {
      name
      code
    }
    blacklistedDomains
    status
  }
}
    `;

/**
 * __usePublisherLegacyQuery__
 *
 * To run a query within a React component, call `usePublisherLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function usePublisherLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherLegacyQuery, PublisherLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherLegacyQuery, PublisherLegacyQueryVariables>(PublisherLegacyDocument, options);
      }
export function usePublisherLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherLegacyQuery, PublisherLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherLegacyQuery, PublisherLegacyQueryVariables>(PublisherLegacyDocument, options);
        }
export type PublisherLegacyQueryHookResult = ReturnType<typeof usePublisherLegacyQuery>;
export type PublisherLegacyLazyQueryHookResult = ReturnType<typeof usePublisherLegacyLazyQuery>;
export type PublisherLegacyQueryResult = ApolloReactCommon.QueryResult<PublisherLegacyQuery, PublisherLegacyQueryVariables>;
export const PublisherAssociatedAdsLegacyDocument = gql`
    query PublisherAssociatedAdsLegacy($id: ID!, $territories: [Territory!]!) {
  publisherLegacy(id: $id) {
    id
    associatedAds(
      filter: {status_in: [LIVE, READY, PAUSED]}
      territories: $territories
    ) {
      id
      altId
      name
      startDate {
        isInherited
        value
      }
      endDate {
        isInherited
        value
      }
      status
      campaign {
        id
        name
        timeZone
        pacing
        owner {
          id
          email
        }
      }
    }
  }
}
    `;

/**
 * __usePublisherAssociatedAdsLegacyQuery__
 *
 * To run a query within a React component, call `usePublisherAssociatedAdsLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherAssociatedAdsLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherAssociatedAdsLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function usePublisherAssociatedAdsLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherAssociatedAdsLegacyQuery, PublisherAssociatedAdsLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherAssociatedAdsLegacyQuery, PublisherAssociatedAdsLegacyQueryVariables>(PublisherAssociatedAdsLegacyDocument, options);
      }
export function usePublisherAssociatedAdsLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherAssociatedAdsLegacyQuery, PublisherAssociatedAdsLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherAssociatedAdsLegacyQuery, PublisherAssociatedAdsLegacyQueryVariables>(PublisherAssociatedAdsLegacyDocument, options);
        }
export type PublisherAssociatedAdsLegacyQueryHookResult = ReturnType<typeof usePublisherAssociatedAdsLegacyQuery>;
export type PublisherAssociatedAdsLegacyLazyQueryHookResult = ReturnType<typeof usePublisherAssociatedAdsLegacyLazyQuery>;
export type PublisherAssociatedAdsLegacyQueryResult = ApolloReactCommon.QueryResult<PublisherAssociatedAdsLegacyQuery, PublisherAssociatedAdsLegacyQueryVariables>;
export const PublisherAssociatedDealsLegacyDocument = gql`
    query PublisherAssociatedDealsLegacy($id: ID!, $territories: [Territory!]!) {
  publisherLegacy(id: $id) {
    id
    associatedDeals(filter: {status_in: [ACTIVE, READY]}, territories: $territories) {
      id
      altId
      name
      startDate
      endDate
      timeZone
      status
      priority
      salesChannel {
        id
        name
        owner {
          id
          email
        }
      }
    }
  }
}
    `;

/**
 * __usePublisherAssociatedDealsLegacyQuery__
 *
 * To run a query within a React component, call `usePublisherAssociatedDealsLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherAssociatedDealsLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherAssociatedDealsLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function usePublisherAssociatedDealsLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherAssociatedDealsLegacyQuery, PublisherAssociatedDealsLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherAssociatedDealsLegacyQuery, PublisherAssociatedDealsLegacyQueryVariables>(PublisherAssociatedDealsLegacyDocument, options);
      }
export function usePublisherAssociatedDealsLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherAssociatedDealsLegacyQuery, PublisherAssociatedDealsLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherAssociatedDealsLegacyQuery, PublisherAssociatedDealsLegacyQueryVariables>(PublisherAssociatedDealsLegacyDocument, options);
        }
export type PublisherAssociatedDealsLegacyQueryHookResult = ReturnType<typeof usePublisherAssociatedDealsLegacyQuery>;
export type PublisherAssociatedDealsLegacyLazyQueryHookResult = ReturnType<typeof usePublisherAssociatedDealsLegacyLazyQuery>;
export type PublisherAssociatedDealsLegacyQueryResult = ApolloReactCommon.QueryResult<PublisherAssociatedDealsLegacyQuery, PublisherAssociatedDealsLegacyQueryVariables>;
export const PublisherTimeSeriesLegacyDocument = gql`
    query PublisherTimeSeriesLegacy($id: ID!, $timeZone: ZoneId!) {
  publisherLegacy(id: $id) {
    id
    impressionsTimeSeries(params: {timeUnit: HOUR, timeZone: $timeZone}) {
      dataPoints {
        t
        v
      }
    }
  }
}
    `;

/**
 * __usePublisherTimeSeriesLegacyQuery__
 *
 * To run a query within a React component, call `usePublisherTimeSeriesLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherTimeSeriesLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherTimeSeriesLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function usePublisherTimeSeriesLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublisherTimeSeriesLegacyQuery, PublisherTimeSeriesLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublisherTimeSeriesLegacyQuery, PublisherTimeSeriesLegacyQueryVariables>(PublisherTimeSeriesLegacyDocument, options);
      }
export function usePublisherTimeSeriesLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublisherTimeSeriesLegacyQuery, PublisherTimeSeriesLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublisherTimeSeriesLegacyQuery, PublisherTimeSeriesLegacyQueryVariables>(PublisherTimeSeriesLegacyDocument, options);
        }
export type PublisherTimeSeriesLegacyQueryHookResult = ReturnType<typeof usePublisherTimeSeriesLegacyQuery>;
export type PublisherTimeSeriesLegacyLazyQueryHookResult = ReturnType<typeof usePublisherTimeSeriesLegacyLazyQuery>;
export type PublisherTimeSeriesLegacyQueryResult = ApolloReactCommon.QueryResult<PublisherTimeSeriesLegacyQuery, PublisherTimeSeriesLegacyQueryVariables>;
export const AllPublishersAndChannelsLegacyDocument = gql`
    query AllPublishersAndChannelsLegacy($networkId: ID, $territories: [Territory!]!) {
  allPublishersLegacy(
    networkId: $networkId
    filter: {status_in: [ENABLED]}
    territories: $territories
  ) {
    id
    name
    channels(filter: {status_in: ENABLED}, territories: $territories) {
      id
      name
    }
  }
}
    `;

/**
 * __useAllPublishersAndChannelsLegacyQuery__
 *
 * To run a query within a React component, call `useAllPublishersAndChannelsLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPublishersAndChannelsLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPublishersAndChannelsLegacyQuery({
 *   variables: {
 *      networkId: // value for 'networkId'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllPublishersAndChannelsLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllPublishersAndChannelsLegacyQuery, AllPublishersAndChannelsLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllPublishersAndChannelsLegacyQuery, AllPublishersAndChannelsLegacyQueryVariables>(AllPublishersAndChannelsLegacyDocument, options);
      }
export function useAllPublishersAndChannelsLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllPublishersAndChannelsLegacyQuery, AllPublishersAndChannelsLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllPublishersAndChannelsLegacyQuery, AllPublishersAndChannelsLegacyQueryVariables>(AllPublishersAndChannelsLegacyDocument, options);
        }
export type AllPublishersAndChannelsLegacyQueryHookResult = ReturnType<typeof useAllPublishersAndChannelsLegacyQuery>;
export type AllPublishersAndChannelsLegacyLazyQueryHookResult = ReturnType<typeof useAllPublishersAndChannelsLegacyLazyQuery>;
export type AllPublishersAndChannelsLegacyQueryResult = ApolloReactCommon.QueryResult<AllPublishersAndChannelsLegacyQuery, AllPublishersAndChannelsLegacyQueryVariables>;
export const AllPublisherContractsLegacyDocument = gql`
    query AllPublisherContractsLegacy($publisherId: ID!) {
  allPublisherContractsLegacy(publisherId: $publisherId) {
    id
    altId
    startDate
    endDate
    publisher {
      id
      name
    }
    publisherCategories {
      id
      name
    }
    directSpotCpm
    programmaticSpotCpm
    hostReadCpm
    spotRevenueShare
    hostReadRevenueShare
    sponsorshipRevenueShare
    minRevenueGuaranteed
    minRevenueIdeal
    minInventoryGuaranteed
    maxInventoryGuaranteed
    percentFillGuaranteed
    currency
    territories
    notes
  }
}
    `;

/**
 * __useAllPublisherContractsLegacyQuery__
 *
 * To run a query within a React component, call `useAllPublisherContractsLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPublisherContractsLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPublisherContractsLegacyQuery({
 *   variables: {
 *      publisherId: // value for 'publisherId'
 *   },
 * });
 */
export function useAllPublisherContractsLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllPublisherContractsLegacyQuery, AllPublisherContractsLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllPublisherContractsLegacyQuery, AllPublisherContractsLegacyQueryVariables>(AllPublisherContractsLegacyDocument, options);
      }
export function useAllPublisherContractsLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllPublisherContractsLegacyQuery, AllPublisherContractsLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllPublisherContractsLegacyQuery, AllPublisherContractsLegacyQueryVariables>(AllPublisherContractsLegacyDocument, options);
        }
export type AllPublisherContractsLegacyQueryHookResult = ReturnType<typeof useAllPublisherContractsLegacyQuery>;
export type AllPublisherContractsLegacyLazyQueryHookResult = ReturnType<typeof useAllPublisherContractsLegacyLazyQuery>;
export type AllPublisherContractsLegacyQueryResult = ApolloReactCommon.QueryResult<AllPublisherContractsLegacyQuery, AllPublisherContractsLegacyQueryVariables>;
export const AllPublisherCategoriesDocument = gql`
    query allPublisherCategories {
  allPublisherCategories {
    id
    name
  }
}
    `;

/**
 * __useAllPublisherCategoriesQuery__
 *
 * To run a query within a React component, call `useAllPublisherCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPublisherCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPublisherCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPublisherCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllPublisherCategoriesQuery, AllPublisherCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllPublisherCategoriesQuery, AllPublisherCategoriesQueryVariables>(AllPublisherCategoriesDocument, options);
      }
export function useAllPublisherCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllPublisherCategoriesQuery, AllPublisherCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllPublisherCategoriesQuery, AllPublisherCategoriesQueryVariables>(AllPublisherCategoriesDocument, options);
        }
export type AllPublisherCategoriesQueryHookResult = ReturnType<typeof useAllPublisherCategoriesQuery>;
export type AllPublisherCategoriesLazyQueryHookResult = ReturnType<typeof useAllPublisherCategoriesLazyQuery>;
export type AllPublisherCategoriesQueryResult = ApolloReactCommon.QueryResult<AllPublisherCategoriesQuery, AllPublisherCategoriesQueryVariables>;
export const CreateTranscodePresetDocument = gql`
    mutation CreateTranscodePreset($bitRate: PositiveInt!, $format: String!, $mode: SoundMode!, $sampleRate: PositiveInt!, $volume: NegativeInt!, $extension: String) {
  createTranscodePreset(
    attributes: {bitRate: $bitRate, format: $format, mode: $mode, sampleRate: $sampleRate, volume: $volume, extension: $extension}
  ) {
    id
    altId
    name
    bitRate
    format
    mode
    sampleRate
    volume
    extension
  }
}
    `;
export type CreateTranscodePresetMutationFn = ApolloReactCommon.MutationFunction<CreateTranscodePresetMutation, CreateTranscodePresetMutationVariables>;

/**
 * __useCreateTranscodePresetMutation__
 *
 * To run a mutation, you first call `useCreateTranscodePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTranscodePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTranscodePresetMutation, { data, loading, error }] = useCreateTranscodePresetMutation({
 *   variables: {
 *      bitRate: // value for 'bitRate'
 *      format: // value for 'format'
 *      mode: // value for 'mode'
 *      sampleRate: // value for 'sampleRate'
 *      volume: // value for 'volume'
 *      extension: // value for 'extension'
 *   },
 * });
 */
export function useCreateTranscodePresetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTranscodePresetMutation, CreateTranscodePresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTranscodePresetMutation, CreateTranscodePresetMutationVariables>(CreateTranscodePresetDocument, options);
      }
export type CreateTranscodePresetMutationHookResult = ReturnType<typeof useCreateTranscodePresetMutation>;
export type CreateTranscodePresetMutationResult = ApolloReactCommon.MutationResult<CreateTranscodePresetMutation>;
export type CreateTranscodePresetMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTranscodePresetMutation, CreateTranscodePresetMutationVariables>;
export const TranscodePresetDocument = gql`
    query TranscodePreset($id: ID!) {
  transcodePreset(id: $id) {
    id
    altId
    name
    bitRate
    format
    mode
    sampleRate
    volume
  }
}
    `;

/**
 * __useTranscodePresetQuery__
 *
 * To run a query within a React component, call `useTranscodePresetQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranscodePresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranscodePresetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTranscodePresetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TranscodePresetQuery, TranscodePresetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TranscodePresetQuery, TranscodePresetQueryVariables>(TranscodePresetDocument, options);
      }
export function useTranscodePresetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TranscodePresetQuery, TranscodePresetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TranscodePresetQuery, TranscodePresetQueryVariables>(TranscodePresetDocument, options);
        }
export type TranscodePresetQueryHookResult = ReturnType<typeof useTranscodePresetQuery>;
export type TranscodePresetLazyQueryHookResult = ReturnType<typeof useTranscodePresetLazyQuery>;
export type TranscodePresetQueryResult = ApolloReactCommon.QueryResult<TranscodePresetQuery, TranscodePresetQueryVariables>;
export const PrimaryControlDocument = gql`
    mutation PrimaryControl($entity: PrimaryControlEntity!, $state: PrimaryControlState!, $entries: [PrimaryControlEntryInput!]!) {
  primaryControl(entity: $entity, state: $state, entries: $entries) {
    enabled
    territory
  }
}
    `;
export type PrimaryControlMutationFn = ApolloReactCommon.MutationFunction<PrimaryControlMutation, PrimaryControlMutationVariables>;

/**
 * __usePrimaryControlMutation__
 *
 * To run a mutation, you first call `usePrimaryControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimaryControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primaryControlMutation, { data, loading, error }] = usePrimaryControlMutation({
 *   variables: {
 *      entity: // value for 'entity'
 *      state: // value for 'state'
 *      entries: // value for 'entries'
 *   },
 * });
 */
export function usePrimaryControlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrimaryControlMutation, PrimaryControlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrimaryControlMutation, PrimaryControlMutationVariables>(PrimaryControlDocument, options);
      }
export type PrimaryControlMutationHookResult = ReturnType<typeof usePrimaryControlMutation>;
export type PrimaryControlMutationResult = ApolloReactCommon.MutationResult<PrimaryControlMutation>;
export type PrimaryControlMutationOptions = ApolloReactCommon.BaseMutationOptions<PrimaryControlMutation, PrimaryControlMutationVariables>;
export const UpdateGlobalBlocklistDocument = gql`
    mutation UpdateGlobalBlocklist($domains: [DomainName!]!, $iabCategories: [ID!]!, $territory: Territory!) {
  updateGlobalBlacklistedDomains(
    territory: $territory
    blacklistedDomains: $domains
  ) {
    domains
  }
  updateGlobalBlacklistedIabCategories(
    territory: $territory
    blacklistedIabCategoryCodes: $iabCategories
  ) {
    iabCategories {
      code
    }
  }
}
    `;
export type UpdateGlobalBlocklistMutationFn = ApolloReactCommon.MutationFunction<UpdateGlobalBlocklistMutation, UpdateGlobalBlocklistMutationVariables>;

/**
 * __useUpdateGlobalBlocklistMutation__
 *
 * To run a mutation, you first call `useUpdateGlobalBlocklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlobalBlocklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlobalBlocklistMutation, { data, loading, error }] = useUpdateGlobalBlocklistMutation({
 *   variables: {
 *      domains: // value for 'domains'
 *      iabCategories: // value for 'iabCategories'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useUpdateGlobalBlocklistMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGlobalBlocklistMutation, UpdateGlobalBlocklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateGlobalBlocklistMutation, UpdateGlobalBlocklistMutationVariables>(UpdateGlobalBlocklistDocument, options);
      }
export type UpdateGlobalBlocklistMutationHookResult = ReturnType<typeof useUpdateGlobalBlocklistMutation>;
export type UpdateGlobalBlocklistMutationResult = ApolloReactCommon.MutationResult<UpdateGlobalBlocklistMutation>;
export type UpdateGlobalBlocklistMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateGlobalBlocklistMutation, UpdateGlobalBlocklistMutationVariables>;
export const PrimaryControlsDocument = gql`
    query PrimaryControls {
  primaryControls {
    entity
    entries {
      enabled
      territory
    }
  }
}
    `;

/**
 * __usePrimaryControlsQuery__
 *
 * To run a query within a React component, call `usePrimaryControlsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimaryControlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimaryControlsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrimaryControlsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PrimaryControlsQuery, PrimaryControlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PrimaryControlsQuery, PrimaryControlsQueryVariables>(PrimaryControlsDocument, options);
      }
export function usePrimaryControlsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrimaryControlsQuery, PrimaryControlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PrimaryControlsQuery, PrimaryControlsQueryVariables>(PrimaryControlsDocument, options);
        }
export type PrimaryControlsQueryHookResult = ReturnType<typeof usePrimaryControlsQuery>;
export type PrimaryControlsLazyQueryHookResult = ReturnType<typeof usePrimaryControlsLazyQuery>;
export type PrimaryControlsQueryResult = ApolloReactCommon.QueryResult<PrimaryControlsQuery, PrimaryControlsQueryVariables>;
export const GlobalBlocklistsDocument = gql`
    query GlobalBlocklists($territories: [Territory!]!) {
  globalBlacklistedDomains(territories: $territories) {
    territory
    domains
  }
  globalBlacklistedIabCategories(territories: $territories) {
    territory
    iabCategories {
      code
      name
    }
  }
}
    `;

/**
 * __useGlobalBlocklistsQuery__
 *
 * To run a query within a React component, call `useGlobalBlocklistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalBlocklistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalBlocklistsQuery({
 *   variables: {
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useGlobalBlocklistsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GlobalBlocklistsQuery, GlobalBlocklistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalBlocklistsQuery, GlobalBlocklistsQueryVariables>(GlobalBlocklistsDocument, options);
      }
export function useGlobalBlocklistsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalBlocklistsQuery, GlobalBlocklistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalBlocklistsQuery, GlobalBlocklistsQueryVariables>(GlobalBlocklistsDocument, options);
        }
export type GlobalBlocklistsQueryHookResult = ReturnType<typeof useGlobalBlocklistsQuery>;
export type GlobalBlocklistsLazyQueryHookResult = ReturnType<typeof useGlobalBlocklistsLazyQuery>;
export type GlobalBlocklistsQueryResult = ApolloReactCommon.QueryResult<GlobalBlocklistsQuery, GlobalBlocklistsQueryVariables>;
export const UpdateProgrammaticCreativeDocument = gql`
    mutation UpdateProgrammaticCreative($id: ID!, $status: ApprovalStatus) {
  updateProgrammaticCreative(id: $id, attributes: {status: $status}) {
    id
    status
  }
}
    `;
export type UpdateProgrammaticCreativeMutationFn = ApolloReactCommon.MutationFunction<UpdateProgrammaticCreativeMutation, UpdateProgrammaticCreativeMutationVariables>;

/**
 * __useUpdateProgrammaticCreativeMutation__
 *
 * To run a mutation, you first call `useUpdateProgrammaticCreativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgrammaticCreativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgrammaticCreativeMutation, { data, loading, error }] = useUpdateProgrammaticCreativeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateProgrammaticCreativeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProgrammaticCreativeMutation, UpdateProgrammaticCreativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProgrammaticCreativeMutation, UpdateProgrammaticCreativeMutationVariables>(UpdateProgrammaticCreativeDocument, options);
      }
export type UpdateProgrammaticCreativeMutationHookResult = ReturnType<typeof useUpdateProgrammaticCreativeMutation>;
export type UpdateProgrammaticCreativeMutationResult = ApolloReactCommon.MutationResult<UpdateProgrammaticCreativeMutation>;
export type UpdateProgrammaticCreativeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProgrammaticCreativeMutation, UpdateProgrammaticCreativeMutationVariables>;
export const PaginatedProgrammaticCreativesDocument = gql`
    query PaginatedProgrammaticCreatives($first: Int, $last: Int, $after: String, $before: String, $ordering: ProgrammaticCreativeOrdering, $filter: ProgrammaticCreativeFilter, $territories: [Territory!]!) {
  paginateProgrammaticCreatives(
    first: $first
    last: $last
    after: $after
    before: $before
    ordering: $ordering
    filter: $filter
    territories: $territories
  ) {
    edges {
      cursor
      node {
        id
        name
        type
        status
        url
        iabCategoryCodes
        advertiserDomains
        firstBidDate
        approvalDate
        spec {
          ... on ProgrammaticCreativeAudioSpec {
            duration
          }
          ... on ProgrammaticCreativeImageSpec {
            width
            height
          }
        }
        firstSeenDeal {
          id
          name
        }
        deals {
          id
          name
        }
        territories
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __usePaginatedProgrammaticCreativesQuery__
 *
 * To run a query within a React component, call `usePaginatedProgrammaticCreativesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedProgrammaticCreativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedProgrammaticCreativesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      ordering: // value for 'ordering'
 *      filter: // value for 'filter'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function usePaginatedProgrammaticCreativesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedProgrammaticCreativesQuery, PaginatedProgrammaticCreativesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginatedProgrammaticCreativesQuery, PaginatedProgrammaticCreativesQueryVariables>(PaginatedProgrammaticCreativesDocument, options);
      }
export function usePaginatedProgrammaticCreativesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedProgrammaticCreativesQuery, PaginatedProgrammaticCreativesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginatedProgrammaticCreativesQuery, PaginatedProgrammaticCreativesQueryVariables>(PaginatedProgrammaticCreativesDocument, options);
        }
export type PaginatedProgrammaticCreativesQueryHookResult = ReturnType<typeof usePaginatedProgrammaticCreativesQuery>;
export type PaginatedProgrammaticCreativesLazyQueryHookResult = ReturnType<typeof usePaginatedProgrammaticCreativesLazyQuery>;
export type PaginatedProgrammaticCreativesQueryResult = ApolloReactCommon.QueryResult<PaginatedProgrammaticCreativesQuery, PaginatedProgrammaticCreativesQueryVariables>;
export const TotalProgrammaticCreativesDocument = gql`
    query TotalProgrammaticCreatives($filter: ProgrammaticCreativeFilter, $territories: [Territory!]!) {
  totalProgrammaticCreatives(filter: $filter, territories: $territories)
}
    `;

/**
 * __useTotalProgrammaticCreativesQuery__
 *
 * To run a query within a React component, call `useTotalProgrammaticCreativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalProgrammaticCreativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalProgrammaticCreativesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useTotalProgrammaticCreativesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TotalProgrammaticCreativesQuery, TotalProgrammaticCreativesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TotalProgrammaticCreativesQuery, TotalProgrammaticCreativesQueryVariables>(TotalProgrammaticCreativesDocument, options);
      }
export function useTotalProgrammaticCreativesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TotalProgrammaticCreativesQuery, TotalProgrammaticCreativesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TotalProgrammaticCreativesQuery, TotalProgrammaticCreativesQueryVariables>(TotalProgrammaticCreativesDocument, options);
        }
export type TotalProgrammaticCreativesQueryHookResult = ReturnType<typeof useTotalProgrammaticCreativesQuery>;
export type TotalProgrammaticCreativesLazyQueryHookResult = ReturnType<typeof useTotalProgrammaticCreativesLazyQuery>;
export type TotalProgrammaticCreativesQueryResult = ApolloReactCommon.QueryResult<TotalProgrammaticCreativesQuery, TotalProgrammaticCreativesQueryVariables>;
export const AllProgrammaticCreativesMinimalDocument = gql`
    query AllProgrammaticCreativesMinimal($filter: ProgrammaticCreativeFilter, $first: Int, $territories: [Territory!]!) {
  paginateProgrammaticCreatives(
    first: $first
    filter: $filter
    territories: $territories
  ) {
    edges {
      node {
        id
        status
      }
    }
  }
}
    `;

/**
 * __useAllProgrammaticCreativesMinimalQuery__
 *
 * To run a query within a React component, call `useAllProgrammaticCreativesMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProgrammaticCreativesMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProgrammaticCreativesMinimalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllProgrammaticCreativesMinimalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllProgrammaticCreativesMinimalQuery, AllProgrammaticCreativesMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllProgrammaticCreativesMinimalQuery, AllProgrammaticCreativesMinimalQueryVariables>(AllProgrammaticCreativesMinimalDocument, options);
      }
export function useAllProgrammaticCreativesMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllProgrammaticCreativesMinimalQuery, AllProgrammaticCreativesMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllProgrammaticCreativesMinimalQuery, AllProgrammaticCreativesMinimalQueryVariables>(AllProgrammaticCreativesMinimalDocument, options);
        }
export type AllProgrammaticCreativesMinimalQueryHookResult = ReturnType<typeof useAllProgrammaticCreativesMinimalQuery>;
export type AllProgrammaticCreativesMinimalLazyQueryHookResult = ReturnType<typeof useAllProgrammaticCreativesMinimalLazyQuery>;
export type AllProgrammaticCreativesMinimalQueryResult = ApolloReactCommon.QueryResult<AllProgrammaticCreativesMinimalQuery, AllProgrammaticCreativesMinimalQueryVariables>;
export const CreateDataCenterLegacyDocument = gql`
    mutation CreateDataCenterLegacy($technicalProviderId: ID!, $name: String, $region: Region, $bidUrl: Url, $maxQps: NonNegativeInt) {
  createDataCenterLegacy(
    technicalProviderId: $technicalProviderId
    attributes: {name: $name, region: $region, bidUrl: $bidUrl, maxQps: $maxQps}
  ) {
    id
    altId
    name
    region
    bidUrl
    maxQps
    status
    technicalProvider {
      id
    }
  }
}
    `;
export type CreateDataCenterLegacyMutationFn = ApolloReactCommon.MutationFunction<CreateDataCenterLegacyMutation, CreateDataCenterLegacyMutationVariables>;

/**
 * __useCreateDataCenterLegacyMutation__
 *
 * To run a mutation, you first call `useCreateDataCenterLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataCenterLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataCenterLegacyMutation, { data, loading, error }] = useCreateDataCenterLegacyMutation({
 *   variables: {
 *      technicalProviderId: // value for 'technicalProviderId'
 *      name: // value for 'name'
 *      region: // value for 'region'
 *      bidUrl: // value for 'bidUrl'
 *      maxQps: // value for 'maxQps'
 *   },
 * });
 */
export function useCreateDataCenterLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDataCenterLegacyMutation, CreateDataCenterLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDataCenterLegacyMutation, CreateDataCenterLegacyMutationVariables>(CreateDataCenterLegacyDocument, options);
      }
export type CreateDataCenterLegacyMutationHookResult = ReturnType<typeof useCreateDataCenterLegacyMutation>;
export type CreateDataCenterLegacyMutationResult = ApolloReactCommon.MutationResult<CreateDataCenterLegacyMutation>;
export type CreateDataCenterLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDataCenterLegacyMutation, CreateDataCenterLegacyMutationVariables>;
export const UpdateDataCenterLegacyDocument = gql`
    mutation UpdateDataCenterLegacy($id: ID!, $name: String, $status: DataCenterLegacyStatus, $region: Region, $bidUrl: Url, $maxQps: NonNegativeInt) {
  updateDataCenterLegacy(
    id: $id
    attributes: {name: $name, status: $status, region: $region, bidUrl: $bidUrl, maxQps: $maxQps}
  ) {
    id
    altId
    name
    status
    region
    bidUrl
    maxQps
    technicalProvider {
      id
    }
  }
}
    `;
export type UpdateDataCenterLegacyMutationFn = ApolloReactCommon.MutationFunction<UpdateDataCenterLegacyMutation, UpdateDataCenterLegacyMutationVariables>;

/**
 * __useUpdateDataCenterLegacyMutation__
 *
 * To run a mutation, you first call `useUpdateDataCenterLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataCenterLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataCenterLegacyMutation, { data, loading, error }] = useUpdateDataCenterLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      region: // value for 'region'
 *      bidUrl: // value for 'bidUrl'
 *      maxQps: // value for 'maxQps'
 *   },
 * });
 */
export function useUpdateDataCenterLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDataCenterLegacyMutation, UpdateDataCenterLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDataCenterLegacyMutation, UpdateDataCenterLegacyMutationVariables>(UpdateDataCenterLegacyDocument, options);
      }
export type UpdateDataCenterLegacyMutationHookResult = ReturnType<typeof useUpdateDataCenterLegacyMutation>;
export type UpdateDataCenterLegacyMutationResult = ApolloReactCommon.MutationResult<UpdateDataCenterLegacyMutation>;
export type UpdateDataCenterLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDataCenterLegacyMutation, UpdateDataCenterLegacyMutationVariables>;
export const AllDataCentersLegacyDocument = gql`
    query AllDataCentersLegacy($technicalProviderId: ID) {
  allDataCentersLegacy(technicalProviderId: $technicalProviderId) {
    id
    altId
    name
    region
    bidUrl
    maxQps
  }
}
    `;

/**
 * __useAllDataCentersLegacyQuery__
 *
 * To run a query within a React component, call `useAllDataCentersLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDataCentersLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDataCentersLegacyQuery({
 *   variables: {
 *      technicalProviderId: // value for 'technicalProviderId'
 *   },
 * });
 */
export function useAllDataCentersLegacyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllDataCentersLegacyQuery, AllDataCentersLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllDataCentersLegacyQuery, AllDataCentersLegacyQueryVariables>(AllDataCentersLegacyDocument, options);
      }
export function useAllDataCentersLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllDataCentersLegacyQuery, AllDataCentersLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllDataCentersLegacyQuery, AllDataCentersLegacyQueryVariables>(AllDataCentersLegacyDocument, options);
        }
export type AllDataCentersLegacyQueryHookResult = ReturnType<typeof useAllDataCentersLegacyQuery>;
export type AllDataCentersLegacyLazyQueryHookResult = ReturnType<typeof useAllDataCentersLegacyLazyQuery>;
export type AllDataCentersLegacyQueryResult = ApolloReactCommon.QueryResult<AllDataCentersLegacyQuery, AllDataCentersLegacyQueryVariables>;
export const DataCenterLegacyDocument = gql`
    query DataCenterLegacy($id: ID!) {
  dataCenterLegacy(id: $id) {
    id
    altId
    name
    region
    bidUrl
    maxQps
    status
    technicalProvider {
      id
      name
      status
    }
  }
}
    `;

/**
 * __useDataCenterLegacyQuery__
 *
 * To run a query within a React component, call `useDataCenterLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataCenterLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataCenterLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataCenterLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DataCenterLegacyQuery, DataCenterLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DataCenterLegacyQuery, DataCenterLegacyQueryVariables>(DataCenterLegacyDocument, options);
      }
export function useDataCenterLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DataCenterLegacyQuery, DataCenterLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DataCenterLegacyQuery, DataCenterLegacyQueryVariables>(DataCenterLegacyDocument, options);
        }
export type DataCenterLegacyQueryHookResult = ReturnType<typeof useDataCenterLegacyQuery>;
export type DataCenterLegacyLazyQueryHookResult = ReturnType<typeof useDataCenterLegacyLazyQuery>;
export type DataCenterLegacyQueryResult = ApolloReactCommon.QueryResult<DataCenterLegacyQuery, DataCenterLegacyQueryVariables>;
export const CreateDealLegacyDocument = gql`
    mutation CreateDealLegacy($salesChannelId: ID!, $name: String, $startDate: LocalDateTime, $endDate: LocalDateTime, $floorCpm: BigDecimal, $timeZone: ZoneId, $externalId: String, $currency: Currency, $auctionType: AuctionType, $overridePublisherFloor: Boolean, $priority: NonNegativeInt, $privateAuction: Boolean, $offsetCpm: BigDecimal, $trusted: Boolean, $ownerId: ID, $targetingDefinition: TargetingDefinitionAttributes, $targetingDefinitionV2: TargetingDefinitionV2Attributes, $adSeparation: NonNegativeFloat, $adExclusive: Boolean, $seatAllocation: MultiSeatAllocation, $territory: Territory, $dspIncludedSeats: DspIncludedSeats, $targetingVersion: TargetingVersion) {
  createDealLegacy(
    salesChannelId: $salesChannelId
    attributes: {name: $name, startDate: $startDate, endDate: $endDate, floorCpm: $floorCpm, timeZone: $timeZone, auctionType: $auctionType, currency: $currency, externalId: $externalId, overridePublisherFloor: $overridePublisherFloor, priority: $priority, privateAuction: $privateAuction, offsetCpm: $offsetCpm, trusted: $trusted, ownerId: $ownerId, targetingDefinition: $targetingDefinition, targetingDefinitionV2: $targetingDefinitionV2, adSeparation: $adSeparation, adExclusive: $adExclusive, seatAllocation: $seatAllocation, territory: $territory, dspIncludedSeats: $dspIncludedSeats, targetingVersion: $targetingVersion}
  ) {
    id
    altId
    name
    startDate
    endDate
    floorCpm
    timeZone
    auctionType
    currency
    externalId
    overridePublisherFloor
    priority
    privateAuction
    offsetCpm
    status
    trusted
    adSeparation
    adExclusive
    salesChannel {
      id
    }
    owner {
      id
      email
    }
    dsp {
      id
    }
    seats {
      id
    }
    dspIncludedSeats
    targetingVersion
  }
}
    `;
export type CreateDealLegacyMutationFn = ApolloReactCommon.MutationFunction<CreateDealLegacyMutation, CreateDealLegacyMutationVariables>;

/**
 * __useCreateDealLegacyMutation__
 *
 * To run a mutation, you first call `useCreateDealLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealLegacyMutation, { data, loading, error }] = useCreateDealLegacyMutation({
 *   variables: {
 *      salesChannelId: // value for 'salesChannelId'
 *      name: // value for 'name'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      floorCpm: // value for 'floorCpm'
 *      timeZone: // value for 'timeZone'
 *      externalId: // value for 'externalId'
 *      currency: // value for 'currency'
 *      auctionType: // value for 'auctionType'
 *      overridePublisherFloor: // value for 'overridePublisherFloor'
 *      priority: // value for 'priority'
 *      privateAuction: // value for 'privateAuction'
 *      offsetCpm: // value for 'offsetCpm'
 *      trusted: // value for 'trusted'
 *      ownerId: // value for 'ownerId'
 *      targetingDefinition: // value for 'targetingDefinition'
 *      targetingDefinitionV2: // value for 'targetingDefinitionV2'
 *      adSeparation: // value for 'adSeparation'
 *      adExclusive: // value for 'adExclusive'
 *      seatAllocation: // value for 'seatAllocation'
 *      territory: // value for 'territory'
 *      dspIncludedSeats: // value for 'dspIncludedSeats'
 *      targetingVersion: // value for 'targetingVersion'
 *   },
 * });
 */
export function useCreateDealLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDealLegacyMutation, CreateDealLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDealLegacyMutation, CreateDealLegacyMutationVariables>(CreateDealLegacyDocument, options);
      }
export type CreateDealLegacyMutationHookResult = ReturnType<typeof useCreateDealLegacyMutation>;
export type CreateDealLegacyMutationResult = ApolloReactCommon.MutationResult<CreateDealLegacyMutation>;
export type CreateDealLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDealLegacyMutation, CreateDealLegacyMutationVariables>;
export const UpdateDealLegacyDocument = gql`
    mutation UpdateDealLegacy($id: ID!, $name: String, $startDate: LocalDateTime, $endDate: LocalDateTime, $status: DealLegacyStatus, $floorCpm: BigDecimal, $timeZone: ZoneId, $externalId: String, $currency: Currency, $auctionType: AuctionType, $overridePublisherFloor: Boolean, $priority: NonNegativeInt, $privateAuction: Boolean, $offsetCpm: BigDecimal, $trusted: Boolean, $ownerId: ID, $targetingDefinition: TargetingDefinitionAttributes, $targetingDefinitionV2: TargetingDefinitionV2Attributes, $adSeparation: NonNegativeFloat, $adExclusive: Boolean, $seatAllocation: MultiSeatAllocation, $dspIncludedSeats: DspIncludedSeats, $territory: Territory, $targetingVersion: TargetingVersion) {
  updateDealLegacy(
    id: $id
    attributes: {name: $name, startDate: $startDate, endDate: $endDate, status: $status, floorCpm: $floorCpm, timeZone: $timeZone, auctionType: $auctionType, currency: $currency, externalId: $externalId, overridePublisherFloor: $overridePublisherFloor, priority: $priority, privateAuction: $privateAuction, offsetCpm: $offsetCpm, trusted: $trusted, ownerId: $ownerId, targetingDefinition: $targetingDefinition, targetingDefinitionV2: $targetingDefinitionV2, adSeparation: $adSeparation, adExclusive: $adExclusive, seatAllocation: $seatAllocation, dspIncludedSeats: $dspIncludedSeats, territory: $territory, targetingVersion: $targetingVersion}
  ) {
    id
    altId
    adSeparation
    name
    startDate
    endDate
    status
    floorCpm
    timeZone
    auctionType
    currency
    externalId
    overridePublisherFloor
    priority
    privateAuction
    offsetCpm
    trusted
    adExclusive
    salesChannel {
      id
    }
    owner {
      id
      email
    }
    dspIncludedSeats
    dsp {
      id
    }
    seats {
      id
    }
    targetingVersion
  }
}
    `;
export type UpdateDealLegacyMutationFn = ApolloReactCommon.MutationFunction<UpdateDealLegacyMutation, UpdateDealLegacyMutationVariables>;

/**
 * __useUpdateDealLegacyMutation__
 *
 * To run a mutation, you first call `useUpdateDealLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealLegacyMutation, { data, loading, error }] = useUpdateDealLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      status: // value for 'status'
 *      floorCpm: // value for 'floorCpm'
 *      timeZone: // value for 'timeZone'
 *      externalId: // value for 'externalId'
 *      currency: // value for 'currency'
 *      auctionType: // value for 'auctionType'
 *      overridePublisherFloor: // value for 'overridePublisherFloor'
 *      priority: // value for 'priority'
 *      privateAuction: // value for 'privateAuction'
 *      offsetCpm: // value for 'offsetCpm'
 *      trusted: // value for 'trusted'
 *      ownerId: // value for 'ownerId'
 *      targetingDefinition: // value for 'targetingDefinition'
 *      targetingDefinitionV2: // value for 'targetingDefinitionV2'
 *      adSeparation: // value for 'adSeparation'
 *      adExclusive: // value for 'adExclusive'
 *      seatAllocation: // value for 'seatAllocation'
 *      dspIncludedSeats: // value for 'dspIncludedSeats'
 *      territory: // value for 'territory'
 *      targetingVersion: // value for 'targetingVersion'
 *   },
 * });
 */
export function useUpdateDealLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDealLegacyMutation, UpdateDealLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDealLegacyMutation, UpdateDealLegacyMutationVariables>(UpdateDealLegacyDocument, options);
      }
export type UpdateDealLegacyMutationHookResult = ReturnType<typeof useUpdateDealLegacyMutation>;
export type UpdateDealLegacyMutationResult = ApolloReactCommon.MutationResult<UpdateDealLegacyMutation>;
export type UpdateDealLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDealLegacyMutation, UpdateDealLegacyMutationVariables>;
export const CloneDealLegacyDocument = gql`
    mutation CloneDealLegacy($id: ID!) {
  cloneDealLegacy(id: $id) {
    id
  }
}
    `;
export type CloneDealLegacyMutationFn = ApolloReactCommon.MutationFunction<CloneDealLegacyMutation, CloneDealLegacyMutationVariables>;

/**
 * __useCloneDealLegacyMutation__
 *
 * To run a mutation, you first call `useCloneDealLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneDealLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneDealLegacyMutation, { data, loading, error }] = useCloneDealLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloneDealLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CloneDealLegacyMutation, CloneDealLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CloneDealLegacyMutation, CloneDealLegacyMutationVariables>(CloneDealLegacyDocument, options);
      }
export type CloneDealLegacyMutationHookResult = ReturnType<typeof useCloneDealLegacyMutation>;
export type CloneDealLegacyMutationResult = ApolloReactCommon.MutationResult<CloneDealLegacyMutation>;
export type CloneDealLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CloneDealLegacyMutation, CloneDealLegacyMutationVariables>;
export const DealLegacyDocument = gql`
    query DealLegacy($id: ID!) {
  dealLegacy(id: $id) {
    id
    altId
    adSeparation
    name
    startDate
    endDate
    status
    floorCpm
    timeZone
    auctionType
    currency
    externalId
    overridePublisherFloor
    priority
    privateAuction
    offsetCpm
    trusted
    adExclusive
    territory
    targetingVersion
    seats {
      id
      name
    }
    dsp {
      id
      name
    }
    dspIncludedSeats
    salesChannel {
      id
      name
      owner {
        id
        email
        status
      }
      status
    }
    programmaticCreatives {
      id
      name
      type
      status
      url
      iabCategoryCodes
      advertiserDomains
      firstBidDate
      approvalDate
      spec {
        ... on ProgrammaticCreativeAudioSpec {
          duration
        }
        ... on ProgrammaticCreativeImageSpec {
          width
          height
        }
      }
    }
    owner {
      id
      email
      status
    }
    targetingDefinition {
      id
      masterTargetingTemplates {
        id
        name
        description
        isMasterTemplate
        targetingGroups {
          id
          masterTargetingGroupId
          listenerAccuracy
          channels {
            id
          }
          audienceParams {
            ... on KeyValueGroupParam {
              keyValues {
                key
                value
              }
              clusivity
            }
            ... on AgeParam {
              ageRange {
                minAge
                maxAge
              }
              clusivity
            }
            ... on GenderParam {
              genders
              clusivity
            }
            ... on DayAndTimeParam {
              timeZone
              daysOfWeek {
                day
                hours
              }
              clusivity
            }
            ... on DeviceTypeParam {
              deviceTypes
              clusivity
            }
            ... on DeviceOperatingSystemParam {
              deviceOperatingSystems {
                versions
                name
              }
              clusivity
            }
            ... on ConnectionTypeParam {
              clusivity
              connectionTypes
            }
            ... on DeviceMakerParam {
              deviceMakers {
                name
                models
              }
              clusivity
            }
            ... on BrowserLanguageParam {
              browserLanguages {
                description
                code
              }
              clusivity
            }
            ... on PostalCodeParam {
              postalCodes
              postcodeGroups {
                id
                name
              }
              clusivity
            }
            ... on LocationParam {
              positions {
                latitude
                longitude
                radius
              }
              clusivity
            }
            ... on DmpSegmentParam {
              segmentType
              segments {
                ... on NielsenSegment {
                  id
                  fullName
                }
              }
              clusivity
            }
            ... on DmaParam {
              dmas {
                code
                name
              }
              clusivity
            }
            ... on AudienceSegmentParam {
              segments {
                id
                displayName
              }
              clusivity
            }
            ... on GenreParam {
              genres
              clusivity
            }
            ... on ItunesCategoryParam {
              categories
              clusivity
            }
            ... on PodcastParam {
              podcastTargets {
                collectionId
                episodeId
                showId
                name
              }
              clusivity
            }
            ... on AdPositionParam {
              positions {
                position
                midRollPositions
              }
              clusivity
            }
            ... on IspParam {
              isps {
                id
                name
              }
              clusivity
            }
            ... on CountryParam {
              code
              name
              clusivity
              countryGroups {
                name
                id
              }
              subdivisions {
                ... on CityParam {
                  name
                  regionCode
                  subRegionCode
                }
                ... on RegionParam {
                  name
                  code
                  subRegions {
                    name
                    code
                  }
                }
              }
            }
          }
        }
      }
      generalTargetingGroup {
        id
        listenerAccuracy
        channels {
          id
        }
        audienceParams {
          ... on KeyValueGroupParam {
            keyValues {
              key
              value
            }
            clusivity
          }
          ... on AgeParam {
            ageRange {
              minAge
              maxAge
            }
            clusivity
          }
          ... on GenderParam {
            genders
            clusivity
          }
          ... on DayAndTimeParam {
            timeZone
            daysOfWeek {
              day
              hours
            }
            clusivity
          }
          ... on DeviceTypeParam {
            deviceTypes
            clusivity
          }
          ... on DeviceOperatingSystemParam {
            deviceOperatingSystems {
              versions
              name
            }
            clusivity
          }
          ... on ConnectionTypeParam {
            clusivity
            connectionTypes
          }
          ... on DeviceMakerParam {
            deviceMakers {
              name
              models
            }
            clusivity
          }
          ... on BrowserLanguageParam {
            browserLanguages {
              description
              code
            }
            clusivity
          }
          ... on PostalCodeParam {
            postalCodes
            postcodeGroups {
              id
              name
            }
            clusivity
          }
          ... on LocationParam {
            positions {
              latitude
              longitude
              radius
            }
            clusivity
          }
          ... on DmpSegmentParam {
            segmentType
            segments {
              ... on NielsenSegment {
                id
                fullName
              }
            }
            clusivity
          }
          ... on DmaParam {
            dmas {
              code
              name
            }
            clusivity
          }
          ... on AudienceSegmentParam {
            segments {
              id
              displayName
            }
            clusivity
          }
          ... on GenreParam {
            genres
            clusivity
          }
          ... on ItunesCategoryParam {
            categories
            clusivity
          }
          ... on PodcastParam {
            podcastTargets {
              collectionId
              episodeId
              showId
              name
            }
            clusivity
          }
          ... on AdPositionParam {
            positions {
              position
              midRollPositions
            }
            clusivity
          }
          ... on IspParam {
            isps {
              id
              name
            }
            clusivity
          }
          ... on CountryParam {
            code
            name
            clusivity
            countryGroups {
              name
              id
            }
            subdivisions {
              ... on CityParam {
                name
                regionCode
                subRegionCode
              }
              ... on RegionParam {
                name
                code
                subRegions {
                  name
                  code
                }
              }
            }
          }
        }
      }
      targetingGroups {
        id
        masterTargetingGroupId
        listenerAccuracy
        channels {
          id
        }
        audienceParams {
          ... on KeyValueGroupParam {
            keyValues {
              key
              value
            }
            clusivity
          }
          ... on AgeParam {
            ageRange {
              minAge
              maxAge
            }
            clusivity
          }
          ... on GenderParam {
            genders
            clusivity
          }
          ... on DayAndTimeParam {
            timeZone
            daysOfWeek {
              day
              hours
            }
            clusivity
          }
          ... on DeviceTypeParam {
            deviceTypes
            clusivity
          }
          ... on DeviceOperatingSystemParam {
            deviceOperatingSystems {
              versions
              name
            }
            clusivity
          }
          ... on ConnectionTypeParam {
            clusivity
            connectionTypes
          }
          ... on DeviceMakerParam {
            deviceMakers {
              name
              models
            }
            clusivity
          }
          ... on BrowserLanguageParam {
            browserLanguages {
              description
              code
            }
            clusivity
          }
          ... on PostalCodeParam {
            postalCodes
            postcodeGroups {
              id
              name
            }
            clusivity
          }
          ... on LocationParam {
            positions {
              latitude
              longitude
              radius
            }
            clusivity
          }
          ... on DmpSegmentParam {
            segmentType
            segments {
              ... on NielsenSegment {
                id
                fullName
              }
            }
            clusivity
          }
          ... on DmaParam {
            dmas {
              code
              name
            }
            clusivity
          }
          ... on AudienceSegmentParam {
            segments {
              id
              displayName
            }
            clusivity
          }
          ... on GenreParam {
            genres
            clusivity
          }
          ... on ItunesCategoryParam {
            categories
            clusivity
          }
          ... on PodcastParam {
            podcastTargets {
              collectionId
              episodeId
              showId
              name
            }
            clusivity
          }
          ... on AdPositionParam {
            positions {
              position
              midRollPositions
            }
            clusivity
          }
          ... on IspParam {
            isps {
              id
              name
            }
            clusivity
          }
          ... on CountryParam {
            code
            name
            clusivity
            countryGroups {
              name
              id
            }
            subdivisions {
              ... on CityParam {
                name
                regionCode
                subRegionCode
              }
              ... on RegionParam {
                name
                code
                subRegions {
                  name
                  code
                }
              }
            }
          }
        }
      }
    }
    targetingDefinitionV2 {
      id
      audienceTargeting {
        audiences {
          parameters {
            type
            clusivity
            values {
              id
              name
              active
              activeGrades
            }
            enabledGrades
          }
        }
      }
      locationTargeting {
        locations {
          limitLocationParameterValue {
            id
          }
          accuracyRadius
          parameters {
            type
            clusivity
            values {
              id
              name
              parents {
                id
                name
              }
            }
          }
        }
      }
      technologyTargeting {
        technologies {
          parameters {
            type
            clusivity
            values {
              id
              name
            }
          }
        }
      }
      inventoryTargeting {
        inventories {
          parameters {
            type
            clusivity
            values {
              id
              name
              active
              parents {
                id
                name
              }
            }
          }
        }
      }
      dayTimeTargeting {
        clusivity
        timeZone
        daysOfWeek {
          day
          hours
        }
      }
      customTargeting {
        customGroups {
          parameters {
            clusivity
            customKvps {
              key
              value
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDealLegacyQuery__
 *
 * To run a query within a React component, call `useDealLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDealLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DealLegacyQuery, DealLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DealLegacyQuery, DealLegacyQueryVariables>(DealLegacyDocument, options);
      }
export function useDealLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DealLegacyQuery, DealLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DealLegacyQuery, DealLegacyQueryVariables>(DealLegacyDocument, options);
        }
export type DealLegacyQueryHookResult = ReturnType<typeof useDealLegacyQuery>;
export type DealLegacyLazyQueryHookResult = ReturnType<typeof useDealLegacyLazyQuery>;
export type DealLegacyQueryResult = ApolloReactCommon.QueryResult<DealLegacyQuery, DealLegacyQueryVariables>;
export const DealTimeSeriesDocument = gql`
    query DealTimeSeries($id: ID!, $timeZone: ZoneId!, $currency: Currency!) {
  dealLegacy(id: $id) {
    id
    timeZone
    timeSeries(params: {timeUnit: HOUR, timeZone: $timeZone}, currency: $currency) {
      impressions {
        dataPoints {
          t
          v
        }
      }
      eCpm {
        dataPoints {
          t
          v
        }
      }
      advPayout {
        dataPoints {
          t
          v
        }
      }
      ltr {
        dataPoints {
          t
          v
        }
      }
    }
  }
}
    `;

/**
 * __useDealTimeSeriesQuery__
 *
 * To run a query within a React component, call `useDealTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealTimeSeriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      timeZone: // value for 'timeZone'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useDealTimeSeriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DealTimeSeriesQuery, DealTimeSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DealTimeSeriesQuery, DealTimeSeriesQueryVariables>(DealTimeSeriesDocument, options);
      }
export function useDealTimeSeriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DealTimeSeriesQuery, DealTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DealTimeSeriesQuery, DealTimeSeriesQueryVariables>(DealTimeSeriesDocument, options);
        }
export type DealTimeSeriesQueryHookResult = ReturnType<typeof useDealTimeSeriesQuery>;
export type DealTimeSeriesLazyQueryHookResult = ReturnType<typeof useDealTimeSeriesLazyQuery>;
export type DealTimeSeriesQueryResult = ApolloReactCommon.QueryResult<DealTimeSeriesQuery, DealTimeSeriesQueryVariables>;
export const DealHealthLegacyDocument = gql`
    query DealHealthLegacy($id: ID!, $from: LocalDate, $until: LocalDate) {
  dealLegacy(id: $id) {
    id
    health(from: $from, until: $until) {
      id
      name
      parentId
      childrenIds
      value
      percentOfParent
      category
      breakdown {
        name
        value
      }
    }
  }
}
    `;

/**
 * __useDealHealthLegacyQuery__
 *
 * To run a query within a React component, call `useDealHealthLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealHealthLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealHealthLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      until: // value for 'until'
 *   },
 * });
 */
export function useDealHealthLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DealHealthLegacyQuery, DealHealthLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DealHealthLegacyQuery, DealHealthLegacyQueryVariables>(DealHealthLegacyDocument, options);
      }
export function useDealHealthLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DealHealthLegacyQuery, DealHealthLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DealHealthLegacyQuery, DealHealthLegacyQueryVariables>(DealHealthLegacyDocument, options);
        }
export type DealHealthLegacyQueryHookResult = ReturnType<typeof useDealHealthLegacyQuery>;
export type DealHealthLegacyLazyQueryHookResult = ReturnType<typeof useDealHealthLegacyLazyQuery>;
export type DealHealthLegacyQueryResult = ApolloReactCommon.QueryResult<DealHealthLegacyQuery, DealHealthLegacyQueryVariables>;
export const AllActiveDealsLegacyDocument = gql`
    query AllActiveDealsLegacy($salesChannelId: ID, $filter: DealLegacyFilter, $territories: [Territory!]!) {
  allDealsLegacy(
    salesChannelId: $salesChannelId
    filter: $filter
    territories: $territories
  ) {
    id
    altId
    name
    floorCpm
    startDate
    endDate
    timeZone
    status
    priority
    externalId
    trusted
    owner {
      id
      email
      status
    }
    territory
  }
}
    `;

/**
 * __useAllActiveDealsLegacyQuery__
 *
 * To run a query within a React component, call `useAllActiveDealsLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllActiveDealsLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllActiveDealsLegacyQuery({
 *   variables: {
 *      salesChannelId: // value for 'salesChannelId'
 *      filter: // value for 'filter'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllActiveDealsLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllActiveDealsLegacyQuery, AllActiveDealsLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllActiveDealsLegacyQuery, AllActiveDealsLegacyQueryVariables>(AllActiveDealsLegacyDocument, options);
      }
export function useAllActiveDealsLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllActiveDealsLegacyQuery, AllActiveDealsLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllActiveDealsLegacyQuery, AllActiveDealsLegacyQueryVariables>(AllActiveDealsLegacyDocument, options);
        }
export type AllActiveDealsLegacyQueryHookResult = ReturnType<typeof useAllActiveDealsLegacyQuery>;
export type AllActiveDealsLegacyLazyQueryHookResult = ReturnType<typeof useAllActiveDealsLegacyLazyQuery>;
export type AllActiveDealsLegacyQueryResult = ApolloReactCommon.QueryResult<AllActiveDealsLegacyQuery, AllActiveDealsLegacyQueryVariables>;
export const CreateDspLegacyDocument = gql`
    mutation CreateDspLegacy($technicalProviderId: ID!, $name: String, $dailyCap: NonNegativeInt, $maxAds: NonNegativeInt, $territories: [Territory!]) {
  createDspLegacy(
    technicalProviderId: $technicalProviderId
    attributes: {name: $name, dailyCap: $dailyCap, maxAds: $maxAds, territories: $territories}
  ) {
    id
    name
    dailyCap
    maxAds
    altId
    status
    territories
  }
}
    `;
export type CreateDspLegacyMutationFn = ApolloReactCommon.MutationFunction<CreateDspLegacyMutation, CreateDspLegacyMutationVariables>;

/**
 * __useCreateDspLegacyMutation__
 *
 * To run a mutation, you first call `useCreateDspLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDspLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDspLegacyMutation, { data, loading, error }] = useCreateDspLegacyMutation({
 *   variables: {
 *      technicalProviderId: // value for 'technicalProviderId'
 *      name: // value for 'name'
 *      dailyCap: // value for 'dailyCap'
 *      maxAds: // value for 'maxAds'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useCreateDspLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDspLegacyMutation, CreateDspLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDspLegacyMutation, CreateDspLegacyMutationVariables>(CreateDspLegacyDocument, options);
      }
export type CreateDspLegacyMutationHookResult = ReturnType<typeof useCreateDspLegacyMutation>;
export type CreateDspLegacyMutationResult = ApolloReactCommon.MutationResult<CreateDspLegacyMutation>;
export type CreateDspLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDspLegacyMutation, CreateDspLegacyMutationVariables>;
export const UpdateDspLegacyDocument = gql`
    mutation UpdateDspLegacy($id: ID!, $name: String, $status: DspLegacyStatus, $dailyCap: NonNegativeInt, $maxAds: NonNegativeInt, $territories: [Territory!]) {
  updateDspLegacy(
    id: $id
    attributes: {name: $name, status: $status, dailyCap: $dailyCap, maxAds: $maxAds, territories: $territories}
  ) {
    id
    name
    status
    dailyCap
    maxAds
    altId
    territories
  }
}
    `;
export type UpdateDspLegacyMutationFn = ApolloReactCommon.MutationFunction<UpdateDspLegacyMutation, UpdateDspLegacyMutationVariables>;

/**
 * __useUpdateDspLegacyMutation__
 *
 * To run a mutation, you first call `useUpdateDspLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDspLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDspLegacyMutation, { data, loading, error }] = useUpdateDspLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      dailyCap: // value for 'dailyCap'
 *      maxAds: // value for 'maxAds'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useUpdateDspLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDspLegacyMutation, UpdateDspLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDspLegacyMutation, UpdateDspLegacyMutationVariables>(UpdateDspLegacyDocument, options);
      }
export type UpdateDspLegacyMutationHookResult = ReturnType<typeof useUpdateDspLegacyMutation>;
export type UpdateDspLegacyMutationResult = ApolloReactCommon.MutationResult<UpdateDspLegacyMutation>;
export type UpdateDspLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDspLegacyMutation, UpdateDspLegacyMutationVariables>;
export const DspMinimalLegacyDocument = gql`
    query DspMinimalLegacy($id: ID!) {
  dspLegacy(id: $id) {
    id
    name
    territories
  }
}
    `;

/**
 * __useDspMinimalLegacyQuery__
 *
 * To run a query within a React component, call `useDspMinimalLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDspMinimalLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDspMinimalLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDspMinimalLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DspMinimalLegacyQuery, DspMinimalLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DspMinimalLegacyQuery, DspMinimalLegacyQueryVariables>(DspMinimalLegacyDocument, options);
      }
export function useDspMinimalLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DspMinimalLegacyQuery, DspMinimalLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DspMinimalLegacyQuery, DspMinimalLegacyQueryVariables>(DspMinimalLegacyDocument, options);
        }
export type DspMinimalLegacyQueryHookResult = ReturnType<typeof useDspMinimalLegacyQuery>;
export type DspMinimalLegacyLazyQueryHookResult = ReturnType<typeof useDspMinimalLegacyLazyQuery>;
export type DspMinimalLegacyQueryResult = ApolloReactCommon.QueryResult<DspMinimalLegacyQuery, DspMinimalLegacyQueryVariables>;
export const DspLegacyDocument = gql`
    query DspLegacy($id: ID!, $territories: [Territory!]) {
  dspLegacy(id: $id) {
    id
    dailyCap
    maxAds
    name
    altId
    status
    seats(territories: $territories) {
      id
      altId
      name
      status
      externalSeatId
    }
    technicalProvider {
      id
      name
      status
      territories
    }
    territories
  }
}
    `;

/**
 * __useDspLegacyQuery__
 *
 * To run a query within a React component, call `useDspLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDspLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDspLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useDspLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DspLegacyQuery, DspLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DspLegacyQuery, DspLegacyQueryVariables>(DspLegacyDocument, options);
      }
export function useDspLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DspLegacyQuery, DspLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DspLegacyQuery, DspLegacyQueryVariables>(DspLegacyDocument, options);
        }
export type DspLegacyQueryHookResult = ReturnType<typeof useDspLegacyQuery>;
export type DspLegacyLazyQueryHookResult = ReturnType<typeof useDspLegacyLazyQuery>;
export type DspLegacyQueryResult = ApolloReactCommon.QueryResult<DspLegacyQuery, DspLegacyQueryVariables>;
export const AllDspsLegacyDocument = gql`
    query AllDspsLegacy($technicalProviderId: ID, $territories: [Territory!]!) {
  allDspsLegacy(
    technicalProviderId: $technicalProviderId
    territories: $territories
  ) {
    id
    name
    dailyCap
    seats(filter: {status_in: [ACTIVE]}, territories: $territories) {
      id
      name
    }
    technicalProvider {
      id
      openSeatDsp {
        id
      }
    }
  }
}
    `;

/**
 * __useAllDspsLegacyQuery__
 *
 * To run a query within a React component, call `useAllDspsLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDspsLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDspsLegacyQuery({
 *   variables: {
 *      technicalProviderId: // value for 'technicalProviderId'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllDspsLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllDspsLegacyQuery, AllDspsLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllDspsLegacyQuery, AllDspsLegacyQueryVariables>(AllDspsLegacyDocument, options);
      }
export function useAllDspsLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllDspsLegacyQuery, AllDspsLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllDspsLegacyQuery, AllDspsLegacyQueryVariables>(AllDspsLegacyDocument, options);
        }
export type AllDspsLegacyQueryHookResult = ReturnType<typeof useAllDspsLegacyQuery>;
export type AllDspsLegacyLazyQueryHookResult = ReturnType<typeof useAllDspsLegacyLazyQuery>;
export type AllDspsLegacyQueryResult = ApolloReactCommon.QueryResult<AllDspsLegacyQuery, AllDspsLegacyQueryVariables>;
export const CreateSalesChannelLegacyDocument = gql`
    mutation CreateSalesChannelLegacy($agencyId: ID!, $name: String, $ownerId: ID, $territory: Territory) {
  createSalesChannelLegacy(
    agencyId: $agencyId
    attributes: {name: $name, ownerId: $ownerId, territory: $territory}
  ) {
    id
    name
    altId
    status
    territory
    agency {
      id
      name
    }
    owner {
      id
      email
    }
  }
}
    `;
export type CreateSalesChannelLegacyMutationFn = ApolloReactCommon.MutationFunction<CreateSalesChannelLegacyMutation, CreateSalesChannelLegacyMutationVariables>;

/**
 * __useCreateSalesChannelLegacyMutation__
 *
 * To run a mutation, you first call `useCreateSalesChannelLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSalesChannelLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSalesChannelLegacyMutation, { data, loading, error }] = useCreateSalesChannelLegacyMutation({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      name: // value for 'name'
 *      ownerId: // value for 'ownerId'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useCreateSalesChannelLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSalesChannelLegacyMutation, CreateSalesChannelLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSalesChannelLegacyMutation, CreateSalesChannelLegacyMutationVariables>(CreateSalesChannelLegacyDocument, options);
      }
export type CreateSalesChannelLegacyMutationHookResult = ReturnType<typeof useCreateSalesChannelLegacyMutation>;
export type CreateSalesChannelLegacyMutationResult = ApolloReactCommon.MutationResult<CreateSalesChannelLegacyMutation>;
export type CreateSalesChannelLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSalesChannelLegacyMutation, CreateSalesChannelLegacyMutationVariables>;
export const UpdateSalesChannelLegacyDocument = gql`
    mutation UpdateSalesChannelLegacy($id: ID!, $name: String, $status: SalesChannelLegacyStatus, $ownerId: ID, $territory: Territory) {
  updateSalesChannelLegacy(
    id: $id
    attributes: {name: $name, status: $status, ownerId: $ownerId, territory: $territory}
  ) {
    id
    name
    status
    territory
    agency {
      id
      name
    }
    owner {
      id
      email
    }
  }
}
    `;
export type UpdateSalesChannelLegacyMutationFn = ApolloReactCommon.MutationFunction<UpdateSalesChannelLegacyMutation, UpdateSalesChannelLegacyMutationVariables>;

/**
 * __useUpdateSalesChannelLegacyMutation__
 *
 * To run a mutation, you first call `useUpdateSalesChannelLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalesChannelLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalesChannelLegacyMutation, { data, loading, error }] = useUpdateSalesChannelLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      ownerId: // value for 'ownerId'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useUpdateSalesChannelLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSalesChannelLegacyMutation, UpdateSalesChannelLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSalesChannelLegacyMutation, UpdateSalesChannelLegacyMutationVariables>(UpdateSalesChannelLegacyDocument, options);
      }
export type UpdateSalesChannelLegacyMutationHookResult = ReturnType<typeof useUpdateSalesChannelLegacyMutation>;
export type UpdateSalesChannelLegacyMutationResult = ApolloReactCommon.MutationResult<UpdateSalesChannelLegacyMutation>;
export type UpdateSalesChannelLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSalesChannelLegacyMutation, UpdateSalesChannelLegacyMutationVariables>;
export const AllSalesChannelsLegacyDocument = gql`
    query AllSalesChannelsLegacy($agencyId: ID, $territories: [Territory!]!) {
  allSalesChannelsLegacy(agencyId: $agencyId, territories: $territories) {
    id
    altId
    name
    status
    territory
    owner {
      id
      email
      status
    }
  }
}
    `;

/**
 * __useAllSalesChannelsLegacyQuery__
 *
 * To run a query within a React component, call `useAllSalesChannelsLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSalesChannelsLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSalesChannelsLegacyQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllSalesChannelsLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllSalesChannelsLegacyQuery, AllSalesChannelsLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllSalesChannelsLegacyQuery, AllSalesChannelsLegacyQueryVariables>(AllSalesChannelsLegacyDocument, options);
      }
export function useAllSalesChannelsLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllSalesChannelsLegacyQuery, AllSalesChannelsLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllSalesChannelsLegacyQuery, AllSalesChannelsLegacyQueryVariables>(AllSalesChannelsLegacyDocument, options);
        }
export type AllSalesChannelsLegacyQueryHookResult = ReturnType<typeof useAllSalesChannelsLegacyQuery>;
export type AllSalesChannelsLegacyLazyQueryHookResult = ReturnType<typeof useAllSalesChannelsLegacyLazyQuery>;
export type AllSalesChannelsLegacyQueryResult = ApolloReactCommon.QueryResult<AllSalesChannelsLegacyQuery, AllSalesChannelsLegacyQueryVariables>;
export const SalesChannelMinimalLegacyDocument = gql`
    query SalesChannelMinimalLegacy($id: ID!) {
  salesChannelLegacy(id: $id) {
    id
    name
    owner {
      id
      email
      status
    }
    territory
  }
}
    `;

/**
 * __useSalesChannelMinimalLegacyQuery__
 *
 * To run a query within a React component, call `useSalesChannelMinimalLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesChannelMinimalLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesChannelMinimalLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSalesChannelMinimalLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SalesChannelMinimalLegacyQuery, SalesChannelMinimalLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SalesChannelMinimalLegacyQuery, SalesChannelMinimalLegacyQueryVariables>(SalesChannelMinimalLegacyDocument, options);
      }
export function useSalesChannelMinimalLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SalesChannelMinimalLegacyQuery, SalesChannelMinimalLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SalesChannelMinimalLegacyQuery, SalesChannelMinimalLegacyQueryVariables>(SalesChannelMinimalLegacyDocument, options);
        }
export type SalesChannelMinimalLegacyQueryHookResult = ReturnType<typeof useSalesChannelMinimalLegacyQuery>;
export type SalesChannelMinimalLegacyLazyQueryHookResult = ReturnType<typeof useSalesChannelMinimalLegacyLazyQuery>;
export type SalesChannelMinimalLegacyQueryResult = ApolloReactCommon.QueryResult<SalesChannelMinimalLegacyQuery, SalesChannelMinimalLegacyQueryVariables>;
export const SalesChannelLegacyDocument = gql`
    query SalesChannelLegacy($id: ID!) {
  salesChannelLegacy(id: $id) {
    id
    altId
    name
    status
    territory
    health {
      id
      name
      parentId
      childrenIds
      value
      percentOfParent
      category
    }
    deals {
      id
      altId
      name
      floorCpm
      startDate
      endDate
      timeZone
      status
      priority
      externalId
      trusted
      owner {
        id
        email
        status
      }
    }
    agency {
      id
      name
      status
    }
    owner {
      id
      email
      status
    }
  }
}
    `;

/**
 * __useSalesChannelLegacyQuery__
 *
 * To run a query within a React component, call `useSalesChannelLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesChannelLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesChannelLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSalesChannelLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SalesChannelLegacyQuery, SalesChannelLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SalesChannelLegacyQuery, SalesChannelLegacyQueryVariables>(SalesChannelLegacyDocument, options);
      }
export function useSalesChannelLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SalesChannelLegacyQuery, SalesChannelLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SalesChannelLegacyQuery, SalesChannelLegacyQueryVariables>(SalesChannelLegacyDocument, options);
        }
export type SalesChannelLegacyQueryHookResult = ReturnType<typeof useSalesChannelLegacyQuery>;
export type SalesChannelLegacyLazyQueryHookResult = ReturnType<typeof useSalesChannelLegacyLazyQuery>;
export type SalesChannelLegacyQueryResult = ApolloReactCommon.QueryResult<SalesChannelLegacyQuery, SalesChannelLegacyQueryVariables>;
export const SalesChannelHealthLegacyDocument = gql`
    query SalesChannelHealthLegacy($id: ID!, $from: LocalDate, $until: LocalDate) {
  salesChannelLegacy(id: $id) {
    id
    health(from: $from, until: $until) {
      id
      name
      parentId
      childrenIds
      value
      percentOfParent
      category
    }
  }
}
    `;

/**
 * __useSalesChannelHealthLegacyQuery__
 *
 * To run a query within a React component, call `useSalesChannelHealthLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesChannelHealthLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesChannelHealthLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      until: // value for 'until'
 *   },
 * });
 */
export function useSalesChannelHealthLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SalesChannelHealthLegacyQuery, SalesChannelHealthLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SalesChannelHealthLegacyQuery, SalesChannelHealthLegacyQueryVariables>(SalesChannelHealthLegacyDocument, options);
      }
export function useSalesChannelHealthLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SalesChannelHealthLegacyQuery, SalesChannelHealthLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SalesChannelHealthLegacyQuery, SalesChannelHealthLegacyQueryVariables>(SalesChannelHealthLegacyDocument, options);
        }
export type SalesChannelHealthLegacyQueryHookResult = ReturnType<typeof useSalesChannelHealthLegacyQuery>;
export type SalesChannelHealthLegacyLazyQueryHookResult = ReturnType<typeof useSalesChannelHealthLegacyLazyQuery>;
export type SalesChannelHealthLegacyQueryResult = ApolloReactCommon.QueryResult<SalesChannelHealthLegacyQuery, SalesChannelHealthLegacyQueryVariables>;
export const CreateSeatLegacyDocument = gql`
    mutation CreateSeatLegacy($dspId: ID!, $name: String, $externalSeatId: String, $territories: [Territory!]) {
  createSeatLegacy(
    dspId: $dspId
    attributes: {name: $name, externalSeatId: $externalSeatId, territories: $territories}
  ) {
    altId
    externalSeatId
    id
    name
    status
    territories
  }
}
    `;
export type CreateSeatLegacyMutationFn = ApolloReactCommon.MutationFunction<CreateSeatLegacyMutation, CreateSeatLegacyMutationVariables>;

/**
 * __useCreateSeatLegacyMutation__
 *
 * To run a mutation, you first call `useCreateSeatLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeatLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeatLegacyMutation, { data, loading, error }] = useCreateSeatLegacyMutation({
 *   variables: {
 *      dspId: // value for 'dspId'
 *      name: // value for 'name'
 *      externalSeatId: // value for 'externalSeatId'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useCreateSeatLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSeatLegacyMutation, CreateSeatLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSeatLegacyMutation, CreateSeatLegacyMutationVariables>(CreateSeatLegacyDocument, options);
      }
export type CreateSeatLegacyMutationHookResult = ReturnType<typeof useCreateSeatLegacyMutation>;
export type CreateSeatLegacyMutationResult = ApolloReactCommon.MutationResult<CreateSeatLegacyMutation>;
export type CreateSeatLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSeatLegacyMutation, CreateSeatLegacyMutationVariables>;
export const UpdateSeatLegacyDocument = gql`
    mutation UpdateSeatLegacy($id: ID!, $name: String, $status: SeatLegacyStatus, $externalSeatId: String, $territories: [Territory!]) {
  updateSeatLegacy(
    id: $id
    attributes: {name: $name, status: $status, externalSeatId: $externalSeatId, territories: $territories}
  ) {
    altId
    externalSeatId
    id
    name
    status
    territories
  }
}
    `;
export type UpdateSeatLegacyMutationFn = ApolloReactCommon.MutationFunction<UpdateSeatLegacyMutation, UpdateSeatLegacyMutationVariables>;

/**
 * __useUpdateSeatLegacyMutation__
 *
 * To run a mutation, you first call `useUpdateSeatLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeatLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeatLegacyMutation, { data, loading, error }] = useUpdateSeatLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      externalSeatId: // value for 'externalSeatId'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useUpdateSeatLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSeatLegacyMutation, UpdateSeatLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSeatLegacyMutation, UpdateSeatLegacyMutationVariables>(UpdateSeatLegacyDocument, options);
      }
export type UpdateSeatLegacyMutationHookResult = ReturnType<typeof useUpdateSeatLegacyMutation>;
export type UpdateSeatLegacyMutationResult = ApolloReactCommon.MutationResult<UpdateSeatLegacyMutation>;
export type UpdateSeatLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSeatLegacyMutation, UpdateSeatLegacyMutationVariables>;
export const SeatLegacyDocument = gql`
    query SeatLegacy($id: ID!) {
  seatLegacy(id: $id) {
    altId
    externalSeatId
    id
    name
    status
    dsp {
      id
      name
      status
      territories
    }
    territories
  }
}
    `;

/**
 * __useSeatLegacyQuery__
 *
 * To run a query within a React component, call `useSeatLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeatLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeatLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSeatLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SeatLegacyQuery, SeatLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SeatLegacyQuery, SeatLegacyQueryVariables>(SeatLegacyDocument, options);
      }
export function useSeatLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SeatLegacyQuery, SeatLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SeatLegacyQuery, SeatLegacyQueryVariables>(SeatLegacyDocument, options);
        }
export type SeatLegacyQueryHookResult = ReturnType<typeof useSeatLegacyQuery>;
export type SeatLegacyLazyQueryHookResult = ReturnType<typeof useSeatLegacyLazyQuery>;
export type SeatLegacyQueryResult = ApolloReactCommon.QueryResult<SeatLegacyQuery, SeatLegacyQueryVariables>;
export const GenerateUniqueExternalIdDocument = gql`
    query GenerateUniqueExternalId {
  generateUniqueExternalId
}
    `;

/**
 * __useGenerateUniqueExternalIdQuery__
 *
 * To run a query within a React component, call `useGenerateUniqueExternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateUniqueExternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateUniqueExternalIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateUniqueExternalIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GenerateUniqueExternalIdQuery, GenerateUniqueExternalIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GenerateUniqueExternalIdQuery, GenerateUniqueExternalIdQueryVariables>(GenerateUniqueExternalIdDocument, options);
      }
export function useGenerateUniqueExternalIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GenerateUniqueExternalIdQuery, GenerateUniqueExternalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GenerateUniqueExternalIdQuery, GenerateUniqueExternalIdQueryVariables>(GenerateUniqueExternalIdDocument, options);
        }
export type GenerateUniqueExternalIdQueryHookResult = ReturnType<typeof useGenerateUniqueExternalIdQuery>;
export type GenerateUniqueExternalIdLazyQueryHookResult = ReturnType<typeof useGenerateUniqueExternalIdLazyQuery>;
export type GenerateUniqueExternalIdQueryResult = ApolloReactCommon.QueryResult<GenerateUniqueExternalIdQuery, GenerateUniqueExternalIdQueryVariables>;
export const CreateTechnicalProviderLegacyDocument = gql`
    mutation CreateTechnicalProviderLegacy($name: String, $userSyncUrl: Url, $userSyncSecureUrl: Url, $currency: Currency, $blockGeoData: Boolean, $truncateGpsCoords: Boolean, $blockIpData: Boolean, $truncateIpAddress: Boolean, $block1stPartyData: Boolean, $blockListenerId: Boolean, $kvps1stPartyData: String, $gzipCompressed: Boolean, $sendNotSyncedUsers: Boolean, $blockSite: Boolean, $blockApp: Boolean, $appBundle: String, $blockPublisher: Boolean, $publisherId: String, $publisherTagId: String, $consentVendorId: NonNegativeInt, $vastVersions: [VastVersion], $dspProvider: DspProvider, $territories: [Territory!], $bidFloorPrecision: NonNegativeInt) {
  createTechnicalProviderLegacy(
    attributes: {name: $name, userSyncUrl: $userSyncUrl, userSyncSecureUrl: $userSyncSecureUrl, currency: $currency, blockGeoData: $blockGeoData, truncateGpsCoords: $truncateGpsCoords, blockIpData: $blockIpData, truncateIpAddress: $truncateIpAddress, block1stPartyData: $block1stPartyData, blockListenerId: $blockListenerId, kvps1stPartyData: $kvps1stPartyData, gzipCompressed: $gzipCompressed, sendNotSyncedUsers: $sendNotSyncedUsers, blockSite: $blockSite, blockApp: $blockApp, appBundle: $appBundle, blockPublisher: $blockPublisher, publisherId: $publisherId, publisherTagId: $publisherTagId, consentVendorId: $consentVendorId, vastVersions: $vastVersions, dspProvider: $dspProvider, territories: $territories, bidFloorPrecision: $bidFloorPrecision}
  ) {
    id
    altId
    name
    userSyncUrl
    userSyncSecureUrl
    currency
    status
    blockGeoData
    truncateGpsCoords
    blockIpData
    truncateIpAddress
    block1stPartyData
    blockListenerId
    kvps1stPartyData
    gzipCompressed
    sendNotSyncedUsers
    blockSite
    siteName
    siteDomain
    blockApp
    appBundle
    appName
    appDomain
    blockPublisher
    publisherId
    publisherName
    publisherDomain
    publisherTagId
    consentVendorId
    vastVersions
    dspProvider
    territories
    bidFloorPrecision
  }
}
    `;
export type CreateTechnicalProviderLegacyMutationFn = ApolloReactCommon.MutationFunction<CreateTechnicalProviderLegacyMutation, CreateTechnicalProviderLegacyMutationVariables>;

/**
 * __useCreateTechnicalProviderLegacyMutation__
 *
 * To run a mutation, you first call `useCreateTechnicalProviderLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTechnicalProviderLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTechnicalProviderLegacyMutation, { data, loading, error }] = useCreateTechnicalProviderLegacyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      userSyncUrl: // value for 'userSyncUrl'
 *      userSyncSecureUrl: // value for 'userSyncSecureUrl'
 *      currency: // value for 'currency'
 *      blockGeoData: // value for 'blockGeoData'
 *      truncateGpsCoords: // value for 'truncateGpsCoords'
 *      blockIpData: // value for 'blockIpData'
 *      truncateIpAddress: // value for 'truncateIpAddress'
 *      block1stPartyData: // value for 'block1stPartyData'
 *      blockListenerId: // value for 'blockListenerId'
 *      kvps1stPartyData: // value for 'kvps1stPartyData'
 *      gzipCompressed: // value for 'gzipCompressed'
 *      sendNotSyncedUsers: // value for 'sendNotSyncedUsers'
 *      blockSite: // value for 'blockSite'
 *      blockApp: // value for 'blockApp'
 *      appBundle: // value for 'appBundle'
 *      blockPublisher: // value for 'blockPublisher'
 *      publisherId: // value for 'publisherId'
 *      publisherTagId: // value for 'publisherTagId'
 *      consentVendorId: // value for 'consentVendorId'
 *      vastVersions: // value for 'vastVersions'
 *      dspProvider: // value for 'dspProvider'
 *      territories: // value for 'territories'
 *      bidFloorPrecision: // value for 'bidFloorPrecision'
 *   },
 * });
 */
export function useCreateTechnicalProviderLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTechnicalProviderLegacyMutation, CreateTechnicalProviderLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTechnicalProviderLegacyMutation, CreateTechnicalProviderLegacyMutationVariables>(CreateTechnicalProviderLegacyDocument, options);
      }
export type CreateTechnicalProviderLegacyMutationHookResult = ReturnType<typeof useCreateTechnicalProviderLegacyMutation>;
export type CreateTechnicalProviderLegacyMutationResult = ApolloReactCommon.MutationResult<CreateTechnicalProviderLegacyMutation>;
export type CreateTechnicalProviderLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTechnicalProviderLegacyMutation, CreateTechnicalProviderLegacyMutationVariables>;
export const UpdateTechnicalProviderLegacyDocument = gql`
    mutation UpdateTechnicalProviderLegacy($id: ID!, $name: String, $status: TechnicalProviderLegacyStatus, $userSyncUrl: Url, $userSyncSecureUrl: Url, $currency: Currency, $blockGeoData: Boolean, $truncateGpsCoords: Boolean, $blockIpData: Boolean, $truncateIpAddress: Boolean, $block1stPartyData: Boolean, $blockListenerId: Boolean, $kvps1stPartyData: String, $gzipCompressed: Boolean, $sendNotSyncedUsers: Boolean, $blockSite: Boolean, $blockApp: Boolean, $appBundle: String, $blockPublisher: Boolean, $publisherId: String, $publisherTagId: String, $consentVendorId: NonNegativeInt, $vastVersions: [VastVersion], $dspProvider: DspProvider, $territories: [Territory!], $bidFloorPrecision: NonNegativeInt) {
  updateTechnicalProviderLegacy(
    id: $id
    attributes: {name: $name, status: $status, userSyncUrl: $userSyncUrl, userSyncSecureUrl: $userSyncSecureUrl, currency: $currency, blockGeoData: $blockGeoData, truncateGpsCoords: $truncateGpsCoords, blockIpData: $blockIpData, truncateIpAddress: $truncateIpAddress, block1stPartyData: $block1stPartyData, blockListenerId: $blockListenerId, kvps1stPartyData: $kvps1stPartyData, gzipCompressed: $gzipCompressed, sendNotSyncedUsers: $sendNotSyncedUsers, blockSite: $blockSite, blockApp: $blockApp, appBundle: $appBundle, blockPublisher: $blockPublisher, publisherId: $publisherId, publisherTagId: $publisherTagId, consentVendorId: $consentVendorId, vastVersions: $vastVersions, dspProvider: $dspProvider, territories: $territories, bidFloorPrecision: $bidFloorPrecision}
  ) {
    id
    altId
    name
    status
    userSyncUrl
    userSyncSecureUrl
    currency
    blockGeoData
    truncateGpsCoords
    blockIpData
    truncateIpAddress
    block1stPartyData
    blockListenerId
    kvps1stPartyData
    gzipCompressed
    sendNotSyncedUsers
    blockSite
    siteName
    siteDomain
    blockApp
    appBundle
    appName
    appDomain
    blockPublisher
    publisherId
    publisherName
    publisherDomain
    publisherTagId
    consentVendorId
    vastVersions
    dspProvider
    territories
    bidFloorPrecision
  }
}
    `;
export type UpdateTechnicalProviderLegacyMutationFn = ApolloReactCommon.MutationFunction<UpdateTechnicalProviderLegacyMutation, UpdateTechnicalProviderLegacyMutationVariables>;

/**
 * __useUpdateTechnicalProviderLegacyMutation__
 *
 * To run a mutation, you first call `useUpdateTechnicalProviderLegacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTechnicalProviderLegacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTechnicalProviderLegacyMutation, { data, loading, error }] = useUpdateTechnicalProviderLegacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      userSyncUrl: // value for 'userSyncUrl'
 *      userSyncSecureUrl: // value for 'userSyncSecureUrl'
 *      currency: // value for 'currency'
 *      blockGeoData: // value for 'blockGeoData'
 *      truncateGpsCoords: // value for 'truncateGpsCoords'
 *      blockIpData: // value for 'blockIpData'
 *      truncateIpAddress: // value for 'truncateIpAddress'
 *      block1stPartyData: // value for 'block1stPartyData'
 *      blockListenerId: // value for 'blockListenerId'
 *      kvps1stPartyData: // value for 'kvps1stPartyData'
 *      gzipCompressed: // value for 'gzipCompressed'
 *      sendNotSyncedUsers: // value for 'sendNotSyncedUsers'
 *      blockSite: // value for 'blockSite'
 *      blockApp: // value for 'blockApp'
 *      appBundle: // value for 'appBundle'
 *      blockPublisher: // value for 'blockPublisher'
 *      publisherId: // value for 'publisherId'
 *      publisherTagId: // value for 'publisherTagId'
 *      consentVendorId: // value for 'consentVendorId'
 *      vastVersions: // value for 'vastVersions'
 *      dspProvider: // value for 'dspProvider'
 *      territories: // value for 'territories'
 *      bidFloorPrecision: // value for 'bidFloorPrecision'
 *   },
 * });
 */
export function useUpdateTechnicalProviderLegacyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTechnicalProviderLegacyMutation, UpdateTechnicalProviderLegacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTechnicalProviderLegacyMutation, UpdateTechnicalProviderLegacyMutationVariables>(UpdateTechnicalProviderLegacyDocument, options);
      }
export type UpdateTechnicalProviderLegacyMutationHookResult = ReturnType<typeof useUpdateTechnicalProviderLegacyMutation>;
export type UpdateTechnicalProviderLegacyMutationResult = ApolloReactCommon.MutationResult<UpdateTechnicalProviderLegacyMutation>;
export type UpdateTechnicalProviderLegacyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTechnicalProviderLegacyMutation, UpdateTechnicalProviderLegacyMutationVariables>;
export const AllTechnicalProvidersLegacyDocument = gql`
    query AllTechnicalProvidersLegacy($territories: [Territory!]!) {
  allTechnicalProvidersLegacy(territories: $territories) {
    id
    altId
    name
    status
    userSyncUrl
    userSyncSecureUrl
  }
}
    `;

/**
 * __useAllTechnicalProvidersLegacyQuery__
 *
 * To run a query within a React component, call `useAllTechnicalProvidersLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTechnicalProvidersLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTechnicalProvidersLegacyQuery({
 *   variables: {
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllTechnicalProvidersLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllTechnicalProvidersLegacyQuery, AllTechnicalProvidersLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllTechnicalProvidersLegacyQuery, AllTechnicalProvidersLegacyQueryVariables>(AllTechnicalProvidersLegacyDocument, options);
      }
export function useAllTechnicalProvidersLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllTechnicalProvidersLegacyQuery, AllTechnicalProvidersLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllTechnicalProvidersLegacyQuery, AllTechnicalProvidersLegacyQueryVariables>(AllTechnicalProvidersLegacyDocument, options);
        }
export type AllTechnicalProvidersLegacyQueryHookResult = ReturnType<typeof useAllTechnicalProvidersLegacyQuery>;
export type AllTechnicalProvidersLegacyLazyQueryHookResult = ReturnType<typeof useAllTechnicalProvidersLegacyLazyQuery>;
export type AllTechnicalProvidersLegacyQueryResult = ApolloReactCommon.QueryResult<AllTechnicalProvidersLegacyQuery, AllTechnicalProvidersLegacyQueryVariables>;
export const TechnicalProviderLegacyMinimalDocument = gql`
    query TechnicalProviderLegacyMinimal($id: ID!) {
  technicalProviderLegacy(id: $id) {
    id
    name
    territories
  }
}
    `;

/**
 * __useTechnicalProviderLegacyMinimalQuery__
 *
 * To run a query within a React component, call `useTechnicalProviderLegacyMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTechnicalProviderLegacyMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTechnicalProviderLegacyMinimalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTechnicalProviderLegacyMinimalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TechnicalProviderLegacyMinimalQuery, TechnicalProviderLegacyMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TechnicalProviderLegacyMinimalQuery, TechnicalProviderLegacyMinimalQueryVariables>(TechnicalProviderLegacyMinimalDocument, options);
      }
export function useTechnicalProviderLegacyMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TechnicalProviderLegacyMinimalQuery, TechnicalProviderLegacyMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TechnicalProviderLegacyMinimalQuery, TechnicalProviderLegacyMinimalQueryVariables>(TechnicalProviderLegacyMinimalDocument, options);
        }
export type TechnicalProviderLegacyMinimalQueryHookResult = ReturnType<typeof useTechnicalProviderLegacyMinimalQuery>;
export type TechnicalProviderLegacyMinimalLazyQueryHookResult = ReturnType<typeof useTechnicalProviderLegacyMinimalLazyQuery>;
export type TechnicalProviderLegacyMinimalQueryResult = ApolloReactCommon.QueryResult<TechnicalProviderLegacyMinimalQuery, TechnicalProviderLegacyMinimalQueryVariables>;
export const TechnicalProviderLegacyDocument = gql`
    query TechnicalProviderLegacy($id: ID!, $territories: [Territory!]) {
  technicalProviderLegacy(id: $id) {
    id
    altId
    name
    userSyncUrl
    userSyncSecureUrl
    currency
    blockGeoData
    truncateGpsCoords
    blockIpData
    truncateIpAddress
    block1stPartyData
    blockListenerId
    kvps1stPartyData
    gzipCompressed
    sendNotSyncedUsers
    blockSite
    siteName
    siteDomain
    blockApp
    appBundle
    appName
    appDomain
    blockPublisher
    publisherId
    publisherName
    publisherDomain
    publisherTagId
    status
    consentVendorId
    dspProvider
    dataCenters {
      id
      altId
      name
      status
    }
    dsps(territories: $territories) {
      id
      name
      altId
      status
    }
    vastVersions
    territories
    bidFloorPrecision
  }
}
    `;

/**
 * __useTechnicalProviderLegacyQuery__
 *
 * To run a query within a React component, call `useTechnicalProviderLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTechnicalProviderLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTechnicalProviderLegacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useTechnicalProviderLegacyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TechnicalProviderLegacyQuery, TechnicalProviderLegacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TechnicalProviderLegacyQuery, TechnicalProviderLegacyQueryVariables>(TechnicalProviderLegacyDocument, options);
      }
export function useTechnicalProviderLegacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TechnicalProviderLegacyQuery, TechnicalProviderLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TechnicalProviderLegacyQuery, TechnicalProviderLegacyQueryVariables>(TechnicalProviderLegacyDocument, options);
        }
export type TechnicalProviderLegacyQueryHookResult = ReturnType<typeof useTechnicalProviderLegacyQuery>;
export type TechnicalProviderLegacyLazyQueryHookResult = ReturnType<typeof useTechnicalProviderLegacyLazyQuery>;
export type TechnicalProviderLegacyQueryResult = ApolloReactCommon.QueryResult<TechnicalProviderLegacyQuery, TechnicalProviderLegacyQueryVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($name: String, $description: String) {
  createTag(attributes: {name: $name, description: $description}) {
    id
    name
    description
  }
}
    `;
export type CreateTagMutationFn = ApolloReactCommon.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = ApolloReactCommon.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($id: ID!, $name: String, $description: String) {
  updateTag(id: $id, attributes: {name: $name, description: $description}) {
    id
    name
    description
  }
}
    `;
export type UpdateTagMutationFn = ApolloReactCommon.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = ApolloReactCommon.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($id: ID!) {
  deleteTag(id: $id) {
    id
    name
    description
  }
}
    `;
export type DeleteTagMutationFn = ApolloReactCommon.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = ApolloReactCommon.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const AllTagsDocument = gql`
    query AllTags {
  allTags {
    id
    name
    description
  }
}
    `;

/**
 * __useAllTagsQuery__
 *
 * To run a query within a React component, call `useAllTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllTagsQuery, AllTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllTagsQuery, AllTagsQueryVariables>(AllTagsDocument, options);
      }
export function useAllTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllTagsQuery, AllTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllTagsQuery, AllTagsQueryVariables>(AllTagsDocument, options);
        }
export type AllTagsQueryHookResult = ReturnType<typeof useAllTagsQuery>;
export type AllTagsLazyQueryHookResult = ReturnType<typeof useAllTagsLazyQuery>;
export type AllTagsQueryResult = ApolloReactCommon.QueryResult<AllTagsQuery, AllTagsQueryVariables>;
export const ListAudienceDocument = gql`
    query ListAudience {
  allAudienceSegments {
    id
    displayName
  }
}
    `;

/**
 * __useListAudienceQuery__
 *
 * To run a query within a React component, call `useListAudienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAudienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAudienceQuery({
 *   variables: {
 *   },
 * });
 */
export function useListAudienceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListAudienceQuery, ListAudienceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListAudienceQuery, ListAudienceQueryVariables>(ListAudienceDocument, options);
      }
export function useListAudienceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListAudienceQuery, ListAudienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListAudienceQuery, ListAudienceQueryVariables>(ListAudienceDocument, options);
        }
export type ListAudienceQueryHookResult = ReturnType<typeof useListAudienceQuery>;
export type ListAudienceLazyQueryHookResult = ReturnType<typeof useListAudienceLazyQuery>;
export type ListAudienceQueryResult = ApolloReactCommon.QueryResult<ListAudienceQuery, ListAudienceQueryVariables>;
export const AllBrowserLanguagesDocument = gql`
    query allBrowserLanguages {
  allBrowserLanguages {
    description
    code
  }
}
    `;

/**
 * __useAllBrowserLanguagesQuery__
 *
 * To run a query within a React component, call `useAllBrowserLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBrowserLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBrowserLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllBrowserLanguagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllBrowserLanguagesQuery, AllBrowserLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllBrowserLanguagesQuery, AllBrowserLanguagesQueryVariables>(AllBrowserLanguagesDocument, options);
      }
export function useAllBrowserLanguagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllBrowserLanguagesQuery, AllBrowserLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllBrowserLanguagesQuery, AllBrowserLanguagesQueryVariables>(AllBrowserLanguagesDocument, options);
        }
export type AllBrowserLanguagesQueryHookResult = ReturnType<typeof useAllBrowserLanguagesQuery>;
export type AllBrowserLanguagesLazyQueryHookResult = ReturnType<typeof useAllBrowserLanguagesLazyQuery>;
export type AllBrowserLanguagesQueryResult = ApolloReactCommon.QueryResult<AllBrowserLanguagesQuery, AllBrowserLanguagesQueryVariables>;
export const ListCitiesDocument = gql`
    query ListCities($countryCodes: [String!]!) {
  allCities(countryCodes: $countryCodes) {
    countryCode
    cities {
      name
      regionCode
      subRegionCode
    }
  }
}
    `;

/**
 * __useListCitiesQuery__
 *
 * To run a query within a React component, call `useListCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCitiesQuery({
 *   variables: {
 *      countryCodes: // value for 'countryCodes'
 *   },
 * });
 */
export function useListCitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListCitiesQuery, ListCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListCitiesQuery, ListCitiesQueryVariables>(ListCitiesDocument, options);
      }
export function useListCitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListCitiesQuery, ListCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListCitiesQuery, ListCitiesQueryVariables>(ListCitiesDocument, options);
        }
export type ListCitiesQueryHookResult = ReturnType<typeof useListCitiesQuery>;
export type ListCitiesLazyQueryHookResult = ReturnType<typeof useListCitiesLazyQuery>;
export type ListCitiesQueryResult = ApolloReactCommon.QueryResult<ListCitiesQuery, ListCitiesQueryVariables>;
export const AllCountriesDocument = gql`
    query allCountries {
  allCountries {
    code
    name
  }
}
    `;

/**
 * __useAllCountriesQuery__
 *
 * To run a query within a React component, call `useAllCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCountriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllCountriesQuery, AllCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllCountriesQuery, AllCountriesQueryVariables>(AllCountriesDocument, options);
      }
export function useAllCountriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllCountriesQuery, AllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllCountriesQuery, AllCountriesQueryVariables>(AllCountriesDocument, options);
        }
export type AllCountriesQueryHookResult = ReturnType<typeof useAllCountriesQuery>;
export type AllCountriesLazyQueryHookResult = ReturnType<typeof useAllCountriesLazyQuery>;
export type AllCountriesQueryResult = ApolloReactCommon.QueryResult<AllCountriesQuery, AllCountriesQueryVariables>;
export const AllDeviceTypesDocument = gql`
    query allDeviceTypes {
  allDeviceTypes
}
    `;

/**
 * __useAllDeviceTypesQuery__
 *
 * To run a query within a React component, call `useAllDeviceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDeviceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDeviceTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDeviceTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllDeviceTypesQuery, AllDeviceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllDeviceTypesQuery, AllDeviceTypesQueryVariables>(AllDeviceTypesDocument, options);
      }
export function useAllDeviceTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllDeviceTypesQuery, AllDeviceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllDeviceTypesQuery, AllDeviceTypesQueryVariables>(AllDeviceTypesDocument, options);
        }
export type AllDeviceTypesQueryHookResult = ReturnType<typeof useAllDeviceTypesQuery>;
export type AllDeviceTypesLazyQueryHookResult = ReturnType<typeof useAllDeviceTypesLazyQuery>;
export type AllDeviceTypesQueryResult = ApolloReactCommon.QueryResult<AllDeviceTypesQuery, AllDeviceTypesQueryVariables>;
export const AllDeviceOsDocument = gql`
    query allDeviceOS {
  allDeviceOperatingSystems {
    name
    versions
  }
}
    `;

/**
 * __useAllDeviceOsQuery__
 *
 * To run a query within a React component, call `useAllDeviceOsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDeviceOsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDeviceOsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDeviceOsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllDeviceOsQuery, AllDeviceOsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllDeviceOsQuery, AllDeviceOsQueryVariables>(AllDeviceOsDocument, options);
      }
export function useAllDeviceOsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllDeviceOsQuery, AllDeviceOsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllDeviceOsQuery, AllDeviceOsQueryVariables>(AllDeviceOsDocument, options);
        }
export type AllDeviceOsQueryHookResult = ReturnType<typeof useAllDeviceOsQuery>;
export type AllDeviceOsLazyQueryHookResult = ReturnType<typeof useAllDeviceOsLazyQuery>;
export type AllDeviceOsQueryResult = ApolloReactCommon.QueryResult<AllDeviceOsQuery, AllDeviceOsQueryVariables>;
export const AllDeviceMakersDocument = gql`
    query AllDeviceMakers {
  allDeviceMakers {
    name
    models
  }
}
    `;

/**
 * __useAllDeviceMakersQuery__
 *
 * To run a query within a React component, call `useAllDeviceMakersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDeviceMakersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDeviceMakersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDeviceMakersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllDeviceMakersQuery, AllDeviceMakersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllDeviceMakersQuery, AllDeviceMakersQueryVariables>(AllDeviceMakersDocument, options);
      }
export function useAllDeviceMakersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllDeviceMakersQuery, AllDeviceMakersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllDeviceMakersQuery, AllDeviceMakersQueryVariables>(AllDeviceMakersDocument, options);
        }
export type AllDeviceMakersQueryHookResult = ReturnType<typeof useAllDeviceMakersQuery>;
export type AllDeviceMakersLazyQueryHookResult = ReturnType<typeof useAllDeviceMakersLazyQuery>;
export type AllDeviceMakersQueryResult = ApolloReactCommon.QueryResult<AllDeviceMakersQuery, AllDeviceMakersQueryVariables>;
export const ListDmasDocument = gql`
    query ListDmas {
  allDmas {
    code
    name
  }
}
    `;

/**
 * __useListDmasQuery__
 *
 * To run a query within a React component, call `useListDmasQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDmasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDmasQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDmasQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListDmasQuery, ListDmasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListDmasQuery, ListDmasQueryVariables>(ListDmasDocument, options);
      }
export function useListDmasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListDmasQuery, ListDmasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListDmasQuery, ListDmasQueryVariables>(ListDmasDocument, options);
        }
export type ListDmasQueryHookResult = ReturnType<typeof useListDmasQuery>;
export type ListDmasLazyQueryHookResult = ReturnType<typeof useListDmasLazyQuery>;
export type ListDmasQueryResult = ApolloReactCommon.QueryResult<ListDmasQuery, ListDmasQueryVariables>;
export const ListDmpSegmentsDocument = gql`
    query ListDmpSegments($type: DmpSegmentType!) {
  allDmpSegments(type: $type) {
    ... on NielsenSegment {
      id
      fullName
    }
  }
}
    `;

/**
 * __useListDmpSegmentsQuery__
 *
 * To run a query within a React component, call `useListDmpSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDmpSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDmpSegmentsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useListDmpSegmentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListDmpSegmentsQuery, ListDmpSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListDmpSegmentsQuery, ListDmpSegmentsQueryVariables>(ListDmpSegmentsDocument, options);
      }
export function useListDmpSegmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListDmpSegmentsQuery, ListDmpSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListDmpSegmentsQuery, ListDmpSegmentsQueryVariables>(ListDmpSegmentsDocument, options);
        }
export type ListDmpSegmentsQueryHookResult = ReturnType<typeof useListDmpSegmentsQuery>;
export type ListDmpSegmentsLazyQueryHookResult = ReturnType<typeof useListDmpSegmentsLazyQuery>;
export type ListDmpSegmentsQueryResult = ApolloReactCommon.QueryResult<ListDmpSegmentsQuery, ListDmpSegmentsQueryVariables>;
export const SearchDmpSegmentsDocument = gql`
    query SearchDmpSegments($type: DmpSegmentType!, $text: String!) {
  searchDmpSegments(type: $type, text: $text) {
    ... on NielsenSegment {
      id
      fullName
    }
  }
}
    `;

/**
 * __useSearchDmpSegmentsQuery__
 *
 * To run a query within a React component, call `useSearchDmpSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDmpSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDmpSegmentsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSearchDmpSegmentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchDmpSegmentsQuery, SearchDmpSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchDmpSegmentsQuery, SearchDmpSegmentsQueryVariables>(SearchDmpSegmentsDocument, options);
      }
export function useSearchDmpSegmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchDmpSegmentsQuery, SearchDmpSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchDmpSegmentsQuery, SearchDmpSegmentsQueryVariables>(SearchDmpSegmentsDocument, options);
        }
export type SearchDmpSegmentsQueryHookResult = ReturnType<typeof useSearchDmpSegmentsQuery>;
export type SearchDmpSegmentsLazyQueryHookResult = ReturnType<typeof useSearchDmpSegmentsLazyQuery>;
export type SearchDmpSegmentsQueryResult = ApolloReactCommon.QueryResult<SearchDmpSegmentsQuery, SearchDmpSegmentsQueryVariables>;
export const AllGenresDocument = gql`
    query allGenres {
  allGenres
}
    `;

/**
 * __useAllGenresQuery__
 *
 * To run a query within a React component, call `useAllGenresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGenresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGenresQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllGenresQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllGenresQuery, AllGenresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllGenresQuery, AllGenresQueryVariables>(AllGenresDocument, options);
      }
export function useAllGenresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllGenresQuery, AllGenresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllGenresQuery, AllGenresQueryVariables>(AllGenresDocument, options);
        }
export type AllGenresQueryHookResult = ReturnType<typeof useAllGenresQuery>;
export type AllGenresLazyQueryHookResult = ReturnType<typeof useAllGenresLazyQuery>;
export type AllGenresQueryResult = ApolloReactCommon.QueryResult<AllGenresQuery, AllGenresQueryVariables>;
export const SearchIspsDocument = gql`
    query SearchIsps($text: String!) {
  searchIsps(text: $text) {
    id
    name
  }
}
    `;

/**
 * __useSearchIspsQuery__
 *
 * To run a query within a React component, call `useSearchIspsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchIspsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchIspsQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSearchIspsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchIspsQuery, SearchIspsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchIspsQuery, SearchIspsQueryVariables>(SearchIspsDocument, options);
      }
export function useSearchIspsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchIspsQuery, SearchIspsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchIspsQuery, SearchIspsQueryVariables>(SearchIspsDocument, options);
        }
export type SearchIspsQueryHookResult = ReturnType<typeof useSearchIspsQuery>;
export type SearchIspsLazyQueryHookResult = ReturnType<typeof useSearchIspsLazyQuery>;
export type SearchIspsQueryResult = ApolloReactCommon.QueryResult<SearchIspsQuery, SearchIspsQueryVariables>;
export const AllItunesCategoriesDocument = gql`
    query allItunesCategories {
  allItunesCategories {
    name
    subItunesCategories {
      name
    }
  }
}
    `;

/**
 * __useAllItunesCategoriesQuery__
 *
 * To run a query within a React component, call `useAllItunesCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllItunesCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllItunesCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllItunesCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllItunesCategoriesQuery, AllItunesCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllItunesCategoriesQuery, AllItunesCategoriesQueryVariables>(AllItunesCategoriesDocument, options);
      }
export function useAllItunesCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllItunesCategoriesQuery, AllItunesCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllItunesCategoriesQuery, AllItunesCategoriesQueryVariables>(AllItunesCategoriesDocument, options);
        }
export type AllItunesCategoriesQueryHookResult = ReturnType<typeof useAllItunesCategoriesQuery>;
export type AllItunesCategoriesLazyQueryHookResult = ReturnType<typeof useAllItunesCategoriesLazyQuery>;
export type AllItunesCategoriesQueryResult = ApolloReactCommon.QueryResult<AllItunesCategoriesQuery, AllItunesCategoriesQueryVariables>;
export const CreateCountryGroupDocument = gql`
    mutation CreateCountryGroup($name: String!, $description: String, $countries: [CountryGroupElementAttributes!]!, $territory: Territory) {
  createCountryGroup(
    attributes: {name: $name, description: $description, countries: $countries, territory: $territory}
  ) {
    id
    name
    description
    territory
  }
}
    `;
export type CreateCountryGroupMutationFn = ApolloReactCommon.MutationFunction<CreateCountryGroupMutation, CreateCountryGroupMutationVariables>;

/**
 * __useCreateCountryGroupMutation__
 *
 * To run a mutation, you first call `useCreateCountryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCountryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCountryGroupMutation, { data, loading, error }] = useCreateCountryGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      countries: // value for 'countries'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useCreateCountryGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCountryGroupMutation, CreateCountryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCountryGroupMutation, CreateCountryGroupMutationVariables>(CreateCountryGroupDocument, options);
      }
export type CreateCountryGroupMutationHookResult = ReturnType<typeof useCreateCountryGroupMutation>;
export type CreateCountryGroupMutationResult = ApolloReactCommon.MutationResult<CreateCountryGroupMutation>;
export type CreateCountryGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCountryGroupMutation, CreateCountryGroupMutationVariables>;
export const UpdateCountryGroupDocument = gql`
    mutation UpdateCountryGroup($id: ID!, $name: String!, $description: String, $countries: [CountryGroupElementAttributes!]!, $territory: Territory) {
  updateCountryGroup(
    id: $id
    attributes: {name: $name, description: $description, countries: $countries, territory: $territory}
  ) {
    id
    name
    description
    territory
  }
}
    `;
export type UpdateCountryGroupMutationFn = ApolloReactCommon.MutationFunction<UpdateCountryGroupMutation, UpdateCountryGroupMutationVariables>;

/**
 * __useUpdateCountryGroupMutation__
 *
 * To run a mutation, you first call `useUpdateCountryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCountryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCountryGroupMutation, { data, loading, error }] = useUpdateCountryGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      countries: // value for 'countries'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useUpdateCountryGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCountryGroupMutation, UpdateCountryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCountryGroupMutation, UpdateCountryGroupMutationVariables>(UpdateCountryGroupDocument, options);
      }
export type UpdateCountryGroupMutationHookResult = ReturnType<typeof useUpdateCountryGroupMutation>;
export type UpdateCountryGroupMutationResult = ApolloReactCommon.MutationResult<UpdateCountryGroupMutation>;
export type UpdateCountryGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCountryGroupMutation, UpdateCountryGroupMutationVariables>;
export const DeleteCountryGroupDocument = gql`
    mutation DeleteCountryGroup($id: ID!) {
  deleteCountryGroup(id: $id) {
    id
    name
    description
  }
}
    `;
export type DeleteCountryGroupMutationFn = ApolloReactCommon.MutationFunction<DeleteCountryGroupMutation, DeleteCountryGroupMutationVariables>;

/**
 * __useDeleteCountryGroupMutation__
 *
 * To run a mutation, you first call `useDeleteCountryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCountryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCountryGroupMutation, { data, loading, error }] = useDeleteCountryGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCountryGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCountryGroupMutation, DeleteCountryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCountryGroupMutation, DeleteCountryGroupMutationVariables>(DeleteCountryGroupDocument, options);
      }
export type DeleteCountryGroupMutationHookResult = ReturnType<typeof useDeleteCountryGroupMutation>;
export type DeleteCountryGroupMutationResult = ApolloReactCommon.MutationResult<DeleteCountryGroupMutation>;
export type DeleteCountryGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCountryGroupMutation, DeleteCountryGroupMutationVariables>;
export const ListRegionsDocument = gql`
    query ListRegions($countryCodes: [String!]!) {
  allRegions(countryCodes: $countryCodes) {
    countryCode
    regions {
      code
      name
    }
  }
}
    `;

/**
 * __useListRegionsQuery__
 *
 * To run a query within a React component, call `useListRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRegionsQuery({
 *   variables: {
 *      countryCodes: // value for 'countryCodes'
 *   },
 * });
 */
export function useListRegionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListRegionsQuery, ListRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListRegionsQuery, ListRegionsQueryVariables>(ListRegionsDocument, options);
      }
export function useListRegionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListRegionsQuery, ListRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListRegionsQuery, ListRegionsQueryVariables>(ListRegionsDocument, options);
        }
export type ListRegionsQueryHookResult = ReturnType<typeof useListRegionsQuery>;
export type ListRegionsLazyQueryHookResult = ReturnType<typeof useListRegionsLazyQuery>;
export type ListRegionsQueryResult = ApolloReactCommon.QueryResult<ListRegionsQuery, ListRegionsQueryVariables>;
export const AllCountryGroupsDocument = gql`
    query AllCountryGroups($territories: [Territory!]!) {
  allCountryGroups(territories: $territories) {
    id
    name
    description
    territory
  }
}
    `;

/**
 * __useAllCountryGroupsQuery__
 *
 * To run a query within a React component, call `useAllCountryGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCountryGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCountryGroupsQuery({
 *   variables: {
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllCountryGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllCountryGroupsQuery, AllCountryGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllCountryGroupsQuery, AllCountryGroupsQueryVariables>(AllCountryGroupsDocument, options);
      }
export function useAllCountryGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllCountryGroupsQuery, AllCountryGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllCountryGroupsQuery, AllCountryGroupsQueryVariables>(AllCountryGroupsDocument, options);
        }
export type AllCountryGroupsQueryHookResult = ReturnType<typeof useAllCountryGroupsQuery>;
export type AllCountryGroupsLazyQueryHookResult = ReturnType<typeof useAllCountryGroupsLazyQuery>;
export type AllCountryGroupsQueryResult = ApolloReactCommon.QueryResult<AllCountryGroupsQuery, AllCountryGroupsQueryVariables>;
export const CountryGroupDocument = gql`
    query CountryGroup($id: ID!) {
  countryGroup(id: $id) {
    id
    name
    description
    countries {
      code
      name
      subdivisions {
        ... on RegionParam {
          code
          name
          subRegions {
            name
            code
          }
        }
      }
    }
    territory
  }
}
    `;

/**
 * __useCountryGroupQuery__
 *
 * To run a query within a React component, call `useCountryGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCountryGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CountryGroupQuery, CountryGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CountryGroupQuery, CountryGroupQueryVariables>(CountryGroupDocument, options);
      }
export function useCountryGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CountryGroupQuery, CountryGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CountryGroupQuery, CountryGroupQueryVariables>(CountryGroupDocument, options);
        }
export type CountryGroupQueryHookResult = ReturnType<typeof useCountryGroupQuery>;
export type CountryGroupLazyQueryHookResult = ReturnType<typeof useCountryGroupLazyQuery>;
export type CountryGroupQueryResult = ApolloReactCommon.QueryResult<CountryGroupQuery, CountryGroupQueryVariables>;
export const ListSubRegionsDocument = gql`
    query ListSubRegions($countryCode: String!, $regionCodes: [String!]!) {
  allSubRegions(countryCode: $countryCode, regionCodes: $regionCodes) {
    countryCode
    regions {
      code
      name
    }
  }
}
    `;

/**
 * __useListSubRegionsQuery__
 *
 * To run a query within a React component, call `useListSubRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSubRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSubRegionsQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      regionCodes: // value for 'regionCodes'
 *   },
 * });
 */
export function useListSubRegionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListSubRegionsQuery, ListSubRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListSubRegionsQuery, ListSubRegionsQueryVariables>(ListSubRegionsDocument, options);
      }
export function useListSubRegionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListSubRegionsQuery, ListSubRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListSubRegionsQuery, ListSubRegionsQueryVariables>(ListSubRegionsDocument, options);
        }
export type ListSubRegionsQueryHookResult = ReturnType<typeof useListSubRegionsQuery>;
export type ListSubRegionsLazyQueryHookResult = ReturnType<typeof useListSubRegionsLazyQuery>;
export type ListSubRegionsQueryResult = ApolloReactCommon.QueryResult<ListSubRegionsQuery, ListSubRegionsQueryVariables>;
export const AllAudienceParametersDocument = gql`
    query allAudienceParameters {
  allAudienceParameters {
    type
    name
    cardinality
  }
}
    `;

/**
 * __useAllAudienceParametersQuery__
 *
 * To run a query within a React component, call `useAllAudienceParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAudienceParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAudienceParametersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAudienceParametersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllAudienceParametersQuery, AllAudienceParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllAudienceParametersQuery, AllAudienceParametersQueryVariables>(AllAudienceParametersDocument, options);
      }
export function useAllAudienceParametersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllAudienceParametersQuery, AllAudienceParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllAudienceParametersQuery, AllAudienceParametersQueryVariables>(AllAudienceParametersDocument, options);
        }
export type AllAudienceParametersQueryHookResult = ReturnType<typeof useAllAudienceParametersQuery>;
export type AllAudienceParametersLazyQueryHookResult = ReturnType<typeof useAllAudienceParametersLazyQuery>;
export type AllAudienceParametersQueryResult = ApolloReactCommon.QueryResult<AllAudienceParametersQuery, AllAudienceParametersQueryVariables>;
export const AudienceParameterValuesDocument = gql`
    query audienceParameterValues($type: AudienceParameterType!, $territory: Territory!) {
  audienceParameterValues(type: $type, territory: $territory) {
    id
    name
    active
    activeGrades
    children {
      id
      name
      active
      activeGrades
      children {
        id
        name
        active
        activeGrades
        children {
          id
          name
          active
          activeGrades
        }
      }
    }
  }
}
    `;

/**
 * __useAudienceParameterValuesQuery__
 *
 * To run a query within a React component, call `useAudienceParameterValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceParameterValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceParameterValuesQuery({
 *   variables: {
 *      type: // value for 'type'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useAudienceParameterValuesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AudienceParameterValuesQuery, AudienceParameterValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AudienceParameterValuesQuery, AudienceParameterValuesQueryVariables>(AudienceParameterValuesDocument, options);
      }
export function useAudienceParameterValuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AudienceParameterValuesQuery, AudienceParameterValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AudienceParameterValuesQuery, AudienceParameterValuesQueryVariables>(AudienceParameterValuesDocument, options);
        }
export type AudienceParameterValuesQueryHookResult = ReturnType<typeof useAudienceParameterValuesQuery>;
export type AudienceParameterValuesLazyQueryHookResult = ReturnType<typeof useAudienceParameterValuesLazyQuery>;
export type AudienceParameterValuesQueryResult = ApolloReactCommon.QueryResult<AudienceParameterValuesQuery, AudienceParameterValuesQueryVariables>;
export const AllInventoryParametersDocument = gql`
    query allInventoryParameters {
  allInventoryParameters {
    type
    name
    cardinality
  }
}
    `;

/**
 * __useAllInventoryParametersQuery__
 *
 * To run a query within a React component, call `useAllInventoryParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllInventoryParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllInventoryParametersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllInventoryParametersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllInventoryParametersQuery, AllInventoryParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllInventoryParametersQuery, AllInventoryParametersQueryVariables>(AllInventoryParametersDocument, options);
      }
export function useAllInventoryParametersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllInventoryParametersQuery, AllInventoryParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllInventoryParametersQuery, AllInventoryParametersQueryVariables>(AllInventoryParametersDocument, options);
        }
export type AllInventoryParametersQueryHookResult = ReturnType<typeof useAllInventoryParametersQuery>;
export type AllInventoryParametersLazyQueryHookResult = ReturnType<typeof useAllInventoryParametersLazyQuery>;
export type AllInventoryParametersQueryResult = ApolloReactCommon.QueryResult<AllInventoryParametersQuery, AllInventoryParametersQueryVariables>;
export const InventoryParameterValuesDocument = gql`
    query inventoryParameterValues($type: InventoryParameterType!, $territory: Territory!, $status: InventoryStatus) {
  inventoryParameterValues(type: $type, territory: $territory, status: $status) {
    id
    name
    children {
      id
      name
      children {
        id
        name
        children {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useInventoryParameterValuesQuery__
 *
 * To run a query within a React component, call `useInventoryParameterValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryParameterValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryParameterValuesQuery({
 *   variables: {
 *      type: // value for 'type'
 *      territory: // value for 'territory'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useInventoryParameterValuesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InventoryParameterValuesQuery, InventoryParameterValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InventoryParameterValuesQuery, InventoryParameterValuesQueryVariables>(InventoryParameterValuesDocument, options);
      }
export function useInventoryParameterValuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InventoryParameterValuesQuery, InventoryParameterValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InventoryParameterValuesQuery, InventoryParameterValuesQueryVariables>(InventoryParameterValuesDocument, options);
        }
export type InventoryParameterValuesQueryHookResult = ReturnType<typeof useInventoryParameterValuesQuery>;
export type InventoryParameterValuesLazyQueryHookResult = ReturnType<typeof useInventoryParameterValuesLazyQuery>;
export type InventoryParameterValuesQueryResult = ApolloReactCommon.QueryResult<InventoryParameterValuesQuery, InventoryParameterValuesQueryVariables>;
export const AllLocationParametersDocument = gql`
    query allLocationParameters($territory: Territory) {
  allLocationParameters(territory: $territory) {
    type
    name
    cardinality
  }
}
    `;

/**
 * __useAllLocationParametersQuery__
 *
 * To run a query within a React component, call `useAllLocationParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLocationParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLocationParametersQuery({
 *   variables: {
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useAllLocationParametersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllLocationParametersQuery, AllLocationParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllLocationParametersQuery, AllLocationParametersQueryVariables>(AllLocationParametersDocument, options);
      }
export function useAllLocationParametersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllLocationParametersQuery, AllLocationParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllLocationParametersQuery, AllLocationParametersQueryVariables>(AllLocationParametersDocument, options);
        }
export type AllLocationParametersQueryHookResult = ReturnType<typeof useAllLocationParametersQuery>;
export type AllLocationParametersLazyQueryHookResult = ReturnType<typeof useAllLocationParametersLazyQuery>;
export type AllLocationParametersQueryResult = ApolloReactCommon.QueryResult<AllLocationParametersQuery, AllLocationParametersQueryVariables>;
export const LocationParameterValuesDocument = gql`
    query locationParameterValues($type: LocationParameterType!, $search: String) {
  locationParameterValues(type: $type, search: $search) {
    id
    name
    children {
      id
      name
      children {
        id
        name
        children {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useLocationParameterValuesQuery__
 *
 * To run a query within a React component, call `useLocationParameterValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationParameterValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationParameterValuesQuery({
 *   variables: {
 *      type: // value for 'type'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useLocationParameterValuesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LocationParameterValuesQuery, LocationParameterValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocationParameterValuesQuery, LocationParameterValuesQueryVariables>(LocationParameterValuesDocument, options);
      }
export function useLocationParameterValuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocationParameterValuesQuery, LocationParameterValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocationParameterValuesQuery, LocationParameterValuesQueryVariables>(LocationParameterValuesDocument, options);
        }
export type LocationParameterValuesQueryHookResult = ReturnType<typeof useLocationParameterValuesQuery>;
export type LocationParameterValuesLazyQueryHookResult = ReturnType<typeof useLocationParameterValuesLazyQuery>;
export type LocationParameterValuesQueryResult = ApolloReactCommon.QueryResult<LocationParameterValuesQuery, LocationParameterValuesQueryVariables>;
export const AllLocationAccuraciesDocument = gql`
    query AllLocationAccuracies {
  allLocationAccuracies {
    defaultValue
    allValues
  }
}
    `;

/**
 * __useAllLocationAccuraciesQuery__
 *
 * To run a query within a React component, call `useAllLocationAccuraciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLocationAccuraciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLocationAccuraciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllLocationAccuraciesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllLocationAccuraciesQuery, AllLocationAccuraciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllLocationAccuraciesQuery, AllLocationAccuraciesQueryVariables>(AllLocationAccuraciesDocument, options);
      }
export function useAllLocationAccuraciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllLocationAccuraciesQuery, AllLocationAccuraciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllLocationAccuraciesQuery, AllLocationAccuraciesQueryVariables>(AllLocationAccuraciesDocument, options);
        }
export type AllLocationAccuraciesQueryHookResult = ReturnType<typeof useAllLocationAccuraciesQuery>;
export type AllLocationAccuraciesLazyQueryHookResult = ReturnType<typeof useAllLocationAccuraciesLazyQuery>;
export type AllLocationAccuraciesQueryResult = ApolloReactCommon.QueryResult<AllLocationAccuraciesQuery, AllLocationAccuraciesQueryVariables>;
export const GetLocationParameterValueByTerritoryDocument = gql`
    query getLocationParameterValueByTerritory($territory: Territory!) {
  getLocationParameterValueByTerritory(territory: $territory) {
    id
  }
}
    `;

/**
 * __useGetLocationParameterValueByTerritoryQuery__
 *
 * To run a query within a React component, call `useGetLocationParameterValueByTerritoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationParameterValueByTerritoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationParameterValueByTerritoryQuery({
 *   variables: {
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useGetLocationParameterValueByTerritoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetLocationParameterValueByTerritoryQuery, GetLocationParameterValueByTerritoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLocationParameterValueByTerritoryQuery, GetLocationParameterValueByTerritoryQueryVariables>(GetLocationParameterValueByTerritoryDocument, options);
      }
export function useGetLocationParameterValueByTerritoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLocationParameterValueByTerritoryQuery, GetLocationParameterValueByTerritoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLocationParameterValueByTerritoryQuery, GetLocationParameterValueByTerritoryQueryVariables>(GetLocationParameterValueByTerritoryDocument, options);
        }
export type GetLocationParameterValueByTerritoryQueryHookResult = ReturnType<typeof useGetLocationParameterValueByTerritoryQuery>;
export type GetLocationParameterValueByTerritoryLazyQueryHookResult = ReturnType<typeof useGetLocationParameterValueByTerritoryLazyQuery>;
export type GetLocationParameterValueByTerritoryQueryResult = ApolloReactCommon.QueryResult<GetLocationParameterValueByTerritoryQuery, GetLocationParameterValueByTerritoryQueryVariables>;
export const AllRegionPacksDocument = gql`
    query allRegionPacks($territories: [Territory!]!) {
  allRegionPacks(territories: $territories) {
    id
    name
  }
}
    `;

/**
 * __useAllRegionPacksQuery__
 *
 * To run a query within a React component, call `useAllRegionPacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRegionPacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRegionPacksQuery({
 *   variables: {
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllRegionPacksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllRegionPacksQuery, AllRegionPacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllRegionPacksQuery, AllRegionPacksQueryVariables>(AllRegionPacksDocument, options);
      }
export function useAllRegionPacksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllRegionPacksQuery, AllRegionPacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllRegionPacksQuery, AllRegionPacksQueryVariables>(AllRegionPacksDocument, options);
        }
export type AllRegionPacksQueryHookResult = ReturnType<typeof useAllRegionPacksQuery>;
export type AllRegionPacksLazyQueryHookResult = ReturnType<typeof useAllRegionPacksLazyQuery>;
export type AllRegionPacksQueryResult = ApolloReactCommon.QueryResult<AllRegionPacksQuery, AllRegionPacksQueryVariables>;
export const ValidateZipcodesDocument = gql`
    query validateZipcodes($postcodes: [String!]!) {
  validatePostcodes(postcodes: $postcodes) {
    valid
    invalid
  }
}
    `;

/**
 * __useValidateZipcodesQuery__
 *
 * To run a query within a React component, call `useValidateZipcodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateZipcodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateZipcodesQuery({
 *   variables: {
 *      postcodes: // value for 'postcodes'
 *   },
 * });
 */
export function useValidateZipcodesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ValidateZipcodesQuery, ValidateZipcodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ValidateZipcodesQuery, ValidateZipcodesQueryVariables>(ValidateZipcodesDocument, options);
      }
export function useValidateZipcodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidateZipcodesQuery, ValidateZipcodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ValidateZipcodesQuery, ValidateZipcodesQueryVariables>(ValidateZipcodesDocument, options);
        }
export type ValidateZipcodesQueryHookResult = ReturnType<typeof useValidateZipcodesQuery>;
export type ValidateZipcodesLazyQueryHookResult = ReturnType<typeof useValidateZipcodesLazyQuery>;
export type ValidateZipcodesQueryResult = ApolloReactCommon.QueryResult<ValidateZipcodesQuery, ValidateZipcodesQueryVariables>;
export const AllTechnologyParametersDocument = gql`
    query allTechnologyParameters {
  allTechnologyParameters {
    type
    name
    cardinality
  }
}
    `;

/**
 * __useAllTechnologyParametersQuery__
 *
 * To run a query within a React component, call `useAllTechnologyParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTechnologyParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTechnologyParametersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTechnologyParametersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllTechnologyParametersQuery, AllTechnologyParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllTechnologyParametersQuery, AllTechnologyParametersQueryVariables>(AllTechnologyParametersDocument, options);
      }
export function useAllTechnologyParametersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllTechnologyParametersQuery, AllTechnologyParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllTechnologyParametersQuery, AllTechnologyParametersQueryVariables>(AllTechnologyParametersDocument, options);
        }
export type AllTechnologyParametersQueryHookResult = ReturnType<typeof useAllTechnologyParametersQuery>;
export type AllTechnologyParametersLazyQueryHookResult = ReturnType<typeof useAllTechnologyParametersLazyQuery>;
export type AllTechnologyParametersQueryResult = ApolloReactCommon.QueryResult<AllTechnologyParametersQuery, AllTechnologyParametersQueryVariables>;
export const TechnologyParameterValuesDocument = gql`
    query technologyParameterValues($type: TechnologyParameterType!, $search: String) {
  technologyParameterValues(type: $type, search: $search) {
    id
    name
    children {
      id
      name
    }
  }
}
    `;

/**
 * __useTechnologyParameterValuesQuery__
 *
 * To run a query within a React component, call `useTechnologyParameterValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTechnologyParameterValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTechnologyParameterValuesQuery({
 *   variables: {
 *      type: // value for 'type'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTechnologyParameterValuesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TechnologyParameterValuesQuery, TechnologyParameterValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TechnologyParameterValuesQuery, TechnologyParameterValuesQueryVariables>(TechnologyParameterValuesDocument, options);
      }
export function useTechnologyParameterValuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TechnologyParameterValuesQuery, TechnologyParameterValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TechnologyParameterValuesQuery, TechnologyParameterValuesQueryVariables>(TechnologyParameterValuesDocument, options);
        }
export type TechnologyParameterValuesQueryHookResult = ReturnType<typeof useTechnologyParameterValuesQuery>;
export type TechnologyParameterValuesLazyQueryHookResult = ReturnType<typeof useTechnologyParameterValuesLazyQuery>;
export type TechnologyParameterValuesQueryResult = ApolloReactCommon.QueryResult<TechnologyParameterValuesQuery, TechnologyParameterValuesQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($email: String, $permissions: [PermissionName!], $territories: [Territory!]!, $primaryTerritory: Territory, $entityPermissions: [EntityPermissionAttributes!], $userType: UserType) {
  createUser(
    attributes: {email: $email, permissions: $permissions, territories: $territories, primaryTerritory: $primaryTerritory, entityPermissions: $entityPermissions, userType: $userType}
  ) {
    id
    email
    permissions {
      id
      name
    }
    territories
    primaryTerritory
    entityPermissions {
      entityName
      entityId
      entityType
    }
    userType
  }
}
    `;
export type CreateUserMutationFn = ApolloReactCommon.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      permissions: // value for 'permissions'
 *      territories: // value for 'territories'
 *      primaryTerritory: // value for 'primaryTerritory'
 *      entityPermissions: // value for 'entityPermissions'
 *      userType: // value for 'userType'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = ApolloReactCommon.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: ID!, $email: String, $permissions: [PermissionName!], $territories: [Territory!]!, $primaryTerritory: Territory, $entityPermissions: [EntityPermissionAttributes!], $userType: UserType) {
  updateUser(
    id: $id
    attributes: {email: $email, permissions: $permissions, territories: $territories, primaryTerritory: $primaryTerritory, entityPermissions: $entityPermissions, userType: $userType}
  ) {
    id
    email
    permissions {
      id
      name
    }
    territories
    primaryTerritory
    entityPermissions {
      entityName
      entityId
      entityType
    }
    userType
  }
}
    `;
export type UpdateUserMutationFn = ApolloReactCommon.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      permissions: // value for 'permissions'
 *      territories: // value for 'territories'
 *      primaryTerritory: // value for 'primaryTerritory'
 *      entityPermissions: // value for 'entityPermissions'
 *      userType: // value for 'userType'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactCommon.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: ID!) {
  deleteUser(id: $id) {
    id
    email
    permissions {
      id
      name
    }
  }
}
    `;
export type DeleteUserMutationFn = ApolloReactCommon.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = ApolloReactCommon.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const InviteUserDocument = gql`
    mutation InviteUser($id: ID!) {
  inviteUser(id: $id) {
    email
  }
}
    `;
export type InviteUserMutationFn = ApolloReactCommon.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = ApolloReactCommon.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const AllUserTypesDocument = gql`
    query AllUserTypes {
  allUserTypes {
    userType
    displayName
  }
}
    `;

/**
 * __useAllUserTypesQuery__
 *
 * To run a query within a React component, call `useAllUserTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUserTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllUserTypesQuery, AllUserTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllUserTypesQuery, AllUserTypesQueryVariables>(AllUserTypesDocument, options);
      }
export function useAllUserTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllUserTypesQuery, AllUserTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllUserTypesQuery, AllUserTypesQueryVariables>(AllUserTypesDocument, options);
        }
export type AllUserTypesQueryHookResult = ReturnType<typeof useAllUserTypesQuery>;
export type AllUserTypesLazyQueryHookResult = ReturnType<typeof useAllUserTypesLazyQuery>;
export type AllUserTypesQueryResult = ApolloReactCommon.QueryResult<AllUserTypesQuery, AllUserTypesQueryVariables>;
export const AllUsersDocument = gql`
    query AllUsers($permissions: [PermissionName!], $territories: [Territory!]!) {
  allUsers(permissions: $permissions, territories: $territories) {
    id
    email
    status
    permissions {
      id
      name
    }
  }
}
    `;

/**
 * __useAllUsersQuery__
 *
 * To run a query within a React component, call `useAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersQuery({
 *   variables: {
 *      permissions: // value for 'permissions'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
      }
export function useAllUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
        }
export type AllUsersQueryHookResult = ReturnType<typeof useAllUsersQuery>;
export type AllUsersLazyQueryHookResult = ReturnType<typeof useAllUsersLazyQuery>;
export type AllUsersQueryResult = ApolloReactCommon.QueryResult<AllUsersQuery, AllUsersQueryVariables>;
export const UserDocument = gql`
    query User($id: ID!) {
  user(id: $id) {
    id
    email
    status
    permissions {
      id
      name
    }
    entityPermissions {
      entityName
      entityId
      entityType
    }
    territories
    primaryTerritory
    userType
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = ApolloReactCommon.QueryResult<UserQuery, UserQueryVariables>;
export const AllAffectedEntitiesDocument = gql`
    query AllAffectedEntities($targetStatus: EntityStatus!, $entityAttributes: EntityAttributes!) {
  allAffectedEntities(
    targetStatus: $targetStatus
    entityAttributes: $entityAttributes
  ) {
    id
    entityType
  }
}
    `;

/**
 * __useAllAffectedEntitiesQuery__
 *
 * To run a query within a React component, call `useAllAffectedEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAffectedEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAffectedEntitiesQuery({
 *   variables: {
 *      targetStatus: // value for 'targetStatus'
 *      entityAttributes: // value for 'entityAttributes'
 *   },
 * });
 */
export function useAllAffectedEntitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllAffectedEntitiesQuery, AllAffectedEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllAffectedEntitiesQuery, AllAffectedEntitiesQueryVariables>(AllAffectedEntitiesDocument, options);
      }
export function useAllAffectedEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllAffectedEntitiesQuery, AllAffectedEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllAffectedEntitiesQuery, AllAffectedEntitiesQueryVariables>(AllAffectedEntitiesDocument, options);
        }
export type AllAffectedEntitiesQueryHookResult = ReturnType<typeof useAllAffectedEntitiesQuery>;
export type AllAffectedEntitiesLazyQueryHookResult = ReturnType<typeof useAllAffectedEntitiesLazyQuery>;
export type AllAffectedEntitiesQueryResult = ApolloReactCommon.QueryResult<AllAffectedEntitiesQuery, AllAffectedEntitiesQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    id
    email
    permissions {
      id
      name
      featureToggles {
        id
        name
        toggled
      }
    }
    entityPermissions {
      entityId
      entityType
    }
    primaryTerritory
    territories
    userType
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = ApolloReactCommon.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const SearchPostcodesDocument = gql`
    query SearchPostcodes($postcode: String!) {
  searchPostcodes(text: $postcode)
}
    `;

/**
 * __useSearchPostcodesQuery__
 *
 * To run a query within a React component, call `useSearchPostcodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPostcodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPostcodesQuery({
 *   variables: {
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function useSearchPostcodesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchPostcodesQuery, SearchPostcodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchPostcodesQuery, SearchPostcodesQueryVariables>(SearchPostcodesDocument, options);
      }
export function useSearchPostcodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchPostcodesQuery, SearchPostcodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchPostcodesQuery, SearchPostcodesQueryVariables>(SearchPostcodesDocument, options);
        }
export type SearchPostcodesQueryHookResult = ReturnType<typeof useSearchPostcodesQuery>;
export type SearchPostcodesLazyQueryHookResult = ReturnType<typeof useSearchPostcodesLazyQuery>;
export type SearchPostcodesQueryResult = ApolloReactCommon.QueryResult<SearchPostcodesQuery, SearchPostcodesQueryVariables>;
export const ValidatePostcodesDocument = gql`
    query ValidatePostcodes($postcodes: [String!]!) {
  validatePostcodes(postcodes: $postcodes) {
    valid
    invalid
  }
}
    `;

/**
 * __useValidatePostcodesQuery__
 *
 * To run a query within a React component, call `useValidatePostcodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePostcodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePostcodesQuery({
 *   variables: {
 *      postcodes: // value for 'postcodes'
 *   },
 * });
 */
export function useValidatePostcodesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ValidatePostcodesQuery, ValidatePostcodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ValidatePostcodesQuery, ValidatePostcodesQueryVariables>(ValidatePostcodesDocument, options);
      }
export function useValidatePostcodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidatePostcodesQuery, ValidatePostcodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ValidatePostcodesQuery, ValidatePostcodesQueryVariables>(ValidatePostcodesDocument, options);
        }
export type ValidatePostcodesQueryHookResult = ReturnType<typeof useValidatePostcodesQuery>;
export type ValidatePostcodesLazyQueryHookResult = ReturnType<typeof useValidatePostcodesLazyQuery>;
export type ValidatePostcodesQueryResult = ApolloReactCommon.QueryResult<ValidatePostcodesQuery, ValidatePostcodesQueryVariables>;
export const SearchDocument = gql`
    query Search($filter: SearchFilter!, $territories: [Territory!]!) {
  search(filter: $filter, territories: $territories) {
    id
    altId
    name
    type
    status
  }
}
    `;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = ApolloReactCommon.QueryResult<SearchQuery, SearchQueryVariables>;
export const CreatePostcodeGroupDocument = gql`
    mutation CreatePostcodeGroup($name: String!, $description: String, $postcodes: [String!]!, $territory: Territory) {
  createPostcodeGroup(
    attributes: {name: $name, description: $description, postcodes: $postcodes, territory: $territory}
  ) {
    id
    name
    description
    territory
  }
}
    `;
export type CreatePostcodeGroupMutationFn = ApolloReactCommon.MutationFunction<CreatePostcodeGroupMutation, CreatePostcodeGroupMutationVariables>;

/**
 * __useCreatePostcodeGroupMutation__
 *
 * To run a mutation, you first call `useCreatePostcodeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostcodeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostcodeGroupMutation, { data, loading, error }] = useCreatePostcodeGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      postcodes: // value for 'postcodes'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useCreatePostcodeGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePostcodeGroupMutation, CreatePostcodeGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePostcodeGroupMutation, CreatePostcodeGroupMutationVariables>(CreatePostcodeGroupDocument, options);
      }
export type CreatePostcodeGroupMutationHookResult = ReturnType<typeof useCreatePostcodeGroupMutation>;
export type CreatePostcodeGroupMutationResult = ApolloReactCommon.MutationResult<CreatePostcodeGroupMutation>;
export type CreatePostcodeGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePostcodeGroupMutation, CreatePostcodeGroupMutationVariables>;
export const UpdatePostcodeGroupDocument = gql`
    mutation UpdatePostcodeGroup($id: ID!, $name: String!, $description: String, $postcodes: [String!]!, $territory: Territory) {
  updatePostcodeGroup(
    id: $id
    attributes: {name: $name, description: $description, postcodes: $postcodes, territory: $territory}
  ) {
    id
    name
    description
    territory
  }
}
    `;
export type UpdatePostcodeGroupMutationFn = ApolloReactCommon.MutationFunction<UpdatePostcodeGroupMutation, UpdatePostcodeGroupMutationVariables>;

/**
 * __useUpdatePostcodeGroupMutation__
 *
 * To run a mutation, you first call `useUpdatePostcodeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostcodeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostcodeGroupMutation, { data, loading, error }] = useUpdatePostcodeGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      postcodes: // value for 'postcodes'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useUpdatePostcodeGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePostcodeGroupMutation, UpdatePostcodeGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePostcodeGroupMutation, UpdatePostcodeGroupMutationVariables>(UpdatePostcodeGroupDocument, options);
      }
export type UpdatePostcodeGroupMutationHookResult = ReturnType<typeof useUpdatePostcodeGroupMutation>;
export type UpdatePostcodeGroupMutationResult = ApolloReactCommon.MutationResult<UpdatePostcodeGroupMutation>;
export type UpdatePostcodeGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePostcodeGroupMutation, UpdatePostcodeGroupMutationVariables>;
export const DeletePostcodeGroupDocument = gql`
    mutation DeletePostcodeGroup($id: ID!) {
  deletePostcodeGroup(id: $id) {
    id
    name
    description
  }
}
    `;
export type DeletePostcodeGroupMutationFn = ApolloReactCommon.MutationFunction<DeletePostcodeGroupMutation, DeletePostcodeGroupMutationVariables>;

/**
 * __useDeletePostcodeGroupMutation__
 *
 * To run a mutation, you first call `useDeletePostcodeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostcodeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostcodeGroupMutation, { data, loading, error }] = useDeletePostcodeGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePostcodeGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePostcodeGroupMutation, DeletePostcodeGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePostcodeGroupMutation, DeletePostcodeGroupMutationVariables>(DeletePostcodeGroupDocument, options);
      }
export type DeletePostcodeGroupMutationHookResult = ReturnType<typeof useDeletePostcodeGroupMutation>;
export type DeletePostcodeGroupMutationResult = ApolloReactCommon.MutationResult<DeletePostcodeGroupMutation>;
export type DeletePostcodeGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePostcodeGroupMutation, DeletePostcodeGroupMutationVariables>;
export const PostcodeGroupDocument = gql`
    query PostcodeGroup($id: ID!) {
  postcodeGroup(id: $id) {
    id
    name
    description
    postcodes
    territory
  }
}
    `;

/**
 * __usePostcodeGroupQuery__
 *
 * To run a query within a React component, call `usePostcodeGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostcodeGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostcodeGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostcodeGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PostcodeGroupQuery, PostcodeGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PostcodeGroupQuery, PostcodeGroupQueryVariables>(PostcodeGroupDocument, options);
      }
export function usePostcodeGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PostcodeGroupQuery, PostcodeGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PostcodeGroupQuery, PostcodeGroupQueryVariables>(PostcodeGroupDocument, options);
        }
export type PostcodeGroupQueryHookResult = ReturnType<typeof usePostcodeGroupQuery>;
export type PostcodeGroupLazyQueryHookResult = ReturnType<typeof usePostcodeGroupLazyQuery>;
export type PostcodeGroupQueryResult = ApolloReactCommon.QueryResult<PostcodeGroupQuery, PostcodeGroupQueryVariables>;
export const AllPostcodeGroupsDocument = gql`
    query AllPostcodeGroups($territories: [Territory!]!) {
  allPostcodeGroups(territories: $territories) {
    id
    name
    description
    territory
  }
}
    `;

/**
 * __useAllPostcodeGroupsQuery__
 *
 * To run a query within a React component, call `useAllPostcodeGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPostcodeGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPostcodeGroupsQuery({
 *   variables: {
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllPostcodeGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllPostcodeGroupsQuery, AllPostcodeGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllPostcodeGroupsQuery, AllPostcodeGroupsQueryVariables>(AllPostcodeGroupsDocument, options);
      }
export function useAllPostcodeGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllPostcodeGroupsQuery, AllPostcodeGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllPostcodeGroupsQuery, AllPostcodeGroupsQueryVariables>(AllPostcodeGroupsDocument, options);
        }
export type AllPostcodeGroupsQueryHookResult = ReturnType<typeof useAllPostcodeGroupsQuery>;
export type AllPostcodeGroupsLazyQueryHookResult = ReturnType<typeof useAllPostcodeGroupsLazyQuery>;
export type AllPostcodeGroupsQueryResult = ApolloReactCommon.QueryResult<AllPostcodeGroupsQuery, AllPostcodeGroupsQueryVariables>;
export const CreateTargetingTemplateDocument = gql`
    mutation CreateTargetingTemplate($name: String, $description: String, $isMasterTemplate: Boolean, $generalTargetingGroup: TargetingGroupAttributes, $targetingGroups: [TargetingGroupAttributes!], $territory: Territory) {
  createTargetingTemplate(
    isMasterTemplate: $isMasterTemplate
    attributes: {name: $name, description: $description, generalTargetingGroup: $generalTargetingGroup, targetingGroups: $targetingGroups, territory: $territory}
  ) {
    id
    name
    description
    isMasterTemplate
    territory
    targetingGroups {
      listenerAccuracy
      channels {
        id
      }
      audienceParams {
        ... on KeyValueGroupParam {
          keyValues {
            key
            value
          }
          clusivity
        }
        ... on AgeParam {
          ageRange {
            minAge
            maxAge
          }
          clusivity
        }
        ... on GenderParam {
          genders
          clusivity
        }
        ... on DayAndTimeParam {
          timeZone
          daysOfWeek {
            day
            hours
          }
          clusivity
        }
        ... on DeviceTypeParam {
          deviceTypes
          clusivity
        }
        ... on DeviceOperatingSystemParam {
          deviceOperatingSystems {
            versions
            name
          }
          clusivity
        }
        ... on ConnectionTypeParam {
          clusivity
          connectionTypes
        }
        ... on DeviceMakerParam {
          deviceMakers {
            name
            models
          }
          clusivity
        }
        ... on BrowserLanguageParam {
          browserLanguages {
            description
            code
          }
          clusivity
        }
        ... on PostalCodeParam {
          postalCodes
          postcodeGroups {
            id
            name
          }
          clusivity
        }
        ... on LocationParam {
          positions {
            latitude
            longitude
            radius
          }
          clusivity
        }
        ... on DmpSegmentParam {
          segmentType
          segments {
            ... on NielsenSegment {
              id
              fullName
            }
          }
          clusivity
        }
        ... on DmaParam {
          dmas {
            code
            name
          }
          clusivity
        }
        ... on AudienceSegmentParam {
          segments {
            id
            displayName
          }
          clusivity
        }
        ... on GenreParam {
          genres
          clusivity
        }
        ... on ItunesCategoryParam {
          categories
          clusivity
        }
        ... on PodcastParam {
          podcastTargets {
            collectionId
            episodeId
            showId
            name
          }
          clusivity
        }
        ... on AdPositionParam {
          positions {
            position
            midRollPositions
          }
          clusivity
        }
        ... on IspParam {
          isps {
            id
            name
          }
          clusivity
        }
        ... on CountryParam {
          code
          name
          clusivity
          countryGroups {
            name
            id
          }
          subdivisions {
            ... on CityParam {
              name
              regionCode
              subRegionCode
            }
            ... on RegionParam {
              name
              code
              subRegions {
                name
                code
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type CreateTargetingTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateTargetingTemplateMutation, CreateTargetingTemplateMutationVariables>;

/**
 * __useCreateTargetingTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTargetingTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTargetingTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTargetingTemplateMutation, { data, loading, error }] = useCreateTargetingTemplateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      isMasterTemplate: // value for 'isMasterTemplate'
 *      generalTargetingGroup: // value for 'generalTargetingGroup'
 *      targetingGroups: // value for 'targetingGroups'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useCreateTargetingTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTargetingTemplateMutation, CreateTargetingTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTargetingTemplateMutation, CreateTargetingTemplateMutationVariables>(CreateTargetingTemplateDocument, options);
      }
export type CreateTargetingTemplateMutationHookResult = ReturnType<typeof useCreateTargetingTemplateMutation>;
export type CreateTargetingTemplateMutationResult = ApolloReactCommon.MutationResult<CreateTargetingTemplateMutation>;
export type CreateTargetingTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTargetingTemplateMutation, CreateTargetingTemplateMutationVariables>;
export const UpdateTargetingTemplateDocument = gql`
    mutation UpdateTargetingTemplate($id: ID!, $name: String, $description: String, $generalTargetingGroup: TargetingGroupAttributes, $targetingGroups: [TargetingGroupAttributes!], $territory: Territory) {
  updateTargetingTemplate(
    id: $id
    attributes: {name: $name, description: $description, generalTargetingGroup: $generalTargetingGroup, targetingGroups: $targetingGroups, territory: $territory}
  ) {
    id
    name
    description
    isMasterTemplate
    territory
    targetingGroups {
      listenerAccuracy
      channels {
        id
      }
      audienceParams {
        ... on KeyValueGroupParam {
          keyValues {
            key
            value
          }
          clusivity
        }
        ... on AgeParam {
          ageRange {
            minAge
            maxAge
          }
          clusivity
        }
        ... on GenderParam {
          genders
          clusivity
        }
        ... on DayAndTimeParam {
          timeZone
          daysOfWeek {
            day
            hours
          }
          clusivity
        }
        ... on DeviceTypeParam {
          deviceTypes
          clusivity
        }
        ... on DeviceOperatingSystemParam {
          deviceOperatingSystems {
            versions
            name
          }
          clusivity
        }
        ... on ConnectionTypeParam {
          clusivity
          connectionTypes
        }
        ... on DeviceMakerParam {
          deviceMakers {
            name
            models
          }
          clusivity
        }
        ... on BrowserLanguageParam {
          browserLanguages {
            description
            code
          }
          clusivity
        }
        ... on PostalCodeParam {
          postalCodes
          postcodeGroups {
            id
            name
          }
          clusivity
        }
        ... on LocationParam {
          positions {
            latitude
            longitude
            radius
          }
          clusivity
        }
        ... on DmpSegmentParam {
          segmentType
          segments {
            ... on NielsenSegment {
              id
              fullName
            }
          }
          clusivity
        }
        ... on DmaParam {
          dmas {
            code
            name
          }
          clusivity
        }
        ... on AudienceSegmentParam {
          segments {
            id
            displayName
          }
          clusivity
        }
        ... on GenreParam {
          genres
          clusivity
        }
        ... on ItunesCategoryParam {
          categories
          clusivity
        }
        ... on PodcastParam {
          podcastTargets {
            collectionId
            episodeId
            showId
            name
          }
          clusivity
        }
        ... on AdPositionParam {
          positions {
            position
            midRollPositions
          }
          clusivity
        }
        ... on IspParam {
          isps {
            id
            name
          }
          clusivity
        }
        ... on CountryParam {
          code
          name
          clusivity
          countryGroups {
            name
            id
          }
          subdivisions {
            ... on CityParam {
              name
              regionCode
              subRegionCode
            }
            ... on RegionParam {
              name
              code
              subRegions {
                name
                code
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type UpdateTargetingTemplateMutationFn = ApolloReactCommon.MutationFunction<UpdateTargetingTemplateMutation, UpdateTargetingTemplateMutationVariables>;

/**
 * __useUpdateTargetingTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTargetingTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTargetingTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTargetingTemplateMutation, { data, loading, error }] = useUpdateTargetingTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      generalTargetingGroup: // value for 'generalTargetingGroup'
 *      targetingGroups: // value for 'targetingGroups'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useUpdateTargetingTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTargetingTemplateMutation, UpdateTargetingTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTargetingTemplateMutation, UpdateTargetingTemplateMutationVariables>(UpdateTargetingTemplateDocument, options);
      }
export type UpdateTargetingTemplateMutationHookResult = ReturnType<typeof useUpdateTargetingTemplateMutation>;
export type UpdateTargetingTemplateMutationResult = ApolloReactCommon.MutationResult<UpdateTargetingTemplateMutation>;
export type UpdateTargetingTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTargetingTemplateMutation, UpdateTargetingTemplateMutationVariables>;
export const TargetingTemplateDocument = gql`
    query TargetingTemplate($id: ID!) {
  targetingTemplate(id: $id) {
    assignedTo {
      __typename
      ... on AdLegacy {
        id
        name
        adStatus: status
        altId
      }
      ... on DealLegacy {
        id
        name
        dealStatus: status
        altId
      }
    }
    id
    name
    description
    isMasterTemplate
    status
    territory
    targetingGroups {
      id
      masterTargetingGroupId
      listenerAccuracy
      channels {
        id
        name
      }
      audienceParams {
        ... on KeyValueGroupParam {
          keyValues {
            key
            value
          }
          clusivity
        }
        ... on AgeParam {
          ageRange {
            minAge
            maxAge
          }
          clusivity
        }
        ... on GenderParam {
          genders
          clusivity
        }
        ... on DayAndTimeParam {
          timeZone
          daysOfWeek {
            day
            hours
          }
          clusivity
        }
        ... on DeviceTypeParam {
          deviceTypes
          clusivity
        }
        ... on DeviceOperatingSystemParam {
          deviceOperatingSystems {
            versions
            name
          }
          clusivity
        }
        ... on ConnectionTypeParam {
          clusivity
          connectionTypes
        }
        ... on DeviceMakerParam {
          deviceMakers {
            name
            models
          }
          clusivity
        }
        ... on BrowserLanguageParam {
          browserLanguages {
            description
            code
          }
          clusivity
        }
        ... on PostalCodeParam {
          postalCodes
          postcodeGroups {
            id
            name
          }
          clusivity
        }
        ... on LocationParam {
          positions {
            latitude
            longitude
            radius
          }
          clusivity
        }
        ... on DmpSegmentParam {
          segmentType
          segments {
            ... on NielsenSegment {
              id
              fullName
            }
          }
          clusivity
        }
        ... on DmaParam {
          dmas {
            code
            name
          }
          clusivity
        }
        ... on AudienceSegmentParam {
          segments {
            id
            displayName
          }
          clusivity
        }
        ... on GenreParam {
          genres
          clusivity
        }
        ... on ItunesCategoryParam {
          categories
          clusivity
        }
        ... on PodcastParam {
          podcastTargets {
            collectionId
            episodeId
            showId
            name
          }
          clusivity
        }
        ... on AdPositionParam {
          positions {
            position
            midRollPositions
          }
          clusivity
        }
        ... on IspParam {
          isps {
            id
            name
          }
          clusivity
        }
        ... on CountryParam {
          code
          name
          clusivity
          countryGroups {
            name
            id
          }
          subdivisions {
            ... on CityParam {
              name
              regionCode
              subRegionCode
            }
            ... on RegionParam {
              name
              code
              subRegions {
                name
                code
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTargetingTemplateQuery__
 *
 * To run a query within a React component, call `useTargetingTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetingTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetingTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTargetingTemplateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TargetingTemplateQuery, TargetingTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TargetingTemplateQuery, TargetingTemplateQueryVariables>(TargetingTemplateDocument, options);
      }
export function useTargetingTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TargetingTemplateQuery, TargetingTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TargetingTemplateQuery, TargetingTemplateQueryVariables>(TargetingTemplateDocument, options);
        }
export type TargetingTemplateQueryHookResult = ReturnType<typeof useTargetingTemplateQuery>;
export type TargetingTemplateLazyQueryHookResult = ReturnType<typeof useTargetingTemplateLazyQuery>;
export type TargetingTemplateQueryResult = ApolloReactCommon.QueryResult<TargetingTemplateQuery, TargetingTemplateQueryVariables>;
export const AllTargetingTemplatesDocument = gql`
    query AllTargetingTemplates($territories: [Territory!]!) {
  allTargetingTemplates(territories: $territories) {
    id
    name
    description
    isMasterTemplate
    status
    targetingGroups {
      id
      masterTargetingGroupId
      channels {
        id
        name
      }
      audienceParams {
        ... on KeyValueGroupParam {
          keyValues {
            key
            value
          }
          clusivity
        }
        ... on AgeParam {
          ageRange {
            minAge
            maxAge
          }
          clusivity
        }
        ... on GenderParam {
          genders
          clusivity
        }
        ... on DayAndTimeParam {
          timeZone
          daysOfWeek {
            day
            hours
          }
          clusivity
        }
        ... on DeviceTypeParam {
          deviceTypes
          clusivity
        }
        ... on DeviceOperatingSystemParam {
          deviceOperatingSystems {
            versions
            name
          }
          clusivity
        }
        ... on ConnectionTypeParam {
          clusivity
          connectionTypes
        }
        ... on DeviceMakerParam {
          deviceMakers {
            name
            models
          }
          clusivity
        }
        ... on BrowserLanguageParam {
          browserLanguages {
            description
            code
          }
          clusivity
        }
        ... on PostalCodeParam {
          postalCodes
          postcodeGroups {
            id
            name
          }
          clusivity
        }
        ... on LocationParam {
          positions {
            latitude
            longitude
            radius
          }
          clusivity
        }
        ... on DmpSegmentParam {
          segmentType
          segments {
            ... on NielsenSegment {
              id
              fullName
            }
          }
          clusivity
        }
        ... on DmaParam {
          dmas {
            code
            name
          }
          clusivity
        }
        ... on AudienceSegmentParam {
          segments {
            id
            displayName
          }
          clusivity
        }
        ... on GenreParam {
          genres
          clusivity
        }
        ... on ItunesCategoryParam {
          categories
          clusivity
        }
        ... on PodcastParam {
          podcastTargets {
            collectionId
            episodeId
            showId
            name
          }
          clusivity
        }
        ... on AdPositionParam {
          positions {
            position
            midRollPositions
          }
          clusivity
        }
        ... on IspParam {
          isps {
            id
            name
          }
          clusivity
        }
        ... on CountryParam {
          code
          name
          clusivity
          countryGroups {
            name
            id
          }
          subdivisions {
            ... on CityParam {
              name
              regionCode
              subRegionCode
            }
            ... on RegionParam {
              name
              code
              subRegions {
                name
                code
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAllTargetingTemplatesQuery__
 *
 * To run a query within a React component, call `useAllTargetingTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTargetingTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTargetingTemplatesQuery({
 *   variables: {
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllTargetingTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllTargetingTemplatesQuery, AllTargetingTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllTargetingTemplatesQuery, AllTargetingTemplatesQueryVariables>(AllTargetingTemplatesDocument, options);
      }
export function useAllTargetingTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllTargetingTemplatesQuery, AllTargetingTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllTargetingTemplatesQuery, AllTargetingTemplatesQueryVariables>(AllTargetingTemplatesDocument, options);
        }
export type AllTargetingTemplatesQueryHookResult = ReturnType<typeof useAllTargetingTemplatesQuery>;
export type AllTargetingTemplatesLazyQueryHookResult = ReturnType<typeof useAllTargetingTemplatesLazyQuery>;
export type AllTargetingTemplatesQueryResult = ApolloReactCommon.QueryResult<AllTargetingTemplatesQuery, AllTargetingTemplatesQueryVariables>;
export const AllTargetingTemplatesMinimalDocument = gql`
    query AllTargetingTemplatesMinimal($territories: [Territory!]!) {
  allTargetingTemplates(territories: $territories) {
    id
    name
    description
    isMasterTemplate
    status
  }
}
    `;

/**
 * __useAllTargetingTemplatesMinimalQuery__
 *
 * To run a query within a React component, call `useAllTargetingTemplatesMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTargetingTemplatesMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTargetingTemplatesMinimalQuery({
 *   variables: {
 *      territories: // value for 'territories'
 *   },
 * });
 */
export function useAllTargetingTemplatesMinimalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllTargetingTemplatesMinimalQuery, AllTargetingTemplatesMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllTargetingTemplatesMinimalQuery, AllTargetingTemplatesMinimalQueryVariables>(AllTargetingTemplatesMinimalDocument, options);
      }
export function useAllTargetingTemplatesMinimalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllTargetingTemplatesMinimalQuery, AllTargetingTemplatesMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllTargetingTemplatesMinimalQuery, AllTargetingTemplatesMinimalQueryVariables>(AllTargetingTemplatesMinimalDocument, options);
        }
export type AllTargetingTemplatesMinimalQueryHookResult = ReturnType<typeof useAllTargetingTemplatesMinimalQuery>;
export type AllTargetingTemplatesMinimalLazyQueryHookResult = ReturnType<typeof useAllTargetingTemplatesMinimalLazyQuery>;
export type AllTargetingTemplatesMinimalQueryResult = ApolloReactCommon.QueryResult<AllTargetingTemplatesMinimalQuery, AllTargetingTemplatesMinimalQueryVariables>;